
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("OCz5m", function(module, exports) {
/* editorSSRExtensionHandlers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $h9yJL = parcelRequire("h9yJL");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");


var $6mKj3 = parcelRequire("6mKj3");


var $5kjCz = parcelRequire("5kjCz");


var $dwS6P = parcelRequire("dwS6P");


var $kuTjv = parcelRequire("kuTjv");


var $8pcS0 = parcelRequire("8pcS0");


var $4EIU1 = parcelRequire("4EIU1");


var $ceVeI = parcelRequire("ceVeI");


var $9m03g = parcelRequire("9m03g");


var $5a4cC = parcelRequire("5a4cC");


var $n9ft3 = parcelRequire("n9ft3");


var $bBRJy = parcelRequire("bBRJy");


var $aG1nm = parcelRequire("aG1nm");


var $lJs0a = parcelRequire("lJs0a");


var $jaHkh = parcelRequire("jaHkh");


var $3bvCJ = parcelRequire("3bvCJ");


var $bJaqz = parcelRequire("bJaqz");


var $cTOQy = parcelRequire("cTOQy");


var $lE7FD = parcelRequire("lE7FD");


var $hEeUR = parcelRequire("hEeUR");


var $CbxlN = parcelRequire("CbxlN");

const $e673ff442c42ddbb$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ajq _bfhksm61",
            __cmplp.className
        ])
    });
});
const $e673ff442c42ddbb$var$createEditorSSRExtensionHandlers = ({ contentId: contentId, spaceKey: spaceKey, cloudId: cloudId, userId: userId })=>{
    return {
        'com.atlassian.confluence.macro.core': (extension, doc)=>{
            const { extensionKey: extensionKey } = extension;
            const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
            const macroDefaultProps = {
                mode: (0, $5kjCz.EDITOR),
                node: extension,
                extensionKey: extensionKey,
                attributes: attributes,
                references: [],
                contentId: contentId,
                spaceKey: spaceKey
            };
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).TEAM_CALENDARS && (0, $6mKj3.expValEquals)('cc-engagement-team-calendar-macro-afm-migration', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kuTjv.TeamCalendarMacroLoader), {
                extensionNode: extension,
                macroDefaultProps: macroDefaultProps
            });
            if (extensionKey === 'toc') {
                const editorTransformer = new (0, $h9yJL.JSONTransformer)();
                const adf = editorTransformer.encode(doc);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e673ff442c42ddbb$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dwS6P.TableOfContentsLoader), {
                    isInEditMode: true,
                    adf: adf,
                    userId: userId || '',
                    cloudId: cloudId,
                    macroDefaultProps: macroDefaultProps
                }));
            }
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).CONTRIBUTORS && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).CONTRIBUTORS)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4EIU1.ContributorsMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).RECENTLY_UPDATED && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).RECENTLY_UPDATED)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $n9ft3.RecentlyUpdatedMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: {
                    ...extension?.parameters?.macroParams,
                    currentSpaceKey: spaceKey
                }
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).POPULAR_LABELS && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).POPULAR_LABELS)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bBRJy.PopularLabelsMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).PROFILE_PICTURE && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).PROFILE_PICTURE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9m03g.ProfilePictureMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lE7FD.DetailsSummaryExtensionHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).PROFILE && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).PROFILE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5a4cC.UserProfileMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).WIDGET && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).WIDGET)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aG1nm.WidgetMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).CONTENT_BY_LABEL && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).CONTENT_BY_LABEL)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lJs0a.ContentByLabelSSRExtensionHandler), {
                ...macroDefaultProps,
                Renderer: (0, $hEeUR.ADFRenderer),
                getExtensionHandlers: $e673ff442c42ddbb$var$createEditorSSRExtensionHandlers
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).INCLUDE && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).INCLUDE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3bvCJ.PageIncludeSSRExtensionHandler), {
                ...macroDefaultProps,
                Renderer: (0, $hEeUR.ADFRenderer),
                getExtensionHandlers: $e673ff442c42ddbb$var$createEditorSSRExtensionHandlers
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).BLOG_POSTS && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).BLOG_POSTS)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cTOQy.BlogPostsSSRExtensionHandler), {
                ...macroDefaultProps,
                Renderer: (0, $hEeUR.ADFRenderer),
                getExtensionHandlers: $e673ff442c42ddbb$var$createEditorSSRExtensionHandlers
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).CONTENT_REPORT_TABLE && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).CONTENT_REPORT_TABLE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jaHkh.ContentReportTableMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: {
                    ...extension?.parameters?.macroParams,
                    currentSpaceKey: spaceKey
                }
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).CHANGE_HISTORY && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).CHANGE_HISTORY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $CbxlN.ChangeHistoryMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).ATTACHMENTS && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).ATTACHMENTS)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bJaqz.AttachmentsMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
             // Unsupported (yet) extensions should default to existing provider-based handling
            // and rendering on a client side only.
            return null;
        }
    };
};
const $e673ff442c42ddbb$export$206691819bb24df7 = (contentId, spaceKey, extensionProviders)=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const [providersReady, setProvidersReady] = (0, $42omo.useState)(false);
    const isTransition = (0, $dPJCf.useIsTransition)();
    (0, $42omo.useEffect)(()=>{
        const providerPromises = extensionProviders?.map((provider)=>{
            return typeof provider.manifestsPromise !== 'undefined' ? provider.manifestsPromise : provider;
        });
        Promise.all(providerPromises).then(()=>setProvidersReady(true)).catch((_error)=>{
            // NOOP: Here, if any of the provider promises fail, the best we can do is to
            // fall back the original experience where macros are resolved and rendered on
            // the client only, although in this case the extensions experience would likely
            // be hosed anyway.
            setProvidersReady(true);
        });
    }, [
        extensionProviders
    ]);
    const extensionHandlers = (0, $42omo.useMemo)(()=>$e673ff442c42ddbb$var$createEditorSSRExtensionHandlers({
            contentId: contentId,
            spaceKey: spaceKey,
            cloudId: cloudId,
            userId: userId
        }), [
        contentId,
        spaceKey,
        cloudId,
        userId
    ]);
    return isTransition || providersReady ? undefined : extensionHandlers;
};
module.exports["useEditorSSRExtensionHandlers"] = $e673ff442c42ddbb$export$206691819bb24df7;

});

parcelRegister("jFkNO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $1ITQ3 = parcelRequire("1ITQ3");

const $bbc19db46e52068c$var$FORGE_VIEWPORT_SIZES = [
    'small',
    'medium',
    'default',
    'large',
    'xlarge'
];
const $bbc19db46e52068c$var$FORGE_MANIFEST_VIEWPORT_HEIGHTS = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
/**
 * Currently, very few legacy (connect) macros provide their expected rendered height/width
 * values in their macro parameters. Of those that do, there's a slight but consistent
 * margin of error for the height value. Others that don't render dynamic content we can
 * set a default height for (such as Miro embed).
 *
 * Any changes here should be mirrored in content-renderer-legacy-macros/src/useConnectExtensionViewportSize.ts
 * and getCalculatedHeightFromNode.ts
 */ const $bbc19db46e52068c$var$DRAW_IO_HEIGHT_OFFSET = 52;
const $bbc19db46e52068c$var$GOOGLE_DRIVE_EMBED_FILE_OFFSET_HEIGHT = 79;
const $bbc19db46e52068c$var$PLANTUML_OFFSET_HEIGHT = 40;
// Default sizes
const $bbc19db46e52068c$var$MIRO_EMBED_DEFAULT_HEIGHT = 570;
const $bbc19db46e52068c$var$EASY_MATH_BLOCK_DEFAULT_HEIGHT = 47;
const $bbc19db46e52068c$var$MATH_BLOCK_DEFAULT_HEIGHT = 58;
const $bbc19db46e52068c$var$PAGE_SIGNATURES_DEFAULT_HEIGHT = 23;
const $bbc19db46e52068c$var$QUESTIONS_LIST_DEFAULT_HEIGHT = 800;
const $bbc19db46e52068c$var$JIRA_ROADMAP_DEFAULT_HEIGHT = 600;
const $bbc19db46e52068c$var$LUCID_CHART_DEFAULT_HEIGHT = 500;
const $bbc19db46e52068c$var$GLIFFY_DEFAULT_HEIGHT = 150;
const $bbc19db46e52068c$var$AURA_DIVIDER_DEFAULT_HEIGHT = 21;
const $bbc19db46e52068c$var$AURA_CARDS_DEFAULT_HEIGHT = 226;
const $bbc19db46e52068c$var$getForgeExtensionHeight = (extensionId, extensionViewportSizes)=>{
    if (!extensionViewportSizes || !extensionId || !Array.isArray(extensionViewportSizes)) return;
    const viewportSize = extensionViewportSizes.find((ext)=>ext.extensionId === extensionId)?.viewportSize;
    if (!viewportSize) return undefined;
    if ($bbc19db46e52068c$var$FORGE_VIEWPORT_SIZES.includes(viewportSize)) return $bbc19db46e52068c$var$FORGE_MANIFEST_VIEWPORT_HEIGHTS[viewportSize];
    return undefined;
};
const $bbc19db46e52068c$var$getHeightFromNode = (node)=>{
    if (!node) return;
    const extensionKey = node.attrs.extensionKey;
    const params = node.attrs.parameters?.macroParams;
    /**
	 * DrawIo will resize diagrams based on the viewport they are rendered in
	 * if the diagram's width is greater than 530px. This means that the natural dimensions
	 * provided in macro parameters could be the incorrect height to reserve so we will
	 * conservatively exclude them.
	 */ if (extensionKey === 'drawio' || extensionKey === 'inc-drawio' || extensionKey === 'drawio-sketch') {
        const diagramWidth = Number(params?.width?.value);
        const zoomFactor = Number(params?.zoom?.value);
        if (diagramWidth && diagramWidth > 530 || zoomFactor !== 1) // Exclude wide diagrams due to allow resizing by vendor
        return;
    }
    if (extensionKey === 'plantumlcloud') return params?.originalHeight?.value;
    return params?.height?.value;
};
const $bbc19db46e52068c$export$bdad5f6d3f57f201 = ()=>{
    /**
	 * To attribute impact to each ecosystem, we plan to rollout Forge improvements separately
	 * via (confluence_preload_forge_viewport_heights_editor) with Connect improvements after
	 * via (confluence_connect_macro_preset_height). Thus we'll isolate Forge functionality first with
	 * the long term plan to merge both into a single function after successful rollout.
	 */ const extensionViewportSizes = (0, $1ITQ3.useExtensionViewportSizes)(!(0, $9wGTI.fg)('confluence_preload_forge_viewport_heights_editor'));
    const getForgeViewportHeight = (node)=>{
        // Forge in-content macros contain an ARI/environment/appKey extensionId value
        const extensionId = node.attrs.parameters?.extensionId;
        const forgeExtensionHeight = $bbc19db46e52068c$var$getForgeExtensionHeight(extensionId, extensionViewportSizes);
        if (forgeExtensionHeight) return forgeExtensionHeight;
    };
    const getCalculatedHeightFromNode = (0, $42omo.useCallback)((node)=>{
        // Check if it's a Connect extension with macro parameters
        const extensionKey = node.attrs.extensionKey;
        const nodeHeight = $bbc19db46e52068c$var$getHeightFromNode(node);
        let height = Number(nodeHeight);
        if (!Number.isNaN(height)) // for extensions that provide a number, add their offset
        switch(extensionKey){
            case 'drawio':
            case 'inc-drawio':
            case 'drawio-sketch':
                height += $bbc19db46e52068c$var$DRAW_IO_HEIGHT_OFFSET;
                break;
            case 'lref-gdrive-embedded-file':
                height += $bbc19db46e52068c$var$GOOGLE_DRIVE_EMBED_FILE_OFFSET_HEIGHT;
                break;
            case 'plantumlcloud':
                height += $bbc19db46e52068c$var$PLANTUML_OFFSET_HEIGHT;
                break;
            default:
                break;
        }
        else // for extensions that don't resize based on their content, we can set a default height
        switch(extensionKey){
            case 'gliffy':
                height = $bbc19db46e52068c$var$GLIFFY_DEFAULT_HEIGHT;
                break;
            case 'aura-divider':
                height = $bbc19db46e52068c$var$AURA_DIVIDER_DEFAULT_HEIGHT;
                break;
            case 'aura-cards':
                height = $bbc19db46e52068c$var$AURA_CARDS_DEFAULT_HEIGHT;
                break;
            case 'miro-macro-resizing':
                height = $bbc19db46e52068c$var$MIRO_EMBED_DEFAULT_HEIGHT;
                break;
            case 'easy-math-block':
                height = $bbc19db46e52068c$var$EASY_MATH_BLOCK_DEFAULT_HEIGHT;
                break;
            case 'mathblock':
                height = $bbc19db46e52068c$var$MATH_BLOCK_DEFAULT_HEIGHT;
                break;
            case 'page-signatures':
                height = $bbc19db46e52068c$var$PAGE_SIGNATURES_DEFAULT_HEIGHT;
                break;
            case 'questionslist-macro':
                height = $bbc19db46e52068c$var$QUESTIONS_LIST_DEFAULT_HEIGHT;
                break;
            case 'jiraroadmap':
                height = $bbc19db46e52068c$var$JIRA_ROADMAP_DEFAULT_HEIGHT;
                break;
            case 'lucidchart':
                height = $bbc19db46e52068c$var$LUCID_CHART_DEFAULT_HEIGHT;
                break;
            default:
                height = undefined;
                break;
        }
        return height?.toString();
    }, []);
    if ((0, $9wGTI.fg)('confluence_preload_forge_viewport_heights_editor')) return getForgeViewportHeight;
    if ((0, $9wGTI.fg)('confluence_connect_macro_preset_height')) return getCalculatedHeightFromNode;
};
module.exports["useExtensionNodeParams"] = $bbc19db46e52068c$export$bdad5f6d3f57f201;

});

parcelRegister("fthpM", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $b5IZN = parcelRequire("b5IZN");


var $2NcJL = parcelRequire("2NcJL");

const $75195e6585fa4719$export$a15423dd96de66f2 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function FullPageEditor(props) {
    const $ = (0, $frIzR.c)(3);
    const t0 = props.appearance ?? "full-page";
    let t1;
    if ($[0] !== props || $[1] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
            ...props,
            appearance: t0,
            AppearanceComponent: (0, $2NcJL.FullPageEditor),
            __livePage: props.__livePage
        });
        $[0] = props;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function FullPageEditor(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
        ...props,
        appearance: props.appearance ?? 'full-page',
        AppearanceComponent: (0, $2NcJL.FullPageEditor),
        __livePage: props.__livePage
    });
};
module.exports["FullPageEditor"] = $75195e6585fa4719$export$a15423dd96de66f2;

});

parcelRegister("ijGoX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iPfZG = parcelRequire("iPfZG");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $eEA8O = parcelRequire("eEA8O");


var $hMFTu = parcelRequire("hMFTu");


var $7cTWR = parcelRequire("7cTWR");


var $3Npfo = parcelRequire("3Npfo");


var $k5HOq = parcelRequire("k5HOq");


var $9A5yV = parcelRequire("9A5yV");

function $ed290d22e560c9dd$var$_defineProperty(e, r, t) {
    return (r = $ed290d22e560c9dd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ed290d22e560c9dd$var$_toPropertyKey(t) {
    var i = $ed290d22e560c9dd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ed290d22e560c9dd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $ed290d22e560c9dd$var$baselineUnit = "var(--ds-space-050, 4px)";
const $ed290d22e560c9dd$var$COLOR_N900 = '#091E42';
// eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
const $ed290d22e560c9dd$var$ContentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $ed290d22e560c9dd$var$Image = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $ed290d22e560c9dd$var$ButtonContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pk1b66",
            __cmplp.className
        ])
    });
});
const $ed290d22e560c9dd$var$BodyContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0q1b66 _n3td1b66 _syazi7uo",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $ed290d22e560c9dd$export$c7313f750e9cbc9d extends (0, $42omo.Component) {
    getPrimaryButton() {
        const { primaryAction: primaryAction, primaryText: primaryText } = this.props;
        return this.getActionButton('primary', this.onPrimaryClick, primaryAction, primaryText);
    }
    getSecondaryButton() {
        const { secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        return this.getActionButton('subtle-link', this.onSecondaryClick, secondaryAction, secondaryText);
    }
    getActionButton(appearance, onClick, action, text) {
        const type = action ? action.type : (0, $7cTWR.buttonActionTypes).DISMISS;
        switch(type){
            case (0, $7cTWR.buttonActionTypes).LINK:
                {
                    const actionData = action.data;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                        href: actionData.url,
                        target: actionData.target,
                        appearance: appearance,
                        onClick: onClick
                    }, text);
                }
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                    appearance: appearance,
                    onClick: onClick
                }, text);
        }
    }
    render() {
        const { children: children, title: title, imageSrc: imageSrc, imageAlt: imageAlt, body: body, position: position, order: order, secondaryText: secondaryText } = this.props;
        const messageContent = {
            image: null,
            title: null,
            body: null
        };
        if (title) // eslint-disable-next-line @atlaskit/design-system/use-heading
        messageContent.title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("h4", {
            key: "title"
        }, title);
        if (imageSrc) messageContent.image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ed290d22e560c9dd$var$Image, {
            key: "img",
            src: imageSrc,
            alt: imageAlt
        });
        messageContent.body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ed290d22e560c9dd$var$BodyContainer, {
            key: "body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9A5yV.default), {
            html: body
        }));
        const orderedContent = order.map((c)=>messageContent[c]);
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ed290d22e560c9dd$var$ContentContainer, null, orderedContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ed290d22e560c9dd$var$ButtonContainer, null, this.getPrimaryButton(), secondaryText ? this.getSecondaryButton() : null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hMFTu.default), {
            content: content,
            placement: position,
            isOpen: true
        }, children);
    }
    constructor(...args){
        super(...args);
        $ed290d22e560c9dd$var$_defineProperty(this, "onPrimaryClick", ()=>{
            this.props.fireClickEvent('primary');
        });
        $ed290d22e560c9dd$var$_defineProperty(this, "onSecondaryClick", ()=>{
            this.props.fireClickEvent('secondary');
        });
    }
}
$ed290d22e560c9dd$var$_defineProperty($ed290d22e560c9dd$export$c7313f750e9cbc9d, "defaultProps", {
    children: null,
    order: [
        'title',
        'image',
        'body'
    ],
    position: 'bottom left'
});
const $ed290d22e560c9dd$export$3660ec843fc5ef1b = (0, $3Npfo.default)($ed290d22e560c9dd$export$c7313f750e9cbc9d);
const $ed290d22e560c9dd$var$_default_1 = (0, $k5HOq.default)($ed290d22e560c9dd$export$3660ec843fc5ef1b, 'inlineDialog'); // eslint-disable-next-line camelcase
var $ed290d22e560c9dd$export$2e2bcd8739ae039 = $ed290d22e560c9dd$var$_default_1;





const $9b64448510e1eff4$export$3c29cca421979b0e = (coordinationClient, messageId)=>{
    const [started, setStarted] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        (async ()=>{
            try {
                const started = await coordinationClient.start(messageId);
                if (started) setStarted(true);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to start flow message ${messageId}. ${err}`);
            }
        })();
    }, [
        coordinationClient,
        messageId
    ]);
    const stop = (0, $42omo.useCallback)(async (force)=>{
        if (!force && !started) return;
        try {
            await coordinationClient.stop(messageId);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to stop flow message ${messageId}. ${err}`);
        }
    }, [
        started,
        coordinationClient,
        messageId
    ]);
    return [
        started,
        stop
    ];
};





class $7e9dab50b8978c7c$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    async componentDidMount() {
        const { client: client, messageId: messageId } = this.props;
        try {
            const started = await client.start(messageId);
            if (started) // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({
                shouldRenderChildren: true
            });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to start flow message ${messageId}. ${err}`);
        }
    }
    injectStop(children) {
        return /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
            stop: this.stop
        });
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const { shouldRenderChildren: shouldRenderChildren } = this.state;
        return shouldRenderChildren ? this.injectStop(children) : fallback;
    }
    constructor(...args){
        super(...args);
        this.state = {
            shouldRenderChildren: false
        };
        this.stop = async ()=>{
            const { client: client, messageId: messageId } = this.props;
            try {
                await client.stop(messageId);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to stop flow message ${messageId}. ${err}`);
            }
        };
    }
}
$7e9dab50b8978c7c$export$2e2bcd8739ae039.defaultProps = {
    fallback: null
};



var $lwNi3 = parcelRequire("lwNi3");

const $e86ccba267113370$export$4d97def4de07dcc1 = ()=>{
    const coordinationClient = (0, $lwNi3.useCoordinationClient)();
    // [ED-27497] IMPORTANT: If you change the code below, please also update the
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/engagementPlatformPluginOptions.ts
    return (0, $42omo.useMemo)(()=>{
        const config = {
            epComponents: {
                EngagementSpotlight: $iPfZG.EngagementSpotlight,
                EngagementInlineDialog: $ed290d22e560c9dd$export$2e2bcd8739ae039,
                Coordination: $7e9dab50b8978c7c$export$2e2bcd8739ae039
            },
            epHooks: {
                useCoordination: $9b64448510e1eff4$export$3c29cca421979b0e
            },
            coordinationClient: coordinationClient
        };
        return {
            config: config
        };
    }, [
        coordinationClient
    ]);
};
module.exports["useEditorEngagementPlatform"] = $e86ccba267113370$export$4d97def4de07dcc1;

});

parcelRegister("bDgLc", function(module, exports) {

var $5spQU = parcelRequire("5spQU");


var $42omo = parcelRequire("42omo");


var $kyKWe = parcelRequire("kyKWe");


var $c0rhi = parcelRequire("c0rhi");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");

/**
 * @generated SignedSource<<312647498233a7b45d0a0262adb9e32d>>
 * @relayHash d3f124aab91672208e07302d03b07351
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c184940bfc597924791e760a99e4cec505eb44de79daa104a6aa46e6adac4b2b
const $60d3698972303f3d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageARI"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "workspaceId"
        }
    ], v1 = [
        {
            "concreteType": "KnowledgeDiscoveryQueryApi",
            "kind": "LinkedField",
            "name": "knowledgeDiscovery",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "entityAri",
                            "variableName": "pageARI"
                        },
                        {
                            "kind": "Variable",
                            "name": "workspaceId",
                            "variableName": "workspaceId"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "keyPhrases",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "KnowledgeDiscoveryKeyPhrase",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "keyPhrase"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "category"
                                        }
                                    ]
                                }
                            ],
                            "type": "KnowledgeDiscoveryKeyPhraseConnection"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "HighlightKeywordsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "HighlightKeywordsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d3f124aab91672208e07302d03b07351",
            "id": "c184940bfc597924791e760a99e4cec505eb44de79daa104a6aa46e6adac4b2b",
            "metadata": {},
            "name": "HighlightKeywordsQuery",
            "operationKind": "query",
            "text": "query HighlightKeywordsQuery($pageARI:String,$workspaceId:String){knowledgeDiscovery{keyPhrases(entityAri:$pageARI,workspaceId:$workspaceId)@optIn(to:\"KnowledgeDiscovery Get Key Phrases\"){__typename,...on KnowledgeDiscoveryKeyPhraseConnection{nodes{keyPhrase,category}},...on QueryError{message}}}}"
        }
    };
}();
$60d3698972303f3d$var$node.hash = "2eaa54e2c6daee5ed7b85802235eee06";
var $60d3698972303f3d$export$2e2bcd8739ae039 = $60d3698972303f3d$var$node;


const $770d1260eccad933$export$b855f1e1a990429f = (0, $60d3698972303f3d$export$2e2bcd8739ae039);



var $7rLBD = parcelRequire("7rLBD");

const $70f493264a46a679$var$cachedAcronymRegex = {
    pageARI: '',
    regex: new RegExp('(?!)')
};
const $70f493264a46a679$var$getAcronymRegex = (acronyms, pageARI = '', ignoreCase = false)=>{
    if (pageARI === $70f493264a46a679$var$cachedAcronymRegex.pageARI) return $70f493264a46a679$var$cachedAcronymRegex.regex;
    let regex;
    try {
        regex = new RegExp(acronyms.map((node)=>`\\b${node.phrase}\\b`).join('|'), ignoreCase ? 'gi' : 'g');
    } catch  {
        regex = new RegExp('(?!)');
    }
    $70f493264a46a679$var$cachedAcronymRegex.pageARI = pageARI;
    $70f493264a46a679$var$cachedAcronymRegex.regex = regex;
    return regex;
};
const $70f493264a46a679$export$ce57c3ee398efaad = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const pageARI = contentId ? (0, $7rLBD.generatePageARI)(contentId, cloudId, contentType) : undefined;
    const workspaceId = (0, $7rLBD.generateWorkspaceId)(activationId, cloudId);
    const queryHighlightAcronyms = (0, $42omo.useCallback)(async ({ cacheKey: cacheKey = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))() } = {})=>{
        if (!workspaceId || !pageARI) return {
            acronyms: []
        };
        try {
            const { data: data } = await (0, $c0rhi.queryInterop)({
                query: (0, $770d1260eccad933$export$b855f1e1a990429f),
                fetchPolicy: 'network-only',
                errorPolicy: 'ignore',
                variables: {
                    cacheKey: // comment from confluence/next/packages/content-appearance/src/contentAppearance.ts
                    // This is dummy variable is used to force "network-only" requests to only be run as network calls.
                    // A bug in Apollo sometimes makes this query return data from the cache even if the policy is "network-only"
                    // See for more details: https://pug.jira-dev.com/wiki/spaces/~683304838/pages/5971970200/Apollo+Client+-+weird+refetch+behavior
                    // @ts-expect-error
                    cacheKey,
                    pageARI: pageARI,
                    workspaceId: workspaceId
                },
                interopApolloAggClient: true,
                __callerPackage__: "@confluence/contextual-reading-aids"
            });
            const keyPhrasesData = data?.knowledgeDiscovery?.keyPhrases;
            const keyPhrases = keyPhrasesData && keyPhrasesData.__typename === 'KnowledgeDiscoveryKeyPhraseConnection' && keyPhrasesData.nodes ? // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
            keyPhrasesData.nodes.filter((phrase)=>phrase != null).map((phrase)=>({
                    phrase: phrase.keyPhrase,
                    category: phrase.category
                })) : [];
            // getAcronymRegex use pageARI to cache the regex for the page
            // but for live edit pages we should be careful with the cache
            // because the page content is changing constantly
            const pageARIWithCacheKey = `${pageARI}-${cacheKey}`;
            let acronymRegex = undefined;
            if (keyPhrases.length) acronymRegex = $70f493264a46a679$var$getAcronymRegex(keyPhrases, pageARIWithCacheKey, true);
            return {
                acronyms: keyPhrases,
                acronymRegex: acronymRegex
            };
        } catch  {
            return {
                acronyms: []
            };
        }
    }, [
        pageARI,
        workspaceId
    ]);
    return {
        queryHighlightAcronyms: queryHighlightAcronyms
    };
};






var $2Jxlo = parcelRequire("2Jxlo");








var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $7mpOv = parcelRequire("7mpOv");

const $5ea2be36e6b2ae4f$export$718b2890e94c1d28 = ()=>{
    /**
	 * see comments in `AIDefinitionsPluginConfig` for more details about why not checking `isLivePage` here
	 * const isLivePage = useIsCurrentPageLive();
	 */ const [contentId] = (0, $ep3mz.usePageContentId)();
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    // environment-aware enablement via feature encoding
    const isAIFeatureEnabled = (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai');
    const featureEnabled = isAIEnabledForContent || isRovoEnabledForContent;
    return isAIFeatureEnabled && featureEnabled;
};
const $5ea2be36e6b2ae4f$export$eeb7064aa16baa7e = ()=>{
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    return (isAIEnabledForContent || isRovoEnabledForContent) && locale.startsWith('en') && !JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_READING_AIDS_AUTO_HIGHLIGHT) || '""');
};
const $5ea2be36e6b2ae4f$export$538319b84b3e9de0 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const enabled = $5ea2be36e6b2ae4f$export$718b2890e94c1d28();
    const autoHighlightEnabled = $5ea2be36e6b2ae4f$export$eeb7064aa16baa7e();
    const { queryHighlightAcronyms: queryHighlightAcronyms } = (0, $70f493264a46a679$export$ce57c3ee398efaad)();
    const { isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const enablementSource = isRovoEnabledForContent ? 'rovo' : 'general-ai';
    return {
        enabled: enabled,
        contentId: contentId,
        autoHighlightEnabled: autoHighlightEnabled,
        queryHighlightAcronyms: queryHighlightAcronyms,
        ReadingAidsPopup: $2Jxlo.ReadingAidsPopup,
        enablementSource: enablementSource,
        readingAidsMaxWordCount: (0, $7rLBD.READING_AIDS_MAX_WORD_COUNT)
    };
};
module.exports["useEditorPluginAIDefinitionsEnabled"] = $5ea2be36e6b2ae4f$export$718b2890e94c1d28;
module.exports["useEditorPluginAIDefinitionsConfig"] = $5ea2be36e6b2ae4f$export$538319b84b3e9de0;

});

parcelRegister("diJQD", function(module, exports) {

var $5spQU = parcelRequire("5spQU");


var $4TXTZ = parcelRequire("4TXTZ");


var $hmVoT = parcelRequire("hmVoT");


var $42omo = parcelRequire("42omo");


var $eiA8Z = parcelRequire("eiA8Z");

const $53b900e6d056eba5$export$92a1a3b7554e9387 = {
    SHOW_IMAGE_EDITOR: 'SHOW_IMAGE_EDITOR',
    HIDE_IMAGE_EDITOR: 'HIDE_IMAGE_EDITOR'
};



var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


const $f4d001cda3671719$export$f00c49e7bdf6721d = new (0, $ks2lK.PluginKey)('mediaEditingPlugin');
const $f4d001cda3671719$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $f4d001cda3671719$export$f00c49e7bdf6721d,
        state: {
            init () {
                return {};
            },
            apply: (tr, currentPluginState)=>{
                const meta = tr.getMeta($f4d001cda3671719$export$f00c49e7bdf6721d);
                switch(meta?.type){
                    case (0, $53b900e6d056eba5$export$92a1a3b7554e9387).SHOW_IMAGE_EDITOR:
                        return {
                            ...currentPluginState,
                            imageEditorSelectedMedia: meta.imageEditorSelectedMedia,
                            isImageEditorVisible: meta.isImageEditorVisible
                        };
                    case (0, $53b900e6d056eba5$export$92a1a3b7554e9387).HIDE_IMAGE_EDITOR:
                        return {
                            ...currentPluginState,
                            imageEditorSelectedMedia: undefined,
                            isImageEditorVisible: meta.isImageEditorVisible
                        };
                    default:
                        return currentPluginState;
                }
            }
        }
    });
};


const $9fa213c2875fb91b$export$a0f8e5c5401083f8 = (media)=>({ tr: tr })=>{
        tr.setMeta((0, $f4d001cda3671719$export$f00c49e7bdf6721d), {
            type: (0, $53b900e6d056eba5$export$92a1a3b7554e9387).SHOW_IMAGE_EDITOR,
            imageEditorSelectedMedia: media,
            isImageEditorVisible: true
        });
        tr.setMeta('addToHistory', false);
        return tr;
    };
const $9fa213c2875fb91b$export$ac53b7b0b56dbebd = ({ tr: tr })=>{
    tr.setMeta((0, $f4d001cda3671719$export$f00c49e7bdf6721d), {
        type: (0, $53b900e6d056eba5$export$92a1a3b7554e9387).HIDE_IMAGE_EDITOR,
        imageEditorSelectedMedia: null,
        isImageEditorVisible: false
    });
    tr.setMeta('addToHistory', false);
    return tr;
};







var $9CkUQ = parcelRequire("9CkUQ");

const $040ed71febaf74c3$export$c8d0f9dbb5a183eb = (attrs)=>{
    return attrs.type === 'external';
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $ccHMk = parcelRequire("ccHMk");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $3NvMe = parcelRequire("3NvMe");


var $cvXh8 = parcelRequire("cvXh8");


var $ghftu = parcelRequire("ghftu");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $6xdDU = parcelRequire("6xdDU");


var $gdv5Z = parcelRequire("gdv5Z");


var $9hlns = parcelRequire("9hlns");

/* Cropper.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $fFa3V = parcelRequire("fFa3V");

const $6b13fba10800ce5a$var$isSSRRender = ()=>typeof document === 'undefined' || false; /**
                                                                                                         * Props for the Cropper component
                                                                                                         */ 
const $6b13fba10800ce5a$var$CropperCanvas = 'cropper-canvas';
const $6b13fba10800ce5a$var$CropperImage = 'cropper-image';
const $6b13fba10800ce5a$var$CropperSelection = 'cropper-selection';
const $6b13fba10800ce5a$var$CropperShade = 'cropper-shade';
const $6b13fba10800ce5a$var$CropperGrid = 'cropper-grid';
const $6b13fba10800ce5a$var$CropperCrosshair = 'cropper-crosshair';
const $6b13fba10800ce5a$var$CropperHandle = 'cropper-handle'; /**
                                                                                                             * Options for getting the cropped canvas
                                                                                                             */ 

const $6b13fba10800ce5a$export$71ed2b85d4ca43d3 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ src: src, alt: alt = '', crossOrigin: crossOrigin, aspectRatio: aspectRatio, initialAspectRatio: initialAspectRatio, initialCoverage: initialCoverage = 1, background: background = true, rotatable: rotatable = true, scalable: scalable = true, translatable: translatable = true, movable: movable = true, resizable: resizable = true, zoomable: zoomable = true, multiple: multiple = false, outlined: outlined = true, className: className, onImageReady: onImageReady, isCircle: isCircle = false }, ref)=>{
    const canvasRef = (0, $42omo.useRef)(null);
    const selectionRef = (0, $42omo.useRef)(null);
    const imageRef = (0, $42omo.useRef)(null);
    const previousSelectionRef = (0, $42omo.useRef)(null);
    const [isImageReady, setIsImageReady] = (0, $42omo.useState)(false);
    const [isCropperLoaded, setIsCropperLoaded] = (0, $42omo.useState)(false);
    const getCanvas = (0, $42omo.useCallback)(()=>canvasRef.current, []);
    const getImage = (0, $42omo.useCallback)(()=>imageRef.current, []);
    const getSelection = (0, $42omo.useCallback)(()=>selectionRef.current, []);
    const getCroppedCanvas = (0, $42omo.useCallback)((options)=>{
        const selection = selectionRef.current;
        if (!selection) return Promise.resolve(null);
         // Check if the $toCanvas method exists (web component might not be fully initialized)
        if (typeof selection.$toCanvas !== 'function') return Promise.resolve(null);
         // If circular crop, we need to apply a circular mask
        if (isCircle) {
            // For circular crops, force square dimensions to maintain perfect circle
            const squareOptions = {
                ...options,
                height: options?.width // Make height equal to width for a perfect circle
            };
            return selection.$toCanvas({
                ...squareOptions,
                beforeDraw: (context, canvas)=>{
                    // For circles, ensure we have a square canvas
                    const size = Math.min(canvas.width, canvas.height);
                    const radius = size / 2;
                    const centerX = size / 2;
                    const centerY = size / 2; // Enable high-quality image rendering
                    context.imageSmoothingEnabled = true;
                    context.imageSmoothingQuality = 'high'; // Create a circular clipping path with anti-aliasing
                    context.beginPath();
                    context.arc(centerX, centerY, radius, 0, Math.PI * 2);
                    context.clip();
                }
            });
        }
        return selection.$toCanvas(options);
    }, [
        isCircle
    ]);
    const fitStencilToImage = (0, $42omo.useCallback)(()=>{
        const canvas = canvasRef.current;
        const image = imageRef.current;
        const selection = selectionRef.current;
        if (canvas && image && selection) {
            // Get the real time positions
            const canvasRect = canvas.getBoundingClientRect();
            const imageRect = image.getBoundingClientRect(); // Calculate coordinates relative to the canvas
            requestAnimationFrame(()=>{
                const x = imageRect.left - canvasRect.left;
                const y = imageRect.top - canvasRect.top;
                const width = imageRect.width;
                const height = imageRect.height; // Apply these to the selection (the stencil)
                if (typeof selection.$change === 'function') selection.$change(Math.floor(x), Math.floor(y), Math.floor(width), Math.floor(height));
            });
        }
    }, []); // Clamp position to keep crop area within image boundaries
    const clampPosition = (0, $42omo.useCallback)((current)=>{
        const canvas = canvasRef.current;
        const image = imageRef.current;
        if (!canvas || !image) return null;
        const canvasRect = canvas.getBoundingClientRect();
        const imageRect = image.getBoundingClientRect();
        const imageX = imageRect.left - canvasRect.left;
        const imageY = imageRect.top - canvasRect.top;
        const imageWidth = imageRect.width;
        const imageHeight = imageRect.height;
        let clampedX = current.x;
        let clampedY = current.y; // Clamp left/right
        if (clampedX < imageX) clampedX = imageX;
        else if (clampedX + current.width > imageX + imageWidth) clampedX = imageX + imageWidth - current.width;
         // Clamp top/bottom
        if (clampedY < imageY) clampedY = imageY;
        else if (clampedY + current.height > imageY + imageHeight) clampedY = imageY + imageHeight - current.height;
        return {
            x: clampedX,
            y: clampedY
        };
    }, []); // Correct dimensions when resizing with aspect ratio constraints
    const correctResizeDimensions = (0, $42omo.useCallback)((current, selection)=>{
        const canvas = canvasRef.current;
        const image = imageRef.current;
        if (!canvas || !image) return null;
        const canvasRect = canvas.getBoundingClientRect();
        const imageRect = image.getBoundingClientRect();
        const imageX = imageRect.left - canvasRect.left;
        const imageY = imageRect.top - canvasRect.top;
        const imageWidth = imageRect.width;
        const imageHeight = imageRect.height;
        const maxWidthAvailable = imageX + imageWidth - current.x;
        const maxHeightAvailable = imageY + imageHeight - current.y;
        let correctedWidth = current.width;
        let correctedHeight = current.height;
        const hasAspectRatio = selection.aspectRatio && selection.aspectRatio > 0;
        if (hasAspectRatio) {
            const aspectRatio = selection.aspectRatio;
            const heightIfMaxWidth = maxWidthAvailable / aspectRatio;
            const widthIfMaxHeight = maxHeightAvailable * aspectRatio; // Determine which axis is the limiting factor
            if (heightIfMaxWidth <= maxHeightAvailable) {
                correctedWidth = maxWidthAvailable;
                correctedHeight = heightIfMaxWidth;
            } else {
                correctedHeight = maxHeightAvailable;
                correctedWidth = widthIfMaxHeight;
            }
        } else {
            correctedWidth = Math.min(correctedWidth, maxWidthAvailable);
            correctedHeight = Math.min(correctedHeight, maxHeightAvailable);
        } // Ensure positive dimensions
        correctedWidth = Math.max(1, correctedWidth);
        correctedHeight = Math.max(1, correctedHeight);
        return {
            width: correctedWidth,
            height: correctedHeight
        };
    }, []); // Handle move operation (position changed but size stayed same)
    const handleMove = (0, $42omo.useCallback)(()=>{
        requestAnimationFrame(()=>{
            const selection = selectionRef.current;
            if (!selection) return;
            const current = {
                x: selection.x || 0,
                y: selection.y || 0,
                width: selection.width || 0,
                height: selection.height || 0
            };
            const clamped = clampPosition(current);
            if (!clamped) return;
            if (typeof selection.$change === 'function') selection.$change(Math.floor(clamped.x), Math.floor(clamped.y), Math.floor(current.width), Math.floor(current.height));
            previousSelectionRef.current = {
                width: current.width,
                height: current.height
            };
        });
    }, [
        clampPosition
    ]); // Handle resize operation (size changed, may need aspect ratio correction)
    const handleResize = (0, $42omo.useCallback)(()=>{
        requestAnimationFrame(()=>{
            const selection = selectionRef.current;
            if (!selection) return;
            const current = {
                x: selection.x || 0,
                y: selection.y || 0,
                width: selection.width || 0,
                height: selection.height || 0
            };
            const corrected = correctResizeDimensions(current, selection);
            if (!corrected) return;
            const canvas = canvasRef.current;
            const image = imageRef.current;
            if (!canvas || !image) return;
            const canvasRect = canvas.getBoundingClientRect();
            const imageRect = image.getBoundingClientRect();
            const imageX = imageRect.left - canvasRect.left;
            const imageY = imageRect.top - canvasRect.top;
            const correctedX = Math.max(imageX, current.x);
            const correctedY = Math.max(imageY, current.y);
            if (typeof selection.$change === 'function') selection.$change(Math.floor(correctedX), Math.floor(correctedY), Math.floor(corrected.width), Math.floor(corrected.height));
            previousSelectionRef.current = {
                width: corrected.width,
                height: corrected.height
            };
        });
    }, [
        correctResizeDimensions
    ]); // Check if selection is within image boundaries
    const isSelectionOutOfBounds = (0, $42omo.useCallback)((imageX, imageY, imageWidth, imageHeight, selection)=>{
        const tolerance = 1;
        return selection.x < imageX - tolerance || selection.y < imageY - tolerance || selection.x + selection.width > imageX + imageWidth + tolerance || selection.y + selection.height > imageY + imageHeight + tolerance;
    }, []); // Detect if operation is a move or resize based on dimension change
    const isMovingSelection = (0, $42omo.useCallback)(()=>{
        const prev = previousSelectionRef.current;
        const curr = selectionRef.current;
        if (!prev || !curr) return false;
        return prev.width === curr.width && prev.height === curr.height;
    }, []);
    const handleSelectionChange = (0, $42omo.useCallback)((event)=>{
        const canvas = canvasRef.current;
        const image = imageRef.current;
        const customEvent = event;
        const selection = customEvent.detail;
        if (!canvas || !image || !selection) return;
        const canvasRect = canvas.getBoundingClientRect();
        const imageRect = image.getBoundingClientRect();
        const imageX = imageRect.left - canvasRect.left;
        const imageY = imageRect.top - canvasRect.top;
        const imageWidth = imageRect.width;
        const imageHeight = imageRect.height;
        if (!isSelectionOutOfBounds(imageX, imageY, imageWidth, imageHeight, selection)) {
            previousSelectionRef.current = {
                width: selection.width,
                height: selection.height
            };
            return;
        }
        if (isMovingSelection()) handleMove();
        else handleResize();
    }, [
        isSelectionOutOfBounds,
        isMovingSelection,
        handleMove,
        handleResize
    ]); // Lazy load cropperjs only on the client to avoid SSR side effects
    (0, $42omo.useEffect)(()=>{
        if (!$6b13fba10800ce5a$var$isSSRRender()) (parcelRequire("hcAEn")).then(()=>setIsCropperLoaded(true)).catch(()=>{
            setIsCropperLoaded(false);
        });
    }, []); // Auto-fit stencil to image on mount and when src changes
    // Only run after cropperjs has loaded (client-side only, post-hydration)
    (0, $42omo.useEffect)(()=>{
        if (!isCropperLoaded) return;
         // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
        setIsImageReady(false); // Hide canvas while repositioning
        const image = imageRef.current;
        if (!image) return;
         // Wait for the image to be fully loaded
        if (typeof image.$ready === 'function') image.$ready(()=>{
            const timer = setTimeout(()=>{
                fitStencilToImage();
                setIsImageReady(true);
                onImageReady?.(true);
            }, 500); // Adding a small timeout as there is a rendering issue with webkit
            return ()=>clearTimeout(timer);
        });
        else {
            // Fallback to timeout if $ready is not available
            const timer = setTimeout(()=>{
                fitStencilToImage();
                setIsImageReady(true);
                onImageReady?.(true);
            }, 2000);
            return ()=>clearTimeout(timer);
        }
    }, [
        src,
        isCropperLoaded,
        onImageReady,
        fitStencilToImage
    ]); // Attach selection change listener to enforce boundaries (only after image is ready)
    (0, $42omo.useEffect)(()=>{
        if (!isImageReady) return;
        const selection = selectionRef.current;
        if (!selection) return;
        return (0, $fFa3V.bind)(selection, {
            type: 'change',
            listener: handleSelectionChange
        });
    }, [
        isImageReady,
        handleSelectionChange
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!canvasRef.current || !imageRef.current) return;
        const observer = new ResizeObserver(()=>{
            // This forces the image to recalculate its "contain" logic
            // whenever the canvas wrapper changes size
            if (typeof imageRef.current?.$center === 'function') imageRef.current?.$center('contain');
        });
        observer.observe(canvasRef.current);
        return ()=>observer.disconnect();
    }, [
        canvasRef,
        imageRef
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!canvasRef.current) return;
        const observer = new ResizeObserver(()=>{
            selectionRef.current?.removeAttribute('aspect-ratio');
            fitStencilToImage();
        });
        observer.observe(canvasRef.current);
        return ()=>observer.disconnect();
    }, [
        fitStencilToImage
    ]);
    (0, $42omo.useImperativeHandle)(ref, ()=>({
            fitStencilToImage: fitStencilToImage,
            getCanvas: getCanvas,
            getCroppedCanvas: getCroppedCanvas,
            getImage: getImage,
            isImageReady: isImageReady,
            getSelection: getSelection
        }), [
        getCanvas,
        getCroppedCanvas,
        getImage,
        isImageReady,
        fitStencilToImage,
        getSelection
    ]); // Inject global styles for cropper handles
    (0, $42omo.useEffect)(()=>{
        const style = document.createElement('style');
        const circularStyle = isCircle ? `
			cropper-selection {
				outline: none;
				border-top: 1px solid #0052CC;
				border-right: 1px solid #0052CC;
				border-bottom: 1px solid #0052CC;
				border-left: 1px solid #0052CC;
				box-sizing: border-box;
				border-radius: 50%;
				box-shadow: 0 0 0 9999px rgba(255, 255, 255, 0.6);
			}
		` : `
			cropper-selection {
				outline: none;
				border-top: 1px solid #0052CC;
				border-right: 1px solid #0052CC;
				border-bottom: 1px solid #0052CC;
				border-left: 1px solid #0052CC;
				box-sizing: border-box; 
			}
		`;
        style.textContent = `
				cropper-canvas {
					background-color: #F8F8F8;
					background-image: none;
				}
				cropper-shade {
					outline-color: rgba(255,255,255,0.5);
				}
				cropper-handle[action="move"] {
					opacity: 0;
				}
				cropper-handle[action="ne-resize"] {
					border-radius: 7px 4px 4px 4px;
					border-right: 7px solid rgba(255,255,255,0.6);
					border-top: 7px solid rgba(255,255,255,0.6);
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(-4px, 4px); 
				}
				cropper-handle[action="ne-resize"]::after {
					border-radius: 5px 4px 4px 4px;
					border-right: 5px solid #0052CC;
					border-top: 5px solid #0052CC;
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(-7px, -14px); 
				}
				cropper-handle[action="nw-resize"] {
					border-radius: 4px 7px 4px 4px;
					border-left: 7px solid rgba(255,255,255,0.6);
					border-top: 7px solid rgba(255,255,255,0.6);
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(4px, 4px); 
				}
				cropper-handle[action="nw-resize"]::after {
					border-radius: 4px 5px 4px 4px;
					border-left: 5px solid #0052CC;
					border-top: 5px solid #0052CC;
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(-14px, -14px); 
				}
				cropper-handle[action="se-resize"] {
					border-radius: 4px 4px 7px 4px;
					border-right: 7px solid rgba(255,255,255,0.6);
					border-bottom: 7px solid rgba(255,255,255,0.6);
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(-4px, -4px); 
				}
				cropper-handle[action="se-resize"]::after {
					border-radius: 4px 4px 5px 4px;
					border-right: 5px solid #0052CC;
					border-bottom: 5px solid #0052CC;
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(-7px, -7px); 
				}
				cropper-handle[action="sw-resize"] {
					border-radius: 4px 4px 4px 7px;
					border-left: 7px solid rgba(255,255,255,0.6);
					border-bottom: 7px solid rgba(255,255,255,0.6);
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(4px, -4px); 
				}
				cropper-handle[action="sw-resize"]::after {
					border-radius: 4px 4px 4px 5px;
					border-left: 5px solid #0052CC;
					border-bottom: 5px solid #0052CC;
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(-14px, -7px); 
				}
				${circularStyle}
			`;
        document.head.appendChild(style);
        return ()=>style.remove();
    }, [
        isCircle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6b13fba10800ce5a$var$CropperCanvas, {
        ref: canvasRef,
        class: className,
        background: background,
        style: {
            opacity: isImageReady ? 1 : 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6b13fba10800ce5a$var$CropperImage, {
        ref: imageRef,
        src: src,
        alt: alt,
        crossorigin: crossOrigin,
        rotatable: rotatable,
        scalable: scalable,
        translatable: translatable,
        "initial-center-size": "contain"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6b13fba10800ce5a$var$CropperShade, {
        x: 240,
        y: 5,
        width: 160,
        height: 90
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6b13fba10800ce5a$var$CropperSelection, {
        ref: selectionRef,
        "initial-coverage": initialCoverage,
        "aspect-ratio": aspectRatio,
        "initial-aspect-ratio": initialAspectRatio,
        movable: movable,
        resizable: resizable,
        zoomable: zoomable,
        multiple: multiple,
        outlined: outlined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6b13fba10800ce5a$var$CropperGrid, {
        role: "grid",
        hidden: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6b13fba10800ce5a$var$CropperCrosshair, {
        hidden: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6b13fba10800ce5a$var$CropperHandle, {
        action: "move"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6b13fba10800ce5a$var$CropperHandle, {
        action: "ne-resize"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6b13fba10800ce5a$var$CropperHandle, {
        action: "nw-resize"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6b13fba10800ce5a$var$CropperHandle, {
        action: "se-resize"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6b13fba10800ce5a$var$CropperHandle, {
        action: "sw-resize"
    })));
});
$6b13fba10800ce5a$export$71ed2b85d4ca43d3.displayName = 'Cropper';


/* FlipHorizontalIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $e090d94123374729$var$sizeStyles = {
    small: "_1bsbgktf _4t3igktf",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $e090d94123374729$var$svgStyles = null;
const $e090d94123374729$export$19f53ac153fdf5c1 = ({ label: label, size: size = 'small', primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, isDisabled: isDisabled })=>/*#__PURE__*/ $42omo.createElement("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            color: primaryColor,
            fill: secondaryColor,
            opacity: isDisabled ? 0.5 : 1
        },
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            $e090d94123374729$var$sizeStyles[size]
        ])
    }, /*#__PURE__*/ $42omo.createElement("path", {
        d: "M8.75 16H7.25V0H8.75V16ZM1.97559 3.99609C2.56238 3.77737 3.22379 3.94656 3.63379 4.41992L5.88379 7.01855L5.92773 7.07129C6.37112 7.63335 6.3567 8.43636 5.88379 8.98242L3.63379 11.5801C3.22379 12.0535 2.56239 12.2226 1.97559 12.0039C1.38909 11.7851 1.00022 11.2246 1 10.5986V5.40234C1.00003 4.77617 1.38894 4.21497 1.97559 3.99609ZM12.3662 4.41992C12.7762 3.94656 13.4376 3.77737 14.0244 3.99609C14.6111 4.21497 15 4.77617 15 5.40234V10.5986C14.9998 11.2246 14.6109 11.7851 14.0244 12.0039C13.4376 12.2226 12.7762 12.0535 12.3662 11.5801L10.1162 8.98242C9.6433 8.43636 9.62888 7.63335 10.0723 7.07129L10.1162 7.01855L12.3662 4.41992ZM2.5 10.5986L4.75 8L2.5 5.40234V10.5986ZM11.25 8L13.5 10.5986V5.40234L11.25 8Z",
        fill: primaryColor
    }));


/* FlipVerticalIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $905137a889b7491e$var$sizeStyles = {
    small: "_1bsbgktf _4t3igktf",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $905137a889b7491e$var$svgStyles = null;
const $905137a889b7491e$export$e97029447c2d07bf = ({ label: label, size: size = 'small', primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, isDisabled: isDisabled })=>/*#__PURE__*/ $42omo.createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            color: primaryColor,
            fill: secondaryColor,
            opacity: isDisabled ? 0.5 : 1
        },
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            $905137a889b7491e$var$sizeStyles[size]
        ])
    }, /*#__PURE__*/ $42omo.createElement("path", {
        d: "M1.492e-05 8.75L1.49856e-05 7.25L16 7.25L16 8.75L1.492e-05 8.75ZM12.0039 1.97656C12.2224 2.56323 12.0533 3.2239 11.5801 3.63379L8.98146 5.88379L8.92873 5.92871C8.36667 6.37206 7.56364 6.35668 7.01759 5.88379L4.41994 3.63379C3.94669 3.2239 3.77765 2.56325 3.99611 1.97656C4.21484 1.38987 4.77528 1.00022 5.40138 1L10.5977 1C11.224 1.00003 11.7851 1.38973 12.0039 1.97656ZM11.5801 12.3662C12.0533 12.7761 12.2224 13.4368 12.0039 14.0234C11.7851 14.6103 11.224 15 10.5977 15L5.40138 15C4.77528 14.9998 4.21484 14.6101 3.99611 14.0234C3.77765 13.4368 3.94669 12.7761 4.41994 12.3662L7.01759 10.1162C7.56364 9.64332 8.36667 9.62794 8.92873 10.0713L8.98146 10.1162L11.5801 12.3662ZM5.40138 2.5L8.00002 4.75L10.5977 2.5L5.40138 2.5ZM8.00001 11.25L5.40138 13.5L10.5977 13.5L8.00001 11.25Z",
        fill: primaryColor
    }));


/* RatioIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $28c0aa1f5d6e5d89$var$sizeStyles = {
    small: "_1bsbgktf _4t3igktf",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $28c0aa1f5d6e5d89$var$svgStyles = null;
const $28c0aa1f5d6e5d89$export$8dcfa0333e5b427e = ({ label: label, size: size = 'small', primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, isDisabled: isDisabled })=>/*#__PURE__*/ $42omo.createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            color: primaryColor,
            fill: secondaryColor,
            opacity: isDisabled ? 0.5 : 1
        },
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            $28c0aa1f5d6e5d89$var$sizeStyles[size]
        ])
    }, /*#__PURE__*/ $42omo.createElement("path", {
        d: "M3 10V13H6V14.5H2.875C2.11561 14.5 1.5 13.8844 1.5 13.125V10H3ZM14.5 13.125C14.5 13.8844 13.8844 14.5 13.125 14.5H10V13H13V10H14.5V13.125ZM13.125 1.5C13.8844 1.5 14.5 2.11561 14.5 2.875V6H13V3H10V1.5H13.125ZM6 3H3V6H1.5V2.875C1.5 2.11561 2.11561 1.5 2.875 1.5H6V3Z",
        fill: primaryColor
    }));


/* RotateIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $edcc9465064bcfb0$var$sizeStyles = {
    small: "_1bsbgktf _4t3igktf",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $edcc9465064bcfb0$var$svgStyles = null;
const $edcc9465064bcfb0$export$f48a22e8beb69262 = ({ label: label, size: size = 'small', primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, isDisabled: isDisabled })=>/*#__PURE__*/ $42omo.createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            color: primaryColor,
            fill: secondaryColor,
            opacity: isDisabled ? 0.5 : 1
        },
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            $edcc9465064bcfb0$var$sizeStyles[size]
        ])
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.93459 6.72227C7.47156 6.1853 8.34216 6.1853 8.87913 6.72227L12.0914 9.93458C12.6284 10.4716 12.6284 11.3422 12.0914 11.8791L8.87913 15.0914C8.34216 15.6284 7.47156 15.6284 6.93459 15.0914L3.72228 11.8791C3.18531 11.3422 3.18531 10.4716 3.72228 9.93458L6.93459 6.72227ZM7.90686 7.87132L4.87133 10.9069L7.90686 13.9424L10.9424 10.9069L7.90686 7.87132Z",
        fill: primaryColor
    }), /*#__PURE__*/ $42omo.createElement("path", {
        d: "M0 8.5C0 4.08172 3.58172 0.5 8 0.5C10.6789 0.5 13.0485 1.81718 14.5 3.83691V0.75H16V5.5C16 5.91421 15.6642 6.25 15.25 6.25H10.5V4.75H13.3086C12.1308 3.08578 10.192 2 8 2C4.41015 2 1.5 4.91015 1.5 8.5V9.25H0V8.5Z",
        fill: primaryColor
    }));









var $aXWIB = parcelRequire("aXWIB");

const $ccfae6ffb4dd15f3$var$ASPECT_RATIOS = {
    original: null,
    custom: null,
    square: {
        x: 1,
        y: 1
    },
    circle: {
        x: 1,
        y: 1
    },
    landscape: {
        x: 4,
        y: 3
    },
    portrait: {
        x: 3,
        y: 4
    },
    wide: {
        x: 16,
        y: 9
    }
};
const $ccfae6ffb4dd15f3$export$873aefdf6f4e5566 = ()=>{
    // no ratio = undefined = custom cropping selection
    const getAspectRatioValue = (ratio)=>{
        const aspectRatioValue = $ccfae6ffb4dd15f3$var$ASPECT_RATIOS[ratio];
        if (aspectRatioValue) return aspectRatioValue.x / aspectRatioValue.y;
        return undefined;
    };
    return {
        getAspectRatioValue: getAspectRatioValue
    };
};
const $ccfae6ffb4dd15f3$export$b331ea965923cd1f = (cropperRef)=>{
    const flipHorizontal = ()=>{
        const image = cropperRef.current?.getImage();
        if (image?.$scale) image.$scale(-1, 1);
    };
    const flipVertical = ()=>{
        const image = cropperRef.current?.getImage();
        if (image?.$scale) image.$scale(1, -1);
    };
    return {
        flipHorizontal: flipHorizontal,
        flipVertical: flipVertical
    };
};
const $ccfae6ffb4dd15f3$export$9202d595fd82f22e = (cropperRef)=>{
    const rotateRight = ()=>{
        const canvas = cropperRef.current?.getCanvas();
        const image = cropperRef.current?.getImage();
        if (!canvas || !image) return;
        const selectionEl = canvas.querySelector('cropper-selection');
        if (selectionEl instanceof HTMLElement) selectionEl.style.opacity = '0';
        image.$rotate('90deg');
        image.$center('contain');
        cropperRef.current?.fitStencilToImage();
        if (selectionEl instanceof HTMLElement) selectionEl.style.opacity = '1';
    };
    return {
        rotateRight: rotateRight
    };
};


const $a89f238659bf60f5$export$c9acda86a2363b01 = ()=>{
    const cropperRef = (0, $42omo.useRef)(null);
    const doneButtonRef = (0, $42omo.useRef)(null);
    const aspectRatioResolverRef = (0, $42omo.useRef)(null);
    const isInitialSetupRef = (0, $42omo.useRef)(true);
    const [isImageReady, setIsImageReady] = (0, $42omo.useState)(false);
    const [currentAspectRatio, setCurrentAspectRatio] = (0, $42omo.useState)(undefined);
    const [aspectRatioSelection, setAspectRatioSelection] = (0, $42omo.useState)('custom');
    const { flipHorizontal: flipHorizontal, flipVertical: flipVertical } = (0, $ccfae6ffb4dd15f3$export$b331ea965923cd1f)(cropperRef);
    const { rotateRight: rotateRight } = (0, $ccfae6ffb4dd15f3$export$9202d595fd82f22e)(cropperRef);
    const { getAspectRatioValue: getAspectRatioValue } = (0, $ccfae6ffb4dd15f3$export$873aefdf6f4e5566)();
    const intl = (0, $aXWIB.useIntl)();
    // Initialize editor state and track canvas size changes
    (0, $42omo.useEffect)(()=>{
        if (!isImageReady) return;
        // Get the canvas element to observe for size changes
        const canvas = cropperRef.current?.getCanvas();
        if (!canvas) return;
        // Track initial canvas dimensions before any state updates
        let lastWidth = canvas.clientWidth;
        let lastHeight = canvas.clientHeight;
        // Canvas size will change when the viewport size changes
        // Monitor canvas resizing to detect when user manually adjusts the crop area
        const observer = new ResizeObserver((entries)=>{
            // Skip the first observation during setup
            if (isInitialSetupRef.current) {
                isInitialSetupRef.current = false;
                return;
            }
            const entry = entries[0];
            const { width: width, height: height } = entry.contentRect;
            // If canvas size changes, switch to custom aspect ratio mode
            if (width !== lastWidth || height !== lastHeight) {
                lastWidth = width;
                lastHeight = height;
                setAspectRatioSelection('custom');
            }
        });
        observer.observe(canvas);
        // Calculate and set the original aspect ratio based on the image dimensions
        setAspectRatioSelection('custom');
        // Focus on the done button as soon as image loads
        if (doneButtonRef.current) doneButtonRef.current.focus();
        return ()=>observer.disconnect();
    }, [
        isImageReady
    ]);
    // Listen for aspect ratio selection changes and update current aspect ratio
    // This effect monitors the cropper's selection element for any changes
    // and updates the currentAspectRatio state accordingly
    (0, $42omo.useEffect)(()=>{
        if (isImageReady && aspectRatioSelection !== '') {
            const selection = cropperRef.current?.getSelection();
            if (!selection) return;
            // Update aspect ratio whenever aspect ratio selection changes
            const handleSelectionChange = ()=>{
                const selectionAspectRatio = selection.aspectRatio ? selection.aspectRatio : undefined;
                setCurrentAspectRatio(selectionAspectRatio);
            };
            // Call once to set initial value
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            handleSelectionChange();
            // Attach change listener to selection element
            return (0, $fFa3V.bind)(selection, {
                type: 'change',
                listener: handleSelectionChange
            });
        }
    }, [
        isImageReady,
        aspectRatioSelection
    ]);
    // Resolve pending aspect ratio changes
    // This effect watches for when the aspect ratio reaches its target value
    // and resolves the corresponding promise to allow animations to proceed
    (0, $42omo.useEffect)(()=>{
        const pending = aspectRatioResolverRef.current;
        if (pending && currentAspectRatio === pending.target) {
            // Resolve the promise stored in the ref when target is reached
            pending.resolve();
            aspectRatioResolverRef.current = null;
        }
    }, [
        currentAspectRatio
    ]);
    // Calculate the original aspect ratio of the image
    // Gets the image element's dimensions and computes width/height ratio
    const calculateOriginalRatio = ()=>{
        const image = cropperRef.current?.getImage();
        if (image) {
            const img = image.getBoundingClientRect();
            const ratio = img.width / img.height;
            setCurrentAspectRatio(ratio);
        }
    };
    // Wait for the aspect ratio to reach a target value
    // Used to coordinate aspect ratio changes with animation frames
    // Returns a promise that resolves when the target ratio is reached
    const waitForCurrentAspectRatio = (target)=>new Promise((resolve)=>{
            // If already at target, resolve on next animation frame
            if (currentAspectRatio === target) {
                requestAnimationFrame(()=>resolve());
                return;
            }
            // Otherwise, store resolve callback to be called when target is reached
            aspectRatioResolverRef.current = {
                resolve: resolve,
                target: target
            };
        });
    // Change the aspect ratio selection and animate the transition
    // This function handles smooth transitions between different aspect ratios
    const setSelectionArea = async (selectedRatio)=>{
        // Custom ratio mode: free-form selection without constraints
        if (selectedRatio === 'custom') {
            setAspectRatioSelection(selectedRatio);
            setCurrentAspectRatio(undefined);
            await waitForCurrentAspectRatio(undefined);
            return;
        }
        const selection = cropperRef.current?.getSelection();
        const canvas = cropperRef.current?.getCanvas();
        const shade = canvas?.querySelector('cropper-shade');
        // Fade out selection and shade during transition for smooth animation
        if (selection) selection.style.opacity = '0';
        if (shade) shade.style.opacity = '0';
        // Reset aspect ratio and wait for the crop area to clear
        setCurrentAspectRatio(undefined);
        await waitForCurrentAspectRatio(undefined);
        cropperRef.current?.fitStencilToImage();
        // Wait for DOM to update
        await new Promise((resolve)=>requestAnimationFrame(resolve));
        // Set the new aspect ratio
        if (selectedRatio === 'original') calculateOriginalRatio();
        else {
            const ratioVal = getAspectRatioValue(selectedRatio);
            setCurrentAspectRatio(ratioVal);
            await waitForCurrentAspectRatio(ratioVal);
        }
        setAspectRatioSelection(selectedRatio);
        // Allow time for the new crop area to be positioned and rendered
        await new Promise((resolve)=>setTimeout(resolve, 300));
        // Center the selection and fade back in
        if (selection) {
            selection.$center();
            selection.style.opacity = '1';
        }
        if (shade) shade.style.opacity = '1';
    };
    // Extract the cropped image and save it
    // Converts the cropped canvas to a blob and calls the onSave callback
    const handleSave = async (onSave, onClose, errorReporter)=>{
        try {
            // Get the selection to determine the crop size relative to original image
            const selection = cropperRef.current?.getSelection();
            const image = cropperRef.current?.getImage();
            let canvasWidth;
            if (selection && image) {
                // Try to get the actual <img> from shadow DOM
                const actualImg = image.shadowRoot?.querySelector('img') || null;
                if (actualImg) {
                    // Get the natural (original) image dimensions
                    const naturalWidth = actualImg.naturalWidth;
                    // Get the displayed image dimensions
                    const displayedRect = image.getBoundingClientRect();
                    const displayedWidth = displayedRect.width;
                    // Calculate the scale factor between displayed and original image
                    const scaleX = naturalWidth / displayedWidth;
                    // Get selection dimensions in displayed coordinates
                    const selectionWidth = selection.width || 0;
                    // Calculate the crop width in original image coordinates
                    const cropWidthInOriginal = selectionWidth * scaleX;
                    // Use the crop width from original image, capped at a reasonable maximum
                    canvasWidth = Math.min(cropWidthInOriginal, 1500);
                }
            }
            // Get the cropped canvas with calculated width
            // Fallback to width = 1500 (a reasonable size for keeping high quality images relatively high quality)
            const canvas = await cropperRef.current?.getCroppedCanvas(canvasWidth ? {
                width: canvasWidth
            } : {
                width: 1500
            });
            if (canvas) {
                const outWidth = canvas.width;
                const outHeight = canvas.height;
                // Convert canvas to blob (defaults to png)
                canvas.toBlob((blob)=>{
                    if (blob) onSave?.(blob, outWidth, outHeight);
                });
            }
        } catch (error) {
            // Report any errors to the error reporter
            if (errorReporter) errorReporter.captureException(error instanceof Error ? error : new Error(String(error)));
        }
    };
    return {
        cropperRef: cropperRef,
        doneButtonRef: doneButtonRef,
        isImageReady: isImageReady,
        setIsImageReady: setIsImageReady,
        currentAspectRatio: currentAspectRatio,
        aspectRatioSelection: aspectRatioSelection,
        flipHorizontal: flipHorizontal,
        flipVertical: flipVertical,
        rotateRight: rotateRight,
        setSelectionArea: setSelectionArea,
        handleSave: handleSave,
        formatMessage: intl.formatMessage
    };
};


const $9b27642e6562e0a0$var$imageWrapper = null;
const $9b27642e6562e0a0$var$cropper = null;
const $9b27642e6562e0a0$var$modalFooter = null;
const $9b27642e6562e0a0$var$ratioBtn = null;
const $9b27642e6562e0a0$var$ratioSelect = null;
const $9b27642e6562e0a0$var$loadingImageStyle = null;
const $9b27642e6562e0a0$var$dropdownItemGroup = null;
const $9b27642e6562e0a0$var$btnGroupStyle = {
    box: "_zulpu2gc _1e0c1txw"
};
const $9b27642e6562e0a0$var$aspectRatioLabelMap = {
    original: 'aspectRatioSelectionOriginal',
    custom: 'aspectRatioSelectionCustom',
    square: 'aspectRatioSelectionSquare',
    circle: 'aspectRatioSelectionCircle',
    landscape: 'aspectRatioSelectionLandscape',
    portrait: 'aspectRatioSelectionPortrait',
    wide: 'aspectRatioSelectionWide'
};
const $9b27642e6562e0a0$export$d0486c7a5136628 = ({ imageUrl: imageUrl, isOpen: isOpen, isSaving: isSaving = false, onClose: onClose, onSave: onSave, errorReporter: errorReporter })=>{
    const { cropperRef: cropperRef, doneButtonRef: doneButtonRef, isImageReady: isImageReady, setIsImageReady: setIsImageReady, currentAspectRatio: currentAspectRatio, aspectRatioSelection: aspectRatioSelection, flipHorizontal: flipHorizontal, flipVertical: flipVertical, handleSave: handleSave, setSelectionArea: setSelectionArea, formatMessage: formatMessage, rotateRight: rotateRight } = (0, $a89f238659bf60f5$export$c9acda86a2363b01)();
    return /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null, isOpen && /*#__PURE__*/ $42omo.createElement((0, $8CZUH.default), {
        onClose: isSaving ? ()=>{} : onClose,
        height: 800,
        width: "x-large",
        testId: "image-editor-modal",
        label: "Image editor modal"
    }, /*#__PURE__*/ $42omo.createElement("br", null), /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _4t3i1osq _1bsb1osq _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o"
        ])
    }, !isImageReady && /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _kqswstnw"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
        size: "large",
        testId: "spinner",
        interactionName: "load",
        label: "Loading"
    })), imageUrl && /*#__PURE__*/ $42omo.createElement((0, $6b13fba10800ce5a$export$71ed2b85d4ca43d3), {
        ref: cropperRef,
        src: imageUrl,
        alt: "Crop me",
        crossOrigin: "anonymous",
        initialCoverage: 1,
        aspectRatio: currentAspectRatio,
        isCircle: aspectRatioSelection === 'circle',
        onImageReady: setIsImageReady,
        className: (0, $gMc0m.default)([
            "_p12f1osq _1bsb1osq _4t3i1osq"
        ])
    }))), /*#__PURE__*/ $42omo.createElement((0, $8o1lj.default), null, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _1bsb1osq"
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", null, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        appearance: "default",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: !isImageReady || isSaving,
                isSelected: props.isSelected,
                onClick: props.onClick,
                onFocus: props.onFocus,
                onBlur: props.onBlur,
                "aria-expanded": props['aria-expanded'],
                "aria-haspopup": props['aria-haspopup'],
                "aria-controls": props['aria-controls'],
                testId: props.testId
            }, /*#__PURE__*/ $42omo.createElement("div", {
                className: (0, $gMc0m.default)([
                    "_zulpu2gc _1e0c1txw _4cvr1h6o"
                ])
            }, /*#__PURE__*/ $42omo.createElement((0, $28c0aa1f5d6e5d89$export$8dcfa0333e5b427e), {
                label: "change aspect ratio button",
                isDisabled: !isImageReady || isSaving
            }), aspectRatioSelection && formatMessage((0, $3NvMe.mediaEditingMessages)[$9b27642e6562e0a0$var$aspectRatioLabelMap[aspectRatioSelection]]), /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                label: "",
                size: "small"
            })))
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1ul9uuw1"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $ahaN7.default), null, [
        'original',
        'custom'
    ].map((item)=>/*#__PURE__*/ $42omo.createElement((0, $dAYOx.default), {
            key: item,
            onClick: ()=>{
                setSelectionArea(item);
            }
        }, /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                "_1e0c1txw _1bah1yb4 _4cvr1h6o"
            ])
        }, formatMessage((0, $3NvMe.mediaEditingMessages)[$9b27642e6562e0a0$var$aspectRatioLabelMap[item]]), aspectRatioSelection === item && /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
            label: "selected"
        }))))), /*#__PURE__*/ $42omo.createElement((0, $ahaN7.default), {
        hasSeparator: true
    }, [
        'square',
        'circle',
        'landscape',
        'portrait',
        'wide'
    ].map((item)=>/*#__PURE__*/ $42omo.createElement((0, $dAYOx.default), {
            key: item,
            onClick: ()=>{
                setSelectionArea(item);
            }
        }, /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                "_1e0c1txw _1bah1yb4 _4cvr1h6o"
            ])
        }, formatMessage((0, $3NvMe.mediaEditingMessages)[`${item}Button`]), aspectRatioSelection === item && /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
            label: "selected"
        }))))))), /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
    ), {
        onClick: async ()=>{
            rotateRight();
            await setSelectionArea('custom');
            cropperRef.current?.fitStencilToImage();
        },
        isDisabled: !isImageReady || isSaving,
        testId: "image-editor-rotate-right-btn",
        appearance: "subtle"
    }, /*#__PURE__*/ $42omo.createElement((0, $edcc9465064bcfb0$export$f48a22e8beb69262), {
        label: "rotate right button",
        isDisabled: !isImageReady || isSaving
    })), /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
        onClick: flipVertical,
        isDisabled: !isImageReady || isSaving,
        testId: "image-editor-flip-vertical-btn",
        appearance: "subtle"
    }, /*#__PURE__*/ $42omo.createElement((0, $905137a889b7491e$export$e97029447c2d07bf), {
        label: "flip vertical button",
        isDisabled: !isImageReady || isSaving
    })), /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
        onClick: flipHorizontal,
        isDisabled: !isImageReady || isSaving,
        testId: "image-editor-flip-horizontal-btn",
        appearance: "subtle"
    }, /*#__PURE__*/ $42omo.createElement((0, $e090d94123374729$export$19f53ac153fdf5c1), {
        label: "flip horizontal button",
        isDisabled: !isImageReady || isSaving
    }))), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $9b27642e6562e0a0$var$btnGroupStyle.box
    }, /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: onClose,
        isDisabled: isSaving
    }, formatMessage((0, $3NvMe.mediaEditingMessages).cancelButton)), /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: ()=>handleSave(onSave, onClose, errorReporter),
        isDisabled: !isImageReady || isSaving,
        isLoading: isSaving,
        ref: doneButtonRef
    }, isSaving ? formatMessage((0, $3NvMe.mediaEditingMessages).savingButton) : formatMessage((0, $3NvMe.mediaEditingMessages).doneButton)))))));
};


const $6a12d0ea26926c30$export$8ac4c72242e73a4e = ({ mediaClientConfig: mediaClientConfig, onClose: onClose, selectedNodeAttrs: selectedNodeAttrs, errorReporter: errorReporter, editorView: editorView })=>{
    const [imageUrl, setImageUrl] = (0, $42omo.useState)('');
    const [isSaving, setIsSaving] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        const getImageUrl = ()=>{
            if ((0, $040ed71febaf74c3$export$c8d0f9dbb5a183eb)(selectedNodeAttrs)) {
                // Fall back in case editing button shows by mistake
                onClose();
                errorReporter?.captureException(new Error('Cannot edit external media due to CORS restrictions'));
            } else {
                // File media - use MediaClient to get the image URL
                const { id: id, collection: collection = '' } = selectedNodeAttrs;
                try {
                    const mediaClient = new (0, $9CkUQ.MediaClient)(mediaClientConfig);
                    // Subscribe to file state to get file information
                    const subscription = mediaClient.file.getFileState(id, {
                        collectionName: collection
                    }).subscribe((fileState)=>{
                        if (fileState.status === 'processed' || fileState.status === 'processing') // Get the image URL from the processed file
                        mediaClient.file.getFileBinaryURL(id, collection).then((url)=>{
                            setImageUrl(url);
                        });
                    });
                    // Cleanup subscription on unmount
                    return ()=>subscription.unsubscribe();
                } catch (error) {
                    if (errorReporter) errorReporter.captureException(error instanceof Error ? error : new Error(String(error)));
                    setImageUrl('');
                }
            }
        };
        getImageUrl();
    }, [
        selectedNodeAttrs,
        mediaClientConfig,
        errorReporter,
        onClose
    ]);
    const handleSave = (blob, width, height)=>{
        const mediaClient = new (0, $9CkUQ.MediaClient)(mediaClientConfig);
        const collection = 'collection' in selectedNodeAttrs ? selectedNodeAttrs.collection || '' : '';
        // Ensure blob has MIME type
        const typedBlob = blob.type ? blob : new Blob([
            blob
        ], {
            type: 'image/png'
        });
        const localId = !(0, $040ed71febaf74c3$export$c8d0f9dbb5a183eb)(selectedNodeAttrs) ? selectedNodeAttrs.localId : undefined;
        // Upload the edited image as a new file with a different filename
        const originalFileName = !(0, $040ed71febaf74c3$export$c8d0f9dbb5a183eb)(selectedNodeAttrs) ? selectedNodeAttrs.__fileName : undefined;
        let editedFileName = 'edited-image.png'; // fallback if the filename doesn't exist
        if (originalFileName) {
            const lastDotIndex = originalFileName.lastIndexOf('.');
            if (lastDotIndex > 0) {
                const baseName = originalFileName.substring(0, lastDotIndex);
                editedFileName = `${baseName}-edited-${localId}`;
            } else editedFileName = `${originalFileName}-edited-${localId}`;
        }
        const uploadableFile = {
            content: typedBlob,
            collection: collection,
            mimeType: typedBlob.type,
            name: editedFileName,
            size: typedBlob.size
        };
        // Show saving state in modal
        setIsSaving(true);
        const uploadSubscription = mediaClient.file.upload(uploadableFile).subscribe({
            next: (fileState)=>{
                if (fileState.status === 'error') {
                    setIsSaving(false);
                    onClose();
                    uploadSubscription.unsubscribe();
                    return;
                }
                // Only update document when upload is complete
                if (fileState.status !== 'uploading' && fileState.status !== 'processing') {
                    const updatedAttrs = (0, $040ed71febaf74c3$export$c8d0f9dbb5a183eb)(selectedNodeAttrs) ? selectedNodeAttrs : {
                        ...selectedNodeAttrs,
                        id: fileState.id,
                        __fileName: fileState.name,
                        __fileMimeType: fileState.mimeType,
                        __fileSize: fileState.size,
                        width: width,
                        height: height
                    };
                    // Find the media node position and update it
                    const { state: state, dispatch: dispatch } = editorView;
                    const { doc: doc } = state;
                    let nodePos = null;
                    const selectedLocalId = !(0, $040ed71febaf74c3$export$c8d0f9dbb5a183eb)(selectedNodeAttrs) ? selectedNodeAttrs.localId : undefined;
                    doc.descendants((node, pos)=>{
                        if ((0, $040ed71febaf74c3$export$c8d0f9dbb5a183eb)(selectedNodeAttrs)) return true;
                        // Find by localId (unique per node instance)
                        if (selectedLocalId && node.attrs.localId === selectedLocalId) {
                            nodePos = pos;
                            return false;
                        }
                        return true;
                    });
                    if (nodePos !== null) {
                        const node = doc.nodeAt(nodePos);
                        if (node) {
                            const tr = state.tr.setNodeMarkup(nodePos, undefined, updatedAttrs);
                            dispatch(tr);
                        }
                    }
                    uploadSubscription.unsubscribe();
                    setIsSaving(false);
                    onClose();
                }
            },
            error: (error)=>{
                if (errorReporter) errorReporter.captureException(error instanceof Error ? error : new Error(String(error)));
                uploadSubscription.unsubscribe();
                setIsSaving(false);
                onClose();
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9b27642e6562e0a0$export$d0486c7a5136628), {
        isOpen: true,
        onClose: onClose,
        imageUrl: imageUrl,
        onSave: handleSave,
        errorReporter: errorReporter,
        isSaving: isSaving
    });
};


const $616343a1d45d9a96$var$imageEditorStateSelector = (states)=>{
    return {
        isImageEditorVisible: states.mediaEditingState?.isImageEditorVisible,
        imageEditorSelectedMedia: states.mediaEditingState?.imageEditorSelectedMedia,
        uploadMediaClientConfig: states.mediaState?.uploadMediaClientConfig
    };
};
const $616343a1d45d9a96$var$ImageEditorFunctionalComponent = ({ api: api, editorView: editorView })=>{
    const { isImageEditorVisible: isImageEditorVisible, imageEditorSelectedMedia: imageEditorSelectedMedia, uploadMediaClientConfig: uploadMediaClientConfig } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'mediaEditing',
        'media'
    ], $616343a1d45d9a96$var$imageEditorStateSelector);
    if (!isImageEditorVisible || !imageEditorSelectedMedia || !uploadMediaClientConfig) return null;
    const handleOnClose = ()=>{
        api?.core.actions.execute(api?.mediaEditing.commands.hideImageEditor);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6a12d0ea26926c30$export$8ac4c72242e73a4e), {
        mediaClientConfig: uploadMediaClientConfig,
        onClose: handleOnClose,
        selectedNodeAttrs: imageEditorSelectedMedia,
        editorView: editorView
    });
};
const $616343a1d45d9a96$export$c84116e7ea204952 = ({ api: api })=>({
        name: 'mediaEditing',
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $f4d001cda3671719$export$f00c49e7bdf6721d).getState(editorState) || null;
        },
        commands: {
            showImageEditor: $9fa213c2875fb91b$export$a0f8e5c5401083f8,
            hideImageEditor: $9fa213c2875fb91b$export$ac53b7b0b56dbebd
        },
        pmPlugins () {
            return [
                {
                    name: 'mediaEditingPlugin',
                    plugin: (0, $f4d001cda3671719$export$ae829ec7b2625219)
                }
            ];
        },
        contentComponent ({ editorView: editorView }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($616343a1d45d9a96$var$ImageEditorFunctionalComponent, {
                api: api,
                editorView: editorView
            });
        }
    });



var $bupcf = parcelRequire("bupcf");


var $3ihIB = parcelRequire("3ihIB");


var $hr8mu = parcelRequire("hr8mu");


var $jmHSv = parcelRequire("jmHSv");


var $cpn0f = parcelRequire("cpn0f");


var $PJ00O = parcelRequire("PJ00O");


var $fi7Vj = parcelRequire("fi7Vj");


var $fPXRH = parcelRequire("fPXRH");


var $55skd = parcelRequire("55skd");


var $2E0F0 = parcelRequire("2E0F0");


var $k2prb = parcelRequire("k2prb");


var $khxQ7 = parcelRequire("khxQ7");


var $hSJYu = parcelRequire("hSJYu");


var $cwPVT = parcelRequire("cwPVT");


var $duFi2 = parcelRequire("duFi2");


var $agrUc = parcelRequire("agrUc");


var $kXH7i = parcelRequire("kXH7i");


var $acwPl = parcelRequire("acwPl");


var $01uqX = parcelRequire("01uqX");


var $7rj2U = parcelRequire("7rj2U");


var $jgFdO = parcelRequire("jgFdO");


var $5AZDw = parcelRequire("5AZDw");


var $gyXPd = parcelRequire("gyXPd");


var $5y9PZ = parcelRequire("5y9PZ");


var $dme7x = parcelRequire("dme7x");


var $2yr9J = parcelRequire("2yr9J");


var $kbe7k = parcelRequire("kbe7k");


var $1nZXu = parcelRequire("1nZXu");


var $kIhx9 = parcelRequire("kIhx9");


var $bS1lJ = parcelRequire("bS1lJ");


var $2nH2Y = parcelRequire("2nH2Y");


var $4iQt6 = parcelRequire("4iQt6");


var $4KTOl = parcelRequire("4KTOl");


var $lgjGE = parcelRequire("lgjGE");


var $3mcWz = parcelRequire("3mcWz");


var $hlZXw = parcelRequire("hlZXw");


var $hcboS = parcelRequire("hcboS");


var $8ABVP = parcelRequire("8ABVP");


var $fTvEN = parcelRequire("fTvEN");


var $eyggb = parcelRequire("eyggb");


var $l7rln = parcelRequire("l7rln");


var $dtCIm = parcelRequire("dtCIm");


var $7sK9h = parcelRequire("7sK9h");


var $jS0a0 = parcelRequire("jS0a0");


var $6q6xk = parcelRequire("6q6xk");


var $fYKTL = parcelRequire("fYKTL");


var $fCLXZ = parcelRequire("fCLXZ");


var $flknw = parcelRequire("flknw");


var $cu2RD = parcelRequire("cu2RD");


var $HYzBP = parcelRequire("HYzBP");


var $gATpw = parcelRequire("gATpw");


var $aUwPP = parcelRequire("aUwPP");


var $cVhn8 = parcelRequire("cVhn8");


var $6AqNX = parcelRequire("6AqNX");


var $05jmd = parcelRequire("05jmd");


var $1chBq = parcelRequire("1chBq");


var $5HHoF = parcelRequire("5HHoF");


var $lQotL = parcelRequire("lQotL");


var $80JwR = parcelRequire("80JwR");


var $cWFvG = parcelRequire("cWFvG");


var $2U68K = parcelRequire("2U68K");


var $5u7tz = parcelRequire("5u7tz");


var $dH9DB = parcelRequire("dH9DB");


var $b3BjA = parcelRequire("b3BjA");


var $36iDo = parcelRequire("36iDo");


var $59fTa = parcelRequire("59fTa");


var $kYgUn = parcelRequire("kYgUn");


var $8HLyI = parcelRequire("8HLyI");


var $itirX = parcelRequire("itirX");


var $e6sdP = parcelRequire("e6sdP");


var $5DsxN = parcelRequire("5DsxN");


var $1GAIu = parcelRequire("1GAIu");


var $bULcr = parcelRequire("bULcr");


var $4NiQW = parcelRequire("4NiQW");


var $5Qu3R = parcelRequire("5Qu3R");


var $7nKrc = parcelRequire("7nKrc");


var $84Iqc = parcelRequire("84Iqc");


var $c8680 = parcelRequire("c8680");


var $6borH = parcelRequire("6borH");


var $efDik = parcelRequire("efDik");


var $eeGWn = parcelRequire("eeGWn");


var $jaskt = parcelRequire("jaskt");


var $i2zv0 = parcelRequire("i2zv0");


var $5mDFx = parcelRequire("5mDFx");


var $3JBsx = parcelRequire("3JBsx");


var $1KHo7 = parcelRequire("1KHo7");


var $aB4bz = parcelRequire("aB4bz");


var $fMaLE = parcelRequire("fMaLE");


var $bz4KD = parcelRequire("bz4KD");


var $a5jtK = parcelRequire("a5jtK");


var $kw2eg = parcelRequire("kw2eg");


var $vxKdN = parcelRequire("vxKdN");


var $3O0YV = parcelRequire("3O0YV");


var $hEicH = parcelRequire("hEicH");


var $fI6T7 = parcelRequire("fI6T7");




























































































































































































































































































var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");


var $iu6m9 = parcelRequire("iu6m9");





var $aZxYK = parcelRequire("aZxYK");


var $gOFRe = parcelRequire("gOFRe");


var $6BmjZ = parcelRequire("6BmjZ");


var $iEdEF = parcelRequire("iEdEF");














var $2jMw7 = parcelRequire("2jMw7");








var $bePXf = parcelRequire("bePXf");











var $eLkLF = parcelRequire("eLkLF");




let $b204c96beb2c5d9f$var$executionRequestSequence = 0;
const $b204c96beb2c5d9f$var$createExecutionRequestId = ()=>`execution-${++$b204c96beb2c5d9f$var$executionRequestSequence}`;
const $b204c96beb2c5d9f$var$getFinishExecutionMeta = ({ localId: localId, requestId: requestId })=>localId ? {
        localId: localId,
        requestId: requestId,
        type: 'FINISH_EXECUTION'
    } : undefined;
const $b204c96beb2c5d9f$var$startExecution = ({ editorView: editorView, lifecycleState: lifecycleState, localId: localId, requestId: requestId })=>{
    if (!localId) return;
    (0, $eLkLF.dispatchAgentManagedExtensionMeta)(editorView, {
        lifecycleState: lifecycleState,
        localId: localId,
        requestId: requestId,
        type: 'START_EXECUTION'
    });
};
const $b204c96beb2c5d9f$var$getCurrentLifecycleState = (editorView, localId)=>{
    const found = (0, $6BmjZ.findAgentManagedExtensionByLocalId)(editorView.state, localId) ?? (0, $6BmjZ.findAgentManagedExtension)(editorView.state);
    return found ? (0, $gOFRe.getExecutionLifecycleState)(found.node) : 'no-body-executing';
};
const $b204c96beb2c5d9f$var$isLatestExecutionRequest = ({ editorView: editorView, localId: localId, requestId: requestId })=>{
    const pluginState = (0, $aZxYK.pluginKey).getState(editorView.state);
    if (!pluginState) return true;
    return pluginState.executionLifecycleByLocalId[localId]?.requestId === requestId;
};
const $b204c96beb2c5d9f$export$8235b51c7030883b = async ({ aimoId: aimoId, editorView: editorView, localId: localId })=>{
    const requestId = $b204c96beb2c5d9f$var$createExecutionRequestId();
    const lifecycleState = $b204c96beb2c5d9f$var$getCurrentLifecycleState(editorView, localId);
    $b204c96beb2c5d9f$var$startExecution({
        editorView: editorView,
        lifecycleState: lifecycleState,
        localId: localId,
        requestId: requestId
    });
    try {
        const executionResult = await (0, $bePXf.executeAiManagedObject)(aimoId);
        if (editorView.isDestroyed || !localId) return null;
        if (!$b204c96beb2c5d9f$var$isLatestExecutionRequest({
            editorView: editorView,
            localId: localId,
            requestId: requestId
        })) return null;
        const executeTr = editorView.state.tr;
        (0, $eLkLF.replaceNodeBodyContent)(editorView.state, executeTr, executionResult.output.blockContent, localId);
        const cacheAiManagedObjectMeta = (0, $iEdEF.getCacheAiManagedObjectMeta)(executionResult.aiManagedObject, localId);
        const finishExecutionMeta = $b204c96beb2c5d9f$var$getFinishExecutionMeta({
            localId: localId,
            requestId: requestId
        });
        (0, $eLkLF.setAgentManagedExtensionMeta)(executeTr, finishExecutionMeta ? [
            cacheAiManagedObjectMeta,
            finishExecutionMeta
        ] : cacheAiManagedObjectMeta);
        editorView.dispatch(executeTr);
        return executionResult.aiManagedObject;
    } catch  {
        if (editorView.isDestroyed) return null;
        if (localId && $b204c96beb2c5d9f$var$isLatestExecutionRequest({
            editorView: editorView,
            localId: localId,
            requestId: requestId
        })) {
            const failureTr = editorView.state.tr;
            (0, $eLkLF.setAgentManagedExtensionMeta)(failureTr, [
                {
                    localId: localId,
                    requestId: requestId,
                    type: 'FAIL_EXECUTION'
                },
                {
                    localId: localId,
                    requestId: requestId,
                    type: 'FINISH_EXECUTION'
                }
            ]);
            editorView.dispatch(failureTr);
        }
        return null;
    }
};








const $57a9c3532e5a1b86$var$NO_SELECT_ATTR_SELECTOR = '[data-no-extension-select]';
const $57a9c3532e5a1b86$export$5da0612d8cab41d7 = 'agent-managed-extension';
const $57a9c3532e5a1b86$export$b9bf3748f3ac8521 = 'bodiedExtension-content-dom-wrapper';
const $57a9c3532e5a1b86$export$4e60d7c587e4fea7 = 'data-agent-managed-extension-content-dom';
const $57a9c3532e5a1b86$export$79fd7963490e64c = (doc, node, options = {})=>{
    const root = doc.createElement('div');
    root.classList.add($57a9c3532e5a1b86$export$5da0612d8cab41d7);
    root.setAttribute('data-node-type', 'bodied-extension');
    root.setAttribute('data-extension-type', node.attrs.extensionType);
    root.setAttribute('data-extension-key', node.attrs.extensionKey);
    root.setAttribute('data-local-id', node.attrs.localId ?? '');
    const mountPoint = doc.createElement('div');
    mountPoint.classList.add('extension-container');
    root.appendChild(mountPoint);
    if (!options.includeContentDOM) return {
        root: root,
        mountPoint: mountPoint
    };
    const contentDOM = doc.createElement('div');
    contentDOM.classList.add($57a9c3532e5a1b86$export$b9bf3748f3ac8521);
    contentDOM.setAttribute($57a9c3532e5a1b86$export$4e60d7c587e4fea7, 'true');
    // ProseMirror expects contentDOM to start inside the node view DOM. The
    // React view moves this same node into its body wrapper on first layout so
    // editor-managed body content sits inside the custom chrome.
    root.appendChild(contentDOM);
    return {
        root: root,
        mountPoint: mountPoint,
        contentDOM: contentDOM
    };
};
const $57a9c3532e5a1b86$export$1f8619c80fdc0e01 = (view, dom, getPos)=>{
    const handle = (e)=>{
        const pos = getPos();
        if (typeof pos !== 'number') return;
        const target = e.target;
        if (target?.closest(`${$57a9c3532e5a1b86$var$NO_SELECT_ATTR_SELECTOR}, [${$57a9c3532e5a1b86$export$4e60d7c587e4fea7}]`)) return;
        e.preventDefault();
        view.dispatch(view.state.tr.setSelection((0, $ks2lK.NodeSelection).create(view.state.doc, pos)));
    };
    return (0, $fFa3V.bind)(dom, {
        type: 'mousedown',
        listener: handle
    });
};


const $9e8dc115378f91b1$var$buildPortalKey = (node)=>`agent-managed-extension-${node.attrs.localId ?? Math.random().toString(36)}`;
/**
 * Registry of active agent-managed-extension node views.
 * Used by the plugin's `view.update()` to trigger re-renders when plugin
 * state changes (e.g. config open/close), since ProseMirror only calls
 * `NodeView.update()` when the underlying node itself changes.
 */ const $9e8dc115378f91b1$var$activeNodeViews = new Set();
const $9e8dc115378f91b1$export$924a307d8482cd9d = ()=>{
    for (const nodeView of $9e8dc115378f91b1$var$activeNodeViews)nodeView.renderReact();
};
const $9e8dc115378f91b1$export$85c8b8e715aadfd8 = (view)=>{
    for (const nodeView of $9e8dc115378f91b1$var$activeNodeViews)if (nodeView.belongsToEditorView(view)) nodeView.renderReact();
};
const $9e8dc115378f91b1$export$db77a51a8cbfff28 = (localId, selected)=>{
    for (const nv of $9e8dc115378f91b1$var$activeNodeViews)if (nv.getLocalId() === localId) {
        nv.setSelected(selected);
        nv.renderReact();
        return true;
    }
    return false;
};
/**
 * Custom nodeView for bespoke agent-managed chrome. It exposes `contentDOM`,
 * matching regular bodied extensions so the body ADF is editable whenever the
 * host editor itself is editable.
 */ class $9e8dc115378f91b1$var$AgentManagedExtensionNodeView {
    getLocalId() {
        return this.node.attrs.localId ?? '';
    }
    belongsToEditorView(view) {
        return this.view === view;
    }
    setSelected(selected) {
        this.selected = selected;
    }
    update(node) {
        if (node.type !== this.node.type) return false;
        // Refuse to re-use this nodeView for a non-agent-managed block;
        // ProseMirror will then ask the factory for a fresh nodeView.
        if (!(0, $6BmjZ.isAgentManagedExtension)(node)) return false;
        // Force a remount when the localId changes — prevents stale
        // React state from leaking across instances.
        if (node.attrs.localId !== this.node.attrs.localId) return false;
        if (node === this.node) return true;
        this.dom.setAttribute('data-local-id', node.attrs.localId ?? '');
        this.node = node;
        this.renderReact();
        return true;
    }
    selectNode() {
        this.selected = true;
        this.renderReact();
    }
    deselectNode() {
        this.selected = false;
        this.renderReact();
    }
    destroy() {
        $9e8dc115378f91b1$var$activeNodeViews.delete(this);
        this.detachBodyClick();
        this.nodeViewPortalProviderAPI.remove(this.portalKey);
    }
    stopEvent(event) {
        // Let ProseMirror own selected-node copy/cut so it serializes the extension ADF
        // instead of browser DOM, which includes visual chrome like the block label.
        if (event.type === 'copy' || event.type === 'cut') return false;
        if (this.contentDOM?.contains(event.target)) return false;
        return true;
    }
    ignoreMutation(mutation) {
        if (mutation.type === 'selection') return false;
        return !this.contentDOM?.contains(mutation.target);
    }
    constructor(node, view, getPos, args){
        this.dom = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.view = void 0;
        this.nodeViewPortalProviderAPI = void 0;
        this.mountPoint = void 0;
        this.portalKey = void 0;
        this.detachBodyClick = void 0;
        this.selected = false;
        this.renderReact = ()=>{
            const localId = this.getLocalId();
            const pluginState = (0, $aZxYK.pluginKey).getState(this.view.state);
            const aimoId = (0, $6BmjZ.getNodeAiManagedObject)(this.node.attrs)?.id;
            const transientLifecycleState = localId ? pluginState?.executionLifecycleByLocalId?.[localId]?.state : undefined;
            const lifecycleState = (0, $gOFRe.getAgentManagedBlockLifecycleState)({
                hasLocalExecutionError: Boolean(localId && pluginState?.executionErrorLocalIds?.[localId]),
                node: this.node,
                transientLifecycleState: transientLifecycleState
            });
            const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2jMw7.AgentManagedExtensionView), {
                contentDOM: this.contentDOM,
                hasGeneratedBodyContent: (0, $gOFRe.hasGeneratedBodyContent)(this.node),
                isSelected: this.selected,
                lifecycleState: lifecycleState,
                onRetry: this.view.editable && aimoId ? ()=>{
                    (0, $b204c96beb2c5d9f$export$8235b51c7030883b)({
                        aimoId: aimoId,
                        editorView: this.view,
                        localId: localId || undefined
                    });
                } : undefined,
                readOnly: !this.view.editable
            });
            this.nodeViewPortalProviderAPI.render(()=>element, this.mountPoint, this.portalKey);
        };
        this.node = node;
        this.view = view;
        this.nodeViewPortalProviderAPI = args.nodeViewPortalProviderAPI;
        const { root: root, mountPoint: mountPoint, contentDOM: contentDOM } = (0, $57a9c3532e5a1b86$export$79fd7963490e64c)(view.dom.ownerDocument, node, {
            includeContentDOM: true
        });
        this.dom = root;
        this.mountPoint = mountPoint;
        this.contentDOM = contentDOM;
        this.portalKey = $9e8dc115378f91b1$var$buildPortalKey(node);
        this.detachBodyClick = (0, $57a9c3532e5a1b86$export$1f8619c80fdc0e01)(view, this.dom, getPos);
        $9e8dc115378f91b1$var$activeNodeViews.add(this);
        this.renderReact();
    }
}
const $9e8dc115378f91b1$export$981fde09308f7c44 = (args)=>(node, view, getPos)=>{
        // Only handle agent-managed bodied extensions; let the framework's
        // default `bodiedExtension` nodeView render every other one.
        if (!(0, $6BmjZ.isAgentManagedExtension)(node)) return null;
        return new $9e8dc115378f91b1$var$AgentManagedExtensionNodeView(node, view, getPos, args);
    };









var $ip1Wz = parcelRequire("ip1Wz");

const $f404d63466c1e517$var$MAX_AUTO_OPEN_ATTEMPTS = 5;
const $f404d63466c1e517$var$getPendingAutoOpenLocalId = (editorView)=>(0, $aZxYK.pluginKey).getState(editorView.state)?.pendingAutoOpenLocalId;
const $f404d63466c1e517$var$hasRenderedBlockDom = (editorView, localId)=>{
    const found = (0, $6BmjZ.findAgentManagedExtensionByLocalId)(editorView.state, localId);
    return found?.node.attrs.localId === localId && editorView.nodeDOM(found.pos) instanceof HTMLElement;
};
const $f404d63466c1e517$var$openConfigForBlock = (editorView, localId)=>{
    editorView.dispatch((0, $ip1Wz.setMeta)(editorView.state.tr, {
        localId: localId,
        type: 'OPEN_CONFIG'
    }));
};
const $f404d63466c1e517$export$961bee066c4d0379 = (editorView)=>{
    const handledLocalIds = new Set();
    let scheduledLocalId;
    let animationFrameId;
    let remainingAttempts = 0;
    const clearScheduledOpen = ()=>{
        if (animationFrameId !== undefined) {
            cancelAnimationFrame(animationFrameId);
            animationFrameId = undefined;
        }
        scheduledLocalId = undefined;
        remainingAttempts = 0;
    };
    const getActiveScheduledLocalId = ()=>{
        if (!scheduledLocalId || handledLocalIds.has(scheduledLocalId)) return undefined;
        const pendingLocalId = $f404d63466c1e517$var$getPendingAutoOpenLocalId(editorView);
        return pendingLocalId === scheduledLocalId ? scheduledLocalId : undefined;
    };
    const attemptOpenConfig = ()=>{
        animationFrameId = undefined;
        const localId = getActiveScheduledLocalId();
        if (!localId) {
            clearScheduledOpen();
            return;
        }
        if ($f404d63466c1e517$var$hasRenderedBlockDom(editorView, localId)) {
            handledLocalIds.add(localId);
            $f404d63466c1e517$var$openConfigForBlock(editorView, localId);
            clearScheduledOpen();
            return;
        }
        remainingAttempts -= 1;
        if (remainingAttempts <= 0) {
            clearScheduledOpen();
            return;
        }
        animationFrameId = requestAnimationFrame(attemptOpenConfig);
    };
    const scheduleOpenConfig = (pendingLocalId)=>{
        if (scheduledLocalId === pendingLocalId && animationFrameId !== undefined) return;
        scheduledLocalId = pendingLocalId;
        remainingAttempts = $f404d63466c1e517$var$MAX_AUTO_OPEN_ATTEMPTS;
        animationFrameId = requestAnimationFrame(attemptOpenConfig);
    };
    return {
        destroy () {
            clearScheduledOpen();
        },
        update () {
            const pendingLocalId = $f404d63466c1e517$var$getPendingAutoOpenLocalId(editorView);
            if (!pendingLocalId || handledLocalIds.has(pendingLocalId)) return;
            scheduleOpenConfig(pendingLocalId);
        }
    };
};



var $3Ter7 = parcelRequire("3Ter7");





var $hTKp4 = parcelRequire("hTKp4");

function $7f0a7e5b79ab18a1$export$895a298bdabf4d43() {
    try {
        const { origin: origin, pathname: pathname } = window.location;
        const isLocal = origin.includes('localhost') || origin.includes('127.0.0.1') || origin.includes('0.0.0.0');
        if (isLocal) {
            const baseUrlMeta = (0, $hTKp4.getDocument)()?.querySelector('meta[name="ajs-base-url"]');
            if (baseUrlMeta?.content) return baseUrlMeta.content + pathname;
            const canonical = (0, $hTKp4.getDocument)()?.querySelector('link[rel="canonical"]');
            if (canonical?.href) return canonical.href;
            const siteUrl = window.__SITE_URL__;
            if (siteUrl) return siteUrl + pathname;
        }
        return origin + pathname;
    } catch  {
        return undefined;
    }
}



var $33wgy = parcelRequire("33wgy");


var $5SAOw = parcelRequire("5SAOw");













const $3b4466c560930b74$export$aeee8a234ebb282 = 'aiManagedObjectCopyPaste';


const $d046c43eedccc59e$var$isRecord = (value)=>Boolean(value) && typeof value === 'object' && !Array.isArray(value);
const $d046c43eedccc59e$var$getStringValue = (value)=>typeof value === 'string' && value.length > 0 ? value : undefined;
const $d046c43eedccc59e$export$957229695d10ea4a = (attrs)=>$d046c43eedccc59e$var$getStringValue(attrs?.localId);
const $d046c43eedccc59e$var$parseCopyPasteMarker = (value)=>{
    const rawValue = $d046c43eedccc59e$var$isRecord(value) && 'value' in value ? value.value : value;
    if (typeof rawValue !== 'string') return undefined;
    try {
        const parsed = JSON.parse(rawValue);
        if (!$d046c43eedccc59e$var$isRecord(parsed)) return undefined;
        const operation = parsed.operation;
        const sourceAiManagedObjectId = parsed.sourceAiManagedObjectId;
        if (operation !== 'copy' && operation !== 'cut' || typeof sourceAiManagedObjectId !== 'string') return undefined;
        const marker = {
            operation: operation,
            sourceAiManagedObjectId: sourceAiManagedObjectId
        };
        if (typeof parsed.sourcePageUrl === 'string') marker.sourcePageUrl = parsed.sourcePageUrl;
        if (typeof parsed.sourceReferenceObjectAri === 'string') marker.sourceReferenceObjectAri = parsed.sourceReferenceObjectAri;
        return marker;
    } catch  {
        return undefined;
    }
};
const $d046c43eedccc59e$export$3480fc2ad376a68c = (attrs)=>$d046c43eedccc59e$var$parseCopyPasteMarker(attrs?.parameters?.macroParams?.[0, $3b4466c560930b74$export$aeee8a234ebb282]);
const $d046c43eedccc59e$export$c0cb508f5f9e8218 = (macroParams = {})=>{
    const { [(0, $3b4466c560930b74$export$aeee8a234ebb282)]: _marker, ...rest } = macroParams;
    return rest;
};
const $d046c43eedccc59e$export$b90593cf7b1dd29d = ({ attrs: attrs, clearAiManagedObject: clearAiManagedObject, marker: marker, regenerateLocalId: regenerateLocalId })=>{
    const parameters = attrs.parameters ?? {};
    const macroParams = {
        ...parameters.macroParams,
        [(0, $3b4466c560930b74$export$aeee8a234ebb282)]: {
            value: JSON.stringify(marker)
        }
    };
    if (clearAiManagedObject) delete macroParams.aiManagedObject;
    return {
        ...attrs,
        localId: regenerateLocalId ? (0, $6BmjZ.generateLocalId)() : attrs.localId,
        parameters: {
            ...parameters,
            macroParams: macroParams
        }
    };
};
const $d046c43eedccc59e$export$c285bda75d8ebbf5 = ({ attrs: attrs, clearAiManagedObject: clearAiManagedObject, localId: localId })=>{
    const parameters = attrs.parameters ?? {};
    const macroParams = $d046c43eedccc59e$export$c0cb508f5f9e8218(parameters.macroParams);
    if (clearAiManagedObject) delete macroParams.aiManagedObject;
    return {
        ...attrs,
        localId: localId,
        parameters: {
            ...parameters,
            macroParams: macroParams
        }
    };
};
const $d046c43eedccc59e$export$74b8d6deba872536 = ({ aimo: aimo, attrs: attrs })=>{
    const parameters = attrs.parameters ?? {};
    const macroParams = $d046c43eedccc59e$export$c0cb508f5f9e8218(parameters.macroParams);
    return {
        ...attrs,
        parameters: {
            ...parameters,
            macroParams: {
                ...macroParams,
                aiManagedObject: {
                    value: JSON.stringify((0, $eLkLF.getAiManagedObjectParameter)(aimo))
                }
            }
        }
    };
};


const $5560a3dd0f824e8f$export$4296014ca990d071 = (slice, node)=>{
    const attrs = node.attrs;
    const localId = (0, $d046c43eedccc59e$export$957229695d10ea4a)(attrs);
    if (!localId) return node;
    const firstChildAttrs = slice.content.firstChild?.attrs;
    const lastChildAttrs = slice.content.lastChild?.attrs;
    const isFirstChild = (0, $d046c43eedccc59e$export$957229695d10ea4a)(firstChildAttrs) === localId;
    const isLastChild = (0, $d046c43eedccc59e$export$957229695d10ea4a)(lastChildAttrs) === localId;
    // Open slices mean ProseMirror only copied part of the node. Keeping identity on that
    // fragment could make a partial body look like a complete managed block.
    return isFirstChild && slice.openStart > 0 || isLastChild && slice.openEnd > 0 ? node.content : node;
};
const $5560a3dd0f824e8f$export$dd0d390420a2370a = (slice)=>{
    const found = [];
    slice.content.descendants((node)=>{
        if (!(0, $6BmjZ.isAgentManagedExtension)(node)) return true;
        const completeNode = $5560a3dd0f824e8f$export$4296014ca990d071(slice, node);
        if (completeNode !== node) return false;
        const attrs = node.attrs;
        const localId = (0, $d046c43eedccc59e$export$957229695d10ea4a)(attrs);
        if (localId) {
            const aiManagedObjectId = (0, $6BmjZ.getNodeAiManagedObject)(attrs)?.id;
            found.push({
                ...aiManagedObjectId ? {
                    aiManagedObjectId: aiManagedObjectId
                } : {},
                localId: localId
            });
        }
        return false;
    });
    return found;
};
const $5560a3dd0f824e8f$export$b7a4a6ee1e5b49e7 = (state)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $ks2lK.NodeSelection)) || !(0, $6BmjZ.isAgentManagedExtension)(selection.node)) return undefined;
    return new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(selection.node), 0, 0);
};
const $5560a3dd0f824e8f$var$collectAgentManagedNodes = (state)=>{
    const found = new Map();
    state.doc.descendants((node)=>{
        if (!(0, $6BmjZ.isAgentManagedExtension)(node)) return true;
        const attrs = node.attrs;
        const localId = (0, $d046c43eedccc59e$export$957229695d10ea4a)(attrs);
        if (localId) {
            const aiManagedObjectId = (0, $6BmjZ.getNodeAiManagedObject)(attrs)?.id;
            found.set(localId, {
                ...aiManagedObjectId ? {
                    aiManagedObjectId: aiManagedObjectId
                } : {},
                localId: localId
            });
        }
        return false;
    });
    return found;
};
const $5560a3dd0f824e8f$export$92f9ab68b0f810 = (oldState, newState)=>{
    const oldNodes = $5560a3dd0f824e8f$var$collectAgentManagedNodes(oldState);
    const newNodes = $5560a3dd0f824e8f$var$collectAgentManagedNodes(newState);
    return {
        added: [
            ...newNodes.values()
        ].filter(({ localId: localId })=>!oldNodes.has(localId)),
        removed: [
            ...oldNodes.values()
        ].filter(({ localId: localId })=>!newNodes.has(localId))
    };
};


















const $479e257fc01c59d7$var$CONFLUENCE_CONTENT_ARI_PATTERN = /^ari:cloud:confluence:([^:]+):(blogpost|page)\/([^/]+)$/;
const $479e257fc01c59d7$var$isSupportedContentType = (contentType)=>contentType === 'blogpost' || contentType === 'page';
const $479e257fc01c59d7$export$4d80ff8879a0429d = ({ cloudId: cloudId, contentType: contentType = 'page', contextIdentifierProvider: contextIdentifierProvider, objectId: objectId = contextIdentifierProvider?.objectId, product: product = contextIdentifierProvider?.product })=>{
    if (!objectId) return undefined;
    const match = $479e257fc01c59d7$var$CONFLUENCE_CONTENT_ARI_PATTERN.exec(objectId);
    if (!match) {
        if (!cloudId || product !== 'confluence' || !$479e257fc01c59d7$var$isSupportedContentType(contentType)) return undefined;
        return {
            cloudId: cloudId,
            referenceObjectAri: `ari:cloud:confluence:${cloudId}:${contentType}/${objectId}`
        };
    }
    return {
        cloudId: match[1],
        referenceObjectAri: objectId
    };
};





const $dcdfd2fe816fe891$export$b5a4ee270806b39a = ({ cloudId: cloudId, contentType: contentType, getContextIdentifierProvider: getContextIdentifierProvider })=>{
    const contextIdentifierProvider = getContextIdentifierProvider?.();
    return (0, $479e257fc01c59d7$export$4d80ff8879a0429d)({
        cloudId: cloudId,
        contentType: contentType,
        contextIdentifierProvider: contextIdentifierProvider,
        product: contextIdentifierProvider?.product
    });
};
const $dcdfd2fe816fe891$export$4ea142194dd56f81 = (args)=>$dcdfd2fe816fe891$export$b5a4ee270806b39a(args)?.referenceObjectAri;
const $dcdfd2fe816fe891$export$7830dd0e613d59d9 = async (editorView, marker, localId)=>{
    if (marker.sourceReferenceObjectAri) return marker.sourceReferenceObjectAri;
    const sourceAimo = await (0, $33wgy.getAiManagedObjectWithCache)({
        aimoId: marker.sourceAiManagedObjectId,
        editorView: editorView,
        localId: localId
    });
    return sourceAimo?.referenceObjectAri;
};


const $07bf2d44005b7b22$var$toConfigCreateInput = (config)=>({
        desiredUpdateFrequency: config.desiredUpdateFrequency ?? undefined,
        goal: config.goal ?? undefined,
        goalOperations: config.goalOperations ?? undefined,
        prompt: config.prompt ?? null,
        sources: config.sources?.map((source)=>({
                app: source.app,
                url: source.url
            })) ?? undefined
    });
const $07bf2d44005b7b22$var$rebindCurrentPageSources = ({ config: config, destinationPageUrl: destinationPageUrl, sourcePageUrl: sourcePageUrl })=>{
    if (!sourcePageUrl || !destinationPageUrl || sourcePageUrl === destinationPageUrl) return {
        config: config,
        didRebind: false
    };
    // Current-page sources should follow the destination page when a block is copied.
    let didRebind = false;
    const sources = config.sources?.map((source)=>{
        if (source.url !== sourcePageUrl) return source;
        didRebind = true;
        return {
            ...source,
            app: 'CONFLUENCE',
            url: destinationPageUrl
        };
    });
    return {
        config: didRebind ? {
            ...config,
            sources: sources
        } : config,
        didRebind: didRebind
    };
};
const $07bf2d44005b7b22$var$setCopiedAiManagedObject = (editorView, localId, aimo)=>{
    const found = (0, $6BmjZ.findAgentManagedExtensionByLocalId)(editorView.state, localId);
    if (!found) return;
    const tr = editorView.state.tr;
    tr.setNodeMarkup(found.pos, undefined, {
        ...found.node.attrs,
        ...(0, $d046c43eedccc59e$export$74b8d6deba872536)({
            aimo: aimo,
            attrs: found.node.attrs
        })
    });
    (0, $eLkLF.setAgentManagedExtensionMeta)(tr, (0, $iEdEF.getCacheAiManagedObjectMeta)(aimo, localId));
    editorView.dispatch(tr);
};
const $07bf2d44005b7b22$var$createCopiedAiManagedObject = async ({ args: args, editorView: editorView, localId: localId, marker: marker })=>{
    const referenceObject = (0, $dcdfd2fe816fe891$export$b5a4ee270806b39a)(args);
    if (!referenceObject) return null;
    const sourceAimo = await (0, $33wgy.getAiManagedObjectWithCache)({
        aimoId: marker.sourceAiManagedObjectId,
        editorView: editorView,
        localId: localId
    });
    if (!sourceAimo) return null;
    const { config: config, didRebind: didRebind } = $07bf2d44005b7b22$var$rebindCurrentPageSources({
        config: $07bf2d44005b7b22$var$toConfigCreateInput(sourceAimo.config),
        destinationPageUrl: (0, $7f0a7e5b79ab18a1$export$895a298bdabf4d43)(),
        sourcePageUrl: marker.sourcePageUrl
    });
    const aimo = await (0, $33wgy.createAiManagedObjectWithCache)(editorView, {
        cloudId: referenceObject.cloudId,
        config: config,
        referenceObjectAri: referenceObject.referenceObjectAri,
        referenceProduct: 'CONFLUENCE',
        status: 'ACTIVE',
        type: 'BLOCK'
    }, localId);
    return {
        aimo: aimo,
        shouldExecute: marker.operation === 'cut' || didRebind
    };
};
const $07bf2d44005b7b22$export$dee490768d86cce8 = async ({ args: args, editorView: editorView, localId: localId, marker: marker, pendingArchivedRemovalsByLocalId: pendingArchivedRemovalsByLocalId })=>{
    const currentReferenceObjectAri = (0, $dcdfd2fe816fe891$export$4ea142194dd56f81)(args);
    const sourceReferenceObjectAri = await (0, $dcdfd2fe816fe891$export$7830dd0e613d59d9)(editorView, marker, localId);
    const isSameReferenceObject = Boolean(currentReferenceObjectAri) && currentReferenceObjectAri === sourceReferenceObjectAri;
    const isTrackedSameEditorCut = marker.operation === 'cut' && pendingArchivedRemovalsByLocalId.has(localId);
    // Same-reference cuts preserve the existing object id. We wait for any archive request
    // started by the removal transaction so reactivation cannot race the backend state change.
    if (marker.operation === 'cut' && (isTrackedSameEditorCut || isSameReferenceObject)) {
        const pendingRemoval = pendingArchivedRemovalsByLocalId.get(localId);
        await pendingRemoval?.archivePromise;
        const latestPendingRemoval = pendingArchivedRemovalsByLocalId.get(localId);
        if (latestPendingRemoval?.archiveFailed) return;
        await (0, $33wgy.reactivateAiManagedObjectWithCache)(editorView, marker.sourceAiManagedObjectId, localId);
        pendingArchivedRemovalsByLocalId.delete(localId);
        return;
    }
    const created = await $07bf2d44005b7b22$var$createCopiedAiManagedObject({
        args: args,
        editorView: editorView,
        localId: localId,
        marker: marker
    });
    if (!created) return;
    if (marker.operation === 'cut') pendingArchivedRemovalsByLocalId.delete(localId);
    $07bf2d44005b7b22$var$setCopiedAiManagedObject(editorView, localId, created.aimo);
    // A cut into a different page, or a copy whose current-page source was rebound,
    // should refresh immediately so the visible block matches its new context.
    if (created.shouldExecute) await (0, $b204c96beb2c5d9f$export$8235b51c7030883b)({
        aimoId: created.aimo.id,
        editorView: editorView,
        localId: localId
    });
};
const $07bf2d44005b7b22$export$e6e56a9d778d0808 = async ({ editorView: editorView, localId: localId, pendingArchivedRemovalsByLocalId: pendingArchivedRemovalsByLocalId })=>{
    const pendingRemoval = pendingArchivedRemovalsByLocalId.get(localId);
    if (!pendingRemoval) return;
    const found = (0, $6BmjZ.findAgentManagedExtensionByLocalId)(editorView.state, localId);
    const attrs = found?.node.attrs;
    const currentAimo = (0, $6BmjZ.getNodeAiManagedObject)(attrs);
    if (!found || currentAimo?.id !== pendingRemoval.aiManagedObjectId) return;
    // Undo can restore a cut block after the backend archive was requested; only
    // reactivate after a successful archive so backend lifecycle state stays aligned.
    await pendingRemoval.archivePromise;
    const latestPendingRemoval = pendingArchivedRemovalsByLocalId.get(localId);
    if (latestPendingRemoval?.archiveFailed) return;
    pendingArchivedRemovalsByLocalId.delete(localId);
    await (0, $33wgy.reactivateAiManagedObjectWithCache)(editorView, pendingRemoval.aiManagedObjectId, localId);
};



const $1fc17467ee65648b$export$2c63de875cb788c8 = (args)=>{
    let clipboardOperation;
    let selectedAgentManagedNodeSlice;
    let clipboardContextId = 0;
    const pendingCutRemovalByLocalId = new Map();
    const pendingArchivedRemovalsByLocalId = new Map();
    const pendingPasteByLocalId = new Map();
    const readyArchiveLocalIds = new Set();
    const readyPasteLocalIds = new Set();
    const readyReactivationLocalIds = new Set();
    const markClipboardOperation = (operation, view)=>{
        clipboardContextId += 1;
        const currentClipboardContextId = clipboardContextId;
        clipboardOperation = operation;
        selectedAgentManagedNodeSlice = (0, $5560a3dd0f824e8f$export$b7a4a6ee1e5b49e7)(view.state);
        // Keep transformCopied free of shared-state writes. ProseMirror serializes
        // clipboard content synchronously after the DOM event, then this context expires.
        queueMicrotask(()=>{
            if (clipboardContextId === currentClipboardContextId) {
                clipboardOperation = undefined;
                selectedAgentManagedNodeSlice = undefined;
            }
        });
        return selectedAgentManagedNodeSlice;
    };
    return {
        appendTransaction: (transactions, oldState, newState)=>{
            const hasLocalDocumentChange = transactions.some((tr)=>tr.docChanged && !tr.getMeta('isRemote') && !tr.getMeta('replaceDocument'));
            if (!hasLocalDocumentChange) return null;
            const { added: added, removed: removed } = (0, $5560a3dd0f824e8f$export$92f9ab68b0f810)(oldState, newState);
            removed.forEach(({ aiManagedObjectId: aiManagedObjectId, localId: localId })=>{
                const pendingCutRemoval = pendingCutRemovalByLocalId.get(localId);
                const pendingRemoval = pendingCutRemoval ?? (aiManagedObjectId ? {
                    aiManagedObjectId: aiManagedObjectId
                } : undefined);
                if (!pendingRemoval) return;
                // Cut intent is recorded by the DOM event before serialization, while
                // delete only becomes visible here. Queue the archive until the plugin view runs so
                // the cache can be updated through the live EditorView.
                pendingCutRemovalByLocalId.delete(localId);
                pendingArchivedRemovalsByLocalId.set(localId, pendingRemoval);
                readyArchiveLocalIds.add(localId);
            });
            added.forEach(({ localId: localId })=>{
                if (pendingPasteByLocalId.has(localId)) {
                    readyPasteLocalIds.add(localId);
                    return;
                }
                if (pendingArchivedRemovalsByLocalId.has(localId)) readyReactivationLocalIds.add(localId);
            });
            return null;
        },
        pendingArchivedRemovalsByLocalId: pendingArchivedRemovalsByLocalId,
        pendingPasteByLocalId: pendingPasteByLocalId,
        props: {
            handleDOMEvents: {
                copy: (view)=>{
                    pendingCutRemovalByLocalId.clear();
                    markClipboardOperation('copy', view);
                    return false;
                },
                cut: (view)=>{
                    pendingCutRemovalByLocalId.clear();
                    const selectedSlice = markClipboardOperation('cut', view);
                    const cutSlice = selectedSlice ?? view.state.selection.content();
                    // transformCopied may run multiple times for one cut. Record the cut
                    // identities once, before serialization, and reconcile them after removal.
                    (0, $5560a3dd0f824e8f$export$dd0d390420a2370a)(cutSlice).forEach(({ aiManagedObjectId: aiManagedObjectId, localId: localId })=>{
                        if (aiManagedObjectId) pendingCutRemovalByLocalId.set(localId, {
                            aiManagedObjectId: aiManagedObjectId
                        });
                    });
                    return false;
                }
            },
            // The DOM event tells us whether ProseMirror is serializing for copy or cut;
            // transformCopied alone does not carry that intent.
            transformCopied: (slice)=>{
                const operation = clipboardOperation;
                const copiedSlice = selectedAgentManagedNodeSlice ?? slice;
                if (!operation) return slice;
                const sourcePageUrl = (0, $7f0a7e5b79ab18a1$export$895a298bdabf4d43)();
                return (0, $3Ter7.mapSlice)(copiedSlice, (node)=>{
                    if (!(0, $6BmjZ.isAgentManagedExtension)(node)) return node;
                    const completeNode = (0, $5560a3dd0f824e8f$export$4296014ca990d071)(copiedSlice, node);
                    if (completeNode !== node) return completeNode;
                    const attrs = node.attrs;
                    const aiManagedObject = (0, $6BmjZ.getNodeAiManagedObject)(attrs);
                    if (!aiManagedObject?.id) return node;
                    const marker = {
                        operation: operation,
                        sourceAiManagedObjectId: aiManagedObject.id
                    };
                    if (sourcePageUrl) marker.sourcePageUrl = sourcePageUrl;
                    const sourceReferenceObjectAri = (0, $dcdfd2fe816fe891$export$4ea142194dd56f81)(args);
                    if (sourceReferenceObjectAri) marker.sourceReferenceObjectAri = sourceReferenceObjectAri;
                    // The marker exists only on the clipboard slice. Pasted content strips it and
                    // queues async identity work in plugin state instead of storing transient data.
                    return node.type.create((0, $d046c43eedccc59e$export$b90593cf7b1dd29d)({
                        attrs: attrs,
                        clearAiManagedObject: operation === 'copy',
                        marker: marker,
                        regenerateLocalId: operation === 'copy'
                    }), node.content, node.marks);
                });
            },
            // Paste strips transient clipboard metadata and queues follow-up AIMO work
            // until appendTransaction confirms which localId actually entered the document.
            transformPasted: (slice)=>{
                const currentReferenceObjectAri = (0, $dcdfd2fe816fe891$export$4ea142194dd56f81)(args);
                return (0, $3Ter7.mapSlice)(slice, (node)=>{
                    if (!(0, $6BmjZ.isAgentManagedExtension)(node)) return node;
                    const completeNode = (0, $5560a3dd0f824e8f$export$4296014ca990d071)(slice, node);
                    if (completeNode !== node) return completeNode;
                    const attrs = node.attrs;
                    const aiManagedObject = (0, $6BmjZ.getNodeAiManagedObject)(attrs);
                    const marker = (0, $d046c43eedccc59e$export$3480fc2ad376a68c)(attrs) ?? (aiManagedObject?.id ? {
                        operation: 'copy',
                        sourceAiManagedObjectId: aiManagedObject.id
                    } : undefined);
                    if (!marker) return node;
                    const preserveCutIdentity = marker.operation === 'cut' && (!marker.sourceReferenceObjectAri || Boolean(currentReferenceObjectAri) && currentReferenceObjectAri === marker.sourceReferenceObjectAri);
                    const nextLocalId = preserveCutIdentity ? (0, $d046c43eedccc59e$export$957229695d10ea4a)(attrs) ?? (0, $6BmjZ.generateLocalId)() : (0, $6BmjZ.generateLocalId)();
                    pendingPasteByLocalId.set(nextLocalId, marker);
                    return node.type.create((0, $d046c43eedccc59e$export$c285bda75d8ebbf5)({
                        attrs: attrs,
                        clearAiManagedObject: !preserveCutIdentity,
                        localId: nextLocalId
                    }), node.content, node.marks);
                });
            }
        },
        readyArchiveLocalIds: readyArchiveLocalIds,
        readyPasteLocalIds: readyPasteLocalIds,
        readyReactivationLocalIds: readyReactivationLocalIds
    };
};
const $1fc17467ee65648b$export$ab31f6f79ac952df = (editorView, args)=>{
    const inFlightLocalIds = new Set();
    const processReadyArchives = (view)=>{
        args.readyArchiveLocalIds.forEach((localId)=>{
            const pendingRemoval = args.pendingArchivedRemovalsByLocalId.get(localId);
            if (!pendingRemoval || pendingRemoval.archivePromise) return;
            // Archive after ProseMirror commits the removal, then update the cached AIMO
            // status for toolbar and undo flows that still know this localId. Paste and
            // undo processors await this promise and short-circuit if archiving failed.
            args.readyArchiveLocalIds.delete(localId);
            const archivePromise = (0, $33wgy.archiveAiManagedObjectWithCache)(view, pendingRemoval.aiManagedObjectId, localId).catch((error)=>{
                const latestPendingRemoval = args.pendingArchivedRemovalsByLocalId.get(localId) ?? pendingRemoval;
                args.pendingArchivedRemovalsByLocalId.set(localId, {
                    ...latestPendingRemoval,
                    archiveError: error,
                    archiveFailed: true
                });
            });
            args.pendingArchivedRemovalsByLocalId.set(localId, {
                ...pendingRemoval,
                archivePromise: archivePromise
            });
        });
    };
    const processReadyPastes = (view)=>{
        args.readyPasteLocalIds.forEach((localId)=>{
            const marker = args.pendingPasteByLocalId.get(localId);
            if (!marker || inFlightLocalIds.has(localId)) return;
            inFlightLocalIds.add(localId);
            args.readyPasteLocalIds.delete(localId);
            (0, $07bf2d44005b7b22$export$dee490768d86cce8)({
                args: args,
                editorView: view,
                localId: localId,
                marker: marker,
                pendingArchivedRemovalsByLocalId: args.pendingArchivedRemovalsByLocalId
            }).catch(()=>undefined).finally(()=>{
                args.pendingPasteByLocalId.delete(localId);
                inFlightLocalIds.delete(localId);
            });
        });
    };
    const processReadyReactivations = (view)=>{
        args.readyReactivationLocalIds.forEach((localId)=>{
            if (args.pendingPasteByLocalId.has(localId) || inFlightLocalIds.has(localId)) return;
            inFlightLocalIds.add(localId);
            args.readyReactivationLocalIds.delete(localId);
            (0, $07bf2d44005b7b22$export$e6e56a9d778d0808)({
                editorView: view,
                localId: localId,
                pendingArchivedRemovalsByLocalId: args.pendingArchivedRemovalsByLocalId
            }).catch(()=>undefined).finally(()=>{
                inFlightLocalIds.delete(localId);
            });
        });
    };
    const update = (view)=>{
        processReadyArchives(view);
        processReadyPastes(view);
        processReadyReactivations(view);
    };
    update(editorView);
    return {
        update: (view)=>{
            update(view);
        }
    };
};









const $49c091a1c6089e7e$var$getSelectedAgentManagedLocalId = (editorView)=>(0, $6BmjZ.findAgentManagedExtension)(editorView.state)?.node.attrs.localId;
const $49c091a1c6089e7e$var$getOpenUiLocalId = (editorView)=>{
    const pluginState = (0, $aZxYK.pluginKey).getState(editorView.state);
    if (pluginState?.isConfigOpen) return pluginState.configLocalId ?? $49c091a1c6089e7e$var$getSelectedAgentManagedLocalId(editorView);
    if (pluginState?.isAutoUpdateIntervalOpen) return pluginState.autoUpdateIntervalLocalId;
    return undefined;
};
const $49c091a1c6089e7e$export$7906ccecd478b93e = (editorView)=>{
    let selectedLocalId;
    return {
        update () {
            const nextSelectedLocalId = $49c091a1c6089e7e$var$getOpenUiLocalId(editorView);
            if (nextSelectedLocalId === selectedLocalId) return;
            if (selectedLocalId) (0, $9e8dc115378f91b1$export$db77a51a8cbfff28)(selectedLocalId, false);
            selectedLocalId = nextSelectedLocalId;
            if (selectedLocalId) (0, $9e8dc115378f91b1$export$db77a51a8cbfff28)(selectedLocalId, true);
        }
    };
};





const $c67814a0beae0bd9$export$ae829ec7b2625219 = (args)=>{
    const copyPasteIdentity = (0, $1fc17467ee65648b$export$2c63de875cb788c8)({
        cloudId: args.cloudId,
        contentType: args.contentType,
        getContextIdentifierProvider: args.getContextIdentifierProvider
    });
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $aZxYK.pluginKey),
        appendTransaction: copyPasteIdentity.appendTransaction,
        props: {
            ...copyPasteIdentity.props,
            nodeViews: {
                bodiedExtension: (0, $9e8dc115378f91b1$export$981fde09308f7c44)({
                    nodeViewPortalProviderAPI: args.nodeViewPortalProviderAPI
                })
            }
        },
        state: {
            init: (0, $ip1Wz.initialState),
            apply (tr, prev, oldState, newState) {
                const withMeta = (0, $ip1Wz.applyMeta)(prev, (0, $ip1Wz.getMeta)(tr), newState);
                const withAutoOpen = (0, $ip1Wz.applyAutoOpenOnInsert)(withMeta, tr, oldState, newState);
                return (0, $ip1Wz.applyAutoCloseOnSelectionChange)(withAutoOpen, tr, newState);
            }
        },
        view: (editorView)=>{
            const autoOpen = (0, $f404d63466c1e517$export$961bee066c4d0379)(editorView);
            const copyPaste = (0, $1fc17467ee65648b$export$ab31f6f79ac952df)(editorView, {
                cloudId: args.cloudId,
                contentType: args.contentType,
                getContextIdentifierProvider: args.getContextIdentifierProvider,
                pendingArchivedRemovalsByLocalId: copyPasteIdentity.pendingArchivedRemovalsByLocalId,
                pendingPasteByLocalId: copyPasteIdentity.pendingPasteByLocalId,
                readyArchiveLocalIds: copyPasteIdentity.readyArchiveLocalIds,
                readyPasteLocalIds: copyPasteIdentity.readyPasteLocalIds,
                readyReactivationLocalIds: copyPasteIdentity.readyReactivationLocalIds
            });
            const selectedWhileConfigOpen = (0, $49c091a1c6089e7e$export$7906ccecd478b93e)(editorView);
            let prevEditable = editorView.editable;
            let prevPluginState = (0, $aZxYK.pluginKey).getState(editorView.state);
            return {
                destroy: ()=>{
                    autoOpen.destroy();
                },
                update: (view)=>{
                    autoOpen.update();
                    copyPaste.update(view);
                    selectedWhileConfigOpen.update();
                    const currentPluginState = (0, $aZxYK.pluginKey).getState(view.state);
                    if (view.editable !== prevEditable || currentPluginState !== prevPluginState) {
                        prevEditable = view.editable;
                        prevPluginState = currentPluginState;
                        (0, $9e8dc115378f91b1$export$85c8b8e715aadfd8)(view);
                    }
                }
            };
        }
    });
};












var $jwWgu = parcelRequire("jwWgu");


var $eNKzL = parcelRequire("eNKzL");




var $hOr3J = parcelRequire("hOr3J");

/* ManagedBlockConfig.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $a3fRD = parcelRequire("a3fRD");


var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");




/**
 * Validation logic for AI-managed object configurations.
 *
 * Validation is intentionally centralised here so that every consumer
 * (editor plugin UI, server-side checks, etc.) uses the same rules.
 * The function is designed to be extended as new config fields are
 * introduced — callers should not hard-code their own checks.
 */ function $ba196f68cb9fb124$export$f21a0ba102fbd812(config) {
    const errors = [];
    const hasStructuredConfig = Boolean(config.goal);
    if (!hasStructuredConfig && (!config.prompt || config.prompt.trim().length === 0)) errors.push({
        code: 'EMPTY_PROMPT',
        field: 'prompt'
    });
    if (config.desiredUpdateFrequency && (!config.desiredUpdateFrequency.type || config.desiredUpdateFrequency.value.trim().length === 0)) errors.push({
        code: 'INVALID_DESIRED_UPDATE_FREQUENCY',
        field: 'desiredUpdateFrequency'
    });
    if (hasStructuredConfig) {
        if (!config.goal) errors.push({
            code: 'MISSING_GOAL',
            field: 'goal'
        });
        if (!config.goalOperations?.outputFormat) errors.push({
            code: 'MISSING_OUTPUT_FORMAT',
            field: 'goalOperations.outputFormat'
        });
        if (!config.sources?.length) errors.push({
            code: 'MISSING_SOURCES',
            field: 'sources'
        });
    }
    return {
        valid: errors.length === 0,
        errors: errors
    };
}





/* AimoStatusMetadata.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $esRft = parcelRequire("esRft");





var $7c52C = parcelRequire("7c52C");


var $8j9VY = parcelRequire("8j9VY");


var $3gadb = parcelRequire("3gadb");




const $20cf332ac8636775$var$metadataStyles = null;
const $20cf332ac8636775$var$profileTriggerStyles = null;
const $20cf332ac8636775$var$DIRECTORY_URL = '/gateway/api/directory/graphql';
const $20cf332ac8636775$var$profileClient = new (0, $7c52C.default)({
    url: $20cf332ac8636775$var$DIRECTORY_URL
});
const $20cf332ac8636775$var$getLastSuccessfulExecutionDate = (aimoData)=>{
    if (aimoData?.lastExecutionStatus !== 'SUCCESS' || !aimoData.lastExecutedAt) return null;
    const date = new Date(aimoData.lastExecutedAt);
    return Number.isNaN(date.getTime()) ? null : date;
};
const $20cf332ac8636775$export$b029164683c5c152 = ({ aimoData: aimoData = null, cloudId: cloudId })=>{
    const intl = (0, $aXWIB.useIntl)();
    const ownerId = aimoData?.lastModifiedBy;
    const lastSuccessfulExecutionDate = $20cf332ac8636775$var$getLastSuccessfulExecutionDate(aimoData);
    const [ownerProfile, setOwnerProfile] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        if (!ownerId || !cloudId) {
            setOwnerProfile(null);
            return;
        }
        let cancelled = false;
        setOwnerProfile(null);
        $20cf332ac8636775$var$profileClient.getProfile(cloudId, ownerId).then((profile)=>{
            if (!cancelled) setOwnerProfile(profile ?? null);
        }).catch(()=>{
            if (!cancelled) setOwnerProfile(null);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        cloudId,
        ownerId
    ]);
    const ownerName = ownerProfile?.fullName ?? ownerProfile?.nickname;
    const hasOwner = Boolean(ownerId && cloudId && ownerName);
    const hasUpdatedDate = Boolean(lastSuccessfulExecutionDate);
    if (!(hasOwner || hasUpdatedDate)) return null;
    return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_zulp12x7 _11c8wadc _1e0c1txw _4cvr1h6o _1tke1ejb _syazi7uo"
        ])
    }, hasOwner && ownerId && cloudId && ownerName && /*#__PURE__*/ $42omo.createElement((0, $8j9VY.default), {
        cloudId: cloudId,
        prepopulatedData: ownerProfile ?? undefined,
        resourceClient: $20cf332ac8636775$var$profileClient,
        userId: ownerId
    }, /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
        content: intl.formatMessage((0, $eNKzL.messages).owner)
    }, /*#__PURE__*/ $42omo.createElement("button", {
        type: "button",
        className: (0, $gMc0m.default)([
            "_zulp1b66 _11c8wadc _189eidpf _1rjcidpf _18zridpf _1e0c116y _4cvr1h6o _1tke1ejb _syazi7uo _bfhk1j28 _80omtlke"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $esRft.default), {
        appearance: "circle",
        label: ownerName,
        size: "xsmall",
        src: ownerProfile?.avatarUrl
    }), ownerName))), hasOwner && hasUpdatedDate && /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        as: "span",
        color: "color.text.subtlest"
    }, "|"), lastSuccessfulExecutionDate && /*#__PURE__*/ $42omo.createElement("span", null, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        as: "span",
        color: "color.text.subtle"
    }, intl.formatMessage((0, $eNKzL.messages).lastSuccessfulExecution)), ' ', intl.formatDate(lastSuccessfulExecutionDate, {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    }), ' ', intl.formatTime(lastSuccessfulExecutionDate, {
        hour: 'numeric',
        minute: '2-digit'
    })));
};


/* config-panel-options.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $3fYRQ = parcelRequire("3fYRQ");


var $8tSmd = parcelRequire("8tSmd");


var $54tpX = parcelRequire("54tpX");


var $4ymSL = parcelRequire("4ymSL");







const $12b26cc1dff66792$export$52024dc0d58d35da = (options, value)=>options.find((option)=>option.value === value);
const $12b26cc1dff66792$export$9860925510add594 = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    return (0, $42omo.useMemo)(()=>({
            goalOptions: [
                {
                    label: intl.formatMessage((0, $eNKzL.messages).goalExecutiveSummary),
                    value: 'executive-summary'
                },
                {
                    label: intl.formatMessage((0, $eNKzL.messages).goalDecisionRegister),
                    value: 'decision-register'
                },
                {
                    label: intl.formatMessage((0, $eNKzL.messages).goalMeetingRecap),
                    value: 'meeting-recap'
                },
                // Keep System design ready for later, but do not show it in the goal dropdown yet.
                // {
                // 	label: intl.formatMessage(messages.goalSystemDesign),
                // 	value: 'system-design' as const,
                // },
                {
                    label: intl.formatMessage((0, $eNKzL.messages).promptToggleLabel),
                    value: 'prompt'
                }
            ],
            outputFormatOptions: [
                {
                    icon: /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
                        as: "span",
                        size: "large",
                        "aria-hidden": "true"
                    }, intl.formatMessage((0, $eNKzL.messages).outputFormatTextIcon)),
                    label: intl.formatMessage((0, $eNKzL.messages).outputFormatText),
                    value: 'text'
                },
                {
                    icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($54tpX))), {
                        label: "",
                        color: "currentColor"
                    }),
                    label: intl.formatMessage((0, $eNKzL.messages).outputFormatList),
                    value: 'list'
                },
                {
                    icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ymSL))), {
                        label: "",
                        color: "currentColor"
                    }),
                    label: intl.formatMessage((0, $eNKzL.messages).outputFormatTable),
                    value: 'table'
                },
                {
                    icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
                        label: "",
                        color: "currentColor"
                    }),
                    label: intl.formatMessage((0, $eNKzL.messages).outputFormatPanel),
                    value: 'panel'
                }
            ],
            sourceModeOptions: [
                {
                    label: intl.formatMessage((0, $eNKzL.messages).sourcesModeManual),
                    value: 'manual'
                },
                {
                    label: intl.formatMessage((0, $eNKzL.messages).sourcesModeCurrentPage),
                    value: 'current-page'
                }
            ],
            systemDesignOutputFormatOptions: [
                {
                    icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fYRQ))), {
                        label: "",
                        color: "currentColor"
                    }),
                    isLocked: true,
                    label: intl.formatMessage((0, $eNKzL.messages).outputFormatDiagram),
                    value: 'diagram'
                }
            ]
        }), [
        intl
    ]);
};
















var $6T8v4 = parcelRequire("6T8v4");





/* config-panel-primitives.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $1beab2baaf7dc8a9$var$labelStyles = null;
const $1beab2baaf7dc8a9$export$1acdcf5a973a8414 = ({ children: children, htmlFor: htmlFor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("label", {
        htmlFor: htmlFor,
        className: (0, $gMc0m.default)([
            "_1e0c1ule _syazazsu _otyr12x7"
        ])
    }, children);


const $d87cdb2032958b54$export$9ec0a8bc422643e4 = ({ contentSelection: contentSelection, isDisabled: isDisabled = false, onContentSelectionChange: onContentSelectionChange, options: options })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1beab2baaf7dc8a9$export$1acdcf5a973a8414), {
        htmlFor: "agent-managed-extension-goal"
    }, intl.formatMessage((0, $eNKzL.messages).contentGoalLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
        inputId: "agent-managed-extension-goal",
        options: options,
        value: (0, $12b26cc1dff66792$export$52024dc0d58d35da)(options, contentSelection),
        onChange: (option)=>{
            if (option) onContentSelectionChange(option.value);
        },
        isDisabled: isDisabled,
        isSearchable: false
    }));
};


/* OutputFormatPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 











const $45764b42c7e1d328$var$fieldsetStyles = null;
const $45764b42c7e1d328$var$legendStyles = null;
const $45764b42c7e1d328$var$formatGridStyles = null;
const $45764b42c7e1d328$var$formatButtonStyles = null;
const $45764b42c7e1d328$var$formatButtonSelectedStyles = null;
const $45764b42c7e1d328$var$formatIconStyles = null;
const $45764b42c7e1d328$export$61dd55c259b4cf24 = ({ goal: goal, isDisabled: isDisabled = false, onOutputFormatChange: onOutputFormatChange, outputFormat: outputFormat, outputFormatOptions: outputFormatOptions, systemDesignOutputFormatOptions: systemDesignOutputFormatOptions })=>{
    const intl = (0, $aXWIB.useIntl)();
    const visibleOutputFormatOptions = goal === 'system-design' ? systemDesignOutputFormatOptions : outputFormatOptions;
    return /*#__PURE__*/ $42omo.createElement("fieldset", {
        className: (0, $gMc0m.default)([
            "_189eidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
        ])
    }, /*#__PURE__*/ $42omo.createElement("legend", {
        className: (0, $gMc0m.default)([
            "_syazazsu _otyru2gc _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
        ])
    }, intl.formatMessage((0, $eNKzL.messages).outputFormatLabel)), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c11p5 _yv0eorlc"
        ])
    }, visibleOutputFormatOptions.map((option)=>{
        const isSelected = outputFormat === option.value;
        const isLocked = Boolean(option.isLocked);
        return /*#__PURE__*/ $42omo.createElement("button", {
            key: option.value,
            "aria-disabled": isLocked || undefined,
            "aria-pressed": isSelected,
            disabled: isDisabled,
            onClick: ()=>{
                if (!isLocked) onOutputFormatChange(option.value);
            },
            type: "button",
            className: (0, $gMc0m.default)([
                "_2rko12b0 _11c81kw7 _1h6d1l7x _1dqonqa1 _189ee4h9 _r06hglyw _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _1ul9idpf _1tket9kd _vchhusvi _bfhkvuon _syazi7uo _80omtlke _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _mizu1v1w _1ah3v77o _ra3xnqa1 _128mdkaa _irr31dpa",
                isSelected && "_1h6dq98m _bfhk15s3"
            ])
        }, /*#__PURE__*/ $42omo.createElement("span", {
            "aria-hidden": "true",
            className: (0, $gMc0m.default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1ejb _4t3i1ejb _otyr1b66 _syaz1q3r"
            ])
        }, option.icon), /*#__PURE__*/ $42omo.createElement("span", null, option.label));
    })));
};


/* SourcesPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $1qfLF = parcelRequire("1qfLF");


var $7gpC4 = parcelRequire("7gpC4");


var $hmuev = parcelRequire("hmuev");


var $9pS9R = parcelRequire("9pS9R");





var $k00oi = parcelRequire("k00oi");

var $7bZ3i = parcelRequire("7bZ3i");












var $hpUsb = parcelRequire("hpUsb");





var $9EtP6 = parcelRequire("9EtP6");







var $h9X5P = parcelRequire("h9X5P");

const $0bbb05b83a82c46d$export$56f8b797da4bdab7 = (sourceUrl)=>{
    try {
        const url = new URL(sourceUrl);
        const path = url.pathname.replace(/\/$/, '');
        return path ? `${url.hostname}${path}` : url.hostname;
    } catch  {
        return sourceUrl;
    }
};






var $hS8DP = parcelRequire("hS8DP");




const $1e38b52875f8f7f6$export$5cddb41d9a4259b7 = (currentEntries, rawSourceUrls)=>{
    const candidates = (0, $hS8DP.getSourceUrlCandidatesFromText)(rawSourceUrls);
    const seenUrls = new Set(currentEntries.map((source)=>source.url));
    const entries = [
        ...currentEntries
    ];
    let limitExceeded = false;
    candidates.forEach((candidate)=>{
        if (seenUrls.has(candidate)) return;
        if (entries.length >= (0, $hS8DP.MAX_MANAGED_BLOCK_SOURCES)) {
            limitExceeded = true;
            return;
        }
        seenUrls.add(candidate);
        entries.push((0, $hS8DP.isValidSourceUrl)(candidate) ? {
            app: (0, $hS8DP.getSourceAppFromUrl)(candidate),
            status: 'resolving',
            url: candidate
        } : {
            invalidReason: 'invalid-url',
            status: 'invalid',
            url: candidate
        });
    });
    return {
        entries: entries,
        limitExceeded: limitExceeded
    };
};
const $1e38b52875f8f7f6$export$d2cf2595d48e7504 = (sourceEntries, url, update)=>sourceEntries.map((source)=>source.url === url ? {
            ...source,
            ...update,
            url: url
        } : source);
const $1e38b52875f8f7f6$export$110d8af17cd151ae = (sourceEntries, sourceUrl)=>sourceEntries.filter((source)=>source.url !== sourceUrl);





const $9e588c91b43aada9$var$APP_MATCHERS = [
    [
        'BITBUCKET',
        /bitbucket/
    ],
    [
        'CONFLUENCE',
        /confluence/
    ],
    [
        'GITHUB',
        /github/
    ],
    [
        'GOOGLE_DRIVE',
        /google|gdrive|drive|docs/
    ],
    [
        'JIRA',
        /jira/
    ],
    [
        'LOOM',
        /loom/
    ],
    [
        'MICROSOFT_SHAREPOINT',
        /sharepoint|onedrive/
    ],
    [
        'MICROSOFT_TEAMS',
        /microsoft.?teams|ms.?teams/
    ],
    [
        'SALESFORCE',
        /salesforce/
    ],
    [
        'SLACK',
        /slack/
    ]
];
const $9e588c91b43aada9$var$getTextValue = (value)=>typeof value === 'string' && value.trim().length > 0 ? value : undefined;
const $9e588c91b43aada9$var$getRecord = (value)=>value && typeof value === 'object' ? value : undefined;
const $9e588c91b43aada9$export$247794f7c9f9b348 = (url, response)=>{
    const meta = $9e588c91b43aada9$var$getRecord(response.meta);
    const data = $9e588c91b43aada9$var$getRecord(response.data);
    const metaGenerator = $9e588c91b43aada9$var$getRecord(meta?.generator);
    const dataGenerator = $9e588c91b43aada9$var$getRecord(data?.generator);
    const candidates = [
        meta?.product,
        meta?.key,
        meta?.definitionId,
        metaGenerator?.name,
        metaGenerator?.['@id'],
        dataGenerator?.name,
        dataGenerator?.['@id'],
        data?.url,
        url
    ].map($9e588c91b43aada9$var$getTextValue).filter((candidate)=>Boolean(candidate)).map((candidate)=>candidate.toLowerCase());
    return $9e588c91b43aada9$var$APP_MATCHERS.find(([, matcher])=>candidates.some((candidate)=>matcher.test(candidate)))?.[0] ?? (0, $hS8DP.getSourceAppFromUrl)(url);
};
const $9e588c91b43aada9$export$598ac52f861a5de9 = (response)=>{
    const meta = $9e588c91b43aada9$var$getRecord(response.meta);
    const access = $9e588c91b43aada9$var$getTextValue(meta?.access)?.toLowerCase();
    const visibility = $9e588c91b43aada9$var$getTextValue(meta?.visibility)?.toLowerCase();
    if (visibility === 'not_found') return 'not-found';
    if (access === 'unauthorized' || access === 'forbidden') return 'unauthorized';
    if (access === 'unauthenticated') return 'unauthenticated';
    if (access && access !== 'granted') return 'unavailable';
    return null;
};
const $9e588c91b43aada9$export$fd29b3c31d66ad7a = (error)=>{
    const errorText = error instanceof Error ? `${error.name} ${error.message}`.toLowerCase() : '';
    if (errorText.includes('auth')) return 'unauthenticated';
    if (errorText.includes('forbidden') || errorText.includes('permission')) return 'unauthorized';
    if (errorText.includes('unsupported') || errorText.includes('not found')) return 'not-found';
    return 'unavailable';
};


const $aed8cb7172288181$export$6cb422e489bb93bc = ({ cardClient: cardClient, onChange: onChange, sourceEntries: sourceEntries })=>{
    (0, $42omo.useEffect)(()=>{
        let cancelled = false;
        sourceEntries.filter((source)=>source.status === 'resolving' && (0, $hS8DP.isValidSourceUrl)(source.url)).forEach((source)=>{
            cardClient.fetchData(source.url, false, 'inline').then((response)=>{
                if (cancelled) return;
                const invalidReason = (0, $9e588c91b43aada9$export$598ac52f861a5de9)(response);
                onChange((currentConfiguration)=>{
                    const nextSourceEntries = invalidReason ? (0, $1e38b52875f8f7f6$export$d2cf2595d48e7504)(currentConfiguration.sourceEntries, source.url, {
                        app: (0, $hS8DP.getSourceAppFromUrl)(source.url),
                        invalidReason: invalidReason,
                        status: 'invalid'
                    }) : (0, $1e38b52875f8f7f6$export$d2cf2595d48e7504)(currentConfiguration.sourceEntries, source.url, {
                        app: (0, $9e588c91b43aada9$export$247794f7c9f9b348)(source.url, response),
                        invalidReason: undefined,
                        status: 'resolved'
                    });
                    return {
                        ...currentConfiguration,
                        sourceEntries: nextSourceEntries,
                        sourceUrls: (0, $hS8DP.getSourceUrlsFromEntries)(nextSourceEntries)
                    };
                });
            }).catch((error)=>{
                if (cancelled) return;
                onChange((currentConfiguration)=>{
                    const nextSourceEntries = (0, $1e38b52875f8f7f6$export$d2cf2595d48e7504)(currentConfiguration.sourceEntries, source.url, {
                        app: (0, $hS8DP.getSourceAppFromUrl)(source.url),
                        invalidReason: (0, $9e588c91b43aada9$export$fd29b3c31d66ad7a)(error),
                        status: 'invalid'
                    });
                    return {
                        ...currentConfiguration,
                        sourceEntries: nextSourceEntries,
                        sourceUrls: (0, $hS8DP.getSourceUrlsFromEntries)(nextSourceEntries)
                    };
                });
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        cardClient,
        onChange,
        sourceEntries
    ]);
};









const $965b82d21437df37$export$ee8283cf036594fb = ({ onChange: onChange, onConfigEdit: onConfigEdit, onInteraction: onInteraction, sourceEntries: sourceEntries, sourceMode: sourceMode, sourceUrls: sourceUrls })=>{
    const [sourceInputValue, setSourceInputValue] = (0, $42omo.useState)('');
    const [showSourceLimitError, setShowSourceLimitError] = (0, $42omo.useState)(false);
    const handleSourceModeChange = (0, $42omo.useCallback)((nextSourceMode)=>{
        onInteraction();
        if (sourceMode !== nextSourceMode || sourceUrls.length > 0 || sourceEntries.length > 0 || sourceInputValue.length > 0) onConfigEdit();
        setSourceInputValue('');
        setShowSourceLimitError(false);
        onChange((currentConfiguration)=>({
                ...currentConfiguration,
                sourceEntries: [],
                sourceMode: nextSourceMode,
                sourceUrls: ''
            }));
    }, [
        onChange,
        onConfigEdit,
        onInteraction,
        sourceEntries.length,
        sourceInputValue,
        sourceMode,
        sourceUrls
    ]);
    const handleSourceInputChange = (0, $42omo.useCallback)((event)=>{
        onInteraction();
        setShowSourceLimitError(false);
        setSourceInputValue(event.currentTarget.value);
    }, [
        onInteraction
    ]);
    const addManualSources = (0, $42omo.useCallback)((rawSourceUrls)=>{
        onInteraction();
        const { entries: nextSourceEntries, limitExceeded: limitExceeded } = (0, $1e38b52875f8f7f6$export$5cddb41d9a4259b7)(sourceEntries, rawSourceUrls);
        setShowSourceLimitError(limitExceeded);
        if (nextSourceEntries.length === sourceEntries.length) {
            if (!limitExceeded) setSourceInputValue('');
            return;
        }
        onConfigEdit();
        onChange((currentConfiguration)=>{
            const next = (0, $1e38b52875f8f7f6$export$5cddb41d9a4259b7)(currentConfiguration.sourceEntries, rawSourceUrls).entries;
            return {
                ...currentConfiguration,
                sourceEntries: next,
                sourceUrls: (0, $hS8DP.getSourceUrlsFromEntries)(next)
            };
        });
        setSourceInputValue('');
    }, [
        onChange,
        onConfigEdit,
        onInteraction,
        sourceEntries
    ]);
    const handleSourceInputKeyDown = (0, $42omo.useCallback)((event)=>{
        if (event.key === 'Enter') {
            event.preventDefault();
            addManualSources(sourceInputValue);
        }
    }, [
        addManualSources,
        sourceInputValue
    ]);
    const handleSourceInputPaste = (0, $42omo.useCallback)((event)=>{
        const pastedText = event.clipboardData.getData('text');
        if (pastedText.trim().length === 0) return;
        event.preventDefault();
        addManualSources(pastedText);
    }, [
        addManualSources
    ]);
    const handleRemoveSourceUrl = (0, $42omo.useCallback)((sourceUrl)=>{
        onInteraction();
        const nextSourceEntries = (0, $1e38b52875f8f7f6$export$110d8af17cd151ae)(sourceEntries, sourceUrl);
        if (sourceEntries.length !== nextSourceEntries.length) onConfigEdit();
        setShowSourceLimitError(false);
        onChange((currentConfiguration)=>{
            const next = (0, $1e38b52875f8f7f6$export$110d8af17cd151ae)(currentConfiguration.sourceEntries, sourceUrl);
            return {
                ...currentConfiguration,
                sourceEntries: next,
                sourceUrls: (0, $hS8DP.getSourceUrlsFromEntries)(next)
            };
        });
    }, [
        onChange,
        onConfigEdit,
        onInteraction,
        sourceEntries
    ]);
    const handleRetrySourceUrl = (0, $42omo.useCallback)((sourceUrl)=>{
        onInteraction();
        setShowSourceLimitError(false);
        onChange((currentConfiguration)=>{
            const isValidRetryUrl = (0, $hS8DP.isValidSourceUrl)(sourceUrl);
            const nextSourceEntries = (0, $1e38b52875f8f7f6$export$d2cf2595d48e7504)(currentConfiguration.sourceEntries, sourceUrl, {
                app: (0, $hS8DP.getSourceAppFromUrl)(sourceUrl),
                invalidReason: isValidRetryUrl ? undefined : 'invalid-url',
                status: isValidRetryUrl ? 'resolving' : 'invalid'
            });
            return {
                ...currentConfiguration,
                sourceEntries: nextSourceEntries,
                sourceUrls: (0, $hS8DP.getSourceUrlsFromEntries)(nextSourceEntries)
            };
        });
    }, [
        onChange,
        onInteraction
    ]);
    return {
        sourceInputValue: sourceInputValue,
        showSourceLimitError: showSourceLimitError,
        handleRemoveSourceUrl: handleRemoveSourceUrl,
        handleRetrySourceUrl: handleRetrySourceUrl,
        handleSourceInputChange: handleSourceInputChange,
        handleSourceInputKeyDown: handleSourceInputKeyDown,
        handleSourceInputPaste: handleSourceInputPaste,
        handleSourceModeChange: handleSourceModeChange
    };
};


const $1aa2d71732ab12d5$export$5a4a752748eadf59 = ({ cardClient: cardClient, onChange: onChange, onConfigEdit: onConfigEdit, onInteraction: onInteraction, sourceEntries: sourceEntries, sourceMode: sourceMode, sourceUrls: sourceUrls })=>{
    (0, $aed8cb7172288181$export$6cb422e489bb93bc)({
        cardClient: cardClient,
        onChange: onChange,
        sourceEntries: sourceEntries
    });
    const sourceInput = (0, $965b82d21437df37$export$ee8283cf036594fb)({
        onChange: onChange,
        onConfigEdit: onConfigEdit,
        onInteraction: onInteraction,
        sourceEntries: sourceEntries,
        sourceMode: sourceMode,
        sourceUrls: sourceUrls
    });
    return {
        manualSources: sourceEntries,
        ...sourceInput
    };
};


const $fe5cd846cb8b59a5$var$sourceInputStyles = null;
const $fe5cd846cb8b59a5$var$sourceInputInvalidStyles = null;
const $fe5cd846cb8b59a5$var$sourceChipListStyles = null;
const $fe5cd846cb8b59a5$var$sourceChipStyles = null;
const $fe5cd846cb8b59a5$var$sourceChipInvalidStyles = null;
const $fe5cd846cb8b59a5$var$sourceChipResolvingStyles = null;
const $fe5cd846cb8b59a5$var$sourceChipLabelStyles = null;
const $fe5cd846cb8b59a5$var$sourceInvalidMessageStyles = null;
const $fe5cd846cb8b59a5$var$sourceResolvedCardStyles = null;
const $fe5cd846cb8b59a5$var$sourceStatusStyles = null;
const $fe5cd846cb8b59a5$var$errorTextStyles = null;
const $fe5cd846cb8b59a5$var$additionalContextStyles = {
    root: "_19pku2gc",
    textArea: "_19pk12x7",
    message: "_19pk1b66"
};
const $fe5cd846cb8b59a5$var$getInvalidSourceMessageKey = (invalidReason)=>{
    switch(invalidReason){
        case 'invalid-url':
            return 'sourceInvalidUrl';
        case 'not-found':
            return 'sourceNotFound';
        case 'unauthenticated':
        case 'unauthorized':
            return 'sourceUnauthorized';
        case 'unavailable':
        default:
            return 'sourceUnavailable';
    }
};
const $fe5cd846cb8b59a5$var$getSourceValidationMessageKey = (sourceValidationError)=>{
    switch(sourceValidationError){
        case 'invalid':
            return 'sourceInvalidError';
        case 'pending':
            return 'sourcePendingError';
        case 'required':
            return 'sourceRequiredError';
        default:
            return null;
    }
};
const $fe5cd846cb8b59a5$var$SourceItem = ({ isDisabled: isDisabled, onRemove: onRemove, onRetry: onRetry, source: source })=>{
    const intl = (0, $aXWIB.useIntl)();
    const sourceLabel = (0, $0bbb05b83a82c46d$export$56f8b797da4bdab7)(source.url);
    const invalidMessageKey = $fe5cd846cb8b59a5$var$getInvalidSourceMessageKey(source.invalidReason);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
        className: (0, $gMc0m.default)([
            "_zulp1b66 _2rko12b0 _1e0c116y _4cvr1h6o _vchhusvi _p12f1osq _1ul9idpf _bfhki8nm _syazazsu _ca0q1b66 _u5f31b66 _n3td1b66 _19bv12x7",
            source.status === 'invalid' && "_1h6d1bqt _1dqonqa1 _189ee4h9 _bfhk1gly _syaz1tmw",
            source.status === 'resolving' && "_tzy4txnc"
        ])
    }, source.status === 'resolved' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1ul9idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpUsb.Card), {
        appearance: "inline",
        placeholder: sourceLabel,
        resolvingPlaceholder: sourceLabel,
        url: source.url
    })), source.status === 'resolving' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_zulp1b66 _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        label: intl.formatMessage((0, $eNKzL.messages).sourceResolving),
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1ul9idpf _1bto1l2s _o5721q9c"
        ])
    }, sourceLabel)), source.status === 'invalid' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_zulp1b66 _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        label: "",
        color: "currentColor",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1ul9idpf _1bto1l2s _o5721q9c"
        ])
    }, sourceLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_1o9zidpf _19bv1b66 _o5721q9c"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.danger"
    }, intl.formatMessage((0, $eNKzL.messages)[invalidMessageKey])))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.025",
        alignBlock: "center"
    }, source.status === 'invalid' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9pS9R))),
        isDisabled: isDisabled,
        label: intl.formatMessage((0, $eNKzL.messages).retrySourceLabel, {
            source: sourceLabel
        }),
        onClick: ()=>onRetry(source.url),
        spacing: "compact"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        isDisabled: isDisabled,
        label: intl.formatMessage((0, $eNKzL.messages).removeSourceLabel, {
            source: sourceLabel
        }),
        onClick: ()=>onRemove(source.url),
        spacing: "compact"
    })));
};
const $fe5cd846cb8b59a5$export$2c62bf432071778d = ({ additionalContext: additionalContext, additionalContextValidationError: additionalContextValidationError, isDisabled: isDisabled = false, isAdditionalContextSelected: isAdditionalContextSelected, onChange: onChange, onConfigEdit: onConfigEdit, onInteraction: onInteraction, sourceEntries: sourceEntries, sourceMode: sourceMode, sourceModeOptions: sourceModeOptions, smartCardProviderProduct: smartCardProviderProduct, sourceUrls: sourceUrls, sourceValidationError: sourceValidationError })=>{
    const intl = (0, $aXWIB.useIntl)();
    const cardClient = (0, $42omo.useMemo)(()=>new (0, $k00oi.default)(), []);
    const { manualSources: manualSources, sourceInputValue: sourceInputValue, handleRemoveSourceUrl: handleRemoveSourceUrl, handleRetrySourceUrl: handleRetrySourceUrl, handleSourceInputChange: handleSourceInputChange, handleSourceInputKeyDown: handleSourceInputKeyDown, handleSourceInputPaste: handleSourceInputPaste, handleSourceModeChange: handleSourceModeChange, showSourceLimitError: showSourceLimitError } = (0, $1aa2d71732ab12d5$export$5a4a752748eadf59)({
        cardClient: cardClient,
        onChange: onChange,
        onConfigEdit: onConfigEdit,
        onInteraction: onInteraction,
        sourceEntries: sourceEntries,
        sourceMode: sourceMode,
        sourceUrls: sourceUrls
    });
    const sourceErrorMessageKey = showSourceLimitError ? 'sourceLimitError' : $fe5cd846cb8b59a5$var$getSourceValidationMessageKey(sourceValidationError);
    const sourceErrorId = sourceErrorMessageKey ? 'agent-managed-extension-source-error' : undefined;
    const additionalContextErrorId = additionalContextValidationError ? 'agent-managed-extension-additional-context-error' : undefined;
    const additionalContextCounterId = 'agent-managed-extension-additional-context-counter';
    const additionalContextDescriptionIds = [
        additionalContextErrorId,
        additionalContextCounterId
    ].filter(Boolean).join(' ');
    const additionalContextCharactersRemaining = Math.max(0, (0, $h9X5P.MAX_ADDITIONAL_CONTEXT_LENGTH) - additionalContext.length);
    const handleAdditionalContextChange = (0, $42omo.useCallback)((event)=>{
        const nextAdditionalContext = event.currentTarget.value.slice(0, (0, $h9X5P.MAX_ADDITIONAL_CONTEXT_LENGTH));
        onInteraction();
        if (additionalContext !== nextAdditionalContext) onConfigEdit();
        onChange((currentConfiguration)=>({
                ...currentConfiguration,
                additionalContext: nextAdditionalContext
            }));
    }, [
        additionalContext,
        onChange,
        onConfigEdit,
        onInteraction
    ]);
    const handleAdditionalContextSelectedChange = (0, $42omo.useCallback)((event)=>{
        const nextIsAdditionalContextSelected = event.currentTarget.checked;
        onInteraction();
        if (isAdditionalContextSelected !== nextIsAdditionalContextSelected) onConfigEdit();
        onChange((currentConfiguration)=>({
                ...currentConfiguration,
                isAdditionalContextSelected: nextIsAdditionalContextSelected
            }));
    }, [
        isAdditionalContextSelected,
        onChange,
        onConfigEdit,
        onInteraction
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1beab2baaf7dc8a9$export$1acdcf5a973a8414), {
        htmlFor: "agent-managed-extension-source-mode"
    }, intl.formatMessage((0, $eNKzL.messages).sourcesLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
        inputId: "agent-managed-extension-source-mode",
        options: sourceModeOptions,
        value: (0, $12b26cc1dff66792$export$52024dc0d58d35da)(sourceModeOptions, sourceMode),
        onChange: (option)=>{
            if (option) handleSourceModeChange(option.value);
        },
        isDisabled: isDisabled,
        isSearchable: false
    })), sourceMode === 'manual' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        "aria-describedby": sourceErrorId,
        "aria-invalid": Boolean(sourceErrorMessageKey),
        "data-testid": "agent-managed-extension-source-input",
        disabled: isDisabled,
        onChange: handleSourceInputChange,
        onKeyDown: handleSourceInputKeyDown,
        onPaste: handleSourceInputPaste,
        placeholder: intl.formatMessage((0, $eNKzL.messages).sourcesPlaceholder),
        type: "text",
        value: sourceInputValue,
        className: (0, $gMc0m.default)([
            "_2rko12b0 _11c81kw7 _1h6drsbi _1dqonqa1 _189ee4h9 _1bsb1osq _vchhusvi _bfhkvuon _syazi7uo _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _1idr1rpy _nt751v1w _1bg4v77o _49pcnqa1 _1hvwdkaa",
            sourceErrorMessageKey && "_1h6d1bqt"
        ])
    }), manualSources.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7bZ3i.SmartCardProvider), {
        client: cardClient,
        product: smartCardProviderProduct
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
        "aria-label": intl.formatMessage((0, $eNKzL.messages).sourceLinksLabel),
        className: (0, $gMc0m.default)([
            "_zulp1b66 _qtt8glyw _1e0c1txw _1n261g80 _19pku2gc _2hwxidpf _otyridpf _18u0idpf _1ul9idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
        ])
    }, manualSources.map((source)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fe5cd846cb8b59a5$var$SourceItem, {
            key: source.url,
            isDisabled: isDisabled,
            onRemove: handleRemoveSourceUrl,
            onRetry: handleRetrySourceUrl,
            source: source
        })))), sourceErrorMessageKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        id: sourceErrorId,
        role: "alert",
        className: (0, $gMc0m.default)([
            "_syaz1tmw _19pku2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.danger"
    }, intl.formatMessage((0, $eNKzL.messages)[sourceErrorMessageKey])))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $fe5cd846cb8b59a5$var$additionalContextStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
        id: "agent-managed-extension-additional-context-toggle",
        isChecked: isAdditionalContextSelected,
        isDisabled: isDisabled,
        label: intl.formatMessage((0, $eNKzL.messages).additionalContextLabel),
        onChange: handleAdditionalContextSelectedChange
    }), isAdditionalContextSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $fe5cd846cb8b59a5$var$additionalContextStyles.textArea
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
        "aria-describedby": additionalContextDescriptionIds,
        "aria-label": intl.formatMessage((0, $eNKzL.messages).additionalContextDetailsLabel),
        id: "agent-managed-extension-additional-context",
        isDisabled: isDisabled,
        isInvalid: additionalContextValidationError,
        maxLength: (0, $h9X5P.MAX_ADDITIONAL_CONTEXT_LENGTH),
        minimumRows: 3,
        onChange: handleAdditionalContextChange,
        placeholder: intl.formatMessage((0, $eNKzL.messages).additionalContextPlaceholder),
        testId: "agent-managed-extension-additional-context",
        value: additionalContext
    }), additionalContextValidationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        id: additionalContextErrorId,
        role: "alert",
        xcss: $fe5cd846cb8b59a5$var$additionalContextStyles.message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.danger"
    }, intl.formatMessage((0, $eNKzL.messages).additionalContextRequiredError))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        id: additionalContextCounterId,
        xcss: $fe5cd846cb8b59a5$var$additionalContextStyles.message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle"
    }, intl.formatMessage((0, $eNKzL.messages).additionalContextCharactersRemaining, {
        remaining: additionalContextCharactersRemaining
    }))))));
};


const $a30bbb5fd91239f3$export$aac584ace4a7b830 = ({ additionalContextValidationError: additionalContextValidationError, configuration: configuration, isDisabled: isDisabled = false, onChange: onChange, onConfigEdit: onConfigEdit, onInteraction: onInteraction, onPromptSelect: onPromptSelect, smartCardProviderProduct: smartCardProviderProduct, sourceValidationError: sourceValidationError })=>{
    const { goalOptions: goalOptions, outputFormatOptions: outputFormatOptions, sourceModeOptions: sourceModeOptions, systemDesignOutputFormatOptions: systemDesignOutputFormatOptions } = (0, $12b26cc1dff66792$export$9860925510add594)();
    const handleGoalChange = (0, $42omo.useCallback)((nextGoal)=>{
        const nextOutputFormat = nextGoal === 'system-design' ? 'diagram' : configuration.outputFormat === 'diagram' ? 'text' : configuration.outputFormat;
        onInteraction();
        if (configuration.goal !== nextGoal || configuration.outputFormat !== nextOutputFormat) onConfigEdit();
        onChange((currentConfiguration)=>{
            const currentNextOutputFormat = nextGoal === 'system-design' ? 'diagram' : currentConfiguration.outputFormat === 'diagram' ? 'text' : currentConfiguration.outputFormat;
            return {
                ...currentConfiguration,
                goal: nextGoal,
                outputFormat: currentNextOutputFormat
            };
        });
    }, [
        configuration.goal,
        configuration.outputFormat,
        onChange,
        onConfigEdit,
        onInteraction
    ]);
    const handleContentSelectionChange = (0, $42omo.useCallback)((nextSelection)=>{
        if (nextSelection === 'prompt') {
            onPromptSelect();
            return;
        }
        handleGoalChange(nextSelection);
    }, [
        handleGoalChange,
        onPromptSelect
    ]);
    const handleOutputFormatChange = (0, $42omo.useCallback)((outputFormat)=>{
        onInteraction();
        if (configuration.outputFormat !== outputFormat) onConfigEdit();
        onChange((currentConfiguration)=>({
                ...currentConfiguration,
                outputFormat: outputFormat
            }));
    }, [
        configuration.outputFormat,
        onChange,
        onConfigEdit,
        onInteraction
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d87cdb2032958b54$export$9ec0a8bc422643e4), {
        contentSelection: configuration.goal,
        isDisabled: isDisabled,
        onContentSelectionChange: handleContentSelectionChange,
        options: goalOptions
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $45764b42c7e1d328$export$61dd55c259b4cf24), {
        goal: configuration.goal,
        isDisabled: isDisabled,
        onOutputFormatChange: handleOutputFormatChange,
        outputFormat: configuration.outputFormat,
        outputFormatOptions: outputFormatOptions,
        systemDesignOutputFormatOptions: systemDesignOutputFormatOptions
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fe5cd846cb8b59a5$export$2c62bf432071778d), {
        additionalContext: configuration.additionalContext,
        additionalContextValidationError: additionalContextValidationError,
        isDisabled: isDisabled,
        isAdditionalContextSelected: configuration.isAdditionalContextSelected,
        onChange: onChange,
        onConfigEdit: onConfigEdit,
        onInteraction: onInteraction,
        sourceEntries: configuration.sourceEntries,
        sourceMode: configuration.sourceMode,
        sourceModeOptions: sourceModeOptions,
        smartCardProviderProduct: smartCardProviderProduct,
        sourceValidationError: sourceValidationError,
        sourceUrls: configuration.sourceUrls
    }));
};





var $lbsCi = parcelRequire("lbsCi");

/* DisclaimerAcknowledgement.tsx generated by @compiled/babel-plugin v0.36.1 */ 
























const $2229dad5801064be$var$disclaimerStyles = null;
const $2229dad5801064be$export$8095a6afc34b6dbb = ({ isSaving: isSaving, onAgree: onAgree, onBack: onBack, onCancel: onCancel })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": "agent-managed-extension-disclaimer-step"
    }, /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
        space: "space.150"
    }, /*#__PURE__*/ $42omo.createElement("div", {
        role: "group",
        "aria-labelledby": "agent-managed-extension-disclaimer-title",
        "aria-describedby": "agent-managed-extension-disclaimer-copy"
    }, /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        as: "strong",
        weight: "semibold",
        id: "agent-managed-extension-disclaimer-title"
    }, intl.formatMessage((0, $eNKzL.messages).disclaimerTitle)), /*#__PURE__*/ $42omo.createElement("div", {
        id: "agent-managed-extension-disclaimer-copy",
        className: (0, $gMc0m.default)([
            "_ca0q1b66 _u5f3ze3t _n3td1b66 _19bvze3t"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage((0, $eNKzL.messages).disclaimerCopy))))), /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        space: "space.100",
        alignInline: "end"
    }, onCancel && /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: onCancel,
        isDisabled: isSaving
    }, intl.formatMessage((0, $eNKzL.messages).cancel)), /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: onBack,
        isDisabled: isSaving
    }, intl.formatMessage((0, $eNKzL.messages).disclaimerBack)), /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
        appearance: "primary",
        testId: "agent-managed-extension-disclaimer-agree",
        onClick: onAgree,
        isDisabled: isSaving,
        autoFocus: true,
        iconAfter: isSaving ? ()=>/*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
                size: "small"
            }) : undefined
    }, intl.formatMessage((0, $eNKzL.messages).disclaimerAgree)))));
};



/* ManagedBlockConfigFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $cO1el = parcelRequire("cO1el");







const $d69acc824aed5ffd$var$wrapperStyles = null;
const $d69acc824aed5ffd$export$9ce5063a680c0a10 = ({ children: children, testId: testId })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_2rko12b0 _1h6d1l7x _1dqonqa1 _189ee4h9 _1bsb1osq _vchhusvi _bfhkvuon _ca0qpxbi _u5f3pxbi _n3tdutpp _19bvpxbi _16qs130s"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
        space: "space.150"
    }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
        size: "small"
    }, intl.formatMessage((0, $eNKzL.messages).configureBlock)), children));
};


/* PromptPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $2AytZ = parcelRequire("2AytZ");


var $1Zr9M = parcelRequire("1Zr9M");












const $f9276ab10c8412ed$var$labelStyles = null;
const $f9276ab10c8412ed$var$promptSectionStyles = null;
const $f9276ab10c8412ed$var$promptToggleStyles = null;
const $f9276ab10c8412ed$var$promptToggleTextStyles = null;
const $f9276ab10c8412ed$var$promptToggleChevronStyles = null;
const $f9276ab10c8412ed$var$promptBodyStyles = {
    root: "_19pku2gc",
    error: "_19pku2gc"
};
const $f9276ab10c8412ed$export$a61c020b7ca91c15 = (props)=>{
    const { isDisabled: isDisabled = false, isExpanded: isExpanded, onPromptChange: onPromptChange, prompt: prompt, promptValidationError: promptValidationError } = props;
    const intl = (0, $aXWIB.useIntl)();
    const textareaRef = (0, $42omo.useRef)(null);
    const promptErrorId = promptValidationError ? 'agent-managed-extension-prompt-error' : undefined;
    (0, $42omo.useEffect)(()=>{
        if (isExpanded) textareaRef.current?.focus({
            preventScroll: true
        });
    }, [
        isExpanded
    ]);
    const promptBody = /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $f9276ab10c8412ed$var$promptBodyStyles.root
    }, /*#__PURE__*/ $42omo.createElement("label", {
        htmlFor: "agent-managed-extension-prompt",
        className: (0, $gMc0m.default)([
            "_1e0c1ule _syazazsu _otyr12x7"
        ])
    }, intl.formatMessage((0, $eNKzL.messages).customInstructionsLabel)), /*#__PURE__*/ $42omo.createElement((0, $9EtP6.default), {
        "aria-describedby": promptErrorId,
        id: "agent-managed-extension-prompt",
        testId: "agent-managed-extension-prompt",
        ref: textareaRef,
        minimumRows: 3,
        value: prompt,
        onChange: (event)=>onPromptChange(event.currentTarget.value),
        placeholder: intl.formatMessage((0, $eNKzL.messages).customInstructionsPlaceholder),
        isDisabled: isDisabled,
        isInvalid: promptValidationError
    }), promptValidationError && /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        id: promptErrorId,
        role: "alert",
        xcss: $f9276ab10c8412ed$var$promptBodyStyles.error
    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        color: "color.text.danger"
    }, intl.formatMessage((0, $eNKzL.messages).emptyPrompt))));
    if (props.showToggle === false) return promptBody;
    return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1i531l7x _15a5nqa1 _uwhke4h9 _ca0qutpp"
        ])
    }, /*#__PURE__*/ $42omo.createElement("button", {
        "aria-expanded": isExpanded,
        disabled: isDisabled,
        onClick: props.onToggle,
        type: "button",
        className: (0, $gMc0m.default)([
            "_11c81kw7 _189eidpf _r06hglyw _1e0c1txw _4cvr1h6o _1bsb1osq _bfhk1j28 _syazazsu _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _y3gn1e5h _mizu1v1w _1ah31b66 _ra3xnqa1 _128mdkaa"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
        label: "",
        color: "currentColor"
    }), /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            "_18u012x7"
        ])
    }, intl.formatMessage((0, $eNKzL.messages).promptToggleLabel)), /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            "_18u01wug"
        ])
    }, isExpanded ? /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
        label: "",
        color: "currentColor"
    }) : /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        label: "",
        color: "currentColor"
    }))), isExpanded && promptBody);
};


const $29ca2ddd1047ec4d$var$saveErrorStyles = null;
const $29ca2ddd1047ec4d$var$footerStyles = null;
const $29ca2ddd1047ec4d$var$actionsStyles = null;
const $29ca2ddd1047ec4d$export$ece65817fe850722 = ({ aimoData: aimoData = null, cloudId: cloudId, currentPageSourceUrl: currentPageSourceUrl, initialConfiguration: initialConfiguration, onSave: onSave, onCancel: onCancel, onClearError: onClearError, isSaving: isSaving = false, error: error = null, persistedConfig: persistedConfig = null, smartCardProviderProduct: smartCardProviderProduct })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { goalOptions: promptGoalOptions } = (0, $12b26cc1dff66792$export$9860925510add594)();
    const [configuration, setConfiguration] = (0, $42omo.useState)(initialConfiguration);
    const [hasAttemptedSave, setHasAttemptedSave] = (0, $42omo.useState)(false);
    const [pendingDisclaimerConfig, setPendingDisclaimerConfig] = (0, $42omo.useState)(null);
    const hasEditedConfigurationRef = (0, $42omo.useRef)(false);
    const hasEditedPromptRef = (0, $42omo.useRef)(false);
    const lastHydratedConfigurationRef = (0, $42omo.useRef)(initialConfiguration);
    const configurationRef = (0, $42omo.useRef)(configuration);
    (0, $42omo.useEffect)(()=>{
        configurationRef.current = configuration;
    }, [
        configuration
    ]);
    (0, $42omo.useEffect)(()=>{
        const currentConfiguration = configurationRef.current;
        const lastHydratedConfiguration = lastHydratedConfigurationRef.current;
        lastHydratedConfigurationRef.current = initialConfiguration;
        if ((0, $h9X5P.arePanelConfigurationsEqual)(currentConfiguration, lastHydratedConfiguration, currentPageSourceUrl)) {
            hasEditedConfigurationRef.current = false;
            hasEditedPromptRef.current = false;
            setPendingDisclaimerConfig(null);
            setConfiguration(initialConfiguration);
        }
    }, [
        currentPageSourceUrl,
        initialConfiguration
    ]);
    const clearErrorsOnInteraction = (0, $42omo.useCallback)(()=>{
        setHasAttemptedSave(false);
        setPendingDisclaimerConfig(null);
        onClearError?.();
    }, [
        onClearError
    ]);
    const markConfigurationEdited = (0, $42omo.useCallback)(()=>{
        hasEditedConfigurationRef.current = true;
    }, []);
    const handleConfigurationChange = (0, $42omo.useCallback)((update)=>{
        setConfiguration(update);
    }, []);
    const handlePromptToggle = (0, $42omo.useCallback)(()=>{
        const currentMode = configurationRef.current.mode;
        const shouldResetConfiguration = currentMode === 'prompt' && hasEditedPromptRef.current;
        const shouldResetPrompt = currentMode === 'configuration' && hasEditedConfigurationRef.current;
        clearErrorsOnInteraction();
        setConfiguration((currentConfiguration)=>{
            if (currentConfiguration.mode === 'prompt') {
                if (shouldResetConfiguration) return (0, $h9X5P.getDefaultStructuredPanelConfiguration)(currentConfiguration);
                return {
                    ...currentConfiguration,
                    mode: 'configuration'
                };
            }
            if (shouldResetPrompt) return {
                ...currentConfiguration,
                mode: 'prompt',
                prompt: ''
            };
            return {
                ...currentConfiguration,
                mode: 'prompt'
            };
        });
        if (shouldResetConfiguration || shouldResetPrompt) {
            hasEditedConfigurationRef.current = false;
            hasEditedPromptRef.current = false;
        }
    }, [
        clearErrorsOnInteraction
    ]);
    const handlePromptChange = (0, $42omo.useCallback)((nextPrompt)=>{
        clearErrorsOnInteraction();
        if (configurationRef.current.prompt !== nextPrompt) hasEditedPromptRef.current = true;
        setConfiguration((currentConfiguration)=>({
                ...currentConfiguration,
                prompt: nextPrompt
            }));
    }, [
        clearErrorsOnInteraction
    ]);
    const handlePromptContentSelectionChange = (0, $42omo.useCallback)((nextSelection)=>{
        if (nextSelection === 'prompt') return;
        const shouldResetConfiguration = configurationRef.current.mode === 'prompt' && hasEditedPromptRef.current;
        clearErrorsOnInteraction();
        setConfiguration((currentConfiguration)=>{
            const baseConfiguration = shouldResetConfiguration ? (0, $h9X5P.getDefaultStructuredPanelConfiguration)(currentConfiguration) : {
                ...currentConfiguration,
                mode: 'configuration'
            };
            const nextOutputFormat = (0, $lbsCi.getOutputFormatForGoal)(nextSelection, baseConfiguration.outputFormat);
            if (baseConfiguration.goal !== nextSelection || baseConfiguration.outputFormat !== nextOutputFormat) hasEditedConfigurationRef.current = true;
            return {
                ...baseConfiguration,
                goal: nextSelection,
                outputFormat: nextOutputFormat
            };
        });
        if (shouldResetConfiguration) hasEditedPromptRef.current = false;
    }, [
        clearErrorsOnInteraction
    ]);
    const configInput = (0, $42omo.useMemo)(()=>(0, $h9X5P.toAiManagedObjectConfigInput)(configuration, currentPageSourceUrl), [
        configuration,
        currentPageSourceUrl
    ]);
    const validation = (0, $42omo.useMemo)(()=>(0, $ba196f68cb9fb124$export$f21a0ba102fbd812)(configInput), [
        configInput
    ]);
    const manualSourceValidationError = (0, $42omo.useMemo)(()=>{
        if (configuration.mode !== 'configuration' || configuration.sourceMode !== 'manual') return null;
        if (configuration.sourceEntries.length === 0) return 'required';
        if (configuration.sourceEntries.some((source)=>source.status === 'resolving')) return 'pending';
        if (configuration.sourceEntries.some((source)=>source.status === 'invalid')) return 'invalid';
        if (!configuration.sourceEntries.some((source)=>source.status === 'resolved')) return 'required';
        return null;
    }, [
        configuration.mode,
        configuration.sourceEntries,
        configuration.sourceMode
    ]);
    const sourceValidationError = hasAttemptedSave && configuration.mode === 'configuration' && configuration.sourceMode === 'manual' ? manualSourceValidationError : null;
    const isAdditionalContextInvalid = configuration.mode === 'configuration' && configuration.isAdditionalContextSelected && configuration.additionalContext.trim().length === 0;
    const additionalContextValidationError = hasAttemptedSave && isAdditionalContextInvalid;
    const promptValidationError = hasAttemptedSave && configuration.mode === 'prompt' && configuration.prompt.trim().length === 0;
    const hasConfigurationChanged = (0, $h9X5P.hasPersistedConfigurationChanged)(persistedConfig, configInput);
    const isSaveDisabled = isSaving || !hasConfigurationChanged;
    const handleSave = (0, $42omo.useCallback)(()=>{
        if (isSaveDisabled) return;
        setHasAttemptedSave(true);
        if (manualSourceValidationError || isAdditionalContextInvalid || !validation.valid) return;
        setPendingDisclaimerConfig(configInput);
    }, [
        configInput,
        isAdditionalContextInvalid,
        isSaveDisabled,
        manualSourceValidationError,
        validation
    ]);
    const handleBackFromDisclaimer = (0, $42omo.useCallback)(()=>{
        setPendingDisclaimerConfig(null);
        onClearError?.();
    }, [
        onClearError
    ]);
    const handleAgreeToDisclaimer = (0, $42omo.useCallback)(()=>{
        if (!pendingDisclaimerConfig || isSaving) return;
        Promise.resolve(onSave(pendingDisclaimerConfig)).finally(()=>{
            setPendingDisclaimerConfig(null);
        });
    }, [
        isSaving,
        onSave,
        pendingDisclaimerConfig
    ]);
    const handleCancel = (0, $42omo.useCallback)(()=>{
        setPendingDisclaimerConfig(null);
        onCancel?.();
    }, [
        onCancel
    ]);
    const isDisclaimerStepOpen = pendingDisclaimerConfig !== null;
    return /*#__PURE__*/ $42omo.createElement((0, $d69acc824aed5ffd$export$9ce5063a680c0a10), {
        testId: "agent-managed-extension-configure-panel"
    }, isDisclaimerStepOpen ? /*#__PURE__*/ $42omo.createElement((0, $2229dad5801064be$export$8095a6afc34b6dbb), {
        isSaving: isSaving,
        onAgree: handleAgreeToDisclaimer,
        onBack: handleBackFromDisclaimer,
        onCancel: onCancel ? handleCancel : undefined
    }) : configuration.mode === 'configuration' ? /*#__PURE__*/ $42omo.createElement((0, $a30bbb5fd91239f3$export$aac584ace4a7b830), {
        additionalContextValidationError: additionalContextValidationError,
        configuration: configuration,
        isDisabled: isSaving,
        onChange: handleConfigurationChange,
        onConfigEdit: markConfigurationEdited,
        onInteraction: clearErrorsOnInteraction,
        onPromptSelect: handlePromptToggle,
        smartCardProviderProduct: smartCardProviderProduct,
        sourceValidationError: sourceValidationError
    }) : /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
        space: "space.150"
    }, /*#__PURE__*/ $42omo.createElement((0, $d87cdb2032958b54$export$9ec0a8bc422643e4), {
        contentSelection: "prompt",
        isDisabled: isSaving,
        onContentSelectionChange: handlePromptContentSelectionChange,
        options: promptGoalOptions
    }), /*#__PURE__*/ $42omo.createElement((0, $f9276ab10c8412ed$export$a61c020b7ca91c15), {
        isDisabled: isSaving,
        isExpanded: true,
        onPromptChange: handlePromptChange,
        prompt: configuration.prompt,
        promptValidationError: promptValidationError,
        showToggle: false
    })), error && /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": "agent-managed-extension-error",
        role: "alert",
        className: (0, $gMc0m.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o _syaz1tmw"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        label: "",
        color: "currentColor",
        size: "small"
    }), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        color: "color.text.danger"
    }, error)), !isDisclaimerStepOpen && /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_zulppxbi _1e0c1txw _4cvr1h6o"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $20cf332ac8636775$export$b029164683c5c152), {
        aimoData: aimoData,
        cloudId: cloudId
    }), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_18u01wug"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        space: "space.100",
        alignInline: "end"
    }, onCancel && /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: handleCancel,
        isDisabled: isSaving
    }, intl.formatMessage((0, $eNKzL.messages).cancel)), /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
        appearance: "primary",
        testId: "agent-managed-extension-save",
        onClick: handleSave,
        isDisabled: isSaveDisabled,
        iconAfter: isSaving ? ()=>/*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
                size: "small"
            }) : undefined
    }, intl.formatMessage((0, $eNKzL.messages).save))))));
};



const $44a38ec982d94db4$var$CONTEXT_PRODUCT_TO_SMART_CARD_PRODUCT = {
    atlas: 'ATLAS',
    bitbucket: 'BITBUCKET',
    confluence: 'CONFLUENCE',
    csm: 'CSM',
    elevate: 'ELEVATE',
    jira: 'JSW',
    'jira-product-discovery': 'JPD',
    'jira-service-management': 'JSM',
    'jira-software': 'JSW',
    'jira-work-management': 'JWM',
    jpd: 'JPD',
    jsm: 'JSM',
    jsw: 'JSW',
    jwm: 'JWM',
    trello: 'TRELLO'
};
const $44a38ec982d94db4$export$1989f8c06c32742e = (product)=>{
    if (!product) return undefined;
    const normalizedProduct = product.trim().toLowerCase().replace(/[\s_]+/g, '-');
    return $44a38ec982d94db4$var$CONTEXT_PRODUCT_TO_SMART_CARD_PRODUCT[normalizedProduct];
};





























const $7d1abdddd1130e61$export$abcc4eb8db800758 = ({ editorView: editorView })=>{
    const executeAiManagedObjectCallback = (0, $42omo.useCallback)((args)=>(0, $b204c96beb2c5d9f$export$8235b51c7030883b)({
            ...args,
            editorView: editorView
        }), [
        editorView
    ]);
    return {
        executeAiManagedObject: executeAiManagedObjectCallback
    };
};

















const $fb949713f73cf223$export$31a6a034849cb700 = ({ aimoId: aimoId, aimoLoadStatus: aimoLoadStatus, cachedAimo: cachedAimo, configLocalId: configLocalId, editorView: editorView, foundPos: foundPos, isOpen: isOpen, templateConfig: templateConfig })=>{
    const intl = (0, $aXWIB.useIntl)();
    const configurationLoadErrorMessage = intl.formatMessage((0, $eNKzL.messages).failedToLoadConfiguration);
    const [aimoData, setAimoData] = (0, $42omo.useState)(cachedAimo ?? null);
    const loadRequestIdRef = (0, $42omo.useRef)(0);
    const isMountedRef = (0, $42omo.useRef)(true);
    const isLoadedAimoCurrent = Boolean(aimoId && aimoData?.id === aimoId);
    const isExistingConfigurationPending = isOpen && foundPos !== undefined && Boolean(aimoId) && !cachedAimo && !isLoadedAimoCurrent && aimoLoadStatus !== 'failed';
    const cancelPendingConfigurationLoad = (0, $42omo.useCallback)(()=>{
        loadRequestIdRef.current += 1;
    }, []);
    const loadAiManagedObject = (0, $42omo.useCallback)(()=>{
        if (!aimoId) return;
        const requestId = loadRequestIdRef.current + 1;
        loadRequestIdRef.current = requestId;
        (0, $33wgy.getAiManagedObjectWithCache)({
            aimoId: aimoId,
            cachedAimo: cachedAimo,
            editorView: editorView,
            localId: configLocalId
        }).then((aimo)=>{
            if (!isMountedRef.current || loadRequestIdRef.current !== requestId) return;
            setAimoData(aimo);
        }).catch(()=>{
            if (!isMountedRef.current || loadRequestIdRef.current !== requestId) return;
            setAimoData(null);
        });
    }, [
        aimoId,
        cachedAimo,
        configLocalId,
        editorView
    ]);
    (0, $42omo.useEffect)(()=>()=>{
            isMountedRef.current = false;
            cancelPendingConfigurationLoad();
        }, [
        cancelPendingConfigurationLoad
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isOpen || foundPos === undefined) {
            cancelPendingConfigurationLoad();
            setAimoData(null);
            return;
        }
        if (!aimoId) {
            cancelPendingConfigurationLoad();
            setAimoData(null);
            return;
        }
        if (cachedAimo) {
            cancelPendingConfigurationLoad();
            setAimoData(cachedAimo);
            return;
        }
        if (aimoLoadStatus !== 'failed' && aimoLoadStatus !== 'loading') loadAiManagedObject();
    }, [
        aimoId,
        aimoLoadStatus,
        cachedAimo,
        cancelPendingConfigurationLoad,
        foundPos,
        isOpen,
        loadAiManagedObject
    ]);
    return {
        aimoData: aimoData,
        configurationLoadError: aimoLoadStatus === 'failed' ? configurationLoadErrorMessage : null,
        handleRetryConfigurationLoad: loadAiManagedObject,
        initialConfiguration: aimoData?.config ? (0, $h9X5P.getPanelConfigurationFromAimoConfig)(aimoData.config) : (0, $h9X5P.getPanelConfigurationFromTemplateConfig)(templateConfig),
        isLoadingConfiguration: isExistingConfigurationPending || aimoLoadStatus === 'loading',
        setAimoData: setAimoData
    };
};


const $22854b41e5ff0af2$var$validationErrorMessageKeys = {
    EMPTY_PROMPT: 'emptyPrompt',
    INVALID_DESIRED_UPDATE_FREQUENCY: 'invalidDesiredUpdateFrequency',
    MISSING_GOAL: 'missingGoal',
    MISSING_OUTPUT_FORMAT: 'missingOutputFormat',
    MISSING_SOURCES: 'missingSources'
};
const $22854b41e5ff0af2$var$getSaveTarget = (currentFound)=>{
    const attrs = currentFound.node.attrs;
    return {
        currentId: (0, $6BmjZ.getNodeAiManagedObject)(attrs)?.id,
        localId: currentFound.node.attrs.localId
    };
};
const $22854b41e5ff0af2$var$saveAiManagedObject = async ({ cloudId: cloudId, config: config, contentType: contentType, contextObjectId: contextObjectId, contextProduct: contextProduct, currentId: currentId, editorView: editorView, localId: localId })=>{
    if (currentId) return (0, $33wgy.updateAiManagedObjectWithCache)(editorView, {
        id: currentId,
        config: config
    }, localId, {
        type: 'CLOSE_CONFIG'
    });
    const referenceObject = (0, $479e257fc01c59d7$export$4d80ff8879a0429d)({
        cloudId: cloudId,
        contentType: contentType,
        objectId: contextObjectId,
        product: contextProduct
    });
    if (!referenceObject) return null;
    return (0, $33wgy.createAiManagedObjectWithCache)(editorView, {
        cloudId: referenceObject.cloudId,
        referenceObjectAri: referenceObject.referenceObjectAri,
        referenceProduct: 'CONFLUENCE',
        status: 'ACTIVE',
        type: 'BLOCK',
        config: config
    }, localId, {
        type: 'CLOSE_CONFIG'
    });
};
const $22854b41e5ff0af2$export$430fb711ca8693b9 = ({ aimoId: aimoId, aimoLoadStatus: aimoLoadStatus, cachedAimo: cachedAimo, cloudId: cloudId, configLocalId: configLocalId, contextIdentifierProvider: contextIdentifierProvider, contentType: contentType, editorView: editorView, foundPos: foundPos, isOpen: isOpen, templateConfig: templateConfig })=>{
    const intl = (0, $aXWIB.useIntl)();
    const saveErrorMessage = intl.formatMessage((0, $eNKzL.messages).saveError);
    const [isSaving, setIsSaving] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(null);
    const { executeAiManagedObject: executeAiManagedObject } = (0, $7d1abdddd1130e61$export$abcc4eb8db800758)({
        editorView: editorView
    });
    const contextObjectId = contextIdentifierProvider?.objectId;
    const contextProduct = contextIdentifierProvider?.product;
    const { aimoData: aimoData, configurationLoadError: configurationLoadError, handleRetryConfigurationLoad: handleRetryConfigurationLoad, initialConfiguration: initialConfiguration, isLoadingConfiguration: isLoadingConfiguration, setAimoData: setAimoData } = (0, $fb949713f73cf223$export$31a6a034849cb700)({
        aimoId: aimoId,
        aimoLoadStatus: aimoLoadStatus,
        cachedAimo: cachedAimo,
        configLocalId: configLocalId,
        editorView: editorView,
        foundPos: foundPos,
        isOpen: isOpen,
        templateConfig: templateConfig
    });
    (0, $42omo.useEffect)(()=>{
        if (!isOpen || foundPos === undefined) {
            setError(null);
            setIsSaving(false);
            return;
        }
        if (!aimoId || cachedAimo) setError(null);
    }, [
        aimoId,
        cachedAimo,
        foundPos,
        isOpen
    ]);
    const handleSave = (0, $42omo.useCallback)(async (config)=>{
        const validation = (0, $ba196f68cb9fb124$export$f21a0ba102fbd812)(config);
        if (!validation.valid) {
            const validationMessageKey = validation.errors[0]?.code ? $22854b41e5ff0af2$var$validationErrorMessageKeys[validation.errors[0].code] : undefined;
            setError(validationMessageKey ? intl.formatMessage((0, $eNKzL.messages)[validationMessageKey]) : saveErrorMessage);
            return;
        }
        setIsSaving(true);
        setError(null);
        try {
            const currentFound = (0, $eLkLF.findConfiguredAgentManagedExtension)(editorView, configLocalId);
            if (!currentFound) {
                setError(saveErrorMessage);
                setIsSaving(false);
                return;
            }
            const { currentId: currentId, localId: localId } = $22854b41e5ff0af2$var$getSaveTarget(currentFound);
            const shouldExecuteAfterSave = (0, $h9X5P.hasExecutableConfigurationChanged)(aimoData?.config, config);
            const aimo = await $22854b41e5ff0af2$var$saveAiManagedObject({
                cloudId: cloudId,
                config: config,
                contentType: contentType,
                contextObjectId: contextObjectId,
                contextProduct: contextProduct,
                currentId: currentId,
                editorView: editorView,
                localId: localId
            });
            if (!aimo) {
                setError(saveErrorMessage);
                setIsSaving(false);
                return;
            }
            setAimoData(aimo);
            setIsSaving(false);
            if (!shouldExecuteAfterSave) return;
            const executedAimo = await executeAiManagedObject({
                aimoId: aimo.id,
                localId: localId
            });
            if (executedAimo) setAimoData(executedAimo);
        } catch  {
            setError(saveErrorMessage);
            setIsSaving(false);
        }
    }, [
        aimoData?.config,
        cloudId,
        configLocalId,
        contentType,
        contextObjectId,
        contextProduct,
        editorView,
        executeAiManagedObject,
        intl,
        setAimoData,
        saveErrorMessage
    ]);
    const handleClearError = (0, $42omo.useCallback)(()=>{
        setError(null);
    }, []);
    const handleCancel = (0, $42omo.useCallback)(()=>{
        setError(null);
        setIsSaving(false);
        (0, $eLkLF.dispatchAgentManagedExtensionMeta)(editorView, {
            type: 'CLOSE_CONFIG'
        });
    }, [
        editorView
    ]);
    return {
        aimoData: aimoData,
        configurationLoadError: configurationLoadError,
        error: error,
        handleCancel: handleCancel,
        handleClearError: handleClearError,
        handleRetryConfigurationLoad: handleRetryConfigurationLoad,
        handleSave: handleSave,
        initialConfiguration: initialConfiguration,
        isLoadingConfiguration: isLoadingConfiguration,
        isSaving: isSaving
    };
};












var $dsI2r = parcelRequire("dsI2r");

const $cfd1a7571aeaf365$export$9ad62d688669e1e4 = ({ api: api, editorView: editorView })=>{
    const agentManagedExtensionState = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'agentManagedExtension'
    ], ({ agentManagedExtensionState: agentManagedExtensionState })=>agentManagedExtensionState);
    const isOpen = agentManagedExtensionState?.isConfigOpen ?? false;
    const configLocalId = agentManagedExtensionState?.configLocalId;
    const found = isOpen ? (0, $eLkLF.findConfiguredAgentManagedExtension)(editorView, configLocalId) : null;
    const dom = found ? editorView.nodeDOM(found.pos) : null;
    const blockElement = dom instanceof HTMLElement ? dom : null;
    const foundPos = found?.pos;
    const foundAttrs = found?.node.attrs;
    const aimoId = (0, $6BmjZ.getNodeAiManagedObject)(foundAttrs)?.id;
    const templateConfig = (0, $6BmjZ.getNodeTemplateConfig)(foundAttrs);
    const cachedAimo = aimoId ? (0, $dsI2r.getCachedAiManagedObjectFromPluginState)(agentManagedExtensionState, aimoId) : undefined;
    const aimoLoadStatus = (0, $dsI2r.getAiManagedObjectLoadStatusFromPluginState)(agentManagedExtensionState, aimoId);
    return {
        aimoId: aimoId,
        aimoLoadStatus: aimoLoadStatus,
        blockElement: blockElement,
        cachedAimo: cachedAimo,
        configLocalId: configLocalId,
        found: found,
        foundPos: foundPos,
        isOpen: isOpen,
        templateConfig: templateConfig
    };
};








const $2e88d1c0320ccb10$var$TOOLBAR_SELECTOR = '[data-testid="editor-floating-toolbar"]';
const $2e88d1c0320ccb10$export$73b2aadb6bc56e71 = ({ blockElement: blockElement, isOpen: isOpen })=>{
    const [toolbarElement, setToolbarElement] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        if (!isOpen) {
            if (toolbarElement) setToolbarElement(null);
            return;
        }
        if (toolbarElement) return;
        const toolbar = (0, $hTKp4.getDocument)()?.querySelector($2e88d1c0320ccb10$var$TOOLBAR_SELECTOR);
        if (toolbar) {
            setToolbarElement(toolbar);
            return;
        }
        const id = requestAnimationFrame(()=>{
            const el = (0, $hTKp4.getDocument)()?.querySelector($2e88d1c0320ccb10$var$TOOLBAR_SELECTOR);
            if (el) setToolbarElement(el);
        });
        return ()=>cancelAnimationFrame(id);
    }, [
        isOpen,
        toolbarElement
    ]);
    return toolbarElement ?? blockElement;
};


const $4de22c057a9c1f0d$var$POPUP_STYLE = {
    width: 500
};
const $4de22c057a9c1f0d$var$POPUP_OFFSET = [
    0,
    8
];
const $4de22c057a9c1f0d$var$selector = (states)=>({
        contextIdentifierProvider: states.contextIdentifierState?.contextIdentifierProvider
    });
const $4de22c057a9c1f0d$var$ConfigurationPanel = ({ configurationLoadError: configurationLoadError, isLoadingConfiguration: isLoadingConfiguration, onRetryConfigurationLoad: onRetryConfigurationLoad, ...configProps })=>{
    if (isLoadingConfiguration) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d69acc824aed5ffd$export$9ce5063a680c0a10), {
        testId: "agent-managed-extension-configure-panel-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hOr3J.AimoConfigurationLoadState), {
        status: "loading",
        testId: "agent-managed-extension-configure-panel-loading-state",
        variant: "panel"
    }));
    if (configurationLoadError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d69acc824aed5ffd$export$9ce5063a680c0a10), {
        testId: "agent-managed-extension-configure-panel-load-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hOr3J.AimoConfigurationLoadState), {
        errorMessage: configurationLoadError,
        onRetry: onRetryConfigurationLoad,
        status: "failed",
        testId: "agent-managed-extension-configure-panel-load-error-state",
        variant: "panel"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $29ca2ddd1047ec4d$export$ece65817fe850722), configProps);
};
const $4de22c057a9c1f0d$export$966c9838aaac668b = ({ api: api, cloudId: cloudId, contentType: contentType, editorView: editorView, mountPoint: mountPoint })=>{
    const intl = (0, $aXWIB.useIntl)();
    const configurationAriaLabel = intl.formatMessage((0, $eNKzL.messages).configurationAriaLabel);
    const { contextIdentifierProvider: contextIdentifierProvider } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'contextIdentifier'
    ], $4de22c057a9c1f0d$var$selector);
    const { aimoId: aimoId, aimoLoadStatus: aimoLoadStatus, blockElement: blockElement, cachedAimo: cachedAimo, configLocalId: configLocalId, found: found, foundPos: foundPos, isOpen: isOpen, templateConfig: templateConfig } = (0, $cfd1a7571aeaf365$export$9ad62d688669e1e4)({
        api: api,
        editorView: editorView
    });
    const targetElement = (0, $2e88d1c0320ccb10$export$73b2aadb6bc56e71)({
        blockElement: blockElement,
        isOpen: isOpen
    });
    const referenceObject = (0, $479e257fc01c59d7$export$4d80ff8879a0429d)({
        cloudId: cloudId,
        contentType: contentType,
        contextIdentifierProvider: contextIdentifierProvider
    });
    const currentPageSourceUrl = (0, $42omo.useMemo)(()=>(0, $7f0a7e5b79ab18a1$export$895a298bdabf4d43)(), []);
    const smartCardProviderProduct = (0, $44a38ec982d94db4$export$1989f8c06c32742e)(contextIdentifierProvider?.product);
    const { aimoData: aimoData, configurationLoadError: configurationLoadError, error: error, handleCancel: handleCancel, handleClearError: handleClearError, handleRetryConfigurationLoad: handleRetryConfigurationLoad, handleSave: handleSave, initialConfiguration: initialConfiguration, isLoadingConfiguration: isLoadingConfiguration, isSaving: isSaving } = (0, $22854b41e5ff0af2$export$430fb711ca8693b9)({
        aimoId: aimoId,
        aimoLoadStatus: aimoLoadStatus,
        cachedAimo: cachedAimo,
        cloudId: cloudId,
        configLocalId: configLocalId,
        contextIdentifierProvider: contextIdentifierProvider,
        contentType: contentType,
        editorView: editorView,
        foundPos: foundPos,
        isOpen: isOpen,
        templateConfig: templateConfig
    });
    const panelInitialConfiguration = (0, $42omo.useMemo)(()=>{
        const [source] = aimoData?.config?.sources ?? [];
        const isCurrentPageSource = Boolean(currentPageSourceUrl) && aimoData?.config?.sources?.length === 1 && source?.url === currentPageSourceUrl;
        return isCurrentPageSource ? {
            ...initialConfiguration,
            sourceMode: 'current-page'
        } : initialConfiguration;
    }, [
        aimoData?.config?.sources,
        currentPageSourceUrl,
        initialConfiguration
    ]);
    if (!isOpen || !found || !targetElement) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jwWgu.default), {
        alignX: "center",
        alignY: "bottom",
        target: targetElement,
        mountTo: mountPoint,
        zIndex: 100,
        fitWidth: 500,
        fitHeight: 250,
        preventOverflow: true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- `Popup` accepts only an inline style prop for its outer wrapper
        style: $4de22c057a9c1f0d$var$POPUP_STYLE,
        offset: $4de22c057a9c1f0d$var$POPUP_OFFSET,
        ariaLabel: configurationAriaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4de22c057a9c1f0d$var$ConfigurationPanel, {
        currentPageSourceUrl: currentPageSourceUrl,
        initialConfiguration: panelInitialConfiguration,
        persistedConfig: aimoData?.config,
        onSave: handleSave,
        onCancel: handleCancel,
        onClearError: handleClearError,
        onRetryConfigurationLoad: handleRetryConfigurationLoad,
        configurationLoadError: configurationLoadError,
        isLoadingConfiguration: isLoadingConfiguration,
        isSaving: isSaving,
        error: error,
        aimoData: aimoData,
        cloudId: referenceObject?.cloudId,
        smartCardProviderProduct: smartCardProviderProduct
    }));
};



const $12e05607d9afe6a8$export$29e21093a2799ca6 = ({ api: api, config: config })=>{
    const { cloudId: cloudId, contentType: contentType } = config ?? {};
    let currentEditorView;
    return {
        name: 'agentManagedExtension',
        pmPlugins () {
            return [
                {
                    name: 'agentManagedExtension',
                    plugin: ({ nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $c67814a0beae0bd9$export$ae829ec7b2625219)({
                            cloudId: cloudId,
                            contentType: contentType,
                            getContextIdentifierProvider: ()=>api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider,
                            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                        })
                }
            ];
        },
        actions: {
            cacheAiManagedObject: (aiManagedObject, localId)=>{
                api?.core?.actions.execute((0, $iEdEF.cacheAiManagedObject)(aiManagedObject, localId));
            },
            hasAiManagedObject: (localId)=>{
                const found = currentEditorView ? (0, $6BmjZ.findAgentManagedExtensionByLocalId)(currentEditorView.state, localId) : undefined;
                const attrs = found?.node.attrs;
                return Boolean((0, $6BmjZ.getNodeAiManagedObject)(attrs));
            },
            openConfig: ()=>{
                api?.core?.actions.execute((0, $iEdEF.openConfig)());
            },
            closeConfig: ()=>{
                api?.core?.actions.execute((0, $iEdEF.closeConfig)());
            },
            regenerate: ({ aimoId: fallbackAimoId, localId: localId })=>{
                const editorView = currentEditorView;
                if (!editorView?.editable) return;
                const found = (0, $6BmjZ.findAgentManagedExtensionByLocalId)(editorView.state, localId) ?? (0, $6BmjZ.findAgentManagedExtension)(editorView.state);
                if (!found) return;
                const blockLocalId = found.node.attrs.localId || localId;
                const pluginState = (0, $aZxYK.pluginKey).getState(editorView.state);
                const executionLifecycleState = blockLocalId ? pluginState?.executionLifecycleByLocalId[blockLocalId]?.state : undefined;
                if ((0, $gOFRe.isExecutingLifecycleState)(executionLifecycleState)) return;
                const aimoId = (0, $6BmjZ.getNodeAiManagedObject)(found.node.attrs)?.id ?? fallbackAimoId;
                if (!aimoId) return;
                (0, $b204c96beb2c5d9f$export$8235b51c7030883b)({
                    aimoId: aimoId,
                    editorView: editorView,
                    localId: blockLocalId
                });
            },
            toggleConfig: ()=>{
                api?.core?.actions.execute((0, $iEdEF.toggleConfig)());
            }
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint }) {
            if (!editorView) return null;
            currentEditorView = editorView;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4de22c057a9c1f0d$export$966c9838aaac668b), {
                api: api,
                cloudId: cloudId,
                contentType: contentType,
                editorView: editorView,
                mountPoint: popupsMountPoint
            });
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $aZxYK.pluginKey).getState(editorState) ?? undefined;
        }
    };
};


function $a02a997b573bd076$export$afe0ba724a7b4a9b({ options: options }) {
    return {
        cloudId: options?.cloudId,
        contentType: options?.contentType,
        extensionType: options?.extensionType
    };
}


function $0c2f04e1b2047d35$export$bfd53895e8497571({}) {
    return {};
}


function $d81d1c93b2723a66$export$b3e029fd31f94f55({ options: options, providers: providers }) {
    if (!providers.inlineCommentAnnotationProvider) return undefined;
    return {
        inlineComment: providers.inlineCommentAnnotationProvider,
        createCommentExperience: options.createCommentExperience,
        selectCommentExperience: {
            selectAnnotation: {
                complete: (annotationId)=>{
                    options.selectCommentExperience?.selectAnnotation.complete({
                        pageClass: 'editor',
                        annotationId: annotationId,
                        entryPoint: 'annotation-change'
                    });
                }
            }
        },
        viewInlineCommentTraceUFOPress: options.viewInlineCommentTraceUFOPress,
        annotationManager: options.annotationManager
    };
}


function $62f8ba4880f9bc65$export$eeaea850bc5c5797({ options: options }) {
    return {
        // Avatars are moved to Confluence codebase for Edit in Context
        // When Edit in Context is enabled primaryToolbarComponents is undefined
        // For more details please check
        // https://hello.atlassian.net/wiki/spaces/PCG/pages/2851572180/Editor+toolbar+for+live+pages+and+edit+in+context+projects
        collabEdit: options.collabEdit,
        // originally depends on !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
        takeFullWidth: true,
        showAvatarGroup: false
    };
}





function $f9a8c0c1e7451d6a$export$a23b3fa66082f163({ options: options }) {
    const removeScrollGutter = !(0, $dh538.fg)('confluence_frontend_content_wrapper') && options.__livePage;
    return {
        allowInlineCursorTarget: true,
        allowScrollGutter: removeScrollGutter ? undefined : {
            getScrollElement: ()=>document.querySelector('.fabric-editor-popup-scroll-parent')
        }
    };
}


function $d334ecc47eb552b2$export$af3ae864625d0aa8({ options: options }) {
    return {
        getLinkPath: options.getLinkPath,
        blockLinkHashPrefix: options.blockLinkHashPrefix
    };
}


function $8bccfb424d5fa2dc$export$817c0e398e6ff750({}) {
    return {
        // rolling out under platform_editor_small_font_size experiment
        allowFontSize: true,
        includeBlockQuoteAsTextstyleOption: true,
        lastNodeMustBeParagraph: false,
        isUndoRedoButtonsEnabled: true,
        allowBlockType: undefined
    };
}


function $b4a69510925f1bf4$export$3be6b735d5cbc3e6({ options: options }) {
    return {
        allowBreakoutButton: options.editorAppearance === 'full-page',
        appearance: options.editorAppearance
    };
}



var $eTj7Y = parcelRequire("eTj7Y");

// SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */ const $8224c29320fcf3e7$var$SMART_LINKS_BEFORE_MACROS = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
function $8224c29320fcf3e7$export$514131654bb897e2({ options: options, providers: providers }) {
    return {
        smartCardContext: options.smartCardContext,
        // From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx `CARD_OPTIONS =`
        allowDatasource: true,
        // END SECTION
        // SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
        provider: providers.cardProvider,
        resolveBeforeMacros: $8224c29320fcf3e7$var$SMART_LINKS_BEFORE_MACROS,
        allowBlockCards: true,
        allowEmbeds: true,
        // END SECTION
        onClickCallback: options.onClickCallback,
        fullWidthMode: options.editorAppearance === 'full-width',
        linkPicker: options.linkPicker,
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        lpLinkPicker: true,
        // END SECTION
        editorAppearance: options.editorAppearance,
        // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage: options.__livePage,
        isPageSSRed: Boolean((0, $eTj7Y.isSSR)() || window.__SSR_RENDERED__),
        CompetitorPrompt: options.CompetitorPrompt
    };
}


function $d9d9649de2dbd031$export$3f0ff0bcf72f4d98({ options: options }) {
    return {
        appearance: options.editorAppearance
    };
}





function $a2a62495d0b237cd$export$6e32a592ec823802({}) {
    return {
        allowCodeFolding: (0, $1oCLl.expValEquals)('platform_editor_code_block_fold_gutter', 'isEnabled', true)
    };
}


function $305271ceb53ceba2$export$74cc43e84bb9c20({ providers: providers }) {
    return {
        allowCopyToClipboard: true,
        useLongPressSelection: false,
        allowCompositionInputOverride: false,
        formatCodeProvider: providers.formatCodeProvider
    };
}



var $NPJKR = parcelRequire("NPJKR");




function $97db539f3207cc49$export$c1ebe19806bc53b1({ options: options, providers: providers }) {
    return {
        // Core options
        provider: providers.collabEditProvider,
        userId: options.collabEdit?.userId,
        useNativePlugin: options.collabEdit?.useNativePlugin,
        sanitizePrivateContent: true,
        hideTelecursorOnLoad: options.__livePage || (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true),
        // Invite to edit related options
        inviteToEditHandler: options.collabEdit?.inviteToEditHandler,
        isInviteToEditButtonSelected: options.collabEdit?.isInviteToEditButtonSelected,
        inviteToEditComponent: options.collabEdit?.inviteToEditComponent,
        // Analytics options
        EXPERIMENTAL_allowInternalErrorAnalytics: options.collabEdit?.EXPERIMENTAL_allowInternalErrorAnalytics ?? (0, $NPJKR.shouldForceTracking)()
    };
}


function $7beb6143196eb299$export$8a4106078b67336e({ options: options }) {
    return {
        initialContentMode: options?.initialContentMode ?? 'standard'
    };
}


function $7fda91ee426b843f$export$2c26eb5ff90afcfd({ providers: providers }) {
    return {
        contextIdentifierProvider: providers.contextIdentifierProvider
    };
}





function $fda7dd87454dbbfe$export$48a60d81b6bb28e3({ options: options }) {
    if (!options) return undefined;
    return(// SECTION: From confluence/next/packages/editor-presets/src/full-page/useFullPageEditorPreset.ts
    // If object-sidebar is not enabled, then we don't need to pass the contextPanelOptions
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $dh538.fg)('confluence_frontend_content_wrapper') && (0, $dh538.fg)('platform_editor_ai_object_sidebar_injection') ? {
        objectSideBar: options.objectSideBar
    } : undefined);
}


function $a9d0dea796d301cb$export$f18d68682e981a91({ providers: providers }) {
    return {
        autoformattingProvider: providers.autoformattingProvider
    };
}


function $5800946e73dfdf97$export$5598bb2314a53fa8({}) {
    return {
        weekStartDay: undefined
    };
}


function $ee9933e7e0674f7e$export$de47eee62065048e({ options: options }) {
    return {
        initialDisabledState: options?.disabled
    };
}


function $06215f60dfbcbe67$export$36a79e2b5698697a({ options: options }) {
    return {
        mode: options.viewMode
    };
}


function $a906181f7266be92$export$7adcaf18ca5c72c4({ providers: providers }) {
    return {
        emojiProvider: providers.emojiProvider,
        emojiNodeDataProvider: providers.emojiNodeDataProvider
    };
}


function $362ee14809cbfa43$export$ed53f0c49fce09d6({ options: options }) {
    return {
        allowInsertion: true,
        useLongPressSelection: false,
        appearance: options.editorAppearance,
        allowInteractiveExpand: true,
        __livePage: options.__livePage
    };
}


function $273444f993d6457d$export$c18b9102cd0790c9({ options: options }) {
    return {
        breakoutEnabled: options.editorAppearance === 'full-page',
        extensionHandlers: options.extensionHandlers,
        useLongPressSelection: false,
        appearance: options.editorAppearance,
        __rendererExtensionOptions: options.__rendererExtensionOptions,
        getExtensionHeight: options.getExtensionHeight,
        getUnsupportedContent: options.getUnsupportedContent
    };
}





function $adb3c641336c97c2$export$3bff061e5229a7({}) {
    /**
	 * @private
	 * @deprecated Don't add any new feature flags here!
	 *             If you need a new feature flag, use:
	 *             - {@link editorExperiment} for new experiments.
	 *             - {@link fg} for new feature gates.
	 */ return {
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        /**
		 * This feature flag has completed rollout in Confluence and is to be cleaned up from LD
		 * but cannot yet be cleaned up from editor component as pending rollout in other products first
		 */ lpLinkPicker: true,
        tableWithFixedColumnWidthsOption: true,
        // END SECTION
        // SECTION: From confluence/next/packages/full-page-editor/src/hooks/useEditorFullPageExperiments.ts
        tableSelector: (0, $iu6m9.editorExperiment)('platform_editor_tables_table_selector', true),
        macroInteractionUpdates: true,
        moreElementsInQuickInsertView: true,
        // END SECTION
        // SECTION: From confluence/next/packages/editor-presets/src/utils/createFeatureFlagsFromProps.ts
        catchAllTracking: false,
        showAvatarGroupAsPlugin: false,
        errorBoundaryDocStructure: false,
        synchronyErrorDocStructure: false,
        enableViewUpdateSubscription: false,
        collabAvatarScroll: false,
        twoLineEditorToolbar: false,
        disableSpellcheckByBrowser: undefined
    };
}


function $27d0d6e36526bf47$export$d9e183f0607e1b5d({}) {
    return {
        // originally depends on !!featureFlags.showAvatarGroupAsPlugin === false && !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
        takeFullWidth: true,
        twoLineEditorToolbar: false
    };
}


function $c0ae851f36fdd6ed$export$c66d0d1462a05bd({}) {
    return {
        shouldCalcBreakoutGridLines: true
    };
}


function $bed2397ba1490bc9$export$2a67100cd9c61f05({ options: options }) {
    return options;
}


function $95896b3041c3f29e$export$ab9ae3984d5aef33({ options: options }) {
    return {
        editorAppearance: options.editorAppearance,
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        lpLinkPicker: true,
        // END SECTION
        linkPicker: options.linkPicker,
        onClickCallback: options.onClickCallback,
        platform: 'web'
    };
}





function $fab2d9877f195fe9$export$1e11b615e9dc119e({ options: options }) {
    return {
        allowTables: true,
        allowExpand: true,
        horizontalRuleEnabled: true,
        tableSelectorSupported: (0, $iu6m9.editorExperiment)('platform_editor_tables_table_selector', true),
        nativeStatusSupported: true,
        showElementBrowserLink: true,
        appearance: options.editorAppearance,
        toolbarButtons: options.toolbarButtons
    };
}


function $7af068790f7bfc54$export$33fb6c6592b2cd5f({ options: options }) {
    return {
        allowBreakout: true,
        UNSAFE_addSidebarLayouts: true,
        useLongPressSelection: false,
        UNSAFE_allowSingleColumnLayout: undefined,
        editorAppearance: options.editorAppearance
    };
}


function $6c967c0338972b8a$export$d384a797e800fdbe({ options: options }) {
    return {
        showFlag: options.showFlag,
        contentId: options.contentId,
        killSwitchEnabled: options.killSwitchEnabled
    };
}





function $38bc9474afd9e3da$export$feaee25faac0c640({ options: options }) {
    return {
        // SECTION: From confluence/next/packages/loom-editor-utils/src/hooks/useLoomPluginOptions.tsx
        renderButton: options.renderButton,
        shouldShowToolbarButton: (0, $dh538.fg)('confluence_frontend_content_wrapper') ? false : undefined
    };
}


// oxlint-disable-next-line @atlassian/no-restricted-imports



const $957563a13666e022$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    invalidAltText: {
        id: "editor-presets-confluence.media.alt-text.invalid",
        defaultMessage: "We aren\u2019t able to accept every possible character in Alt text. All Unicode letters and numbers are OK, but these are the only acceptable symbols: , ' . - _ ( )."
    }
});


// @ts-ignore - TS1501 Typescript 5.9.2 upgrade
const $2e6b1e0adf5e7c43$var$STORAGE_SUPPORTS_REGEX = RegExp("^([\\p{L}\\p{N},'\\.\\s\\-_\\(\\)]|&amp;[0-9]{2};)*$", "u");
function $2e6b1e0adf5e7c43$export$484123ae56f6fbd9({ intl: intl, options: options, providers: providers }) {
    return {
        // SECTION: From confluence/next/packages/editor-features/src/utils/mediaOptions.ts
        provider: providers.mediaProvider,
        syncProvider: providers.syncMediaProvider,
        allowMediaSingle: true,
        allowResizing: true,
        allowResizingInTables: true,
        allowLinking: true,
        allowAltTextOnImages: true,
        allowCaptions: true,
        allowMediaInlineImages: true,
        allowPixelResizing: true,
        altTextValidator: (text)=>{
            if (!$2e6b1e0adf5e7c43$var$STORAGE_SUPPORTS_REGEX.test(text)) return [
                intl.formatMessage((0, $957563a13666e022$export$a7357cdd1f0b0168).invalidAltText)
            ];
            return [];
        },
        // END SECTION
        // SECTION: From confluence/next/packages/fabric-media-support/src/mediaFeatureFlags.ts
        featureFlags: {
            mediaInline: true
        },
        // END SECTION
        // SECTION: From confluence/next/packages/editor-presets/src/full-page/createFullPageEditorPreset.ts
        allowLazyLoading: true,
        allowBreakoutSnapPoints: true,
        allowAdvancedToolBarOptions: true,
        // originally value was Boolean(options.annotationProviders),
        allowCommentsOnMedia: true,
        allowDropzoneDropLine: true,
        allowMediaSingleEditable: true,
        allowRemoteDimensionsFetch: true,
        allowMarkingUploadsAsIncomplete: false,
        allowImagePreview: true,
        fullWidthEnabled: options.editorAppearance === 'full-width',
        createCommentExperience: options.createCommentExperience,
        editorAppearance: options.editorAppearance,
        isCopyPasteEnabled: true,
        alignLeftOnInsert: false,
        allowImageEditing: true,
        // END SECTION
        // SECTION: From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx
        waitForMediaUpload: true,
        // END SECTION
        mediaViewerExtensions: options.mediaViewerExtensions
    };
}


function $88561d0a7d14fe25$export$e15342409979aa19({ options: options, providers: providers }) {
    return {
        sanitizePrivateContent: true,
        insertDisplayName: true,
        allowZeroWidthSpaceAfter: true,
        profilecardProvider: providers.profilecardProvider,
        handleMentionsChanged: options.handleMentionsChanged,
        mentionProvider: providers.mentionProvider,
        currentUserId: options.currentUserId,
        getIsRovoPanelOpen: options.getIsRovoPanelOpen
    };
}


function $bd8f1b1ddb5bbf33$export$4677177d82484aef({ options: options }) {
    return options;
}


function $e4ed58ed879c9fcb$export$c18e432f323b002e({}) {
    return {
        useLongPressSelection: false,
        allowCustomPanel: true,
        allowCustomPanelEdit: true
    };
}


// SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */ const $fa78fd9e4ac03220$var$SMART_LINKS_BEFORE_MACROS = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
function $fa78fd9e4ac03220$export$6b1ad42d09c74964({ providers: providers }) {
    return {
        cardOptions: {
            provider: providers.cardProvider,
            // SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
            allowBlockCards: true,
            allowDatasource: true,
            allowEmbeds: true,
            resolveBeforeMacros: $fa78fd9e4ac03220$var$SMART_LINKS_BEFORE_MACROS
        },
        sanitizePrivateContent: true,
        isFullPage: true
    };
}



var $delmI = parcelRequire("delmI");







// oxlint-disable-next-line @atlassian/no-restricted-imports



const $0c363b067c28e4ed$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    easyMentionsPlaceholder: {
        id: "editor-presets-confluence.placeholder.easy-mentions-placeholder",
        defaultMessage: "Type / for all elements or @ to mention someone."
    },
    aiPlaceholder: {
        id: "editor-presets-confluence.placeholder.ai-placeholder",
        defaultMessage: "Type /ai for Atlassian Intelligence, / to add elements, or @ to mention someone (we'll let them know)."
    },
    defaultPlaceholder: {
        id: "editor-presets-confluence.placeholder.default-placeholder",
        defaultMessage: "Type / to insert elements"
    },
    editorEmptyDocumentPlaceholderAI: {
        id: "editor-presets-confluence.placeholder.default-placeholder-ai",
        defaultMessage: "Use {key}+' to ask AI, or type / to insert elements"
    },
    editorEmptyDocumentSpaceShortcutPlaceholder: {
        id: "editor-presets-confluence.placeholder.space-shortcut-placeholder",
        defaultMessage: "Press space to Ask Rovo or / to insert elements"
    },
    placeholderADF: {
        id: "editor-presets-confluence.placeholderADF",
        defaultMessage: "Press <code>space</code> to Ask Rovo or <code>/</code> to insert elements"
    }
});


function $ed527e247ef47110$export$c6841f879d4c8aef({ intl: intl, options: options }) {
    const shouldShowSpaceShortcut = options.isAIEnabled && (0, $dh538.fg)('platform_editor_ai_aifc_streaming');
    const placeholder = (()=>{
        // SECTION: From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx `const placeholderText = `
        if (options.viewMode === 'view') return undefined;
        // END SECTION
        // We disable the placeholder here becuase we want to use the new ADF placeholder, see below.
        if (shouldShowSpaceShortcut) return undefined;
        // SECTION: From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx `_getPlaceholderText()`
        if (!options.isAIEnabled) return intl.formatMessage((0, $0c363b067c28e4ed$export$a7357cdd1f0b0168).editorEmptyDocumentPlaceholderAI);
        if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return intl.formatMessage((0, $0c363b067c28e4ed$export$a7357cdd1f0b0168).defaultPlaceholder);
        return intl.formatMessage((0, $0c363b067c28e4ed$export$a7357cdd1f0b0168).easyMentionsPlaceholder);
    // END SECTION
    })();
    const placeholderADF = (()=>{
        if (options.viewMode === 'view') return undefined;
        if (shouldShowSpaceShortcut) return (0, $delmI.createADFFromHTML)(intl.formatMessage((0, $0c363b067c28e4ed$export$a7357cdd1f0b0168).placeholderADF, {
            code: (parts)=>`<code>${parts}</code>`
        }));
        return undefined;
    })();
    return {
        placeholder: placeholder,
        placeholderADF: placeholderADF,
        isPlaceholderHidden: options.isPlaceholderHidden,
        withEmptyParagraph: (0, $dh538.fg)('platform_editor_ai_aifc_streaming'),
        isRovoLLMEnabled: options.isRovoLLMEnabled,
        enableLoadingSpinner: options.enableLoadingSpinner ?? true
    };
}


function $4b7a940fbd9ab7e6$export$8b53e6ddc7cf96b4({}) {
    return {};
}


function $469541b3a31f7668$export$44901d053a58e418({ options: options }) {
    return {
        contextualFormattingEnabled: options.contextualFormattingEnabled
    };
}


function $0806234c3664bbe3$export$26cff1f2fe9f781b({ options: options }) {
    return {
        enableElementBrowser: true,
        elementBrowserHelpUrl: '',
        disableDefaultItems: false,
        headless: false,
        emptyStateHandler: options?.emptyStateHandler,
        prioritySortingFn: typeof options.quickInsert === 'object' ? options.quickInsert.prioritySortingFn : undefined,
        onInsert: typeof options.quickInsert === 'object' ? options.quickInsert.onInsert : undefined
    };
}


function $50bdc0a742a190dc$export$222c5aa4c9fb0805({ options: options }) {
    return options;
}





function $cac03336baa38d84$export$197b78e13e8987d2({ options: options }) {
    // SECTION: From confluence/next/packages/editor-presets/src/full-page/createFullPageEditorPreset.ts `.add(['selectionMarkerPlugin', ...])`
    return {
        hideCursorOnInit: options.__livePage || (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)
    };
// END SECTION
}


function $bce2ea603100f14d$export$ddc2936355c1da67({ options: options }) {
    return {
        useLongPressSelection: false,
        // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage: options.__livePage
    };
}


function $58fb7e1b2e3d8830$export$bc6dcb3c2a6112e1({ options: options, providers: providers }) {
    return {
        preferenceToolbarAboveSelection: false,
        contextualFormattingEnabled: options.contextualFormattingEnabled,
        userPreferencesProvider: providers.userPreferencesProvider,
        disablePin: options.disablePin
    };
}


function $2f6001cfadc66915$export$5c1f265f89d46b24({ options: options }) {
    if (!options?.originalDoc || !options?.steps) return undefined;
    return {
        originalDoc: options.originalDoc,
        steps: options.steps,
        colorScheme: options.colorScheme
    };
}


function $42449a068d1029fa$export$9d286ea8d36eb908({}) {
    return {
        menuDisabled: false,
        allowZeroWidthSpaceAfter: true
    };
}


function $0ffa63f2ac18d9df$export$3612ff8a6b94af71({}) {
    return undefined;
}


function $22e24b280b21f482$export$b4fe80869e994c19({ options: options }) {
    if (!options) return undefined;
    const { enableSourceCreation: enableSourceCreation, syncedBlockRenderer: syncedBlockRenderer, syncBlockDataProvider: syncBlockDataProvider } = options;
    return {
        enableSourceCreation: enableSourceCreation,
        syncedBlockRenderer: syncedBlockRenderer,
        syncBlockDataProvider: syncBlockDataProvider
    };
}








function $b0fd078804c4d40e$export$9868b594778cf535({ options: options }) {
    return {
        __livePage: (0, $dh538.fg)('platform_editor_table_auto_convert_fix') ? options.__livePage : undefined,
        // value from next/packages/editor-features/src/hooks/useTableOptions.ts
        tableOptions: {
            allowTableResizing: true,
            allowTableAlignment: true,
            allowBackgroundColor: true,
            allowColumnResizing: true,
            allowColumnSorting: true,
            allowDistributeColumns: true,
            allowHeaderColumn: true,
            allowHeaderRow: true,
            allowMergeCells: true,
            allowNumberColumn: true,
            allowNestedTables: true,
            allowControls: true,
            stickyHeaders: true,
            allowAddColumnWithCustomStep: false
        },
        isTableScalingEnabled: true,
        allowContextualMenu: true,
        fullWidthEnabled: options.editorAppearance === 'full-width',
        maxWidthEnabled: options.editorAppearance === 'max',
        wasFullWidthEnabled: options.prevEditorAppearance && options.prevEditorAppearance === 'full-width',
        getEditorFeatureFlags: ()=>({
                // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
                tableWithFixedColumnWidthsOption: (0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? undefined : true,
                // END SECTION
                // SECTION: From confluence/next/packages/full-page-editor/src/hooks/useEditorFullPageExperiments.ts
                tableSelector: (0, $iu6m9.editorExperiment)('platform_editor_tables_table_selector', true)
            }),
        isCommentEditor: false,
        isChromelessEditor: false,
        allowFixedColumnWidthOption: (0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? true : undefined
    };
}


function $7b30ba3bd64ec6ef$export$1d23e03c42bfc1ac({ options: options, providers: providers }) {
    return {
        allowNestedTasks: true,
        consumeTabs: true,
        useLongPressSelection: false,
        taskDecisionProvider: providers.taskDecisionProvider,
        hasEditPermission: options.hasEditPermission,
        requestToEditContent: options.requestToEditContent,
        hasRequestedEditPermission: options.hasRequestedEditPermission,
        allowBlockTaskItem: true
    };
}


function $66d129e0e4c9d3d6$export$a4eedeb4455295f2({}) {
    return true;
}


function $49b70790a016de8e$export$cb883a3a9320698e({}) {
    return {
        responsiveToolbarMenu: true
    };
}


function $c77faf25e0854c3b$export$bd221c449644c740({}) {
    return {
        showIndentationButtons: true,
        allowHeadingAndParagraphIndentation: true
    };
}


function $f35957c892e65a7c$export$2d206ce8fa0c3d37({ options: options }) {
    return {
        contextualFormattingEnabled: options.contextualFormattingEnabled
    };
}


function $13f585291e624521$export$f8fa1184f7aaa2b3({ options: options }) {
    return {
        ButtonWrapper: options?.ButtonWrapper,
        showOnToolbar: true
    };
}


function $bf80d731accec18a$export$612ea2d32c3e4c96({}) {
    return {
        isMobile: false
    };
}


function $5dceb4fefa80f405$export$abdb0d09187eec69({ providers: providers, options: options }) {
    return {
        userPreferencesProvider: providers.userPreferencesProviderNext,
        // If initialToolbarDockingPosition is set, use it to override any saved user preference
        initialUserPreferences: options.initialToolbarDockingPosition ? {
            toolbarDockingPosition: options.initialToolbarDockingPosition
        } : undefined
    };
}


function $61dfe3458b070193$export$e26bb6e41a7de602(props) {
    const { intl: intl, providers: providers, enabledOptionalPlugins: enabledOptionalPlugins } = props;
    // We remove all `never` properties from the ConfluenceFullPageBasePresetOptions.pluginOptions,
    // we need to return them back.
    const pluginOptions = props.pluginOptions;
    // @ts-ignore - Preset builder cannot infer mutually exclusive registry insertion points.
    return new (0, $bupcf.EditorPresetBuilder)().maybeAdd([
        (0, $1chBq.limitedModePlugin),
        (0, $6c967c0338972b8a$export$d384a797e800fdbe)({
            options: pluginOptions.limitedMode
        })
    ], !pluginOptions.limitedMode.killSwitchEnabled).add([
        (0, $l7rln.featureFlagsPlugin),
        (0, $adb3c641336c97c2$export$3bff061e5229a7)({
            options: pluginOptions.featureFlags
        })
    ]).add([
        (0, $jmHSv.analyticsPlugin),
        (0, $0c2f04e1b2047d35$export$bfd53895e8497571)({
            options: pluginOptions.analytics
        })
    ]).add((0, $55skd.betterTypeHistoryPlugin)).add([
        (0, $36iDo.pastePlugin),
        (0, $fa78fd9e4ac03220$export$6b1ad42d09c74964)({
            options: pluginOptions.paste,
            providers: providers
        })
    ]).add((0, $acwPl.default)).add((0, $jS0a0.focusPlugin)).add((0, $gyXPd.compositionPlugin)).add([
        (0, $kbe7k.contextIdentifierPlugin),
        (0, $7fda91ee426b843f$export$2c26eb5ff90afcfd)({
            options: pluginOptions.contextIdentifier,
            providers: providers
        })
    ]).add([
        (0, $fi7Vj.default),
        (0, $f9a8c0c1e7451d6a$export$a23b3fa66082f163)({
            options: pluginOptions.base
        })
    ]).maybeAdd([
        (0, $hEicH.userPreferencesPlugin),
        (0, $5dceb4fefa80f405$export$abdb0d09187eec69)({
            providers: providers,
            options: pluginOptions.userPreferencesPlugin
        })
    ], enabledOptionalPlugins.userPreferences).add((0, $4KTOl.decorationsPlugin)).add([
        (0, $fMaLE.typeAheadPlugin),
        (0, $bf80d731accec18a$export$612ea2d32c3e4c96)({
            options: pluginOptions.typeAhead
        })
    ]).add((0, $HYzBP.default)).add([
        (0, $itirX.primaryToolbarPlugin),
        (0, $469541b3a31f7668$export$44901d053a58e418)({
            options: pluginOptions.primaryToolbar
        })
    ]).maybeAdd((0, $a5jtK.uiControlRegistryPlugin), (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true) || (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_layout_column_menu', 'isEnabled', true)).maybeAdd([
        (0, $3JBsx.toolbarPlugin),
        (0, $f35957c892e65a7c$export$2d206ce8fa0c3d37)({
            options: pluginOptions.toolbar
        })
    ], Boolean(enabledOptionalPlugins.toolbar)).maybeAdd([
        (0, $k2prb.blockMenuPlugin),
        (0, $d334ecc47eb552b2$export$af3ae864625d0aa8)({
            options: pluginOptions.blockMenu
        })
    ], (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true)).add((0, $kw2eg.undoRedoPlugin)).add([
        (0, $khxQ7.blockTypePlugin),
        (0, $8bccfb424d5fa2dc$export$817c0e398e6ff750)({
            options: pluginOptions.blockType
        })
    ]).add((0, $kXH7i.clearMarksOnEmptyDocPlugin)).add([
        (0, $7nKrc.selectionToolbarPlugin),
        (0, $58fb7e1b2e3d8830$export$bc6dcb3c2a6112e1)({
            options: pluginOptions.selectionToolbar,
            providers: providers
        })
    ]).add([
        (0, $gATpw.hyperlinkPlugin),
        (0, $95896b3041c3f29e$export$ab9ae3984d5aef33)({
            options: pluginOptions.hyperlink
        })
    ]).add([
        (0, $5mDFx.textFormattingPlugin),
        (0, $49b70790a016de8e$export$cb883a3a9320698e)({
            options: pluginOptions.textFormatting
        })
    ]).add((0, $fI6T7.widthPlugin)).add([
        (0, $e6sdP.quickInsertPlugin),
        (0, $0806234c3664bbe3$export$26cff1f2fe9f781b)({
            options: pluginOptions.quickInsert
        })
    ]).add([
        (0, $kYgUn.placeholderPlugin),
        (0, $ed527e247ef47110$export$c6841f879d4c8aef)({
            intl: intl,
            options: pluginOptions.placeholder
        })
    ]).add((0, $vxKdN.unsupportedContentPlugin)).add([
        (0, $lgjGE.editorDisabledPlugin),
        (0, $ee9933e7e0674f7e$export$de47eee62065048e)({
            options: pluginOptions.editorDisabled
        })
    ]).add([
        (0, $6borH.submitEditorPlugin),
        (0, $0ffa63f2ac18d9df$export$3612ff8a6b94af71)({
            options: pluginOptions.submitEditor
        })
    ]).add((0, $kIhx9.copyButtonPlugin)).maybeAdd((0, $7sK9h.floatingToolbarPlugin), enabledOptionalPlugins.floatingToolbar ?? true).maybeAdd((0, $6AqNX.interactionPlugin), Boolean(enabledOptionalPlugins.interaction)).add([
        (0, $bULcr.selectionPlugin),
        (0, $bce2ea603100f14d$export$ddc2936355c1da67)({
            options: pluginOptions.selection
        })
    ]).add([
        (0, $7rj2U.default),
        (0, $305271ceb53ceba2$export$74cc43e84bb9c20)({
            providers: providers
        })
    ]).add((0, $bz4KD.ufoPlugin)).add((0, $2nH2Y.dataConsumerPlugin)).add((0, $3ihIB.accessibilityUtilsPlugin)).add((0, $2yr9J.contentInsertionPlugin)).add((0, $fPXRH.batchAttributeUpdatesPlugin)).add([
        (0, $cwPVT.breakoutPlugin),
        (0, $b4a69510925f1bf4$export$3be6b735d5cbc3e6)({
            options: pluginOptions.breakout
        })
    ]).add((0, $hr8mu.alignmentPlugin)).add([
        (0, $i2zv0.textColorPlugin),
        (0, $66d129e0e4c9d3d6$export$a4eedeb4455295f2)({
            options: pluginOptions.textColor
        })
    ]).add((0, $5HHoF.listPlugin)).add((0, $5DsxN.rulePlugin)).add([
        (0, $fTvEN.expandPlugin),
        (0, $362ee14809cbfa43$export$ed53f0c49fce09d6)({
            options: pluginOptions.expand
        })
    ]).add((0, $fCLXZ.guidelinePlugin)).add([
        (0, $fYKTL.gridPlugin),
        (0, $c0ae851f36fdd6ed$export$c66d0d1462a05bd)({
            options: pluginOptions.grid
        })
    ]).add([
        (0, $cpn0f.annotationPlugin),
        (0, $d81d1c93b2723a66$export$b3e029fd31f94f55)({
            options: pluginOptions.annotation,
            providers: providers
        })
    ]).add([
        (0, $cWFvG.mediaPlugin),
        (0, $2e6b1e0adf5e7c43$export$484123ae56f6fbd9)({
            intl: intl,
            options: pluginOptions.media,
            providers: providers
        })
    ]).add((0, $2U68K.mediaInsertPlugin)).add((0, $duFi2.default)).add([
        (0, $5u7tz.mentionsPlugin),
        (0, $88561d0a7d14fe25$export$e15342409979aa19)({
            options: pluginOptions.mentions,
            providers: providers
        })
    ]).add([
        (0, $hcboS.emojiPlugin),
        (0, $a906181f7266be92$export$7adcaf18ca5c72c4)({
            options: pluginOptions.emoji,
            providers: providers
        })
    ]).add([
        (0, $eeGWn.default),
        (0, $b0fd078804c4d40e$export$9868b594778cf535)({
            options: pluginOptions.table
        })
    ]).add([
        (0, $jaskt.tasksAndDecisionsPlugin),
        (0, $7b30ba3bd64ec6ef$export$1d23e03c42bfc1ac)({
            options: pluginOptions.tasksAndDecisions,
            providers: providers
        })
    ]).add([
        (0, $flknw.helpDialogPlugin),
        (0, $bed2397ba1490bc9$export$2a67100cd9c61f05)({
            options: {
                imageUploadProviderExists: false,
                aiEnabled: false
            }
        })
    ]).add([
        (0, $5AZDw.collabEditPlugin),
        (0, $97db539f3207cc49$export$c1ebe19806bc53b1)({
            options: pluginOptions.collabEdit,
            providers: providers
        })
    ]).add([
        (0, $b3BjA.default),
        (0, $e4ed58ed879c9fcb$export$c18e432f323b002e)({
            options: pluginOptions.panel
        })
    ]).add([
        (0, $1nZXu.contextPanelPlugin),
        (0, $fda7dd87454dbbfe$export$48a60d81b6bb28e3)({
            options: pluginOptions.contextPanel
        })
    ]).add([
        (0, $eyggb.extensionPlugin),
        (0, $273444f993d6457d$export$c18b9102cd0790c9)({
            options: pluginOptions.extension
        })
    ]).maybeAdd([
        (0, $12e05607d9afe6a8$export$29e21093a2799ca6),
        (0, $a02a997b573bd076$export$afe0ba724a7b4a9b)({
            options: pluginOptions.agentManagedExtension
        })
    ], (0, $dZ8uq.expValEqualsNoExposure)('agent-managed_blocks_mvp', 'isEnabled', true)).add([
        (0, $4iQt6.default),
        (0, $5800946e73dfdf97$export$5598bb2314a53fa8)({
            options: pluginOptions.date
        })
    ]).add([
        (0, $8HLyI.default),
        (0, $4b7a940fbd9ab7e6$export$8b53e6ddc7cf96b4)({
            options: pluginOptions.placeholderText
        })
    ]).add([
        (0, $05jmd.layoutPlugin),
        (0, $7af068790f7bfc54$export$33fb6c6592b2cd5f)({
            options: pluginOptions.layout
        })
    ]).maybeAdd(// Register uiControlRegistry before cardPlugin so card can register paste menu components at init.
    // @ts-expect-error - Preserve paste registry order; mutually exclusive with layout insertion.
    (0, $a5jtK.uiControlRegistryPlugin), (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_paste_actions_menu', 'isEnabled', true) && !((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_layout_column_menu', 'isEnabled', true) || (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true))).add([
        (0, $agrUc.cardPlugin),
        (0, $8224c29320fcf3e7$export$514131654bb897e2)({
            options: pluginOptions.card,
            providers: providers
        })
    ]).add([
        (0, $bS1lJ.customAutoformatPlugin),
        (0, $a9d0dea796d301cb$export$f18d68682e981a91)({
            options: pluginOptions.customAutoformat,
            providers: providers
        })
    ]).add([
        (0, $c8680.statusPlugin),
        (0, $42449a068d1029fa$export$9d286ea8d36eb908)({
            options: pluginOptions.status
        })
    ]).maybeAdd([
        (0, $efDik.syncedBlockPlugin),
        (0, $22e24b280b21f482$export$b4fe80869e994c19)({
            options: pluginOptions.syncedBlock
        })
    ], !!pluginOptions.syncedBlock && (0, $iu6m9.editorExperiment)('platform_synced_block', true)).add((0, $aUwPP.indentationPlugin)).add((0, $1GAIu.scrollIntoViewPlugin)).add([
        (0, $1KHo7.toolbarListsIndentationPlugin),
        (0, $c77faf25e0854c3b$export$bd221c449644c740)({
            options: pluginOptions.toolbarListsIndentation
        })
    ]).add([
        (0, $cVhn8.insertBlockPlugin),
        (0, $fab2d9877f195fe9$export$1e11b615e9dc119e)({
            options: pluginOptions.insertBlock
        })
    ]).add([
        (0, $PJ00O.avatarGroupPlugin),
        (0, $62f8ba4880f9bc65$export$eeaea850bc5c5797)({
            options: pluginOptions.avatarGroup
        })
    ]).maybeAdd([
        (0, $dtCIm.findReplacePlugin),
        (0, $27d0d6e36526bf47$export$d9e183f0607e1b5d)({
            options: pluginOptions.findReplace
        })
    ], enabledOptionalPlugins.findReplace).add((0, $hSJYu.borderPlugin)).add((0, $6q6xk.fragmentPlugin)).add([
        (0, $59fTa.pasteOptionsToolbarPlugin),
        {
            usePopupBasedPasteActionsMenu: false
        }
    ]).maybeAdd([
        (0, $01uqX.codeBidiWarningPlugin),
        (0, $d9d9649de2dbd031$export$3f0ff0bcf72f4d98)({
            options: pluginOptions.codeBidiWarning
        })
    ], !(0, $1oCLl.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true)).maybeAdd([
        (0, $80JwR.loomPlugin),
        (0, $38bc9474afd9e3da$export$feaee25faac0c640)({
            options: pluginOptions.loom
        })
    ], enabledOptionalPlugins.loom).add([
        (0, $3mcWz.editorViewModePlugin),
        (0, $06215f60dfbcbe67$export$36a79e2b5698697a)({
            options: pluginOptions.editorViewMode
        })
    ]).add((0, $hlZXw.editorViewModeEffectsPlugin)).add([
        (0, $5Qu3R.selectionMarkerPlugin),
        (0, $cac03336baa38d84$export$197b78e13e8987d2)({
            options: pluginOptions.selectionMarker
        })
    ]).add([
        (0, $2E0F0.blockControlsPlugin),
        {
            rightSideControlsEnabled: (0, $dh538.fg)('confluence_remix_button_right_side_block_fg') && (0, $dZ8uq.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true)
        }
    ]).add((0, $cu2RD.highlightPlugin)).maybeAdd((0, $5y9PZ.connectivityPlugin), enabledOptionalPlugins.connectivity).maybeAdd([
        (0, $dH9DB.metricsPlugin),
        (0, $bd8f1b1ddb5bbf33$export$4677177d82484aef)({
            options: pluginOptions.metrics
        })
    ], enabledOptionalPlugins.metrics).add([
        (0, $dme7x.contentFormatPlugin),
        (0, $7beb6143196eb299$export$8a4106078b67336e)({
            options: pluginOptions.contentFormat
        })
    ]).maybeAdd([
        (0, $jgFdO.codeBlockAdvancedPlugin),
        (0, $a2a62495d0b237cd$export$6e32a592ec823802)({
            options: pluginOptions.codeBlockAdvanced
        })
    ], enabledOptionalPlugins.codeBlockAdvanced).maybeAdd([
        (0, $4NiQW.selectionExtensionPlugin),
        (0, $50bdc0a742a190dc$export$222c5aa4c9fb0805)({
            options: pluginOptions.selectionExtension
        })
    ], enabledOptionalPlugins.selectionExtension).add((0, $3O0YV.userIntentPlugin)).maybeAdd([
        (0, $84Iqc.showDiffPlugin),
        (0, $2f6001cfadc66915$export$5c1f265f89d46b24)({
            options: pluginOptions.showDiff
        })
    ], enabledOptionalPlugins.showDiff).maybeAdd([
        (0, $aB4bz.trackChangesPlugin),
        (0, $13f585291e624521$export$f8fa1184f7aaa2b3)({
            options: pluginOptions.trackChanges
        })
    ], enabledOptionalPlugins.trackChanges).maybeAdd((0, $lQotL.localIdPlugin), enabledOptionalPlugins.localId);
}















var $8peeT = parcelRequire("8peeT");



var $4DEL1 = parcelRequire("4DEL1");


var $1ewUw = parcelRequire("1ewUw");


var $2Q35l = parcelRequire("2Q35l");


var $dF1N1 = parcelRequire("dF1N1");


var $bpbkI = parcelRequire("bpbkI");


var $dx8CK = parcelRequire("dx8CK");

function $07e3b36bfab2faab$export$afe0ba724a7b4a9b({ options: options }) {
    return {
        cloudId: options?.cloudId,
        contentType: options?.contentType,
        extensionType: options?.extensionType
    };
}



var $b7xX4 = parcelRequire("b7xX4");


var $bzbkd = parcelRequire("bzbkd");


var $bpSEE = parcelRequire("bpSEE");


var $70Ur3 = parcelRequire("70Ur3");


var $gG3sH = parcelRequire("gG3sH");


var $1eaC0 = parcelRequire("1eaC0");


var $b7e5N = parcelRequire("b7e5N");


var $6e0Xr = parcelRequire("6e0Xr");


var $8mYe0 = parcelRequire("8mYe0");


var $i9XZB = parcelRequire("i9XZB");


var $lSu7N = parcelRequire("lSu7N");


var $loJPN = parcelRequire("loJPN");


var $hCIES = parcelRequire("hCIES");




function $54a86813db4d4780$export$6e32a592ec823802({}) {
    return {
        allowCodeFolding: (0, $1oCLl.expValEquals)('platform_editor_code_block_fold_gutter', 'isEnabled', true)
    };
}



var $dSbzA = parcelRequire("dSbzA");


var $eUaTu = parcelRequire("eUaTu");


var $411xE = parcelRequire("411xE");

function $815cf72c0fd01db1$export$2c26eb5ff90afcfd({ providers: providers }) {
    return {
        contextIdentifierProvider: providers.contextIdentifierProvider
    };
}



var $7DQWQ = parcelRequire("7DQWQ");

function $0239ddf6db5a0e53$export$f18d68682e981a91({ providers: providers }) {
    return {
        autoformattingProvider: providers.autoformattingProvider
    };
}


function $0105ad9f4c3353d7$export$5598bb2314a53fa8({}) {
    return {
        weekStartDay: undefined
    };
}



var $l5VKX = parcelRequire("l5VKX");


var $cvSKL = parcelRequire("cvSKL");

function $0ec938d111941985$export$7adcaf18ca5c72c4({ providers: providers }) {
    return {
        emojiProvider: providers.emojiProvider,
        emojiNodeDataProvider: providers.emojiNodeDataProvider
    };
}



var $bLqvq = parcelRequire("bLqvq");

function $759d2e4ef0d8b24b$export$ed53f0c49fce09d6({ options: options }) {
    return {
        allowInsertion: true,
        useLongPressSelection: false,
        appearance: options.editorAppearance,
        allowInteractiveExpand: true,
        __livePage: options.__livePage
    };
}



var $crNDx = parcelRequire("crNDx");


var $bMIN2 = parcelRequire("bMIN2");

function $3434917e042efc57$export$d9e183f0607e1b5d({}) {
    return {
        // originally depends on !!featureFlags.showAvatarGroupAsPlugin === false && !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
        takeFullWidth: true,
        twoLineEditorToolbar: false
    };
}


function $f0763edceecb76c2$export$c66d0d1462a05bd({}) {
    return {
        shouldCalcBreakoutGridLines: true
    };
}



var $ho6wy = parcelRequire("ho6wy");


var $atxxf = parcelRequire("atxxf");


var $koReu = parcelRequire("koReu");

function $0c59805b4172bf23$export$33fb6c6592b2cd5f({ options: options }) {
    return {
        allowBreakout: true,
        UNSAFE_addSidebarLayouts: true,
        useLongPressSelection: false,
        UNSAFE_allowSingleColumnLayout: undefined,
        editorAppearance: options.editorAppearance
    };
}



var $fXtqB = parcelRequire("fXtqB");




function $1bb1e0cb9a7988e8$export$feaee25faac0c640({ options: options }) {
    return {
        // SECTION: From confluence/next/packages/loom-editor-utils/src/hooks/useLoomPluginOptions.tsx
        renderButton: options.renderButton,
        shouldShowToolbarButton: (0, $dh538.fg)('confluence_frontend_content_wrapper') ? false : undefined
    };
}



var $2RHVA = parcelRequire("2RHVA");

function $4c9dc0bddcbec186$export$e15342409979aa19({ options: options, providers: providers }) {
    return {
        sanitizePrivateContent: true,
        insertDisplayName: true,
        allowZeroWidthSpaceAfter: true,
        profilecardProvider: providers.profilecardProvider,
        handleMentionsChanged: options.handleMentionsChanged,
        mentionProvider: providers.mentionProvider,
        currentUserId: options.currentUserId,
        getIsRovoPanelOpen: options.getIsRovoPanelOpen
    };
}



var $iGGcn = parcelRequire("iGGcn");

function $fc9f968714fe9c5d$export$c18e432f323b002e({}) {
    return {
        useLongPressSelection: false,
        allowCustomPanel: true,
        allowCustomPanelEdit: true
    };
}


function $b06914c286e02396$export$b45c01eec1548cb5({ options: options, usePopupBasedPasteActionsMenuDefault: usePopupBasedPasteActionsMenuDefault }) {
    return {
        pasteMenuButtonsFactory: options?.pasteMenuButtonsFactory,
        usePopupBasedPasteActionsMenu: options?.usePopupBasedPasteActionsMenu ?? usePopupBasedPasteActionsMenuDefault
    };
}



var $jY8iu = parcelRequire("jY8iu");


var $fzjlm = parcelRequire("fzjlm");

function $adb03a718cdd3145$export$8b53e6ddc7cf96b4({}) {
    return {};
}



var $1TfUS = parcelRequire("1TfUS");


var $jmiBO = parcelRequire("jmiBO");


var $34JVP = parcelRequire("34JVP");


var $ddVvy = parcelRequire("ddVvy");


var $3QJIE = parcelRequire("3QJIE");


var $gWT9r = parcelRequire("gWT9r");


var $a38jz = parcelRequire("a38jz");


var $bx6Sm = parcelRequire("bx6Sm");

function $c7ddbb7665d2a7d0$export$9d286ea8d36eb908({}) {
    return {
        menuDisabled: false,
        allowZeroWidthSpaceAfter: true
    };
}



var $kqt6j = parcelRequire("kqt6j");

function $227eaab840448c35$export$b4fe80869e994c19({ options: options }) {
    if (!options) return undefined;
    const { __livePage: __livePage, enableSourceCreation: enableSourceCreation, syncedBlockRenderer: syncedBlockRenderer, syncBlockDataProvider: syncBlockDataProvider } = options;
    return {
        __livePage: __livePage,
        enableSourceCreation: enableSourceCreation,
        syncedBlockRenderer: syncedBlockRenderer,
        syncBlockDataProvider: syncBlockDataProvider
    };
}



var $4H3SW = parcelRequire("4H3SW");


var $aD3RD = parcelRequire("aD3RD");

function $9a9dacee247babb9$export$a4eedeb4455295f2({}) {
    return true;
}



var $fsguo = parcelRequire("fsguo");

function $8ebcccb01b69e781$export$bd221c449644c740({}) {
    return {
        showIndentationButtons: true,
        allowHeadingAndParagraphIndentation: true
    };
}



var $9Da5o = parcelRequire("9Da5o");

function $9da95701694c2ca2$export$f8fa1184f7aaa2b3({ options: options }) {
    return {
        ButtonWrapper: options?.ButtonWrapper,
        showOnToolbar: true
    };
}



var $7Dfbr = parcelRequire("7Dfbr");


var $j5uEY = parcelRequire("j5uEY");

function $2b80134f192952c5$var$fullPagePresetLegacy(props) {
    const { intl: intl, providers: providers, enabledOptionalPlugins: enabledOptionalPlugins } = props;
    // We remove all `never` properties from the FullPagePresetProps.pluginOptions,
    // we need to return them back.
    const pluginOptions = props.pluginOptions;
    // @ts-ignore - Preset builder cannot infer mutually exclusive registry insertion points.
    return new (0, $bupcf.EditorPresetBuilder)().maybeAdd([
        (0, $1chBq.limitedModePlugin),
        (0, $fXtqB.limitedModePluginOptions)({
            options: pluginOptions.limitedMode
        })
    ], !pluginOptions.limitedMode.killSwitchEnabled).add([
        (0, $l7rln.featureFlagsPlugin),
        (0, $bMIN2.featureFlagsPluginOptions)({
            options: pluginOptions.featureFlags
        })
    ]).add([
        (0, $jmHSv.analyticsPlugin),
        (0, $1eaC0.analyticsPluginOptions)({
            options: pluginOptions.analytics
        })
    ]).add((0, $55skd.betterTypeHistoryPlugin)).add([
        (0, $36iDo.pastePlugin),
        (0, $jY8iu.pastePluginOptions)({
            options: pluginOptions.paste,
            providers: providers
        })
    ]).add((0, $acwPl.default)).add((0, $jS0a0.focusPlugin)).add((0, $gyXPd.compositionPlugin)).add([
        (0, $kbe7k.contextIdentifierPlugin),
        (0, $815cf72c0fd01db1$export$2c26eb5ff90afcfd)({
            options: pluginOptions.contextIdentifier,
            providers: providers
        })
    ]).add([
        (0, $fi7Vj.default),
        (0, $8mYe0.basePluginOptions)({
            options: pluginOptions.base
        })
    ]).maybeAdd([
        (0, $hEicH.userPreferencesPlugin),
        (0, $j5uEY.userPreferencesPluginOptions)({
            providers: providers,
            options: pluginOptions.userPreferencesPlugin
        })
    ], enabledOptionalPlugins.userPreferences).add((0, $4KTOl.decorationsPlugin)).add([
        (0, $fMaLE.typeAheadPlugin),
        (0, $7Dfbr.typeAheadPluginOptions)({
            options: pluginOptions.typeAhead
        })
    ]).add((0, $HYzBP.default)).add([
        (0, $itirX.primaryToolbarPlugin),
        (0, $1TfUS.primaryToolbarPluginOptions)({
            options: pluginOptions.primaryToolbar
        })
    ]).maybeAdd((0, $a5jtK.uiControlRegistryPlugin), (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true) || (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_layout_column_menu', 'isEnabled', true)).maybeAdd((0, $3O0YV.userIntentPlugin), (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true) || (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_layout_column_menu', 'isEnabled', true)).maybeAdd([
        (0, $3JBsx.toolbarPlugin),
        (0, $9Da5o.toolbarPluginOptions)({
            options: pluginOptions.toolbar
        })
    ], Boolean(enabledOptionalPlugins.toolbar)).maybeAdd([
        (0, $k2prb.blockMenuPlugin),
        {
            getLinkPath: pluginOptions.blockMenu?.getLinkPath,
            blockLinkHashPrefix: pluginOptions.blockMenu?.blockLinkHashPrefix
        }
    ], (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true)).add((0, $kw2eg.undoRedoPlugin)).add([
        (0, $khxQ7.blockTypePlugin),
        (0, $i9XZB.blockTypePluginOptions)({
            options: pluginOptions.blockType
        })
    ]).add((0, $kXH7i.clearMarksOnEmptyDocPlugin)).add([
        (0, $7nKrc.selectionToolbarPlugin),
        (0, $a38jz.selectionToolbarPluginOptions)({
            options: pluginOptions.selectionToolbar,
            providers: providers
        })
    ]).add([
        (0, $gATpw.hyperlinkPlugin),
        (0, $atxxf.hyperlinkPluginOptions)({
            options: pluginOptions.hyperlink
        })
    ]).add([
        (0, $5mDFx.textFormattingPlugin),
        (0, $fsguo.textFormattingPluginOptions)({
            options: pluginOptions.textFormatting
        })
    ]).add((0, $fI6T7.widthPlugin)).add([
        (0, $e6sdP.quickInsertPlugin),
        (0, $jmiBO.quickInsertPluginOptions)({
            options: pluginOptions.quickInsert
        })
    ]).add([
        (0, $kYgUn.placeholderPlugin),
        (0, $fzjlm.placeholderPluginOptions)({
            intl: intl,
            options: pluginOptions.placeholder
        })
    ]).add((0, $vxKdN.unsupportedContentPlugin)).add([
        (0, $lgjGE.editorDisabledPlugin),
        (0, $l5VKX.editorDisabledPluginOptions)({
            options: pluginOptions.editorDisabled
        })
    ]).add([
        (0, $6borH.submitEditorPlugin),
        (0, $kqt6j.submitEditorPluginOptions)({
            options: pluginOptions.submitEditor
        })
    ]).add((0, $kIhx9.copyButtonPlugin)).maybeAdd((0, $7sK9h.floatingToolbarPlugin), enabledOptionalPlugins.floatingToolbar ?? true).maybeAdd((0, $6AqNX.interactionPlugin), Boolean(enabledOptionalPlugins.interaction)).add([
        (0, $bULcr.selectionPlugin),
        (0, $gWT9r.selectionPluginOptions)({
            options: pluginOptions.selection
        })
    ]).add([
        (0, $7rj2U.default),
        (0, $dSbzA.codeBlockPluginOptions)({
            providers: providers
        })
    ]).add((0, $bz4KD.ufoPlugin)).add((0, $2nH2Y.dataConsumerPlugin)).add((0, $3ihIB.accessibilityUtilsPlugin)).add((0, $2yr9J.contentInsertionPlugin)).add((0, $fPXRH.batchAttributeUpdatesPlugin)).add([
        (0, $cwPVT.breakoutPlugin),
        (0, $lSu7N.breakoutPluginOptions)({
            options: pluginOptions.breakout
        })
    ]).add((0, $hr8mu.alignmentPlugin)).add([
        (0, $i2zv0.textColorPlugin),
        (0, $9a9dacee247babb9$export$a4eedeb4455295f2)({
            options: pluginOptions.textColor
        })
    ]).add((0, $5HHoF.listPlugin)).add((0, $5DsxN.rulePlugin)).add([
        (0, $fTvEN.expandPlugin),
        (0, $759d2e4ef0d8b24b$export$ed53f0c49fce09d6)({
            options: pluginOptions.expand
        })
    ]).add((0, $fCLXZ.guidelinePlugin)).add([
        (0, $fYKTL.gridPlugin),
        (0, $f0763edceecb76c2$export$c66d0d1462a05bd)({
            options: pluginOptions.grid
        })
    ]).add([
        (0, $cpn0f.annotationPlugin),
        (0, $b7e5N.annotationPluginOptions)({
            options: pluginOptions.annotation,
            providers: providers
        })
    ]).add([
        (0, $cWFvG.mediaPlugin),
        (0, $2RHVA.mediaPluginOptions)({
            intl: intl,
            options: pluginOptions.media,
            providers: providers
        })
    ]).add((0, $2U68K.mediaInsertPlugin)).maybeAdd([
        (0, $2Q35l.aiImageGenerationPlugin),
        (0, $bzbkd.aiImageGenerationPluginOptions)({
            options: pluginOptions.aiImageGeneration
        })
    ], enabledOptionalPlugins.aiImageGeneration).add((0, $duFi2.default)).add([
        (0, $5u7tz.mentionsPlugin),
        (0, $4c9dc0bddcbec186$export$e15342409979aa19)({
            options: pluginOptions.mentions,
            providers: providers
        })
    ]).add([
        (0, $hcboS.emojiPlugin),
        (0, $0ec938d111941985$export$7adcaf18ca5c72c4)({
            options: pluginOptions.emoji,
            providers: providers
        })
    ]).add([
        (0, $eeGWn.default),
        (0, $4H3SW.tablePluginOptions)({
            options: pluginOptions.table
        })
    ]).add([
        (0, $jaskt.tasksAndDecisionsPlugin),
        (0, $aD3RD.tasksAndDecisionsPluginOptions)({
            options: pluginOptions.tasksAndDecisions,
            providers: providers
        })
    ]).add([
        (0, $flknw.helpDialogPlugin),
        (0, $ho6wy.helpDialogPluginOptions)({
            options: {
                imageUploadProviderExists: false,
                aiEnabled: enabledOptionalPlugins.aiExperience
            }
        })
    ]).maybeAdd([
        (0, $5AZDw.collabEditPlugin),
        (0, $eUaTu.collabEditPluginOptions)({
            options: pluginOptions.collabEdit,
            providers: providers
        })
    ], Boolean(pluginOptions.collabEdit.collabEdit)).add([
        (0, $b3BjA.default),
        (0, $fc9f968714fe9c5d$export$c18e432f323b002e)({
            options: pluginOptions.panel
        })
    ]).add([
        (0, $1nZXu.contextPanelPlugin),
        (0, $7DQWQ.contextPanelPluginOptions)({
            options: pluginOptions.contextPanel
        })
    ]).add([
        (0, $eyggb.extensionPlugin),
        (0, $crNDx.extensionPluginOptions)({
            options: pluginOptions.extension
        })
    ]).maybeAdd([
        (0, $12e05607d9afe6a8$export$29e21093a2799ca6),
        (0, $07e3b36bfab2faab$export$afe0ba724a7b4a9b)({
            options: pluginOptions.agentManagedExtension
        })
    ], (0, $dZ8uq.expValEqualsNoExposure)('agent-managed_blocks_mvp', 'isEnabled', true)).add([
        (0, $4iQt6.default),
        (0, $0105ad9f4c3353d7$export$5598bb2314a53fa8)({
            options: pluginOptions.date
        })
    ]).add([
        (0, $8HLyI.default),
        (0, $adb03a718cdd3145$export$8b53e6ddc7cf96b4)({
            options: pluginOptions.placeholderText
        })
    ]).add([
        (0, $05jmd.layoutPlugin),
        (0, $0c59805b4172bf23$export$33fb6c6592b2cd5f)({
            options: pluginOptions.layout
        })
    ]).maybeAdd(// Register uiControlRegistry before cardPlugin so card can register paste menu components at init.
    // @ts-expect-error - Mutually exclusive with the earlier layout experiment insertion.
    (0, $a5jtK.uiControlRegistryPlugin), (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_paste_actions_menu', 'isEnabled', true) && !((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_layout_column_menu', 'isEnabled', true) || (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true))).add([
        (0, $agrUc.cardPlugin),
        (0, $loJPN.cardPluginOptions)({
            options: pluginOptions.card,
            providers: providers
        })
    ]).add([
        (0, $bS1lJ.customAutoformatPlugin),
        (0, $0239ddf6db5a0e53$export$f18d68682e981a91)({
            options: pluginOptions.customAutoformat,
            providers: providers
        })
    ]).add([
        (0, $c8680.statusPlugin),
        (0, $c7ddbb7665d2a7d0$export$9d286ea8d36eb908)({
            options: pluginOptions.status
        })
    ]).maybeAdd([
        (0, $efDik.syncedBlockPlugin),
        (0, $227eaab840448c35$export$b4fe80869e994c19)({
            options: pluginOptions.syncedBlock
        })
    ], !!pluginOptions.syncedBlock && (0, $iu6m9.editorExperiment)('platform_synced_block', true)).add((0, $aUwPP.indentationPlugin)).add((0, $1GAIu.scrollIntoViewPlugin)).add([
        (0, $1KHo7.toolbarListsIndentationPlugin),
        (0, $8ebcccb01b69e781$export$bd221c449644c740)({
            options: pluginOptions.toolbarListsIndentation
        })
    ]).add([
        (0, $cVhn8.insertBlockPlugin),
        (0, $koReu.insertBlockPluginOptions)({
            options: pluginOptions.insertBlock
        })
    ]).add([
        (0, $PJ00O.avatarGroupPlugin),
        (0, $6e0Xr.avatarGroupPluginOptions)({
            options: pluginOptions.avatarGroup
        })
    ]).maybeAdd([
        (0, $dtCIm.findReplacePlugin),
        (0, $3434917e042efc57$export$d9e183f0607e1b5d)({
            options: pluginOptions.findReplace
        })
    ], enabledOptionalPlugins.findReplace).add((0, $hSJYu.borderPlugin)).add((0, $6q6xk.fragmentPlugin)).add([
        (0, $59fTa.pasteOptionsToolbarPlugin),
        (0, $b06914c286e02396$export$b45c01eec1548cb5)({
            options: pluginOptions.pasteOptionsToolbar,
            usePopupBasedPasteActionsMenuDefault: enabledOptionalPlugins.aiExperience && pluginOptions.ai?.isInDocumentStreamingEnabled
        })
    ]).maybeAdd([
        (0, $01uqX.codeBidiWarningPlugin),
        (0, $hCIES.codeBidiWarningPluginOptions)({
            options: pluginOptions.codeBidiWarning
        })
    ], !(0, $1oCLl.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true))// below plugins moved from legacy preset
    .maybeAdd([
        (0, $dx8CK.referentialityPlugin),
        enabledOptionalPlugins.referentiality ? (0, $34JVP.referentialityPluginOptions)({
            options: pluginOptions.referentiality
        }) : undefined
    ], enabledOptionalPlugins.referentiality).maybeAdd([
        (0, $80JwR.loomPlugin),
        (0, $1bb1e0cb9a7988e8$export$feaee25faac0c640)({
            options: pluginOptions.loom
        })
    ], enabledOptionalPlugins.loom).add([
        (0, $3mcWz.editorViewModePlugin),
        (0, $cvSKL.editorViewModePluginOptions)({
            options: pluginOptions.editorViewMode
        })
    ]).add((0, $hlZXw.editorViewModeEffectsPlugin))// aiDefinitionsPlugin depends on editorViewModePlugin
    .maybeAdd([
        (0, $1ewUw.aiDefinitionsPlugin),
        (0, $b7xX4.aiDefinitionsPluginOptions)({
            options: pluginOptions.aiDefinitions
        })
    ], enabledOptionalPlugins.aiDefinitions).maybeAdd([
        (0, $4DEL1.aiPlugin),
        (0, $bpSEE.aiPluginOptions)({
            options: pluginOptions.ai
        })
    ], enabledOptionalPlugins.aiExperience).add([
        (0, $5Qu3R.selectionMarkerPlugin),
        (0, $3QJIE.selectionMarkerPluginOptions)({
            options: pluginOptions.selectionMarker
        })
    ]).add([
        (0, $2E0F0.blockControlsPlugin),
        {
            rightSideControlsEnabled: (0, $dh538.fg)('confluence_remix_button_right_side_block_fg') && (0, $dZ8uq.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true)
        }
    ]).add((0, $cu2RD.highlightPlugin)).add([
        (0, $8ABVP.engagementPlatformPlugin),
        (0, $bLqvq.engagementPlatformPluginOptions)({
            options: pluginOptions.engagementPlatform
        })
    ]).maybeAdd((0, $5y9PZ.connectivityPlugin), enabledOptionalPlugins.connectivity).maybeAdd([
        (0, $dH9DB.metricsPlugin),
        (0, $iGGcn.metricsPluginOptions)({
            options: pluginOptions.metrics
        })
    ], enabledOptionalPlugins.metrics).add([
        (0, $dme7x.contentFormatPlugin),
        (0, $411xE.contentFormatPluginOptions)({
            options: pluginOptions.contentFormat
        })
    ]).maybeAdd([
        (0, $jgFdO.codeBlockAdvancedPlugin),
        (0, $54a86813db4d4780$export$6e32a592ec823802)({
            options: pluginOptions.codeBlockAdvanced
        })
    ], enabledOptionalPlugins.codeBlockAdvanced).maybeAdd([
        (0, $4NiQW.selectionExtensionPlugin),
        (0, $ddVvy.selectionExtensionPluginOptions)({
            options: pluginOptions.selectionExtension
        })
    ], enabledOptionalPlugins.selectionExtension).maybeAdd(// @ts-expect-error - Mutually exclusive with the earlier table menu updates experiment insertion.
    (0, $3O0YV.userIntentPlugin), !((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true) || (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_layout_column_menu', 'isEnabled', true))).maybeAdd([
        (0, $84Iqc.showDiffPlugin),
        (0, $bx6Sm.showDiffPluginOptions)({
            options: pluginOptions.showDiff
        })
    ], enabledOptionalPlugins.showDiff).maybeAdd([
        (0, $aB4bz.trackChangesPlugin),
        (0, $9da95701694c2ca2$export$f8fa1184f7aaa2b3)({
            options: pluginOptions.trackChanges
        })
    ], enabledOptionalPlugins.trackChanges).maybeAdd((0, $lQotL.localIdPlugin), enabledOptionalPlugins.localId).maybeAdd([
        (0, $dF1N1.aiStreamingOrchestratorPlugin),
        (0, $70Ur3.aiStreamingOrchestratorPluginOptions)({
            options: pluginOptions.aiStreamingOrchestrator
        })
    ], enabledOptionalPlugins.aiStreamingOrchestrator).maybeAdd((0, $8peeT.aiSpeechToTextPlugin), enabledOptionalPlugins.aiSpeechToText).maybeAdd([
        (0, $bpbkI.aiSuggestionsPlugin),
        (0, $gG3sH.aiSuggestionsOptions)({
            options: pluginOptions.aiSuggestions
        })
    ], enabledOptionalPlugins.aiSuggestions);
}
const $2b80134f192952c5$var$fullPagePresetNext = (props)=>{
    const { intl: intl, providers: providers, enabledOptionalPlugins: enabledOptionalPlugins } = props;
    // We remove all `never` properties from the FullPagePresetProps.pluginOptions,
    // we need to return them back.
    const pluginOptions = props.pluginOptions;
    return (0, $61dfe3458b070193$export$e26bb6e41a7de602)({
        intl: intl,
        providers: providers,
        enabledOptionalPlugins: enabledOptionalPlugins,
        pluginOptions: pluginOptions
    }).maybeAdd([
        (0, $2Q35l.aiImageGenerationPlugin),
        (0, $bzbkd.aiImageGenerationPluginOptions)({
            options: pluginOptions.aiImageGeneration
        })
    ], enabledOptionalPlugins.aiImageGeneration)// below plugins moved from legacy preset
    .maybeAdd([
        (0, $dx8CK.referentialityPlugin),
        enabledOptionalPlugins.referentiality ? (0, $34JVP.referentialityPluginOptions)({
            options: pluginOptions.referentiality
        }) : undefined
    ], enabledOptionalPlugins.referentiality)// aiDefinitionsPlugin depends on editorViewModePlugin
    .maybeAdd([
        (0, $1ewUw.aiDefinitionsPlugin),
        (0, $b7xX4.aiDefinitionsPluginOptions)({
            options: pluginOptions.aiDefinitions
        })
    ], enabledOptionalPlugins.aiDefinitions).maybeAdd([
        (0, $4DEL1.aiPlugin),
        (0, $bpSEE.aiPluginOptions)({
            options: pluginOptions.ai
        })
    ], enabledOptionalPlugins.aiExperience).add([
        (0, $8ABVP.engagementPlatformPlugin),
        (0, $bLqvq.engagementPlatformPluginOptions)({
            options: pluginOptions.engagementPlatform
        })
    ]).maybeAdd([
        (0, $dF1N1.aiStreamingOrchestratorPlugin),
        (0, $70Ur3.aiStreamingOrchestratorPluginOptions)({
            options: pluginOptions.aiStreamingOrchestrator
        })
    ], enabledOptionalPlugins.aiStreamingOrchestrator).maybeAdd((0, $8peeT.aiSpeechToTextPlugin), enabledOptionalPlugins.aiSpeechToText).maybeAdd([
        (0, $bpbkI.aiSuggestionsPlugin),
        (0, $gG3sH.aiSuggestionsOptions)({
            options: pluginOptions.aiSuggestions
        })
    ], enabledOptionalPlugins.aiSuggestions);
};
function $2b80134f192952c5$export$9f1bd789d5e1fd40(props) {
    return (0, $1oCLl.expValEquals)('platform_editor_confluence_base_preset', 'isEnabled', true) ? $2b80134f192952c5$var$fullPagePresetNext(props) : $2b80134f192952c5$var$fullPagePresetLegacy(props);
}



var $ipg0f = parcelRequire("ipg0f");


var $6WVPv = parcelRequire("6WVPv");

/**
 * EDITOR-6558: Denylist of toolbar component `key` strings that should be
 * hidden when the editor is in Markdown Mode.
 *
 * The strings here come from `@atlaskit/editor-common/toolbar/keys`, where
 * each plugin's toolbar registration uses a stable key constant. Anything
 * matching one of these keys is filtered out by `toolbarPlugin`'s
 * `componentFilter` before it reaches the registry, so the buttons never
 * appear (regardless of whether the toolbar is pinned or floating).
 *
 * The list is the toolbar-component-flavoured equivalent of
 * `MARKDOWN_COMPATIBLE_TOOLBAR_ITEM_NAMES` (which targets the `+` insert
 * block specifically). Entries are conservative — only marks/nodes with no
 * GFM round-trip are excluded. Marks like `bold` / `italic` / `code` /
 * `strike` are intentionally NOT in the list because they have a clean GFM
 * representation.
 *
 * This is a denylist (not an allowlist) because toolbar components are
 * registered by ~17 different plugins with hundreds of stable keys; an
 * allowlist would silently break unrelated functionality (selection
 * toolbar, table toolbar, AI floating toolbar, etc.) the moment we miss
 * a key.
 */ const $8114702bedaf0f51$export$a49253e1b6a4f67a = [
    // --- Visual marks with no GFM equivalent ---
    // Text colour & highlight (lossy on round-trip)
    'text-color-highlight-group',
    'text-color-highlight-menu',
    'text-color-highlight-menu-section',
    'text-color-menu-item',
    'highlight-menu-item',
    // Underline / sub / super (GFM strict mode doesn't include these)
    'underline-button-group',
    'underline-button',
    'underline-menu-item',
    'subscript-menu-item',
    'superscript-menu-item',
    // Alignment (GFM has no inline alignment marker)
    'alignment-group',
    'alignment-menu',
    'alignment-menu-section',
    // Indentation as a mark (lists themselves are still supported)
    // Note: list buttons themselves remain — only the indentation-as-mark
    // menu item is removed. We keep the broader lists-indentation group
    // because it carries the bulk of list functionality.
    // --- Inline / block nodes with no GFM equivalent ---
    'mention-group',
    'mention-button',
    'emoji-group',
    'emoji-button',
    'layout-group',
    'layout-button',
    // Note: `media-group` and `media-button` were previously blocked because
    // `mediaSingle`/`media` didn't survive the markdown round-trip. EDITOR-6636
    // fixed this: external media serialises to `![alt](url)` and file media
    // serialises to a Confluence tenant proxy URL, both losslessly parseable
    // back to `mediaSingle > media`. These keys are intentionally NOT in the
    // denylist any more so the media toolbar button is visible in markdown mode.
    // Synced blocks — Atlassian-cloud-only block reuse mechanism with no
    // representation in markdown.
    'synced-block-group',
    'synced-block-button',
    'synced-block-section'
];
const $8114702bedaf0f51$export$35401f2d7ef9b34b = new Set($8114702bedaf0f51$export$a49253e1b6a4f67a);
const $8114702bedaf0f51$export$567bd3c3a1a1ead7 = (component)=>{
    return !$8114702bedaf0f51$export$35401f2d7ef9b34b.has(component.key);
};

/**
 * EDITOR-6558: Allowlist of `MenuItem.value.name` strings that the main
 * editor toolbar should expose when the editor is in Markdown Mode.
 *
 * The strings here come from `editor-plugin-insert-block`'s
 * `ui/ToolbarInsertBlock/item.tsx`, where each item factory hard-codes a
 * `name`. Anything not on this allowlist is hidden from the toolbar
 * (button row + overflow dropdown) while Markdown Mode is active.
 *
 * The list is the toolbar-flavoured equivalent of
 * `MARKDOWN_COMPATIBLE_QUICK_INSERT_ITEM_IDS`. Entries are intentionally
 * kept minimal — only nodes/marks that survive a clean GFM round-trip via
 * `@atlassian/mdast-util-from-pm` are included.
 *
 * If you add a new mdast handler that lets a previously-excluded node
 * round-trip cleanly, add the matching name here so the toolbar surfaces it.
 */ const $5e0cfaca612140f5$export$3d509a43eb16227c = [
    // Inline marks / nodes with a clean GFM equivalent:
    'link',
    'image upload',
    // EDITOR-6636: full media insert also now round-trips cleanly.
    // `'media'` opens the Atlassian media picker (file/URL insert), which
    // produces `mediaSingle > media` — now serialised to a CommonMark image
    // via the proxy-URL pipeline. Keep both so users have both entry points.
    'media',
    'codeblock',
    'blockquote',
    'horizontalrule',
    'table',
    'table selector',
    'action'
];
const $5e0cfaca612140f5$export$5edd677c06a37e6a = new Set($5e0cfaca612140f5$export$3d509a43eb16227c);
const $5e0cfaca612140f5$export$d51800a5a6fed7d2 = (item)=>{
    if (!item.value?.name) return true;
    return $5e0cfaca612140f5$export$5edd677c06a37e6a.has(item.value.name);
};



var $lGoD9 = parcelRequire("lGoD9");





var $dus6D = parcelRequire("dus6D");




const $311d92b3b6eb92ca$export$56937bf89365f70d = new (0, $ks2lK.PluginKey)('aiAutocompletePlugin');


const $038bd350e498990f$export$92a1a3b7554e9387 = {
    TRIGGER_MANUAL: 'TRIGGER_MANUAL',
    TRIGGER_AUTO: 'TRIGGER_AUTO',
    SET_SUGGESTION: 'SET_SUGGESTION',
    REVEAL_SUGGESTION: 'REVEAL_SUGGESTION',
    ENTER_DURING_LOADING: 'ENTER_DURING_LOADING',
    DISMISS: 'DISMISS'
};


function $ce0cb3b91bae6d4d$export$75827d0f82a08bf5(state) {
    const { $from: $from } = state.selection;
    if ($from.depth === 1) {
        const name = $from.parent.type.name;
        return name === 'paragraph' || name === 'heading';
    }
    if ($from.depth === 2 && $from.node(1).type.name === 'panel') {
        const name = $from.parent.type.name;
        return name === 'paragraph' || name === 'heading';
    }
    return false;
}



var $d925B = parcelRequire("d925B");

const $e9233283002d8aa0$export$37798a7ff6f20cd2 = (editorAnalyticsAPI)=>(transaction, triggerType)=>{
        const payload = {
            action: (0, $d925B.ACTION).INVOKED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).AI_AUTOCOMPLETE,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                triggerType: triggerType
            }
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $e9233283002d8aa0$export$edd7849651b2a74a = (editorAnalyticsAPI)=>(transaction)=>{
        const payload = {
            action: (0, $d925B.ACTION).SUGGESTION_VIEWED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).AI_AUTOCOMPLETE,
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $e9233283002d8aa0$export$c26e1e4a084cdc9e = (editorAnalyticsAPI)=>(transaction)=>{
        const payload = {
            action: (0, $d925B.ACTION).SUGGESTION_INSERTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).AI_AUTOCOMPLETE,
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $e9233283002d8aa0$export$61436ea80e595f1a = (editorAnalyticsAPI)=>(transaction)=>{
        const payload = {
            action: (0, $d925B.ACTION).SUGGESTION_DISMISSED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).AI_AUTOCOMPLETE,
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };



var $c6GJD = parcelRequire("c6GJD");

function $20d0f4c91e5cc1c5$var$isStringList(value) {
    return Array.isArray(value) && value.every((item)=>typeof item === 'string');
}
const $20d0f4c91e5cc1c5$var$STRING_LIST_CONFIG_KEY = 'value';
function $20d0f4c91e5cc1c5$export$f1de66450aeccbb6(configName, token) {
    if (!(0, $c6GJD.default).initializeCompleted()) return false;
    try {
        // Dynamic configs are exposed through the same client surface as experiments.
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const config = (0, $c6GJD.default).getExperiment(configName);
        const listCandidate = config.value[$20d0f4c91e5cc1c5$var$STRING_LIST_CONFIG_KEY];
        if (!$20d0f4c91e5cc1c5$var$isStringList(listCandidate)) return false;
        return listCandidate.includes(token);
    } catch  {
        return false;
    }
}


function $371ce3c3ecf3dace$export$7e72d5dcc9007fb(state) {
    const { $from: $from } = state.selection;
    const parent = $from.parent;
    if (parent.type !== state.schema.nodes.heading) return {
        cursorInHeading: false,
        headingPos: -1,
        headingText: '',
        headingLevel: 0
    };
    // $from.before($from.depth) gives us the absolute position of the start of
    // the heading node (the opening token position).
    const headingPos = $from.before($from.depth);
    const headingText = parent.textContent.trim();
    const headingLevel = parent.attrs['level'] ?? 1;
    return {
        cursorInHeading: true,
        headingPos: headingPos,
        headingText: headingText,
        headingLevel: headingLevel
    };
}


/** Default minimum words when `platform_editor_ai_autocomplete_ux_config` has no word-count token. */ const $a33bacd3740d6e5a$var$MIN_DOCUMENT_WORDS = 400;
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
const $a33bacd3740d6e5a$var$WHITESPACE_SPLIT_REGEX = /\s+/u;
/** On Enter: dismiss if the cursor block exceeds this length (non-heading). */ const $a33bacd3740d6e5a$var$AUTO_DISMISS_MAX_CHARS_NON_HEADING = 20;
/** On Enter: dismiss if the cursor block exceeds this length (heading). */ const $a33bacd3740d6e5a$var$AUTO_DISMISS_MAX_CHARS_HEADING = 50;
const $a33bacd3740d6e5a$var$AI_AUTOCOMPLETE_UX_DYNAMIC_CONFIG = 'platform_editor_ai_autocomplete_ux_config';
/**
 * Minimum words in the whole document before autocomplete trigger may fire.
 * Driven by Statsig dynamic config `platform_editor_ai_autocomplete_ux_config`
 * string list (`value` key); first matching token wins if several are present.
 */ function $a33bacd3740d6e5a$var$getMinDocumentWords() {
    if ((0, $20d0f4c91e5cc1c5$export$f1de66450aeccbb6)($a33bacd3740d6e5a$var$AI_AUTOCOMPLETE_UX_DYNAMIC_CONFIG, 'word-count-300')) return 300;
    if ((0, $20d0f4c91e5cc1c5$export$f1de66450aeccbb6)($a33bacd3740d6e5a$var$AI_AUTOCOMPLETE_UX_DYNAMIC_CONFIG, 'word-count-200')) return 200;
    if ((0, $20d0f4c91e5cc1c5$export$f1de66450aeccbb6)($a33bacd3740d6e5a$var$AI_AUTOCOMPLETE_UX_DYNAMIC_CONFIG, 'word-count-350')) return 350;
    return $a33bacd3740d6e5a$var$MIN_DOCUMENT_WORDS;
}
function $a33bacd3740d6e5a$export$6f212eb1ee72d86a(doc) {
    return doc.textBetween(0, doc.content.size, '\n', ' ');
}
/**
 * Word count for the full document, aligned with editor analytics style:
 * normalize whitespace, then `Intl.Segmenter` word + `isWordLike`, else whitespace split.
 */ function $a33bacd3740d6e5a$var$countWordsInDocument(doc) {
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    const normalized = $a33bacd3740d6e5a$export$6f212eb1ee72d86a(doc).replace(/\s+/gu, ' ').trim();
    if (!normalized) return 0;
    if (typeof Intl !== 'undefined' && typeof Intl.Segmenter === 'function') try {
        const seg = new Intl.Segmenter('und', {
            granularity: 'word'
        });
        let n = 0;
        for (const part of seg.segment(normalized))if (part.isWordLike) n++;
        return n;
    } catch  {
    // fall through
    }
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    return normalized.split($a33bacd3740d6e5a$var$WHITESPACE_SPLIT_REGEX).length;
}
function $a33bacd3740d6e5a$export$203aad1d4d95d0de(state) {
    const inHeading = (0, $371ce3c3ecf3dace$export$7e72d5dcc9007fb)(state).cursorInHeading;
    const len = state.selection.$from.parent.textContent.length;
    const maxChars = inHeading ? $a33bacd3740d6e5a$var$AUTO_DISMISS_MAX_CHARS_HEADING : $a33bacd3740d6e5a$var$AUTO_DISMISS_MAX_CHARS_NON_HEADING;
    return len > maxChars;
}
function $a33bacd3740d6e5a$export$8532deffc62f2372(state) {
    const wordCount = $a33bacd3740d6e5a$var$countWordsInDocument(state.doc);
    return wordCount >= $a33bacd3740d6e5a$var$getMinDocumentWords();
}


/** How many lines from the top of the doc still count for Summary auto-trigger (first line = 1). */ const $42b59b5039e481b9$var$MAX_LINES_FROM_DOC_START = 4;
/** How many lines from the end of the doc count for Conclusion auto-trigger. */ const $42b59b5039e481b9$var$MAX_LINES_FROM_DOC_END = 4;
function $42b59b5039e481b9$export$faff1b56818221b9(doc, pos) {
    const maxPos = doc.content.size;
    const clamped = Math.max(1, Math.min(pos, maxPos));
    const slice = doc.textBetween(1, clamped, '\n', ' ');
    if (!slice) return 1;
    return slice.split('\n').length;
}
function $42b59b5039e481b9$export$86e2c649a3fb270b(state) {
    return $42b59b5039e481b9$export$faff1b56818221b9(state.doc, state.selection.from) <= $42b59b5039e481b9$var$MAX_LINES_FROM_DOC_START;
}
function $42b59b5039e481b9$export$a0cc97e2eec5e2c9(state) {
    const { doc: doc } = state;
    const cursorLine = $42b59b5039e481b9$export$faff1b56818221b9(doc, state.selection.from);
    const totalLines = $42b59b5039e481b9$export$faff1b56818221b9(doc, doc.content.size);
    return totalLines - cursorLine < $42b59b5039e481b9$var$MAX_LINES_FROM_DOC_END;
}



function $0d9b827195d68a18$export$430bd2456e5b9d09(event) {
    if (event.metaKey || event.ctrlKey || event.altKey) return false;
    if (event.key === 'Enter') return true;
    if (event.key.length === 1) return $0d9b827195d68a18$var$WORD_TERMINATOR_CHAR_REGEX.test(event.key);
    return false;
}
function $0d9b827195d68a18$export$32dfe294464a680b(state) {
    const { $from: $from } = state.selection;
    if (!$from.parent.isTextblock || $from.parentOffset === 0) return null;
    const textBefore = $from.parent.textBetween(0, $from.parentOffset, undefined, '\ufffc');
    const withoutTrailingSeparators = textBefore.replace($0d9b827195d68a18$var$TRAILING_SEP_RE, '');
    if (!withoutTrailingSeparators) return null;
    const words = withoutTrailingSeparators.split($0d9b827195d68a18$var$WORD_SPLIT_RE);
    const last = words[words.length - 1];
    if (!last || !$0d9b827195d68a18$var$WORD_CHAR_RE.test(last)) return null;
    return last;
}
function $0d9b827195d68a18$export$38f22e55366a41d0(word, keywordSet) {
    return keywordSet.includes(word.toLowerCase());
}
const $0d9b827195d68a18$var$WORD_TERMINATOR_CHAR_REGEX = /[\s.,;:!?)\]}"'»«/\\]/u;
const $0d9b827195d68a18$var$TRAILING_SEP_RE = RegExp("[\\s\\p{P}]+$", "u");
const $0d9b827195d68a18$var$WORD_SPLIT_RE = RegExp("[\\s\\p{P}]+", "u");
const $0d9b827195d68a18$var$WORD_CHAR_RE = RegExp("^[\\p{L}\\p{N}_]+$", "u");
const $0d9b827195d68a18$var$BOUNDARY_RE = RegExp("[\\s\\p{P}]", "u");
function $0d9b827195d68a18$export$2ba08fd9849922d8(state, keywords) {
    const { $from: $from } = state.selection;
    if (!$from.parent.isTextblock || $from.parentOffset === 0) return false;
    let maxKwLen = 0;
    for(let i = 0; i < keywords.length; i++)if (keywords[i].length > maxKwLen) maxKwLen = keywords[i].length;
    // +1 for the word-boundary char we need to inspect; +20 covers trailing
    // separators stripped before matching.
    const extractFrom = Math.max(0, $from.parentOffset - maxKwLen - 21);
    const tail = $from.parent.textBetween(extractFrom, $from.parentOffset, undefined, '\ufffc');
    const trimmed = tail.replace($0d9b827195d68a18$var$TRAILING_SEP_RE, '');
    if (!trimmed) return false;
    const lower = trimmed.toLowerCase();
    for(let i = 0; i < keywords.length; i++){
        const kw = keywords[i];
        if (lower === kw) return true;
        if (lower.length > kw.length && lower.endsWith(kw) && $0d9b827195d68a18$var$BOUNDARY_RE.test(lower[lower.length - kw.length - 1])) return true;
    }
    return false;
}





const $0142429418a04af3$export$ee1116f260b39d9b = (0, $aXWIB.defineMessages)({
    summaryKeywords: {
        id: "fabric.editor.ai.autocomplete.summary.trigger.keywords.non-final",
        defaultMessage: "summary, tldr, tl;dr, tl dr, overview, synopsis, recap, abstract, brief, outline, quick, in short, rundown, review, roundup, highlights, key points, snapshot, at a glance, in essence, takeaways, to summarize, to summarise"
    },
    conclusionKeywords: {
        id: "fabric.editor.ai.autocomplete.conclusion.trigger.keywords.non-final",
        defaultMessage: "conclusion, conclusions, findings, results, outcome, outcomes, final thoughts, takeaway, takeaways, verdict, determination, resolution, final analysis, deduction, judgment, decision, culmination, end result, bottom line, final word, closing, to conclude, final notes, learnings, what we learned, overall"
    },
    nextStepsKeywords: {
        id: "fabric.editor.ai.autocomplete.next.steps.trigger.keywords.non-final",
        defaultMessage: "recommendations, follow-through, implementation, moving forward, going forward, deliverables, path forward, what is next, way forward, what's next, next steps, priorities, whats next, task list, follow-up, follow up, next step, followup, priority, next up, up next, roadmap, actions, action, tasks, todos, to do, to-do, todo, plan"
    }
});


/**
 * Parses the formatted trigger-keywords string (comma-separated phrases) into trimmed tokens.
 */ function $4e14c2a9f109857c$var$splitAutocompleteTriggerKeywords(intl, messages) {
    return intl().formatMessage(messages).split(',').map((s)=>s.trim()).filter((s)=>s.length > 0);
}
function $4e14c2a9f109857c$export$d5883a29c5e2615e(intl) {
    return $4e14c2a9f109857c$var$splitAutocompleteTriggerKeywords(intl, (0, $0142429418a04af3$export$ee1116f260b39d9b).summaryKeywords);
}
function $4e14c2a9f109857c$export$ec1e17d2784ef29d(intl) {
    return $4e14c2a9f109857c$var$splitAutocompleteTriggerKeywords(intl, (0, $0142429418a04af3$export$ee1116f260b39d9b).conclusionKeywords);
}
function $4e14c2a9f109857c$export$840323b8f6b537aa(intl) {
    return $4e14c2a9f109857c$var$splitAutocompleteTriggerKeywords(intl, (0, $0142429418a04af3$export$ee1116f260b39d9b).nextStepsKeywords);
}


/**
 * True for keys that typically mutate document text (printable chars,
 * Backspace, Delete, Enter) when not combined with meta/ctrl modifiers.
 */ function $e09ae141c8fa8668$var$isDocMutatingKey(event) {
    if (event.isComposing || event.key === 'Process') return false;
    if (event.key === 'Backspace' || event.key === 'Delete') return true;
    if (event.key === 'Enter' && !event.metaKey && !event.ctrlKey) return true;
    return event.key.length === 1 && !event.metaKey && !event.ctrlKey;
}
function $e09ae141c8fa8668$export$a57bf7fb2aa68075({ api: api, getIntl: getIntl }) {
    const editorAnalyticsAPI = api?.analytics?.actions;
    const createSectionKeywordTrigger = (config)=>{
        let pendingIdleId;
        const cancel = ()=>{
            if (pendingIdleId === undefined) return;
            if (typeof cancelIdleCallback === 'function') cancelIdleCallback(pendingIdleId);
            else cancelAnimationFrame(pendingIdleId);
            pendingIdleId = undefined;
        };
        /**
     * Pattern matching runs in an idle callback (see block-controls / insert-block)
     * so we do not add work on the critical key path; DOM + doc are up to date by then.
     */ const schedule = (view)=>{
            cancel();
            const flush = ()=>{
                pendingIdleId = undefined;
                if (view.isDestroyed) return;
                if ((0, $0d9b827195d68a18$export$2ba08fd9849922d8)(view.state, config.keywords) && !(0, $a33bacd3740d6e5a$export$203aad1d4d95d0de)(view.state)) {
                    const pluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(view.state);
                    if (pluginState && pluginState.status !== 'idle') api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.dismissSuggestion?.());
                    const { from: resolvedCursorPos } = view.state.selection;
                    const invokeTr = view.state.tr.setMeta((0, $311d92b3b6eb92ca$export$56937bf89365f70d), {
                        type: (0, $038bd350e498990f$export$92a1a3b7554e9387).TRIGGER_AUTO,
                        cursorPos: resolvedCursorPos,
                        triggerType: config.sectionType
                    });
                    const triggerType = (0, $371ce3c3ecf3dace$export$7e72d5dcc9007fb)(view.state).cursorInHeading ? config.headingTriggerType : config.nonHeadingTriggerType;
                    (0, $e9233283002d8aa0$export$37798a7ff6f20cd2)(editorAnalyticsAPI)(invokeTr, triggerType);
                    view.dispatch(invokeTr);
                }
            };
            if (typeof requestIdleCallback === 'function') pendingIdleId = requestIdleCallback(flush, {
                timeout: 2000
            });
            else pendingIdleId = requestAnimationFrame(flush);
        };
        return {
            cancel: cancel,
            schedule: schedule
        };
    };
    const summaryTrigger = createSectionKeywordTrigger({
        keywords: (0, $4e14c2a9f109857c$export$d5883a29c5e2615e)(getIntl),
        sectionType: 'summary',
        headingTriggerType: 'summary-heading',
        nonHeadingTriggerType: 'summary-first-lines'
    });
    const conclusionTrigger = createSectionKeywordTrigger({
        keywords: (0, $4e14c2a9f109857c$export$ec1e17d2784ef29d)(getIntl),
        sectionType: 'conclusion',
        headingTriggerType: 'conclusion-heading',
        nonHeadingTriggerType: 'conclusion-last-lines'
    });
    const nextStepsTrigger = createSectionKeywordTrigger({
        keywords: (0, $4e14c2a9f109857c$export$840323b8f6b537aa)(getIntl),
        sectionType: 'next-steps',
        headingTriggerType: 'next-steps-heading',
        nonHeadingTriggerType: 'next-steps-last-lines'
    });
    const triggerManualInline = (state, dispatch, view)=>{
        if (!dispatch || !view) return false;
        const pluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(state);
        if (pluginState && pluginState.status !== 'idle') api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.dismissSuggestion?.());
        const freshState = view.state;
        const resolvedCursorPos = freshState.selection.from;
        const invokeTr = freshState.tr.setMeta((0, $311d92b3b6eb92ca$export$56937bf89365f70d), {
            type: (0, $038bd350e498990f$export$92a1a3b7554e9387).TRIGGER_MANUAL,
            cursorPos: resolvedCursorPos
        });
        (0, $e9233283002d8aa0$export$37798a7ff6f20cd2)(editorAnalyticsAPI)(invokeTr, 'cmd+shift+space');
        view.dispatch(invokeTr);
        return true;
    };
    // ── Enter: auto-trigger Enter-reveal flow ─────────────────────────
    // Returns `false` in every branch so ProseMirror still processes
    // the Enter key (new paragraph / split node).  Side effects (flag
    // set, dismiss, scheduled reveal) happen before that.
    const handleEnter = (state, _dispatch, view)=>{
        const pluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(state);
        // Active state + exceeds char limit → dismiss, let Enter through
        if (pluginState && pluginState.status !== 'idle' && (0, $a33bacd3740d6e5a$export$203aad1d4d95d0de)(state)) {
            api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.dismissSuggestion?.());
            return false;
        }
        // Loading + auto: flag that Enter was pressed so the API
        // response handler can show the suggestion immediately
        if (pluginState?.status === 'loading' && pluginState.trigger === 'auto' && view) {
            view.dispatch(view.state.tr.setMeta((0, $311d92b3b6eb92ca$export$56937bf89365f70d), {
                type: (0, $038bd350e498990f$export$92a1a3b7554e9387).ENTER_DURING_LOADING
            }));
            return false;
        }
        // suggestion_pending: reveal ghost at new cursor after Enter creates a new block
        if (pluginState?.status === 'suggestion_pending' && view) {
            setTimeout(()=>{
                if (view.isDestroyed) return;
                const pending = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(view.state);
                if (pending?.status !== 'suggestion_pending') return;
                const cursorPos = view.state.selection.from;
                const revealTr = view.state.tr.setMeta((0, $311d92b3b6eb92ca$export$56937bf89365f70d), {
                    type: (0, $038bd350e498990f$export$92a1a3b7554e9387).REVEAL_SUGGESTION,
                    cursorPos: cursorPos
                });
                (0, $e9233283002d8aa0$export$edd7849651b2a74a)(editorAnalyticsAPI)(revealTr);
                view.dispatch(revealTr);
            }, 0);
            return false;
        }
        return false;
    };
    const bindings = {
        ['Mod-Shift-Space']: triggerManualInline,
        ['Meta-Shift-Space']: triggerManualInline,
        ['Enter']: handleEnter,
        ['Tab']: (state, dispatch)=>{
            const pluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(state);
            if (pluginState?.status !== 'suggestion') return false;
            if (!dispatch) return false;
            return api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.acceptSuggestion?.({
                cursorPos: pluginState.cursorPos,
                suggestion: pluginState.suggestion
            })) ?? false;
        },
        ['Escape']: (state, dispatch)=>{
            const pluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(state);
            if (!pluginState || pluginState.status === 'idle') return false;
            if (!dispatch) return false;
            return api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.dismissSuggestion?.()) ?? false;
        }
    };
    return new (0, $1S4f7.SafePlugin)({
        view () {
            return {
                destroy () {
                    summaryTrigger.cancel();
                    conclusionTrigger.cancel();
                    nextStepsTrigger.cancel();
                }
            };
        },
        props: {
            handleKeyDown (view, event) {
                if ((0, $dus6D.keydownHandler)(bindings)(view, event)) return true;
                // Re-read state: the Enter binding may have dispatched a
                // dismiss (char-limit case), making the state idle already.
                const pluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(view.state);
                // The Enter binding returns false (to let the default Enter
                // through) but already set flags / scheduled reveal for these
                // states — don't let the generic dismiss undo that work.
                if (event.key === 'Enter' && !event.shiftKey && pluginState && (pluginState.status === 'loading' || pluginState.status === 'suggestion_pending')) return false;
                // ── Auto loading / pending: same-line editing tolerance ────────
                // Allow document-mutating keys on the trigger line without
                // dismissing the session; once the cursor moves below the trigger
                // line, further typing dismisses.
                if (pluginState && (pluginState.status === 'loading' || pluginState.status === 'suggestion_pending') && pluginState.trigger === 'auto' && $e09ae141c8fa8668$var$isDocMutatingKey(event)) {
                    const lineNow = (0, $42b59b5039e481b9$export$faff1b56818221b9)(view.state.doc, view.state.selection.from);
                    if (lineNow <= pluginState.triggerLineIndex) return false;
                }
                // ── Generic: dismiss any active state ─────────────────────────
                if (pluginState && pluginState.status !== 'idle') api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.dismissSuggestion?.());
                // ── Schedule keyword checks ───────────────────────────────────
                if ((0, $ce0cb3b91bae6d4d$export$75827d0f82a08bf5)(view.state) && (0, $a33bacd3740d6e5a$export$8532deffc62f2372)(view.state)) {
                    if ((0, $42b59b5039e481b9$export$86e2c649a3fb270b)(view.state)) summaryTrigger.schedule(view);
                    if ((0, $42b59b5039e481b9$export$a0cc97e2eec5e2c9)(view.state)) {
                        conclusionTrigger.schedule(view);
                        nextStepsTrigger.schedule(view);
                    }
                }
                return false;
            }
        }
    });
}






function $e687d8470d23775c$var$isSuggestionVisibleState(state) {
    return state?.status === 'suggestion';
}
const $e687d8470d23775c$export$f87341fc5281ec6c = (options)=>{
    const { api: api } = options;
    return new (0, $1S4f7.SafePlugin)({
        view () {
            let previousSuggestionVisible = false;
            return {
                update (view) {
                    if (!api?.placeholder || !api?.core) return;
                    const pluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(view.state);
                    const suggestionVisible = $e687d8470d23775c$var$isSuggestionVisibleState(pluginState);
                    if (suggestionVisible !== previousSuggestionVisible) {
                        previousSuggestionVisible = suggestionVisible;
                        api.core.actions.execute(api.placeholder.commands.setPlaceholderHidden(suggestionVisible));
                    }
                }
            };
        }
    });
};








const $b30d2a251c70d654$export$bb9c6e4618c88231 = ({ cursorPos: cursorPos, suggestion: suggestion }, editorAnalyticsAPI)=>({ tr: tr })=>{
        (0, $e9233283002d8aa0$export$c26e1e4a084cdc9e)(editorAnalyticsAPI)(tr);
        tr.insert(cursorPos, tr.doc.type.schema.text(suggestion));
        tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, cursorPos + suggestion.length));
        tr.setMeta((0, $311d92b3b6eb92ca$export$56937bf89365f70d), {
            type: (0, $038bd350e498990f$export$92a1a3b7554e9387).DISMISS
        });
        tr.setMeta('addToHistory', true);
        return tr;
    };
const $b30d2a251c70d654$export$82b68e9b2902c23d = (editorAnalyticsAPI)=>({ tr: tr })=>{
        (0, $e9233283002d8aa0$export$61436ea80e595f1a)(editorAnalyticsAPI)(tr);
        return tr.setMeta((0, $311d92b3b6eb92ca$export$56937bf89365f70d), {
            type: (0, $038bd350e498990f$export$92a1a3b7554e9387).DISMISS
        });
    };













const $c2e11dbc5bd85e2f$var$MAX_TOKENS = 400;
/**
 * Derives the correct API host, matching the pattern used by other editor AI
 * features in editor-plugin-ai/src/ui/prebuilt/utils.ts.
 *
 * On localhost (non-port-8081) and Atlaskit storybook hosts, routes to
 * pug.jira-dev.com so API calls work without a local backend.
 * In all other environments (staging, prod) uses window.location.origin.
 */ function $c2e11dbc5bd85e2f$var$deriveHost() {
    const { origin: origin = '', port: port = '', hostname: hostname = '' } = typeof window !== 'undefined' && window.location ? window.location : {};
    if (hostname === 'localhost' && port !== '8081' || [
        'atlaskit-website-staging.stg-east.frontend.public.atl-paas.net',
        'statlas.prod.atl-paas.net',
        'atlaskit.atlassian.com'
    ].some((h)=>hostname === h)) return 'https://pug.jira-dev.com';
    return origin;
}
// Convo-AI path (current source of truth, served by conversational-ai-platform).
const $c2e11dbc5bd85e2f$var$CONVO_AI_PATH = '/gateway/api/assist/api/ai/v2/ai-feature/heading-autocomplete';
// cc-smarts path (new home, served by cc-smarts). Reached via the
// cc-smarts-ai-feature stargate route (stargate PR-8755), which strips
// /gateway/api and prepends /api before forwarding to cc-smarts.
const $c2e11dbc5bd85e2f$var$CC_SMARTS_PATH = '/gateway/api/ai/v2/ai-feature/heading-autocomplete';
/**
 * Resolves the heading-autocomplete endpoint URL based on the SPRT routing experiment.
 *
 * Routing: the editor experiment `cc_smarts_heading_autocomplete_migration` (param
 * `useCcSmarts`) decides between cc-smarts (new home, test arm) and conversational-ai-platform
 * (current source of truth, control arm). Wire shape is byte-for-byte identical between
 * the two backends; only the URL path differs. Mirrors `cc_smarts_comment_summary_followups_migration`
 * (AFM PR-388153).
 *
 * On any read failure (experiment lookup throws, Statsig unavailable, etc.) callers fail
 * closed to the convo-ai control arm — that's the safer arm because it's the production
 * source of truth today.
 */ function $c2e11dbc5bd85e2f$var$getApiEndpoint() {
    // Fail-closed: useCcSmarts stays at its initialised value of `false` if expValEquals throws,
    // landing on the convo-ai control arm — the production source of truth today. Do not move the
    // initialiser out of this declaration or remove the empty catch; both are load-bearing for the
    // fail-closed property (per the convo-ai → cc-smarts migration skill guardrails).
    let useCcSmarts = false;
    try {
        useCcSmarts = (0, $1oCLl.expValEquals)('cc_smarts_heading_autocomplete_migration', 'useCcSmarts', true);
    } catch  {
    // Intentionally empty — see the fail-closed comment on the `let` above.
    }
    const path = useCcSmarts ? $c2e11dbc5bd85e2f$var$CC_SMARTS_PATH : $c2e11dbc5bd85e2f$var$CONVO_AI_PATH;
    return `${$c2e11dbc5bd85e2f$var$deriveHost()}${path}`;
}
async function $c2e11dbc5bd85e2f$export$9384628242350716(pageContentMarkdown, sectionType, signal) {
    const response = await fetch($c2e11dbc5bd85e2f$var$getApiEndpoint(), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Experience-Id': 'editor',
            'X-Product': 'confluence'
        },
        credentials: 'include',
        signal: signal,
        body: JSON.stringify({
            ai_feature_input: {
                page_content_markdown: pageContentMarkdown,
                max_tokens: $c2e11dbc5bd85e2f$var$MAX_TOKENS,
                section_type: sectionType
            }
        })
    });
    if (!response.ok) throw new Error(`Heading autocomplete API error: ${response.status} ${response.statusText}`);
    const data = await response.json();
    const generatedParagraph = data?.ai_feature_output?.generated_paragraph;
    if (!generatedParagraph) throw new Error('Heading autocomplete API returned an empty or malformed response');
    return generatedParagraph;
}





var $6eZqW = parcelRequire("6eZqW");

const $517b90048513d413$var$GENERATE_MARKER = '<!-- GENERATE_HERE -->';
function $517b90048513d413$export$99167e00e2d4f9dd(view, cursorPos) {
    const doc = view.state.doc;
    // Serialize content before the cursor
    const beforeSlice = doc.slice(0, cursorPos);
    const { markdown: mdBefore } = (0, $6eZqW.convertProsemirrorToMarkdown)({
        editorView: view,
        fragment: beforeSlice.content,
        featureToggles: {}
    });
    // Serialize content after the cursor
    const afterSlice = doc.slice(cursorPos);
    const { markdown: mdAfter } = (0, $6eZqW.convertProsemirrorToMarkdown)({
        editorView: view,
        fragment: afterSlice.content,
        featureToggles: {}
    });
    const before = mdBefore.trimEnd();
    const after = mdAfter.trimStart();
    if (after) return `${before} ${$517b90048513d413$var$GENERATE_MARKER}\n${after}`;
    return `${before} ${$517b90048513d413$var$GENERATE_MARKER}`;
}



var $24P9d = parcelRequire("24P9d");


var $ftzrq = parcelRequire("ftzrq");

const $54331ed359655e88$var$GHOST_INLINE_CLASS = 'heading-autocomplete-ghost-inline';
const $54331ed359655e88$var$GHOST_HINT_CLASS = 'heading-autocomplete-ghost-text-hint';
const $54331ed359655e88$var$ghostInlineStyle = (0, $24P9d.convertToInlineCss)({
    color: "var(--ds-text-subtlest, #6B6E76)",
    opacity: '0.95',
    pointerEvents: 'auto',
    userSelect: 'none',
    whiteSpace: 'pre-wrap',
    cursor: 'pointer'
});
const $54331ed359655e88$var$ghostHintStyle = (0, $24P9d.convertToInlineCss)({
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    borderRadius: "var(--ds-radius-small, 4px)",
    padding: "var(--ds-space-050, 4px)",
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    marginLeft: "var(--ds-space-050, 4px)",
    verticalAlign: '3px'
});
const $54331ed359655e88$var$ghostHintTabStyle = (0, $24P9d.convertToInlineCss)({
    border: `1px solid ${"var(--ds-border-bold, #7D818A)"}`,
    borderRadius: "var(--ds-radius-small, 4px)",
    padding: `0 ${"var(--ds-space-025, 2px)"}`
});
function $54331ed359655e88$export$ec5102320006649a(state, pluginState) {
    return $54331ed359655e88$var$buildInlineGhostDecoration(state, pluginState.cursorPos, pluginState.suggestion);
}
/**
 * Inline ghost text at the cursor position (manual Cmd+Shift+Space trigger).
 * Accepted with Tab or click.
 */ function $54331ed359655e88$var$buildInlineGhostDecoration(state, cursorPos, suggestion) {
    const widget = (0, $ftzrq.Decoration).widget(cursorPos, ()=>{
        const span = document.createElement('span');
        span.className = $54331ed359655e88$var$GHOST_INLINE_CLASS;
        span.setAttribute('aria-hidden', 'true');
        span.setAttribute('contenteditable', 'false');
        span.setAttribute('data-testid', 'heading-autocomplete-ghost-inline');
        span.setAttribute('style', $54331ed359655e88$var$ghostInlineStyle);
        const text = document.createTextNode(suggestion);
        span.appendChild(text);
        const hint = document.createElement('span');
        hint.className = $54331ed359655e88$var$GHOST_HINT_CLASS;
        hint.setAttribute('style', $54331ed359655e88$var$ghostHintStyle);
        span.appendChild(hint);
        const tab = document.createElement('span');
        tab.className = $54331ed359655e88$var$GHOST_HINT_CLASS;
        tab.setAttribute('style', $54331ed359655e88$var$ghostHintTabStyle);
        tab.textContent = 'Tab';
        hint.appendChild(tab);
        const toAcceptText = document.createTextNode(' or click to accept');
        hint.appendChild(toAcceptText);
        return span;
    }, {
        side: 1,
        key: 'heading-autocomplete-ghost-inline'
    });
    return (0, $ftzrq.DecorationSet).create(state.doc, [
        widget
    ]);
}



const $dd023753b5f7ac8f$export$ae829ec7b2625219 = ({ api: api })=>{
    let abortController = null;
    const editorAnalyticsAPI = api?.analytics?.actions;
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $311d92b3b6eb92ca$export$56937bf89365f70d),
        // -----------------------------------------------------------------------
        // Plugin state — pure synchronous transitions
        // -----------------------------------------------------------------------
        state: {
            init () {
                return {
                    status: 'idle'
                };
            },
            apply (tr, pluginState, _oldState, newState) {
                const action = tr.getMeta((0, $311d92b3b6eb92ca$export$56937bf89365f70d));
                if (action) switch(action.type){
                    case (0, $038bd350e498990f$export$92a1a3b7554e9387).TRIGGER_MANUAL:
                        return {
                            status: 'loading',
                            trigger: 'manual',
                            cursorPos: action.cursorPos
                        };
                    case (0, $038bd350e498990f$export$92a1a3b7554e9387).TRIGGER_AUTO:
                        return {
                            status: 'loading',
                            trigger: 'auto',
                            cursorPos: action.cursorPos,
                            triggerType: action.triggerType,
                            triggerLineIndex: (0, $42b59b5039e481b9$export$faff1b56818221b9)(tr.doc, action.cursorPos),
                            userPressedEnter: false,
                            postEnterPlainTextBaseline: null
                        };
                    case (0, $038bd350e498990f$export$92a1a3b7554e9387).SET_SUGGESTION:
                        if (pluginState.status === 'loading') {
                            if (pluginState.trigger === 'auto') {
                                if ('displaySuggestionImmediately' in action && action.displaySuggestionImmediately === true) {
                                    const cursorPos = 'suggestionCursorPos' in action && action.suggestionCursorPos !== undefined ? action.suggestionCursorPos : pluginState.cursorPos;
                                    return {
                                        status: 'suggestion',
                                        trigger: 'auto',
                                        cursorPos: cursorPos,
                                        suggestion: action.suggestion
                                    };
                                }
                                return {
                                    status: 'suggestion_pending',
                                    trigger: 'auto',
                                    cursorPos: pluginState.cursorPos,
                                    suggestion: action.suggestion,
                                    triggerLineIndex: pluginState.triggerLineIndex
                                };
                            }
                            return {
                                status: 'suggestion',
                                trigger: 'manual',
                                cursorPos: pluginState.cursorPos,
                                suggestion: action.suggestion
                            };
                        }
                        return pluginState;
                    case (0, $038bd350e498990f$export$92a1a3b7554e9387).REVEAL_SUGGESTION:
                        if (pluginState.status === 'suggestion_pending') {
                            const revealCursorPos = 'cursorPos' in action && action.cursorPos !== undefined ? action.cursorPos : pluginState.cursorPos;
                            return {
                                status: 'suggestion',
                                trigger: 'auto',
                                cursorPos: revealCursorPos,
                                suggestion: pluginState.suggestion
                            };
                        }
                        return pluginState;
                    case (0, $038bd350e498990f$export$92a1a3b7554e9387).ENTER_DURING_LOADING:
                        if (pluginState.status === 'loading' && pluginState.trigger === 'auto') return {
                            ...pluginState,
                            userPressedEnter: true
                        };
                        return pluginState;
                    case (0, $038bd350e498990f$export$92a1a3b7554e9387).DISMISS:
                        return {
                            status: 'idle'
                        };
                    default:
                        return pluginState;
                }
                // Structural doc change during auto-loading with Enter pressed:
                // capture a plain-text baseline so the API response handler can
                // verify the doc hasn't changed beyond the Enter-induced split.
                if (pluginState.status === 'loading' && pluginState.trigger === 'auto' && pluginState.userPressedEnter && pluginState.postEnterPlainTextBaseline === null && !tr.before.eq(tr.doc)) return {
                    ...pluginState,
                    postEnterPlainTextBaseline: (0, $a33bacd3740d6e5a$export$6f212eb1ee72d86a)(newState.doc),
                    cursorPos: tr.mapping.map(pluginState.cursorPos)
                };
                if (tr.docChanged && pluginState.status !== 'idle') {
                    const state = pluginState;
                    return {
                        ...state,
                        ...state.status === 'loading' || state.status === 'suggestion' || state.status === 'suggestion_pending' ? {
                            cursorPos: tr.mapping.map(state.cursorPos)
                        } : {}
                    };
                }
                return pluginState;
            }
        },
        // -----------------------------------------------------------------------
        // Decorations
        // -----------------------------------------------------------------------
        props: {
            decorations (state) {
                const pluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(state);
                if (pluginState?.status !== 'suggestion') return null;
                return (0, $54331ed359655e88$export$ec5102320006649a)(state, pluginState);
            },
            handleDOMEvents: {
                click: (view, event)=>{
                    const { target: target } = event;
                    if (target instanceof HTMLElement && target.closest('[data-testid="heading-autocomplete-ghost-inline"]')) {
                        event.preventDefault();
                        const pluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(view.state);
                        if (pluginState?.status === 'suggestion') api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.acceptSuggestion?.({
                            cursorPos: pluginState.cursorPos,
                            suggestion: pluginState.suggestion
                        }));
                        return true;
                    }
                    return false;
                },
                blur: (view)=>{
                    const pluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(view.state);
                    if (pluginState && pluginState.status !== 'idle') api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.dismissSuggestion?.());
                    return false;
                }
            }
        },
        // -----------------------------------------------------------------------
        // view() — owns all side effects (fetch lifecycle)
        // -----------------------------------------------------------------------
        view () {
            return {
                update (view, prevState) {
                    const newPluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(view.state);
                    const prevPluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(prevState);
                    if (newPluginState === prevPluginState) return;
                    // Leaving 'loading' — cancel in-flight fetch
                    if (prevPluginState?.status === 'loading' && newPluginState?.status !== 'loading') {
                        abortController?.abort();
                        abortController = null;
                    }
                    // Entering 'loading' — fire the API call
                    if (newPluginState?.status === 'loading' && prevPluginState?.status !== 'loading') {
                        abortController = new AbortController();
                        const markdown = (0, $517b90048513d413$export$99167e00e2d4f9dd)(view, newPluginState.cursorPos);
                        const sectionType = newPluginState.trigger === 'auto' ? newPluginState.triggerType : undefined;
                        (0, $c2e11dbc5bd85e2f$export$9384628242350716)(markdown, sectionType, abortController.signal).then((suggestion)=>{
                            const loading = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(view.state);
                            if (loading?.status !== 'loading') return;
                            const showImmediately = loading.trigger === 'auto' && loading.userPressedEnter;
                            if (showImmediately && loading.postEnterPlainTextBaseline !== null) {
                                const currentPlain = (0, $a33bacd3740d6e5a$export$6f212eb1ee72d86a)(view.state.doc);
                                if (currentPlain !== loading.postEnterPlainTextBaseline) {
                                    view.dispatch(view.state.tr.setMeta((0, $311d92b3b6eb92ca$export$56937bf89365f70d), {
                                        type: (0, $038bd350e498990f$export$92a1a3b7554e9387).DISMISS
                                    }));
                                    return;
                                }
                            }
                            const tr = view.state.tr.setMeta((0, $311d92b3b6eb92ca$export$56937bf89365f70d), {
                                type: (0, $038bd350e498990f$export$92a1a3b7554e9387).SET_SUGGESTION,
                                suggestion: suggestion,
                                ...showImmediately ? {
                                    displaySuggestionImmediately: true,
                                    suggestionCursorPos: view.state.selection.from
                                } : {}
                            });
                            if (loading.trigger === 'manual' || showImmediately) (0, $e9233283002d8aa0$export$edd7849651b2a74a)(editorAnalyticsAPI)(tr);
                            view.dispatch(tr);
                        }).catch((err)=>{
                            if (err instanceof Error && err.name === 'AbortError') return;
                            const dismissTr = view.state.tr.setMeta((0, $311d92b3b6eb92ca$export$56937bf89365f70d), {
                                type: (0, $038bd350e498990f$export$92a1a3b7554e9387).DISMISS
                            });
                            editorAnalyticsAPI?.attachAnalyticsEvent({
                                action: (0, $d925B.ACTION).ERRORED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).AI_AUTOCOMPLETE,
                                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                                attributes: {
                                    errorMessage: err instanceof Error ? err.message : String(err)
                                }
                            })(dismissTr);
                            view.dispatch(dismissTr);
                        });
                    }
                },
                destroy () {
                    abortController?.abort();
                    abortController = null;
                }
            };
        },
        // -----------------------------------------------------------------------
        // appendTransaction — doc change → dismiss (accept is handled in command)
        // -----------------------------------------------------------------------
        appendTransaction (transactions, _oldState, newState) {
            const currentPluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(newState);
            // Visible suggestion or pending auto reveal: don't dismiss on doc
            // change — keydown already dismisses on typing before the doc mutates.
            if (currentPluginState?.status === 'suggestion' || currentPluginState?.status === 'suggestion_pending') return null;
            // Auto loading: allow doc changes (Enter / same-line edits).
            // Baseline capture is now handled in apply().
            if (currentPluginState?.status === 'loading' && currentPluginState.trigger === 'auto') return null;
            // Use structural doc equality, not `tr.docChanged`: the latter is true for any
            // step (including AnalyticsStep from attachAnalyticsEvent on invoke), which would
            // incorrectly dismiss loading state before the API runs.
            const documentChanged = transactions.some((tr)=>!tr.before.eq(tr.doc));
            if (!documentChanged) return null;
            return newState.tr.setMeta((0, $311d92b3b6eb92ca$export$56937bf89365f70d), {
                type: (0, $038bd350e498990f$export$92a1a3b7554e9387).DISMISS
            });
        }
    });
};


const $9bdb7ad03a409b2b$export$52b2e012ce18dd1 = ({ api: api })=>{
    return {
        name: 'aiAutocomplete',
        commands: {
            acceptSuggestion: (params)=>(0, $b30d2a251c70d654$export$bb9c6e4618c88231)(params, api?.analytics?.actions),
            dismissSuggestion: ()=>(0, $b30d2a251c70d654$export$82b68e9b2902c23d)(api?.analytics?.actions)
        },
        pmPlugins () {
            return [
                {
                    name: 'aiAutocompletePlugin',
                    plugin: ()=>(0, $dd023753b5f7ac8f$export$ae829ec7b2625219)({
                            api: api
                        })
                },
                {
                    name: 'ai-autocomplete-keymap',
                    plugin: (params)=>(0, $e09ae141c8fa8668$export$a57bf7fb2aa68075)({
                            api: api,
                            getIntl: params.getIntl
                        })
                },
                {
                    name: 'ai-autocomplete-placeholder-controller',
                    plugin: ()=>(0, $e687d8470d23775c$export$f87341fc5281ec6c)({
                            api: api
                        })
                }
            ];
        }
    };
};



var $kqbzb = parcelRequire("kqbzb");





var $2FNjD = parcelRequire("2FNjD");














var $2XqLN = parcelRequire("2XqLN");

const $5c15d883298a980d$export$2073a24f9367a16f = (0, $2XqLN.default)(()=>{
    // directly use CSS would cause failed SSR tests.
    if (typeof window !== 'undefined' && window.CSS && window.CSS.supports) return window.CSS.supports('anchor-name: --a');
    return false;
});
class $5c15d883298a980d$export$e1d230f644ff05aa {
    clear() {
        this.isDirty = true;
        this.anchorRectMap = {};
    }
    getRects() {
        if (this.isDirty) {
            const anchorElements = this.view?.dom.querySelectorAll('[data-section-cta-anchor-name]') || [];
            this.anchorRectMap = Array.from(anchorElements).reduce((prev, curr)=>{
                const anchorName = curr.getAttribute('data-section-cta-anchor-name');
                if (anchorName) return {
                    ...prev,
                    [anchorName]: {
                        height: curr.clientHeight,
                        top: curr.offsetTop,
                        left: curr.offsetLeft,
                        right: curr.offsetLeft + curr.clientWidth,
                        width: curr.clientWidth,
                        bottom: curr.offsetTop + curr.clientHeight
                    }
                };
                return prev;
            }, {});
            this.isDirty = false;
        }
        return this.anchorRectMap;
    }
    setEditorView(view) {
        if (this.view !== view) this.view = view;
    }
    getHeight(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.height;
    }
    getWidth(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.width;
    }
    getLeft(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.left;
    }
    getTop(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.top;
    }
    getRight(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.right;
    }
    getRect(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName];
    }
    constructor(){
        this.anchorRectMap = {};
        this.isAnchorSupported = $5c15d883298a980d$export$2073a24f9367a16f();
        this.isDirty = true;
        this.view = null;
    }
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $1Whri = parcelRequire("1Whri");


var $aFUXX = parcelRequire("aFUXX");


var $g5gZt = parcelRequire("g5gZt");




var $fVUfS = parcelRequire("fVUfS");







const $20ed47d9991fb6d4$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    addSection: {
        id: "company-hub-section-cta.plus-button.add-section",
        defaultMessage: "Add section"
    },
    contentHeader: {
        id: "company-hub-section-cta.section-node.content.header",
        defaultMessage: "Give your section a title"
    },
    contentSubHeader: {
        id: "company-hub-section-cta.section-node.content.sub-header",
        defaultMessage: "Organize elements into sections with customizable backgrounds."
    },
    lozengeTitle: {
        id: "company-hub-section-cta.section-node.lozenge-title",
        defaultMessage: "Section"
    },
    placeHolderTitle: {
        id: "company-hub-section-cta.section-node.content.placeholder-title",
        defaultMessage: "Placeholder"
    }
});



const $43c0e35ecb9920ae$var$styles = {
    containerBaseStyles: "_v5641p41 _18zr1i3y _kqswstnw _1bsb16wv _1e0c1txw _1bah1h6o _4cvr1h6o _4t3izwfg _tzy4idpf _1pbyb4wl _16l4kb7n",
    lineStyles: "_16jlkb7n _1o9zkb7n _i0dlf1ug _4t3iyh40 _bfhk1aqn",
    pressable: "_2rko1rr0 _bfhk1aqn _4t3izwfg _1bsbzwfg _irr31ibz _1di6of27"
};
const $43c0e35ecb9920ae$var$Line = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($43c0e35ecb9920ae$var$styles.lineStyles)
    });
const $43c0e35ecb9920ae$export$e50c8b7ca0cd488e = ({ anchorId: anchorId, onClick: onClick, view: view, prevNodeTypeName: prevNodeTypeName, isLastPosition: isLastPosition, anchorRectCache: anchorRectCache })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [dynamicStyles, setDynamicStyles] = (0, $42omo.useState)({});
    (0, $42omo.useEffect)(()=>{
        const calculatePosition = ()=>{
            const isSectionNode = prevNodeTypeName === 'multiBodiedExtension';
            const isParagraphNode = prevNodeTypeName === 'paragraph';
            const isTableNode = prevNodeTypeName === 'table';
            let verticalOffset = '-50%'; // Default for top and after normal nodes
            if (isSectionNode || isTableNode) verticalOffset = '-100%';
            else if (isLastPosition && isParagraphNode) verticalOffset = '0';
            const baseStyles = {
                // Linter errors if we use variables/non-tokens in cssMap so we need to use style prop
                // add 40px to the max width to account for the padding of the editor
                maxWidth: `${(0, $aFUXX.akEditorFullWidthLayoutWidth) + 40}px`
            };
            if ((0, $5c15d883298a980d$export$2073a24f9367a16f)()) {
                setDynamicStyles({
                    ...baseStyles,
                    positionAnchor: `--${anchorId}`,
                    top: 'anchor(bottom)',
                    left: '50%',
                    transform: `translate(-50%, ${verticalOffset})`
                });
                return;
            } // Fallback logic
            anchorRectCache?.clear();
            const rect = anchorRectCache?.getRect(anchorId);
            if (!rect) {
                setDynamicStyles({
                    ...baseStyles,
                    display: 'none'
                });
                return;
            }
            const top = rect.top + rect.height;
            setDynamicStyles({
                ...baseStyles,
                top: `${top}px`,
                left: '50%',
                transform: `translate(-50%, ${verticalOffset})`
            });
        };
        // Set position on initial render and whenever dependencies change.
        calculatePosition(); // Observe for layout changes to recalculate position.
        const observer = new ResizeObserver(calculatePosition);
        observer.observe(view.dom);
        return ()=>{
            observer.disconnect();
        };
    }, [
        anchorId,
        prevNodeTypeName,
        isLastPosition,
        anchorRectCache,
        view.dom
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: dynamicStyles,
        "data-testid": "company-hub-plus-button",
        className: (0, $gMc0m.default)([
            $43c0e35ecb9920ae$var$styles.containerBaseStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($43c0e35ecb9920ae$var$Line, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage((0, $20ed47d9991fb6d4$export$a7357cdd1f0b0168).addSection)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
            ...tooltipProps,
            onClick: onClick,
            xcss: $43c0e35ecb9920ae$var$styles.pressable,
            "aria-label": formatMessage((0, $20ed47d9991fb6d4$export$a7357cdd1f0b0168).addSection)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
            label: "",
            color: "var(--ds-icon-inverse, #FFFFFF)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($43c0e35ecb9920ae$var$Line, null));
};



var $dQl1W = parcelRequire("dQl1W");


var $f3dd73ebb486855e$export$3130b484681bf8bc = /*#__PURE__*/ function(CONTENT_WIDTH) {
    CONTENT_WIDTH["NARROW"] = "narrow";
    CONTENT_WIDTH["WIDE"] = "wide";
    CONTENT_WIDTH["FULL"] = "full";
    return CONTENT_WIDTH;
}({});
const $f3dd73ebb486855e$export$6cccba5fae1d609d = "wide";
const $f3dd73ebb486855e$export$617cdcc6afaae4f7 = "var(--ds-surface, #FFFFFF)";
const $f3dd73ebb486855e$export$c14e692c91462ed4 = 'com.atlassian.confluence.hub-element-placeholder';
const $f3dd73ebb486855e$export$ca3a94184e0fbd97 = 'hub-element-placeholder';
const $f3dd73ebb486855e$export$b39442728ee427d = 'hub-section';
const $f3dd73ebb486855e$export$12ee1d1507d066e8 = 'com.atlassian.confluence.hub-section';


const $fa22ef03bf87464a$export$993dca3597b448e8 = ({ header: header, subHeader: subHeader, placeholderTitle: placeholderTitle })=>({
        type: 'extensionFrame',
        content: [
            {
                type: 'heading',
                attrs: {
                    level: 1,
                    localId: null
                },
                content: [
                    {
                        type: 'text',
                        text: `${header}`
                    }
                ]
            },
            {
                type: 'paragraph',
                attrs: {
                    localId: null
                },
                content: [
                    {
                        type: 'text',
                        text: `${subHeader}`
                    }
                ]
            },
            {
                type: 'paragraph',
                attrs: {
                    localId: null
                }
            },
            {
                type: 'extension',
                attrs: {
                    extensionKey: (0, $f3dd73ebb486855e$export$ca3a94184e0fbd97),
                    extensionType: (0, $f3dd73ebb486855e$export$c14e692c91462ed4),
                    parameters: {
                        extensionTitle: placeholderTitle
                    },
                    text: null,
                    layout: 'default',
                    localId: null
                }
            }
        ]
    });
const $fa22ef03bf87464a$var$sectionContentNode = (state, initialContentText)=>state.schema.nodeFromJSON($fa22ef03bf87464a$export$993dca3597b448e8(initialContentText));
const $fa22ef03bf87464a$export$3cf963ab3631af75 = (state, intl)=>{
    const initialContentText = {
        header: intl.formatMessage((0, $20ed47d9991fb6d4$export$a7357cdd1f0b0168).contentHeader),
        subHeader: intl.formatMessage((0, $20ed47d9991fb6d4$export$a7357cdd1f0b0168).contentSubHeader),
        placeholderTitle: intl.formatMessage((0, $20ed47d9991fb6d4$export$a7357cdd1f0b0168).placeHolderTitle)
    };
    return state.schema.nodes.multiBodiedExtension.create({
        extensionType: (0, $f3dd73ebb486855e$export$12ee1d1507d066e8),
        extensionKey: (0, $f3dd73ebb486855e$export$b39442728ee427d),
        layout: 'full-width',
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        localId: (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))(),
        parameters: {
            extensionTitle: intl.formatMessage((0, $20ed47d9991fb6d4$export$a7357cdd1f0b0168).lozengeTitle),
            backgroundColor: (0, $f3dd73ebb486855e$export$617cdcc6afaae4f7),
            contentWidth: (0, $f3dd73ebb486855e$export$6cccba5fae1d609d)
        }
    }, $fa22ef03bf87464a$var$sectionContentNode(state, initialContentText));
};


const $8c3629cd1d541fcd$export$243f82fe09087876 = new (0, $ks2lK.PluginKey)('companyHubSectionCta');
const $8c3629cd1d541fcd$export$53e55076862e2785 = (state, pos)=>{
    const { schema: schema, doc: doc } = state;
    const $pos = doc.resolve(pos);
    const isParentDoc = $pos.parent.type === schema.nodes.doc;
    if (!isParentDoc) return false;
    const nodeBefore = $pos.nodeBefore;
    // The button should only appear at the start of the document or after section extensions.
    const isAtStart = !nodeBefore;
    const isAfterSectionExtension = nodeBefore?.attrs.extensionKey === 'hub-section' && nodeBefore?.attrs.extensionType === 'com.atlassian.confluence.hub-section';
    // The button should also appear at the very end of the document.
    const isAtEnd = !$pos.nodeAfter;
    return (isAtStart || isAfterSectionExtension || isAtEnd) && $pos.parent.canReplaceWith($pos.index(), $pos.index(), schema.nodes.multiBodiedExtension);
};
const $8c3629cd1d541fcd$var$createAnchorDecorations = (state)=>{
    const decs = [];
    const { doc: doc } = state;
    // A map of valid insertion positions to node info.
    const insertPositions = new Map();
    // 1. Check for an insertion point at the very start of the document.
    if ($8c3629cd1d541fcd$export$53e55076862e2785(state, 0)) {
        // It's the last position if the document is empty.
        const isLastPosition = doc.childCount === 0;
        insertPositions.set(0, {
            prevNodeTypeName: undefined,
            isLastPosition: isLastPosition
        });
    }
    // 2. Check for insertion points after each node in the document.
    doc.content.forEach((node, offset, index)=>{
        const insertPos = offset + node.nodeSize;
        if ($8c3629cd1d541fcd$export$53e55076862e2785(state, insertPos)) {
            const isLastPosition = index === doc.childCount - 1;
            insertPositions.set(insertPos, {
                prevNodeTypeName: node.type.name,
                isLastPosition: isLastPosition
            });
        }
    });
    // 3. Create decorations for all collected valid positions.
    insertPositions.forEach(({ prevNodeTypeName: prevNodeTypeName, isLastPosition: isLastPosition }, insertPos)=>{
        const anchorId = `section-cta-anchor-${insertPos}`;
        decs.push((0, $ftzrq.Decoration).widget(insertPos, ()=>{
            const anchorEl = document.createElement('span');
            anchorEl.style.cssText = `position: absolute; anchor-name: --${anchorId};`;
            anchorEl.setAttribute('data-section-cta-anchor-name', anchorId);
            return anchorEl;
        }, {
            key: anchorId,
            side: -1,
            anchorId: anchorId,
            prevNodeTypeName: prevNodeTypeName,
            isLastPosition: isLastPosition
        }));
    });
    return (0, $ftzrq.DecorationSet).create(doc, decs);
};
class $8c3629cd1d541fcd$var$SectionCtaPluginView {
    update(view, prevState) {
        this.view = view;
        this.anchorRectCache.setEditorView(this.view);
        // We re-render only if the decorations have changed - i.e. the user has modified top level nodes
        const oldState = $8c3629cd1d541fcd$export$243f82fe09087876.getState(prevState);
        const newState = $8c3629cd1d541fcd$export$243f82fe09087876.getState(view.state);
        if (oldState !== newState) {
            this.anchorRectCache.clear();
            this.renderButtons(view.state);
        }
    }
    destroy() {
        this.anchorRectCache.clear();
        this.root.unmount();
        this.container.remove();
    }
    renderButtons(state) {
        const decorationSet = $8c3629cd1d541fcd$export$243f82fe09087876.getState(state);
        if (!decorationSet) return;
        const handleClick = (insertPos)=>{
            const command = this.api?.companyHubSectionCtaPlugin?.commands?.insertSection(insertPos, this.intl);
            if (command) command(this.view.state, this.view.dispatch, this.view);
        };
        // Find all our anchor decorations
        const anchorDecos = decorationSet.find();
        this.root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.RawIntlProvider), {
            value: this.intl
        }, anchorDecos.map((deco)=>{
            const anchorId = deco.spec.anchorId;
            const insertPos = deco.from;
            const prevNodeTypeName = deco.spec.prevNodeTypeName;
            const isLastPosition = deco.spec.isLastPosition;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $43c0e35ecb9920ae$export$e50c8b7ca0cd488e), {
                key: anchorId,
                anchorId: anchorId,
                prevNodeTypeName: prevNodeTypeName,
                isLastPosition: isLastPosition,
                onClick: ()=>handleClick(insertPos),
                anchorRectCache: this.anchorRectCache,
                view: this.view
            });
        })));
    }
    constructor(view, api, intl){
        this.view = void 0;
        this.container = void 0;
        this.root = void 0;
        this.api = void 0;
        this.intl = void 0;
        this.anchorRectCache = void 0;
        this.view = view;
        this.api = api;
        this.intl = intl;
        this.anchorRectCache = new (0, $5c15d883298a980d$export$e1d230f644ff05aa)();
        this.anchorRectCache.setEditorView(this.view);
        this.container = document.createElement('div');
        this.view.dom.parentElement?.appendChild(this.container);
        this.root = (0, (/*@__PURE__*/$parcel$interopDefault($2FNjD))).createRoot(this.container);
        this.renderButtons(this.view.state);
    }
}
const $8c3629cd1d541fcd$export$d82c0e619eaaa2c2 = ({ api: api })=>{
    return {
        name: 'companyHubSectionCtaPlugin',
        pmPlugins () {
            return [
                {
                    name: 'companyHubSectionCtaButton',
                    plugin: ({ getIntl: getIntl })=>{
                        const intl = getIntl();
                        return new (0, $1S4f7.SafePlugin)({
                            key: $8c3629cd1d541fcd$export$243f82fe09087876,
                            state: {
                                init (_, editorState) {
                                    return $8c3629cd1d541fcd$var$createAnchorDecorations(editorState);
                                },
                                apply (tr, oldDecs, newState) {
                                    return $8c3629cd1d541fcd$var$createAnchorDecorations(newState);
                                }
                            },
                            props: {
                                decorations (state) {
                                    // This makes the anchor decorations actually appear in the doc.
                                    return $8c3629cd1d541fcd$export$243f82fe09087876.getState(state);
                                }
                            },
                            view: (editorView)=>new $8c3629cd1d541fcd$var$SectionCtaPluginView(editorView, api, intl)
                        });
                    }
                }
            ];
        },
        commands: {
            insertSection: (position, intl)=>{
                return (state, dispatch)=>{
                    if (dispatch) {
                        const { tr: tr } = state;
                        const nodeToInsert = (0, $fa22ef03bf87464a$export$3cf963ab3631af75)(state, intl);
                        tr.insert(position, nodeToInsert);
                        const selection = (0, $ks2lK.NodeSelection).create(tr.doc, position);
                        tr.setSelection(selection);
                        dispatch(tr);
                    }
                    return true;
                };
            }
        }
    };
};



var $dMGoR = parcelRequire("dMGoR");


var $dXIrr = parcelRequire("dXIrr");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $3YBks = parcelRequire("3YBks");


var $4EKKB = parcelRequire("4EKKB");





var $cPCP8 = parcelRequire("cPCP8");


var $aro2m = parcelRequire("aro2m");

var $kDB94 = parcelRequire("kDB94");











var $gzUv9 = parcelRequire("gzUv9");


var $7ERUE = parcelRequire("7ERUE");

var $iIVVb = parcelRequire("iIVVb");


var $7578h = parcelRequire("7578h");




const $998cc9ceb52ce297$export$a6f5520975c8a85d = (0, $aXWIB.defineMessages)({
    tabs: {
        id: "editor-plugin-native-tabs-toolbar.tabs",
        defaultMessage: "Tabs"
    }
});


const $c491a67421e67e45$var$NATIVE_TABS_QUICK_INSERT_KEY = 'native-tabs:native-tabs';
const $c491a67421e67e45$var$TABS_BUTTON_TEST_ID = 'editor-toolbar-tabs-button';
const $c491a67421e67e45$export$a117598b3d44511f = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { editorView: editorView } = (0, $gzUv9.useEditorToolbar)();
    const cachedTabsItem = (0, $42omo.useRef)(null);
    if (!api?.quickInsert) return null;
    const onClick = ()=>{
        if (editorView) {
            let tabsItem = cachedTabsItem.current;
            if (!tabsItem) {
                const suggestions = api?.quickInsert?.actions?.getSuggestions({
                    query: '',
                    disableDefaultItems: false
                });
                tabsItem = suggestions?.find((item)=>item.key === $c491a67421e67e45$var$NATIVE_TABS_QUICK_INSERT_KEY) ?? null;
                if (tabsItem) cachedTabsItem.current = tabsItem;
            }
            if (tabsItem) {
                const { state: state, dispatch: dispatch } = editorView;
                api?.quickInsert?.actions?.insertItem(tabsItem, (0, $d925B.INPUT_METHOD).TOOLBAR)(state, dispatch);
            }
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
        content: formatMessage((0, $998cc9ceb52ce297$export$a6f5520975c8a85d).tabs)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7578h))), {
            label: formatMessage((0, $998cc9ceb52ce297$export$a6f5520975c8a85d).tabs),
            size: "small"
        }),
        onClick: onClick,
        testId: $c491a67421e67e45$var$TABS_BUTTON_TEST_ID
    }));
};


/**
 * Hardcoded toolbar constants for the native tabs toolbar button.
 * These are kept within this plugin rather than in editor-common
 * because native tabs is a private Confluence feature.
 */ const $0c12e133eae86678$var$TABS_GROUP = {
    key: 'tabs-group',
    type: 'group'
};
const $0c12e133eae86678$var$TABS_BUTTON = {
    key: 'tabs-button',
    type: 'button'
};
/**
 * Rank of the tabs group within the INSERT_BLOCK_SECTION.
 * Positioned between layout (600) and synced-block (700).
 */ const $0c12e133eae86678$var$TABS_GROUP_SECTION_RANK = 650;
/**
 * Rank of the tabs button within the tabs group.
 */ const $0c12e133eae86678$var$TABS_BUTTON_GROUP_RANK = 100;
const $0c12e133eae86678$var$getToolbarComponents = (api)=>{
    return [
        {
            type: $0c12e133eae86678$var$TABS_GROUP.type,
            key: $0c12e133eae86678$var$TABS_GROUP.key,
            parents: [
                {
                    type: (0, $cPCP8.INSERT_BLOCK_SECTION).type,
                    key: (0, $cPCP8.INSERT_BLOCK_SECTION).key,
                    rank: $0c12e133eae86678$var$TABS_GROUP_SECTION_RANK
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aro2m.Show), {
                    above: "md"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, children))
        },
        {
            type: $0c12e133eae86678$var$TABS_BUTTON.type,
            key: $0c12e133eae86678$var$TABS_BUTTON.key,
            parents: [
                {
                    type: $0c12e133eae86678$var$TABS_GROUP.type,
                    key: $0c12e133eae86678$var$TABS_GROUP.key,
                    rank: $0c12e133eae86678$var$TABS_BUTTON_GROUP_RANK
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c491a67421e67e45$export$a117598b3d44511f), {
                    api: api
                })
        }
    ];
};
const $0c12e133eae86678$export$c5dd41c01dfdca7c = ({ api: api })=>{
    api?.toolbar?.actions.registerComponents($0c12e133eae86678$var$getToolbarComponents(api));
    return {
        name: 'nativeTabsToolbar'
    };
};



var $iHrpD = parcelRequire("iHrpD");


var $2x28u = parcelRequire("2x28u");


var $6mKj3 = parcelRequire("6mKj3");


var $8pcS0 = parcelRequire("8pcS0");

function $7cb36df2e500ad5f$export$d4ded51d0f0bd2df(extensionParams) {
    const { extensionKey: extensionKey, extensionType: extensionType, parameters: parameters } = extensionParams;
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).INVALID && extensionType === (0, $8pcS0.EXTENSION_TYPE).MIGRATION) return parameters?.nestedContent;
}






var $3jwuS = parcelRequire("3jwuS");


var $ep3mz = parcelRequire("ep3mz");








var $cqCFf = parcelRequire("cqCFf");

const $4eff3da02bf6b0b9$export$ce9fbb23568613c5 = (_view, event)=>{
    /**
   * We have to use the event.target to indentify that we are dealing with the live search extension
   * instead of the current editor selection because
   *   1. We can’t guarantee the selection won’t change while we are in the extension
   *   2. Often times the selection is not the extension despite currently interacting with the extension
   *
   * As a result, we have to rely on the event.target to identify if the current event is meant for the
   * live search extension.
   */ const isLiveSearchExtensionElement = event.target.classList.contains(`${(0, $cqCFf.LIVE_SEARCH_SELECT_CLASSNAME_PREFIX)}__input`) || event.target.className === (0, $cqCFf.LIVE_SEARCH_BUTTON_CLASSNAME);
    return (event.target instanceof HTMLInputElement || event.target instanceof HTMLButtonElement) && isLiveSearchExtensionElement;
};
const $4eff3da02bf6b0b9$export$c9403d1366bd779d = {
    keydown: $4eff3da02bf6b0b9$export$ce9fbb23568613c5,
    keyup: $4eff3da02bf6b0b9$export$ce9fbb23568613c5,
    keypress: $4eff3da02bf6b0b9$export$ce9fbb23568613c5,
    beforeinput: $4eff3da02bf6b0b9$export$ce9fbb23568613c5
};



var $kyKWe = parcelRequire("kyKWe");




const $73f6dfc0acf21779$export$14e5c8eb6f32c76 = (slice)=>{
    const updatedContent = [];
    slice.content.forEach((node)=>{
        if (node.attrs.extensionType === 'com.atlassian.confluence.macro.core' && node.attrs.extensionKey === 'anchor') {
            // Update the value of the macro param used as anchor name (used as html id in UI) to a unique value, UUID.
            const newAttrs = {
                ...node.attrs,
                parameters: {
                    ...node.attrs.parameters,
                    macroParams: {
                        ...node.attrs.parameters.macroParams,
                        '': {
                            value: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
                        }
                    }
                }
            };
            updatedContent.push(node.type.create(newAttrs, node.content, node.marks));
        } else updatedContent.push(node);
    });
    return new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).fromArray(updatedContent), slice.openStart, slice.openEnd);
};


// Duplicate of TEXTFIELD_ID from @atlassian/dynamic-cards-search-page
const $23f33cc0c92651d7$var$COMPANY_HUB_SEARCH_TEXTFIELD_ID = 'ch-search-text-query-input';
const $23f33cc0c92651d7$export$eb1b190bb6345745 = (_view, event)=>{
    /**
	 * We have to use the event.target to indentify that we are dealing with the Company Hub search extension
	 * instead of the current editor selection because
	 *   1. We can’t guarantee the selection won’t change while we are in the extension
	 *   2. Often times the selection is not the extension despite currently interacting with the extension
	 *
	 * As a result, we have to rely on the event.target to identify if the current event is meant for the
	 * Company Hub search extension.
	 */ return event.target instanceof HTMLInputElement && event.target.id === $23f33cc0c92651d7$var$COMPANY_HUB_SEARCH_TEXTFIELD_ID;
};
const $23f33cc0c92651d7$export$47b865254c03e3eb = {
    keydown: $23f33cc0c92651d7$export$eb1b190bb6345745,
    keyup: $23f33cc0c92651d7$export$eb1b190bb6345745,
    keypress: $23f33cc0c92651d7$export$eb1b190bb6345745,
    beforeinput: $23f33cc0c92651d7$export$eb1b190bb6345745
};


const $1a6e0310908ffd24$export$234cb421a967be1c = 'extensionManager';
const $1a6e0310908ffd24$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)($1a6e0310908ffd24$export$234cb421a967be1c);
const $1a6e0310908ffd24$export$ae829ec7b2625219 = ()=>new (0, $1S4f7.SafePlugin)({
        key: $1a6e0310908ffd24$export$18d4026d1ea86bb1,
        state: {
            init: ()=>({}),
            apply (tr, pluginState) {
                const metadata = tr.getMeta($1a6e0310908ffd24$export$18d4026d1ea86bb1);
                if (metadata) return {
                    ...pluginState,
                    ...metadata
                };
                return pluginState;
            }
        },
        props: {
            handleDOMEvents: {
                ...(0, $4eff3da02bf6b0b9$export$c9403d1366bd779d),
                ...(0, $23f33cc0c92651d7$export$47b865254c03e3eb)
            },
            transformPasted: (0, $73f6dfc0acf21779$export$14e5c8eb6f32c76)
        }
    });









var $cMZNY = parcelRequire("cMZNY");


var $1bY7o = parcelRequire("1bY7o");











var $1NBp8 = parcelRequire("1NBp8");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $cEgMD = parcelRequire("cEgMD");













const $999bd16bdfd9c01c$var$i18n = (0, $aXWIB.defineMessages)({
    defaultTooltipContent: {
        id: "fabric-extension-manager-plugin.anchor.copy-link-button.tooltip",
        defaultMessage: "Copy link to anchor"
    },
    erroredTooltipContent: {
        id: "fabric-extension-manager-plugin.anchor.copy-link-button.tooltip.disabled",
        defaultMessage: "Edit to create link"
    },
    copySuccessTooltipContent: {
        id: "fabric-extension-manager-plugin.anchor.copy-link-button.tooltip.copied",
        defaultMessage: "Copied!"
    }
});
const $999bd16bdfd9c01c$export$baeb5f600fdaf82a = ()=>({ tr: tr })=>tr.setMeta((0, $1a6e0310908ffd24$export$18d4026d1ea86bb1), {
            showAnchorLinkCopiedTooltip: undefined
        });
const $999bd16bdfd9c01c$export$94a93fd1fcc43123 = ({ node: node, intl: intl, api: api, updateTooltipPosition: updateTooltipPosition })=>{
    const showAnchorLinkCopiedTooltip = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        (0, $1a6e0310908ffd24$export$234cb421a967be1c)
    ], (states)=>states?.extensionManagerState?.showAnchorLinkCopiedTooltip);
    const isValidAnchorName = (0, $a511a7deb986d4c1$export$f57cb5ad5ec9d3a8)(node);
    (0, $42omo.useEffect)(()=>{
        // Reset the state of `showAnchorLinkCopiedTooltip` back to default when the component unmounts
        return ()=>{
            api?.core?.actions?.execute?.($999bd16bdfd9c01c$export$baeb5f600fdaf82a());
        };
    }, [
        api
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        // When the content of a visible tooltip changes, its' position isn't recalculated
        // and the tooltip may become misaligned. Since we change the tooltip content when
        // the link is copied, we need to manually recalculate the tooltip position.
        if (showAnchorLinkCopiedTooltip) updateTooltipPosition?.();
    }, [
        showAnchorLinkCopiedTooltip,
        updateTooltipPosition
    ]);
    if (!isValidAnchorName) // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("p", null, intl.formatMessage($999bd16bdfd9c01c$var$i18n.erroredTooltipContent));
    return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("p", null, !!showAnchorLinkCopiedTooltip ? intl.formatMessage($999bd16bdfd9c01c$var$i18n.copySuccessTooltipContent) : intl.formatMessage($999bd16bdfd9c01c$var$i18n.defaultTooltipContent)));
};


const $a511a7deb986d4c1$var$i18n = (0, $aXWIB.defineMessages)({
    anchorMacroCopyLinkCTALabel: {
        id: "fabric-extension-manager-plugin.anchor.copy-link-button.label",
        defaultMessage: "Copy link"
    }
});
const $a511a7deb986d4c1$export$f57cb5ad5ec9d3a8 = (node)=>{
    const rawAnchorName = node.attrs.parameters.macroParams['']?.value;
    // Normalize TinyMCE-era anchor names: strip spaces to match legacy URL format.
    let anchorName = rawAnchorName;
    if (typeof rawAnchorName === 'string' && (0, $dh538.fg)('platform_editor_anchor_spaces_normalization')) anchorName = rawAnchorName.replaceAll(/\s+/g, '');
    if (!anchorName) return false;
    try {
        decodeURIComponent(anchorName);
        return true;
    } catch  {
        return false;
    }
};
const $a511a7deb986d4c1$var$getPathName = (isLivePage, contentId, spaceKey)=>{
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    if (isCompanyHub) return (0, $1NBp8.COMPANY_HUB).toUrl();
    if (isLivePage) return typeof window !== 'undefined' ? window.location.pathname : '';
    return (0, $1NBp8.VIEW_PAGE).toUrl({
        contentId: contentId,
        spaceKey: spaceKey
    });
};
const $a511a7deb986d4c1$var$encodeAnchorNameForUrlFragment = (anchorName)=>{
    // Encode as a fragment value, but keep `/` readable for path-like anchor names.
    return encodeURIComponent(anchorName).replace(/%2F/gi, '/');
};
const $a511a7deb986d4c1$export$548d9151b6657224 = (node, fireAnalyticsEvent)=>(state, dispatch)=>{
        const { tr: tr } = state;
        const { isLivePage: isLivePage, contentId: contentId, spaceKey: spaceKey } = (0, $1a6e0310908ffd24$export$18d4026d1ea86bb1).getState(state)?.pageContext ?? {};
        const rawAnchorName = node.attrs.parameters.macroParams['']?.value;
        // Normalize TinyMCE-era anchor names: strip spaces to match legacy URL format.
        let anchorName = rawAnchorName;
        if (typeof rawAnchorName === 'string' && (0, $dh538.fg)('platform_editor_anchor_spaces_normalization')) anchorName = rawAnchorName.replaceAll(/\s+/g, '');
        const pathName = $a511a7deb986d4c1$var$getPathName(isLivePage, contentId, spaceKey);
        const setShowAnchorLinkCopiedTooltip = (showAnchorLinkCopiedTooltip)=>{
            dispatch?.(tr.setMeta((0, $1a6e0310908ffd24$export$18d4026d1ea86bb1), {
                showAnchorLinkCopiedTooltip: showAnchorLinkCopiedTooltip
            }));
        };
        fireAnalyticsEvent?.({
            action: (0, $d925B.ACTION).CLICKED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).COPY_LINK_TO_ANCHOR,
            eventType: (0, $d925B.EVENT_TYPE).UI,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB,
                extensionKey: node.attrs?.extensionKey,
                extensionType: node.attrs?.extensionType,
                isLivePage: isLivePage
            }
        });
        if (dispatch) try {
            decodeURIComponent(anchorName ?? '');
            const anchorNameForUrlFragment = (0, $dh538.fg)('cc_page_experiences_anchor_encode') ? $a511a7deb986d4c1$var$encodeAnchorNameForUrlFragment(anchorName ?? '') : anchorName ?? '';
            (0, $cMZNY.copyToClipboard)(`${typeof window !== 'undefined' ? window.location.origin : ''}${pathName}#${anchorNameForUrlFragment}`).then(()=>{
                setShowAnchorLinkCopiedTooltip(true);
            }).catch((error)=>{
                (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
                });
                setShowAnchorLinkCopiedTooltip(false);
            });
        } catch  {
            setShowAnchorLinkCopiedTooltip(false);
        }
        return true;
    };
const $a511a7deb986d4c1$export$3178138fc316e9da = (toolbarItems, intl, node, api)=>{
    const updatedToolbarItems = toolbarItems.slice();
    const indexOfFirstSeperator = toolbarItems.map((item)=>item.type).indexOf('separator');
    const { fireAnalyticsEvent: fireAnalyticsEvent } = api?.analytics?.actions ?? {};
    const newItemsToInsert = [
        {
            id: 'editor.anchor.macro.copy-link',
            type: 'button',
            title: intl.formatMessage($a511a7deb986d4c1$var$i18n.anchorMacroCopyLinkCTALabel),
            tooltipContent: ({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $999bd16bdfd9c01c$export$94a93fd1fcc43123), {
                    node: node,
                    intl: intl,
                    api: api,
                    updateTooltipPosition: update
                }),
            showTitle: true,
            hideTooltipOnClick: false,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
            onClick: $a511a7deb986d4c1$export$548d9151b6657224(node, fireAnalyticsEvent),
            disabled: !$a511a7deb986d4c1$export$f57cb5ad5ec9d3a8(node)
        }
    ];
    /**
   * If there is no separator, 1 group present, add
   * separator before the new items to create a new visual
   */ if (indexOfFirstSeperator === -1) newItemsToInsert.unshift({
        type: 'separator',
        hidden: false
    });
    else if (indexOfFirstSeperator !== 0 && indexOfFirstSeperator !== toolbarItems.length - 1) newItemsToInsert.push({
        type: 'separator',
        hidden: false
    });
    updatedToolbarItems.splice(indexOfFirstSeperator + 1, 0, ...newItemsToInsert);
    return updatedToolbarItems;
};
const $a511a7deb986d4c1$export$1ddc93af5b94ad04 = {
    shouldApplyOverride: (state, config)=>{
        const isCurrentSelectionAnchorMacro = state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.attrs.extensionType === 'com.atlassian.confluence.macro.core' && state.selection.node.attrs.extensionKey === 'anchor';
        return isCurrentSelectionAnchorMacro && (Array.isArray(config.nodeType) ? config.nodeType.includes(state.schema.nodes.inlineExtension) : config.nodeType === state.schema.nodes.inlineExtension);
    },
    applyOverride: (config, intl, api)=>{
        if (Array.isArray(config.items)) {
            const toolbarItems = config.items;
            config.items = (node)=>{
                if (node.attrs.extensionType === 'com.atlassian.confluence.macro.core' && node.attrs.extensionKey === 'anchor') return $a511a7deb986d4c1$export$3178138fc316e9da(toolbarItems, intl, node, api);
                return toolbarItems;
            };
        }
    }
};


const $ea140a6e73833f23$export$86ce8f8241c20a3 = (state, intl, _providerFactory, activeConfigs, api)=>{
    if (!activeConfigs?.length) return;
    const overrides = [
        (0, $a511a7deb986d4c1$export$1ddc93af5b94ad04)
    ];
    activeConfigs.forEach((config)=>{
        overrides.forEach(({ shouldApplyOverride: shouldApplyOverride, applyOverride: applyOverride })=>{
            if (shouldApplyOverride(state, config)) applyOverride(config, intl, api);
        });
    });
};


const $b6333eeaeea6365c$export$53933ef6873e4a9f = ({ api: api })=>({
        name: (0, $1a6e0310908ffd24$export$234cb421a967be1c),
        pmPlugins () {
            return [
                {
                    name: (0, $1a6e0310908ffd24$export$234cb421a967be1c),
                    plugin: ()=>(0, $1a6e0310908ffd24$export$ae829ec7b2625219)()
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $1a6e0310908ffd24$export$18d4026d1ea86bb1).getState(editorState);
            return {
                showAnchorLinkCopiedTooltip: pluginState?.showAnchorLinkCopiedTooltip
            };
        },
        usePluginHook ({ editorView: editorView }) {
            const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
            const [{ contentId: contentId, spaceKey: spaceKey }] = (0, $ep3mz.usePageState)();
            (0, $42omo.useEffect)(()=>{
                const { dispatch: dispatch, state: { tr: tr } } = editorView;
                tr.setMeta((0, $1a6e0310908ffd24$export$18d4026d1ea86bb1), {
                    pageContext: {
                        isLivePage: isLivePage,
                        spaceKey: spaceKey,
                        contentId: contentId
                    }
                });
                dispatch(tr);
            }, [
                editorView,
                isLivePage,
                spaceKey,
                contentId
            ]);
        },
        pluginsOptions: {
            floatingToolbar: (...args)=>(0, $ea140a6e73833f23$export$86ce8f8241c20a3)(...args, api)
        }
    });



var $9wGTI = parcelRequire("9wGTI");








var $6qdjm = parcelRequire("6qdjm");


var $91bcx = parcelRequire("91bcx");


var $9NwnH = parcelRequire("9NwnH");








var $ffQ2A = parcelRequire("ffQ2A");


var $cO9ey = parcelRequire("cO9ey");


var $jy7VG = parcelRequire("jy7VG");


var $8EkET = parcelRequire("8EkET");


var $h9yJL = parcelRequire("h9yJL");



















const $bcc122a52e0f74cf$export$3b87fd119d006909 = new (0, $ks2lK.PluginKey)('editorOfflineStoragePlugin');
const $bcc122a52e0f74cf$export$ae829ec7b2625219 = (stepsDatabase)=>()=>{
        return new (0, $1S4f7.SafePlugin)({
            key: $bcc122a52e0f74cf$export$3b87fd119d006909,
            state: {
                init () {
                    // environment-aware enablement via feature encoding
                    const isEditorFeatureEnabled = (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-editor-offline-storage');
                    return {
                        status: 'pending',
                        disabled: !isEditorFeatureEnabled ? 'disabledEnvironment' : false,
                        inactiveSyncing: false
                    };
                },
                apply: (tr, currentPluginState)=>{
                    const meta = tr.getMeta($bcc122a52e0f74cf$export$3b87fd119d006909);
                    if (meta) return {
                        ...currentPluginState,
                        ...meta
                    };
                    return currentPluginState;
                }
            },
            view: ()=>{
                return {
                    destroy () {
                        return stepsDatabase.closeDB(true);
                    }
                };
            }
        });
    };


class $5c049076093b3a44$export$d15eb9e8bb5d03ea {
    get hasLock() {
        return this._hasLock;
    }
    get lockPurpose() {
        return this._lockPurpose;
    }
    init(dbName) {
        this.dbName = dbName;
    }
    /**
   * Release the lock so it can be used elsewhere
   */ releaseLock() {
        this._releaseLock();
    }
    /**
   * Acquire the lock for the page
   *
   * **Waiting on this function will block until the lock is acquired then released, or the lock request is aborted.**
   * If waitUntilAvailable is set to `true`, the lock request will wait for the lock to become available.
   * If waitUntilAvailable is set to `false`, the lock request will abort if the lock is not available at the time it's requested.
   *
   * @param callback - The callback to run when the lock is acquired or the lock request is aborted
   * @param waitUntilAvailable - When set to true the lock request will wait until the lock is available
   */ async acquireLock(callback, waitUntilAvailable = false, purpose) {
        if (!this.dbName) return Promise.reject(new Error('SynchronisationLock not initialized.'));
        await navigator.locks?.request(this.dbName, {
            ifAvailable: !waitUntilAvailable
        }, async (lock)=>{
            if (lock === null) {
                await callback?.(false);
                return;
            }
            const promise = this.holdLock();
            this._lockPurpose = purpose;
            await callback?.(true);
            return promise;
        });
    }
    /**
   * If the lock is currently taken and therefore we shouldn't send any data
   */ async isLocked() {
        if (!this.dbName) return false;
        const locks = await navigator.locks?.query();
        const relevantLocks = locks?.held ? locks.held.filter((lock)=>lock.name === this.dbName) : [];
        if (relevantLocks && relevantLocks.length > 0) return true;
        else return false;
    }
    constructor(){
        this.dbName = void 0;
        this._hasLock = false;
        this._lockPurpose = void 0;
        this._releaseLock = ()=>{};
        this.holdLock = async ()=>{
            this._hasLock = true;
            let resolve;
            this._releaseLock = ()=>{
                // resolving the promise will release the lock
                resolve({});
                this._hasLock = false;
                this._lockPurpose = undefined;
            };
            return new Promise((res)=>{
                resolve = res;
            });
        };
    }
}





const $1a899df20ad45f18$var$isTrackEvent = (props)=>{
    return props.action === 'OFFLINE_EDITING_SUCCESS_STORE_RECOVERY_VERSION';
};
const $1a899df20ad45f18$export$6bd08bb9f59ca292 = (props)=>{
    const { api: api, action: action, ...otherAttributes } = props;
    if (!api || !api.analytics) return;
    // Get additional context from shared state
    const sharedPluginState = api?.editorOfflineStorage?.sharedState.currentState();
    const { version: version, steps: steps, status: status, disabled: disabled } = sharedPluginState ?? {};
    api.analytics.actions?.fireAnalyticsEvent?.({
        eventType: $1a899df20ad45f18$var$isTrackEvent(props) ? (0, $d925B.EVENT_TYPE).TRACK : (0, $d925B.EVENT_TYPE).OPERATIONAL,
        action: action,
        actionSubject: (0, $d925B.ACTION_SUBJECT).OFFLINE_EDITING,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).OFFLINE_EDITING,
        attributes: {
            version: // Additonal context.
            version,
            stepsCount: steps?.length,
            status: status,
            disabled: disabled,
            // Action specific attributes.
            ...otherAttributes
        }
    });
};
const $1a899df20ad45f18$export$91c32f1b22d29b2d = (error)=>{
    if (!error) return 'Unknown error';
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return String(error);
};
const $1a899df20ad45f18$export$ff269655d7dc6e77 = (errors)=>{
    return errors.map((e)=>$1a899df20ad45f18$export$91c32f1b22d29b2d(e)).join(';');
};


/**
 * Background cleanup logic for expired offline editor databases.
 *
 * This module handles checking all databases from other documents and taking action:
 * - Deletes fully-expired databases
 * - Clears expired data while preserving fresh data
 * - Migrates pre-migration databases by adding timestamps
 */ 



var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $awSMG = parcelRequire("awSMG");


const $e9c926f713f211d2$var$THIRTY_DAYS_MS = 2592000000;
const $e9c926f713f211d2$var$BACKGROUND_CLEANUP_INTERVAL_MS = 86400000;
const $e9c926f713f211d2$var$MAX_DATABASES_PER_CLEANUP = 100; // Cap to prevent performance issues on first load
/**
 * Extract contentId from database name by removing the prefix.
 */ const $e9c926f713f211d2$var$extractContentId = (dbName)=>dbName.replace((0, $awSMG.OFFLINE_STEPS_DATABASE_NAME_PREFIX), '');
function $e9c926f713f211d2$export$365e5e8d6c8a82b3() {
    try {
        if (!(0, $17wUi.confluenceLocalStorageInstance)) return false;
        const lastAttempt = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).EDITOR_OFFLINE_LAST_BACKGROUND_CLEANUP_ATTEMPT);
        if (!lastAttempt) return true;
        const timeSinceLastAttempt = Date.now() - parseInt(lastAttempt, 10);
        return timeSinceLastAttempt > $e9c926f713f211d2$var$BACKGROUND_CLEANUP_INTERVAL_MS;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        // Storage access failed - return false to skip cleanup (non-critical)
        return false;
    }
}
function $e9c926f713f211d2$export$df49bbb19630c32d() {
    try {
        if (!(0, $17wUi.confluenceLocalStorageInstance)) return;
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).EDITOR_OFFLINE_LAST_BACKGROUND_CLEANUP_ATTEMPT, Date.now().toString());
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
    // Storage access failed - continue silently (non-critical)
    }
}
/**
 * Delete an entire database.
 */ async function $e9c926f713f211d2$var$deleteDatabase(dbName) {
    return new Promise((resolve, reject)=>{
        const request = indexedDB.deleteDatabase(dbName);
        request.onsuccess = ()=>resolve();
        request.onerror = ()=>reject(request.error);
        request.onblocked = ()=>resolve();
    });
}
/**
 * Add timestamp to pre-migration data to migrate it.
 */ async function $e9c926f713f211d2$var$addTimestampToMigrateData(database, metaData) {
    const tx = database.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readwrite');
    const metaStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
    const updatedMetaData = {
        ...metaData || {
            doc: null,
            version: null
        },
        lastUpdated: Date.now()
    };
    await metaStore.put(updatedMetaData, 1);
    await tx.done;
}
async function $e9c926f713f211d2$export$197ab581d971f15a(dbName) {
    try {
        const db = await (0, $ffQ2A.openDB)(dbName, (0, $awSMG.OFFLINE_STEPS_DATABASE_VERSION), {
            upgrade (database) {
                // Create stores if they don't exist
                if (!database.objectStoreNames.contains((0, $awSMG.OFFLINE_STEPS_STORE_NAME))) database.createObjectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME), {
                    keyPath: 'id',
                    autoIncrement: true
                });
                if (!database.objectStoreNames.contains((0, $awSMG.OFFLINE_META_STORE_NAME))) database.createObjectStore((0, $awSMG.OFFLINE_META_STORE_NAME), {});
            },
            blocking: (_currentVersion, _blockedVersion, event)=>{
                // Close the database connection if the database is deleted or version changes
                // This is important for Firefox compatibility when deleting databases. See HOT-12395 for more details.
                if (event?.target) event.target.close();
            }
        });
        try {
            // Check if both stores exist - if not, database is invalid
            if (!db.objectStoreNames.contains((0, $awSMG.OFFLINE_META_STORE_NAME)) || !db.objectStoreNames.contains((0, $awSMG.OFFLINE_STEPS_STORE_NAME))) {
                db.close();
                await $e9c926f713f211d2$var$deleteDatabase(dbName);
                return {
                    dbName: dbName,
                    deleted: true,
                    reason: 'invalid',
                    errorMessage: 'Database missing required object stores'
                };
            }
            const tx = db.transaction([
                (0, $awSMG.OFFLINE_META_STORE_NAME),
                (0, $awSMG.OFFLINE_STEPS_STORE_NAME)
            ], 'readonly');
            const metaStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const stepsStore = tx.objectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME));
            const metaData = await metaStore.get(1);
            const stepsCount = await stepsStore.count();
            // Empty database: No meta data AND no steps. Safe to delete.
            if (!metaData && stepsCount === 0) {
                db.close();
                await $e9c926f713f211d2$var$deleteDatabase(dbName);
                return {
                    dbName: dbName,
                    deleted: true,
                    reason: 'empty'
                };
            }
            // Migration: Missing metadata or missing timestamp. Add timestamp and skip deletion.
            if (!metaData || !metaData.lastUpdated) {
                await $e9c926f713f211d2$var$addTimestampToMigrateData(db, metaData);
                return {
                    dbName: dbName,
                    deleted: false,
                    reason: 'migrated'
                };
            }
            // At this point, metaData.lastUpdated is guaranteed to exist (migrated above)
            const currentTimestamp = Date.now();
            const databaseAge = currentTimestamp - metaData.lastUpdated;
            const isExpired = databaseAge > $e9c926f713f211d2$var$THIRTY_DAYS_MS;
            // Expired: Delete entire database.
            if (isExpired) {
                const daysExpired = Math.floor(databaseAge / 86400000);
                const hasBackup = !!metaData.versionInsertionBackup;
                db.close();
                await $e9c926f713f211d2$var$deleteDatabase(dbName);
                return {
                    dbName: dbName,
                    deleted: true,
                    reason: 'expired',
                    daysExpired: daysExpired,
                    stepsCount: stepsCount,
                    hasBackup: hasBackup
                };
            }
            // Not expired: Database is active.
            return {
                dbName: dbName,
                deleted: false,
                reason: 'active'
            };
        } catch (error) {
            return {
                dbName: dbName,
                deleted: false,
                reason: 'error',
                errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error)
            };
        } finally{
            db.close();
        }
    } catch (error) {
        // Can't open the database - treat as error case
        return {
            dbName: dbName,
            deleted: false,
            reason: 'error',
            errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error)
        };
    }
}
async function $e9c926f713f211d2$export$1419703707730bf4(currentDbName, api) {
    try {
        if (!window.indexedDB.databases) return;
        const allDatabases = await window.indexedDB.databases();
        const offlineEditorDatabases = allDatabases.filter((dbInfo)=>dbInfo.name?.startsWith((0, $awSMG.OFFLINE_STEPS_DATABASE_NAME_PREFIX)) && dbInfo.name !== currentDbName);
        const totalOfflineDatabases = offlineEditorDatabases.length;
        let databasesProcessed = 0;
        let databasesDeleted = 0;
        const cleanupDetails = [];
        // Early exit if no databases to process
        if (totalOfflineDatabases === 0) {
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: 'OFFLINE_EDITING_BACKGROUND_CLEANUP_COMPLETED',
                databasesProcessed: 0,
                databasesDeleted: 0,
                totalOfflineDatabases: 0,
                cleanupDetails: []
            });
            return;
        }
        // We randomise the order to ensure all databases eventually get checked. Otherwise, we'd check the first N databases every time.
        // We also cap the number of databases checked per run to prevent performance issues. For power users with large backlogs, cleanup will happen gradually over multiple days.
        const randomisedDatabases = offlineEditorDatabases.sort(()=>Math.random() - 0.5);
        const databasesToCheck = randomisedDatabases.slice(0, $e9c926f713f211d2$var$MAX_DATABASES_PER_CLEANUP);
        for (const dbInfo of databasesToCheck){
            const dbName = dbInfo.name;
            try {
                const result = await $e9c926f713f211d2$export$197ab581d971f15a(dbName);
                databasesProcessed++;
                // Fire analytics for database deletions (expired, empty, or invalid)
                if (result.reason === 'expired' || result.reason === 'empty' || result.reason === 'invalid') {
                    databasesDeleted++;
                    cleanupDetails.push({
                        contentId: $e9c926f713f211d2$var$extractContentId(dbName),
                        deletionReason: result.reason,
                        daysExpired: result.daysExpired ?? 0,
                        stepsCount: result.stepsCount ?? 0,
                        hasBackup: result.hasBackup ?? false
                    });
                }
                // Fire analytics for database check errors
                if (result.reason === 'error') (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                    api: api,
                    action: 'OFFLINE_EDITING_BACKGROUND_CLEANUP_ERROR',
                    errorMessage: result.errorMessage ?? 'Unknown error',
                    errorSource: 'database_check',
                    contentId: $e9c926f713f211d2$var$extractContentId(dbName),
                    totalOfflineDatabases: totalOfflineDatabases
                });
            } catch (error) {
                databasesProcessed++;
                (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                    api: api,
                    action: 'OFFLINE_EDITING_BACKGROUND_CLEANUP_ERROR',
                    errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error),
                    errorSource: 'database_check',
                    contentId: $e9c926f713f211d2$var$extractContentId(dbName),
                    totalOfflineDatabases: totalOfflineDatabases
                });
            }
        }
        // Fire completion analytics for every cleanup run
        (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: api,
            action: 'OFFLINE_EDITING_BACKGROUND_CLEANUP_COMPLETED',
            databasesProcessed: databasesProcessed,
            databasesDeleted: databasesDeleted,
            totalOfflineDatabases: totalOfflineDatabases,
            cleanupDetails: cleanupDetails
        });
    } catch (error) {
        (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: api,
            action: 'OFFLINE_EDITING_BACKGROUND_CLEANUP_ERROR',
            errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error),
            errorSource: 'cleanup_init'
        });
    }
}





const $f0050ff6ee6f7eb3$var$SYNC_LOCK_TIMEOUT_MS = 20000;
const $f0050ff6ee6f7eb3$var$THIRTY_DAYS_MS = 2592000000;
class $f0050ff6ee6f7eb3$export$c7a2e99e9e26da1c {
    // Used to cache the result of the IndexedDB validation.
    onError(_id, error, disabledReason) {
        // Indicate the steps database is not healthy.
        this.api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
                disabled: disabledReason ?? 'stepsDatabaseError'
            }));
        (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: this.api,
            action: (0, $d925B.ACTION).OFFLINE_STORAGE_STEPS_DATABASE_ERROR,
            errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error),
            errorSource: _id,
            errorCause: {
                contentIdPresent: !!this.contentId,
                stepsDatabaseInitAttempted: this.initAttempted,
                // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                isSSR: false,
                isIndexedDBAvailable: this.indexedDBAvailable
            }
        });
    }
    /**
   * The name of the database for the current contentId
   */ get dbName() {
        if (!this.contentId) return undefined;
        return `${0, $awSMG.OFFLINE_STEPS_DATABASE_NAME_PREFIX}${this.contentId}`;
    }
    get hasLock() {
        return this.syncLock.hasLock;
    }
    get lockPurpose() {
        return this.syncLock.lockPurpose;
    }
    isLocked() {
        return this.syncLock.isLocked();
    }
    /**
   * Releases the current sync lock. Returns a promise to check if the lock has been released
   * at this point which can be useful if you want to do other operations (ie. update the DB)
   * based on the lock status and need it to be freed.
   *
   * @returns boolean: The result if the sync is still locked.
   */ async releaseSyncLock() {
        this.syncLock.releaseLock?.();
        return this.syncLock.isLocked();
    }
    /**
   * Attempts to acquire a synchronization lock for the database.
   *
   * @param callback - Optional callback function that is called when the lock is acquired or times out.
   *                  The callback receives a boolean indicating if the lock was granted.
   * @param waitUntilAvailable - If true, waits until the lock becomes available. If false, returns immediately.
   * @param timeoutAfterMS - Optional timeout in milliseconds. If provided and waitUntilAvailable is true,
   *                        the callback will be called with false if the lock isn't acquired within this time.
   *                        When platform_editor_offline_editing_web_ga_fixes is cleaned up, this parameter can be removed.
   * @returns A Promise if waiting for the lock, void if not waiting.
   */ acquireSyncLock(callback, waitUntilAvailable = false, purpose, timeoutAfterMS) {
        const lockPromise = this.syncLock.acquireLock(callback, waitUntilAvailable, purpose).catch((e)=>{
            this.onError('acquireSyncLock()', e);
            // Ensure callback is called with false on error
            return callback?.(false);
        });
        // If we're not waiting for the lock, fire-and-forget
        if (!waitUntilAvailable) return;
        const effectiveTimeout = (0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes') ? $f0050ff6ee6f7eb3$var$SYNC_LOCK_TIMEOUT_MS : timeoutAfterMS;
        // If we have a timeout, race the lock acquisition with a timeout. Redundant check when platform_editor_offline_editing_web_ga_fixes is cleaned up.
        if (effectiveTimeout) {
            const timeoutPromise = new Promise((resolve)=>{
                setTimeout(async ()=>{
                    // Callback invoked with granted = false, failed attempt to acquire lock.
                    await callback?.(false);
                    resolve();
                }, effectiveTimeout);
            });
            return Promise.race([
                lockPromise,
                timeoutPromise
            ]);
        }
        return lockPromise;
    }
    /**
   * Initialize the class for the given contentId.
   * Can be re-initialized with a different contentId, which will close an existing connection.
   * Does not open the database connection.
   * @param contentId The unique page contentId
   * @returns true if initialized successfully, false if indexedDB is not supported.
   */ async init(contentId, api) {
        this.initAttempted = true;
        this.api = api;
        if (window?.indexedDB === undefined) {
            this.onError('init()', new Error('indexedDB is not defined'));
            return false;
        }
        if (this.contentId === contentId && this.dbPromise) return true;
        this.contentId = contentId;
        if (this.dbName) this.syncLock.init(this.dbName);
        return true;
    }
    /**
   * Validates IndexedDB access by attempting a test write.
   * @returns Promise<boolean> - true if validation succeeds, false if it fails
   */ async validateIndexedDBAccess() {
        // Check the cached indexedDBAvailable to avoid validating multiple times.
        if (this.indexedDBAvailable !== undefined) return this.indexedDBAvailable ?? true;
        try {
            if (window?.indexedDB === undefined) throw new Error('indexedDB is not defined');
            const testDbName = 'editor:offline-storage-access-test';
            const testDb = await (0, $ffQ2A.openDB)(testDbName, 1, {
                upgrade (database) {
                    database.createObjectStore('test', {
                        autoIncrement: true
                    });
                }
            });
            // Try a test write
            const tx = testDb.transaction('test', 'readwrite');
            const store = tx.objectStore('test');
            await store.add({
                test: 'test'
            });
            await tx.done;
            // Clean up
            testDb.close();
            window.indexedDB.deleteDatabase(testDbName);
            this.indexedDBAvailable = true;
            return true;
        } catch (error) {
            this.onError('validateIndexedDBAccess()', error, 'indexedDBAccessError');
            this.indexedDBAvailable = false;
            return false;
        }
    }
    /**
   * Gets or creates a database connection for the current contentId.
   * If a connection exists, validates it is still usable before returning.
   * If validation fails or no connection exists, creates and returns a new connection.
   *
   * @throws {Error} When dbName is undefined (not initialized – missing contentId, init not called, or in SSR mode)
   * @returns A promise that resolves to a valid database connection
   */ async openDB() {
        if (this.dbName === undefined) throw new Error('StepsDatabase not initialized. Possibly missing contentId, init hasnt been called or rendering in SSR mode.');
        // If we have a cached connection, we validate it with a quick read transaction.
        // If this transaction fails, we close the connection and create a new one.
        if (this.dbPromise) try {
            const db = await this.dbPromise;
            await db.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readonly').objectStore((0, $awSMG.OFFLINE_META_STORE_NAME)).count();
            // Returning the valid cached database connection.
            return this.dbPromise;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (_error) {
            // Cleanup before creating a new connection.
            await this.closeDB();
        }
        this.dbPromise = (0, $ffQ2A.openDB)(this.dbName, (0, $awSMG.OFFLINE_STEPS_DATABASE_VERSION), {
            upgrade (database) {
                if (!database.objectStoreNames.contains((0, $awSMG.OFFLINE_STEPS_STORE_NAME))) database.createObjectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME), {
                    keyPath: 'id',
                    autoIncrement: true
                });
                if (!database.objectStoreNames.contains((0, $awSMG.OFFLINE_META_STORE_NAME))) database.createObjectStore((0, $awSMG.OFFLINE_META_STORE_NAME), {});
            },
            terminated: ()=>{
                this.dbPromise = undefined;
            },
            blocking: (_currentVersion, _blockedVersion, event)=>{
                // Close the database connection when version changes or database is deleted
                // This is important for Firefox compatibility when deleting databases. See HOT-12395 for more details.
                if (event?.target) // event.target is the database object that the versionchange event was fired on
                event.target.close();
            }
        });
        return this.dbPromise;
    }
    sanitizeStep(step) {
        if (step instanceof (0, $jy7VG.AnalyticsStep) || step instanceof (0, $8EkET.LinkMetaStep)) return undefined;
        return step.toJSON();
    }
    /**
   * Update the steps, doc and version in the database if the stored steps are different.
   * It does a full clear and replace with the new steps.
   * @param version The collab version for creating unique key/value pairs in the db
   * @param steps The steps to store in the database
   * @returns true if the steps were updated, false if the steps were the same as the stored steps
   */ async updateIfChanged(version, baseDocJSON, steps) {
        try {
            const isLocked = await this.syncLock.isLocked() && !this.hasLock;
            if (isLocked) return false;
            const db = await this.openDB();
            const tx = db.transaction([
                (0, $awSMG.OFFLINE_STEPS_STORE_NAME),
                (0, $awSMG.OFFLINE_META_STORE_NAME)
            ], 'readwrite');
            const stepsStore = (0, $ffQ2A.unwrap)(tx.objectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME)));
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            // We breakout of idb here. The reason is it ensures we have a single promise
            // for `updateSteps` and ensures `fake-indexeddb` works as intended here.
            // This allows us to test as close as possible to real indexeddb
            const updateSteps = async ()=>{
                await new Promise((resolve, reject)=>{
                    const localSteps = steps.map(this.sanitizeStep).filter((step)=>!!step);
                    const request = stepsStore.clear();
                    request.onsuccess = ()=>{
                        // Store serialized steps in the database
                        let index = 0;
                        const addNextStep = ()=>{
                            if (index < localSteps.length) {
                                const serializedStep = localSteps[index];
                                const addRequest = stepsStore.add({
                                    step: serializedStep
                                });
                                addRequest.onsuccess = ()=>{
                                    index++;
                                    addNextStep();
                                };
                                addRequest.onerror = (event)=>{
                                    reject(event.target?.error);
                                };
                            } else resolve(undefined);
                        };
                        addNextStep();
                    };
                    request.onerror = (event)=>{
                        reject(event.target?.error);
                    };
                });
            };
            await Promise.all([
                updateSteps(),
                // Store the doc, version, and lastUpdated timestamp
                docStore.put({
                    doc: baseDocJSON,
                    version: version,
                    lastUpdated: Date.now()
                }, 1)
            ]);
            await tx.done;
            return true;
        } catch (e) {
            this.onError('updateIfChanged()', e);
            throw e;
        }
    }
    /**
   * Update the stored docJSON and version in the database.
   * This can be called by the leader after applying steps to save the post-apply state for followers.
   * Extracts the confirmed document state and collaboration version from the editor view.
   * @param editorView The editor view to extract document state and version from
   * @returns Promise<boolean> - true if updated successfully, throws on error
   */ async updateDocAndVersion(editorView) {
        try {
            const newVersion = (0, $9NwnH.getCollabState)(editorView.state)?.version;
            if (newVersion === undefined) return false;
            const db = await this.openDB();
            const tx = db.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readwrite');
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const transformer = new (0, $h9yJL.JSONTransformer)();
            // We use getDocBeforeUnconfirmedSteps to ensure we get the latest _confirmed_ document, as some
            // ... unconfirmed steps may have come through while clearing the offline steps and updating the docJSON.
            const newDocJSON = transformer.encode((0, $9NwnH.getDocBeforeUnconfirmedSteps)(editorView.state));
            // Update doc, version, and lastUpdated timestamp
            const updatedData = {
                doc: newDocJSON,
                version: newVersion,
                lastUpdated: Date.now()
            };
            await docStore.put(updatedData, 1);
            await tx.done;
            return true;
        } catch (e) {
            this.onError('updateDocAndVersion()', e);
            throw e;
        }
    }
    /**
   * Retrieve the steps, doc and version from the database.
   * Will open a new database connection, if one is not already open.
   * @param pmSchema The current ProseMirror schema
   * @returns The steps stored in the database
   */ async getData(pmSchema) {
        try {
            const db = await this.openDB();
            const tx = db.transaction([
                (0, $awSMG.OFFLINE_STEPS_STORE_NAME),
                (0, $awSMG.OFFLINE_META_STORE_NAME)
            ], 'readonly');
            const stepsStore = tx.objectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME));
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            // Collect all steps
            const collectSteps = async ()=>{
                const steps = await stepsStore.getAll();
                return steps.map((stepJson)=>(0, $cO9ey.Step).fromJSON(pmSchema, stepJson.step));
            };
            const [storedSteps, data] = await Promise.all([
                collectSteps(),
                docStore.get(1)
            ]);
            await tx.done;
            return data === undefined ? {
                steps: storedSteps,
                docJSON: null,
                version: null
            } : {
                steps: storedSteps,
                docJSON: data.doc,
                version: data.version
            };
        } catch (e) {
            this.onError('getData()', e);
            throw e;
        }
    }
    /**
   * Clear all steps, and stored doc from the database
   * Will open a new database connection, if one is not already open.
   */ async clear(all) {
        try {
            const isLocked = await this.syncLock.isLocked() && !this.hasLock;
            if (isLocked) return false;
            const db = await this.openDB();
            const tx = db.transaction([
                (0, $awSMG.OFFLINE_STEPS_STORE_NAME),
                (0, $awSMG.OFFLINE_META_STORE_NAME)
            ], 'readwrite');
            const stepsStore = tx.objectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME));
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            if (all) await Promise.all([
                stepsStore.clear(),
                docStore.clear()
            ]);
            else await stepsStore.clear();
            await tx.done;
            return true;
        } catch (e) {
            this.onError('clear()', e);
            throw e;
        }
    }
    /**
   * Check and clear expired data from the current document's database.
   * Also triggers background cleanup of other databases (throttled to once per 24 hours).
   * This should be called after init() but before attempting to restore steps.
   */ async checkAndClearExpiredData() {
        // Check and clear current document's expired data
        await this.checkCurrentDocumentExpiry();
        // Run background cleanup of other document's offline databases (non-blocking, throttled)
        if ((0, $e9c926f713f211d2$export$365e5e8d6c8a82b3)()) {
            // Mark attempted immediately to prevent race condition if multiple tabs open simultaneously
            (0, $e9c926f713f211d2$export$df49bbb19630c32d)();
            (0, $e9c926f713f211d2$export$1419703707730bf4)(this.dbName, this.api);
        }
    }
    /**
   * Check if the current document's offline data has expired and clear it if needed.
   * Uses instance methods (this.openDB(), this.clear()) rather than deleting the database entirely.
   * This preserves the database structure and connection since the current document may be
   * actively written to (e.g. user goes offline). Background cleanup of other databases
   * can safely delete them entirely as they have no active StepsDatabase instance.
   *
   * Backwards compatibility: If data exists but no lastUpdated, adds timestamp = now (30-day window starts from today).
   * Expiry: If lastUpdated > 30 days, clears all data via clear(true)
   */ async checkCurrentDocumentExpiry() {
        try {
            const db = await this.openDB();
            // Early exit if the object stores don't exist yet.
            // This is expected for users who haven't used offline storage before.
            if (!db.objectStoreNames.contains((0, $awSMG.OFFLINE_META_STORE_NAME)) || !db.objectStoreNames.contains((0, $awSMG.OFFLINE_STEPS_STORE_NAME))) return;
            const tx = db.transaction([
                (0, $awSMG.OFFLINE_STEPS_STORE_NAME),
                (0, $awSMG.OFFLINE_META_STORE_NAME)
            ], 'readwrite');
            const metaStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const stepsStore = tx.objectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME));
            const [metaData, stepsCount] = await Promise.all([
                metaStore.get(1),
                stepsStore.count()
            ]);
            if (!metaData) {
                await tx.done;
                return;
            }
            const now = Date.now();
            // Backwards compatibility: If data exists but no lastUpdated timestamp, add current timestamp
            // This starts the 30-day window from today for existing data
            if (!metaData.lastUpdated) {
                const updatedData = {
                    ...metaData,
                    lastUpdated: now
                };
                await metaStore.put(updatedData, 1);
                await tx.done;
                return;
            }
            // Check if data has expired (>30 days old) - single timestamp for all data
            if (now - metaData.lastUpdated > $f0050ff6ee6f7eb3$var$THIRTY_DAYS_MS) {
                await tx.done;
                // Gather analytics metadata
                const hasBackup = !!metaData.versionInsertionBackup;
                const daysExpired = Math.floor((now - metaData.lastUpdated) / 86400000);
                if (this.contentId) (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                    api: this.api,
                    action: 'OFFLINE_EDITING_DATA_EXPIRY_CLEANUP',
                    contentId: this.contentId,
                    daysExpired: daysExpired,
                    stepsCount: stepsCount,
                    hasBackup: hasBackup
                });
                await this.clear(true);
                return;
            }
            await tx.done;
        } catch (e) {
            this.onError('checkCurrentDocumentExpiry()', e);
        }
    }
    async closeDB(releaseSyncLock = false) {
        try {
            if (this.dbPromise) {
                const db = await this.dbPromise;
                db.close();
                this.dbPromise = undefined;
                if (releaseSyncLock) this.syncLock.releaseLock?.();
            }
        } catch (e) {
            this.onError('closeDB()', e);
            throw e;
        }
    }
    /**
   * Store a version insertion backup for later retry
   * @param adfContent Stringified ADF content that failed to be inserted
   * @returns Promise<boolean> - true if stored successfully
   */ async storeVersionInsertionBackup(adfContent) {
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) return false;
        try {
            const db = await this.openDB();
            const tx = db.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readwrite');
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const existingData = await docStore.get(1);
            // Only store backup if meta store already exists with doc and version
            // If it doesn't exist, there's no document to store a backup for
            if (!existingData || !existingData.doc || existingData.version === undefined) {
                await tx.done;
                return false;
            }
            // Create the backup object (no timestamp - uses shared lastUpdated)
            const versionInsertionBackup = {
                adfContent: adfContent
            };
            // Preserve all existing data and update both versionInsertionBackup and lastUpdated
            const updatedData = {
                ...existingData,
                versionInsertionBackup: versionInsertionBackup,
                lastUpdated: Date.now()
            };
            await docStore.put(updatedData, 1);
            await tx.done;
            return true;
        } catch (e) {
            this.onError('storeVersionInsertionBackup()', e);
            return false;
        }
    }
    /**
   * Get the stored version insertion backup if one exists
   * @returns Promise<VersionInsertionBackup | null>
   */ async getVersionInsertionBackup() {
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) return null;
        try {
            const db = await this.openDB();
            // Early exit if the meta store doesn't exist yet.
            // This is expected for users who haven't used offline storage before.
            if (!db.objectStoreNames.contains((0, $awSMG.OFFLINE_META_STORE_NAME))) return null;
            const tx = db.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readonly');
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const data = await docStore.get(1);
            await tx.done;
            return data?.versionInsertionBackup ?? null;
        } catch (e) {
            this.onError('getVersionInsertionBackup()', e);
            return null;
        }
    }
    /**
   * Clear the stored version insertion backup and update lastUpdated timestamp
   * @returns Promise<boolean> - true if cleared successfully
   */ async clearVersionInsertionBackup() {
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) return false;
        try {
            const db = await this.openDB();
            const tx = db.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readwrite');
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const existingData = await docStore.get(1);
            // If no data exists or no error field exists, nothing to clear
            if (!existingData || !existingData.versionInsertionBackup) {
                await tx.done;
                return true;
            }
            // Remove the versionInsertionBackup field and update timestamp
            const { versionInsertionBackup: _versionInsertionBackup, ...dataWithoutBackup } = existingData;
            await docStore.put({
                ...dataWithoutBackup,
                lastUpdated: Date.now()
            }, 1);
            await tx.done;
            return true;
        } catch (e) {
            this.onError('clearVersionInsertionBackup()', e);
            return false;
        }
    }
    constructor(){
        this.dbPromise = void 0;
        this.contentId = void 0;
        this.syncLock = new (0, $5c049076093b3a44$export$d15eb9e8bb5d03ea)();
        this.api = void 0;
        this.initAttempted = false;
        this.indexedDBAvailable = void 0;
    }
}












var $ke2AI = parcelRequire("ke2AI");

const $8755c63771d651df$export$43d640f3b62db5ab = (editorView)=>{
    const { state: state } = editorView;
    const newState = state.reconfigure({
        plugins: state.plugins.filter((p)=>{
            return p.spec.key !== (0, $ke2AI.history)().spec.key;
        })
    });
    editorView.updateState(newState);
    const { state: updatedState } = editorView;
    const newerState = updatedState.reconfigure({
        plugins: updatedState.plugins.concat((0, $ke2AI.history)())
    });
    editorView.updateState(newerState);
};



const $c71be5c341006c26$export$e38c76da774a8077 = ({ api: api, editorView: editorView, stepsDatabase: stepsDatabase })=>{
    const isBroadcastChannelSupported = window && 'BroadcastChannel' in window;
    const channelRef = (0, $42omo.useRef)();
    const firstChannelUpdateRef = (0, $42omo.useRef)(false);
    const broadcast = (0, $42omo.useCallback)((messageType = 'resync')=>{
        if (channelRef.current) {
            const message = {
                type: messageType
            };
            channelRef.current.postMessage(message);
        }
    }, []);
    const listener = (0, $42omo.useCallback)(async function(event) {
        const { type: type } = event.data;
        if (type !== 'resync' && type !== 'restore') return;
        const { mode: mode } = api?.connectivity?.sharedState.currentState() ?? {};
        // RESYNC: Only proceed when offline. This happens while syncing tabs when offline.
        // RESTORE: Only proceed when online. We restore on initialisation, when we have a connection.
        if (type === 'resync') {
            if (mode !== 'offline') return;
        } else if (type === 'restore') {
            if (mode !== 'online') return;
        }
        const { steps: steps, docJSON: docJSON, version: cachedVersion } = await stepsDatabase.getData(editorView.state.schema);
        if (!docJSON || cachedVersion === null) return;
        // RESYNC: only proceed when there are steps to sync.
        // RESTORE: only proceed when there are no steps to sync. The docJSON should have the cleared steps already applied.
        if (type === 'resync') {
            if (!steps) return;
        } else if (type === 'restore') {
            if (steps && steps.length > 0) return;
        }
        if (!firstChannelUpdateRef.current) {
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: (0, $d925B.ACTION).OFFLINE_STORAGE_BROADCAST_CHANNEL_FIRST_UPDATE
            });
            firstChannelUpdateRef.current = true;
        }
        const historyState = api?.history?.sharedState?.currentState?.();
        const hasHistory = (historyState?.done?.eventCount ?? 0) > 0 || (historyState?.undone?.eventCount ?? 0) > 0;
        if (hasHistory) (0, $8755c63771d651df$export$43d640f3b62db5ab)(editorView);
        const tr = (0, $9NwnH.syncFromAnotherSource)(editorView.state, cachedVersion, docJSON, steps);
        if (hasHistory && api?.history?.commands.updatePluginState) api.history.commands.updatePluginState({
            tr: tr
        });
        editorView.dispatch(tr);
    }, [
        api,
        editorView,
        stepsDatabase
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isBroadcastChannelSupported || !stepsDatabase.dbName) return;
        channelRef.current = new BroadcastChannel(stepsDatabase.dbName);
        channelRef.current.addEventListener('message', listener);
        return ()=>{
            if (channelRef.current) {
                channelRef.current.removeEventListener('message', listener);
                channelRef.current.close();
            }
        };
    }, [
        isBroadcastChannelSupported,
        stepsDatabase.dbName,
        listener
    ]);
    return broadcast;
};












function $85a440c10c4579b2$export$199006561aceceef() {
    return ({ tr: tr })=>{
        tr.setMeta('addToHistory', false);
        tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
            status: 'ready'
        });
        return tr;
    };
}
function $85a440c10c4579b2$export$415f09fb1d3d2a43(steps, api) {
    return ({ tr: tr })=>{
        const failedSteps = [];
        steps.forEach((step)=>{
            try {
                tr.step(step);
            } catch (e) {
                // step failed to apply, ignore it and attempt to apply other steps
                failedSteps.push({
                    step: step,
                    error: e
                });
            }
        });
        if (failedSteps.length > 0) (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: api,
            action: (0, $d925B.ACTION).OFFLINE_STORAGE_FAILED_STEPS,
            errorInfo: (0, $1a899df20ad45f18$export$ff269655d7dc6e77)(failedSteps.map((s)=>s.error)),
            stepsCount: failedSteps.length
        });
        tr.setMeta('addToHistory', false);
        tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
            status: 'ready'
        });
        return tr;
    };
}
function $85a440c10c4579b2$export$14dd948c471b3773() {
    return ({ tr: tr })=>{
        tr.setMeta('addToHistory', false);
        tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
            status: 'tooManyRetries'
        });
        return tr;
    };
}
function $85a440c10c4579b2$export$e62d02f588ae224b(inactiveSyncing) {
    return ({ tr: tr })=>{
        tr.setMeta('addToHistory', false);
        tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
            inactiveSyncing: inactiveSyncing
        });
        return tr;
    };
}



const $9ea4175711f7ca12$var$MAX_APPLY_ATTEMPTS = 3;
const $9ea4175711f7ca12$export$33afc5c2570a827c = (status, granted)=>{
    switch(status){
        case 'init':
            return granted ? 'leader_granted' : 'follower_waiting'; // First tab becomes leader
        case 'follower_waiting':
            return granted ? 'follower_granted' : 'follower_waiting';
        case 'leader_granted':
        case 'follower_granted':
            return status;
    }
};
const $9ea4175711f7ca12$var$recreateOfflineDoc = (jsonDoc, steps, pmSchema)=>{
    try {
        let doc = pmSchema.nodeFromJSON(jsonDoc);
        steps.forEach((step)=>{
            const res = step.apply(doc);
            if (!res.failed && res.doc) doc = res.doc;
        });
        return doc;
    } catch  {
        // TODO: Follow-up error handling
        return undefined;
    }
};
async function $9ea4175711f7ca12$export$5328e866ce5f6eff(api, stepsDatabase, pmSchema, options) {
    try {
        const { steps: steps, docJSON: docJSON } = await stepsDatabase.getData(pmSchema);
        if (steps.length > 0) {
            if (docJSON) {
                const offlineDoc = $9ea4175711f7ca12$var$recreateOfflineDoc(docJSON, steps, pmSchema);
                if (offlineDoc) options?.createOfflineVersion?.({
                    doc: offlineDoc,
                    steps: steps
                });
            }
            const dispatched = api?.core.actions.execute((0, $85a440c10c4579b2$export$415f09fb1d3d2a43)(steps, api));
            if (!dispatched) return false;
        }
        return true;
    } catch  {
        return false;
    }
}
async function $9ea4175711f7ca12$export$272cc1d3c48af723(api, stepsDatabase) {
    api?.core.actions.execute((0, $85a440c10c4579b2$export$199006561aceceef)());
    await stepsDatabase.releaseSyncLock();
    api?.core.actions.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
}
async function $9ea4175711f7ca12$export$8d012bece2dd72ad(api, stepsDatabase, pmSchema, options) {
    let attempts = 0;
    while(attempts < $9ea4175711f7ca12$var$MAX_APPLY_ATTEMPTS){
        const hasSyncSucceeded = await $9ea4175711f7ca12$export$5328e866ce5f6eff(api, stepsDatabase, pmSchema, {
            createOfflineVersion: options?.createOfflineVersion
        });
        if (hasSyncSucceeded) // The leader tab relies on the usePluginHook to release their lock and clear the steps from the DB.
        // We do not set the leader as "syncing", so we do not need to call setInactiveSyncingCommand(false).
        return;
        else {
            // Allow 1 second between attempts.
            await new Promise((resolve)=>setTimeout(resolve, 1000));
            attempts++;
        }
    }
    // If we get here, leader path failed after all attempts.
    await $9ea4175711f7ca12$export$272cc1d3c48af723(api, stepsDatabase);
}
async function $9ea4175711f7ca12$export$2685e1bc42d6db28(api, stepsDatabase) {
    // Wait 2 seconds before allowing the follower to complete, as sometimes it can complete too quickly, making the banner flash briefly.
    await new Promise((resolve)=>setTimeout(resolve, 2000));
    api?.core.actions.execute((0, $85a440c10c4579b2$export$199006561aceceef)());
    await stepsDatabase.releaseSyncLock();
    api?.core.actions.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
}
async function $9ea4175711f7ca12$export$7ac1d860e1e72b3d(api, stepsDatabase, pmSchema) {
    let attempts = 0;
    while(attempts < $9ea4175711f7ca12$var$MAX_APPLY_ATTEMPTS){
        const hasSyncSucceeded = await $9ea4175711f7ca12$export$5328e866ce5f6eff(api, stepsDatabase, pmSchema);
        if (hasSyncSucceeded) {
            await $9ea4175711f7ca12$export$2685e1bc42d6db28(api, stepsDatabase);
            return;
        } else {
            // Allow 1 second between attempts.
            await new Promise((resolve)=>setTimeout(resolve, 1000));
            attempts++;
        }
    }
    // If we get here, follower path failed after all attempts.
    await $9ea4175711f7ca12$export$272cc1d3c48af723(api, stepsDatabase);
}
async function $9ea4175711f7ca12$export$5c6efac8a19ad9f7(api, stepsDatabase, lockCallback) {
    const LOCK_TIMEOUT = 20000; // Wait for the lock, but only up to 20 seconds.
    api?.core.actions.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(true));
    // TODO: Remove the timeoutAfterMS param after cleaning up the platform_editor_offline_editing_web_ga_fixes gate. All sync lock acquisitions have an expiration timer now.
    await stepsDatabase.acquireSyncLock(lockCallback, true, 'restore', LOCK_TIMEOUT);
}
function $9ea4175711f7ca12$export$f0123301da84dec0(api, stepsDatabase, pmSchema, options) {
    let status = 'init';
    let previousStatus = 'init';
    const callback = async (granted)=>{
        previousStatus = status;
        status = $9ea4175711f7ca12$export$33afc5c2570a827c(status, granted);
        // If we're transitioning to the same state, we might be in a loop. For example, if the follower is stuck in a loop of follower_waiting -> follower_waiting.
        if (status === previousStatus) {
            await $9ea4175711f7ca12$export$272cc1d3c48af723(api, stepsDatabase);
            return;
        }
        switch(status){
            case 'leader_granted':
                await $9ea4175711f7ca12$export$8d012bece2dd72ad(api, stepsDatabase, pmSchema, options);
                break;
            case 'follower_waiting':
                await $9ea4175711f7ca12$export$5c6efac8a19ad9f7(api, stepsDatabase, callback);
                break;
            case 'follower_granted':
                await $9ea4175711f7ca12$export$7ac1d860e1e72b3d(api, stepsDatabase, pmSchema);
                break;
        }
    };
    return callback;
}


const $576038989d33c4bf$var$MAX_RETRIES = 2;
const $576038989d33c4bf$var$RETRY_DELAY = 1000;
async function $576038989d33c4bf$export$68ef7af6a41f5e44(stepsDatabase, pmSchema) {
    // If there's an error, the validateIndexedDBAccess will disable the plugin.
    const isIndexedDBAvailable = await stepsDatabase.validateIndexedDBAccess();
    if (!isIndexedDBAvailable) return false;
    const databases = await window.indexedDB.databases();
    const dbExists = Boolean(databases.find((db)=>db.name === stepsDatabase.dbName));
    if (!dbExists) return false;
    // If there are steps, we need to restore them.
    const { steps: steps } = await stepsDatabase.getData(pmSchema);
    if (steps.length > 0) return true;
    return false;
}
async function $576038989d33c4bf$export$d647a8cf160c7fa9(api, stepsDatabase, editorView, pmSchema, retryCount, error) {
    if (retryCount >= $576038989d33c4bf$var$MAX_RETRIES) {
        api?.core.actions.execute((0, $85a440c10c4579b2$export$14dd948c471b3773)());
        (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: api,
            action: (0, $d925B.ACTION).OFFLINE_STORAGE_TOO_MANY_RETRIES_ERROR,
            errorMessage: `Exceeded max retries (${$576038989d33c4bf$var$MAX_RETRIES}) with delay of ${$576038989d33c4bf$var$RETRY_DELAY}ms`,
            errorInfo: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error),
            maxRetries: $576038989d33c4bf$var$MAX_RETRIES,
            retrySource: 'isStepsRestoreRequired'
        });
        return;
    }
    await new Promise((resolve)=>setTimeout(resolve, $576038989d33c4bf$var$RETRY_DELAY));
    $576038989d33c4bf$export$312d5d76abf7691a(api, stepsDatabase, editorView, retryCount + 1)(pmSchema);
}
function $576038989d33c4bf$export$312d5d76abf7691a(api, stepsDatabase, editorView, retryCount = 0, options) {
    return async (pmSchema)=>{
        try {
            const shouldRestore = await $576038989d33c4bf$export$68ef7af6a41f5e44(stepsDatabase, pmSchema);
            if (!shouldRestore) {
                api?.core.actions.execute((0, $85a440c10c4579b2$export$199006561aceceef)());
                return;
            }
        } catch (error) {
            await $576038989d33c4bf$export$d647a8cf160c7fa9(api, stepsDatabase, editorView, pmSchema, retryCount, error);
            return;
        }
        (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: api,
            action: (0, $d925B.ACTION).OFFLINE_STORAGE_RESTORE_STEPS_INITIATED,
            retryCount: retryCount
        });
        const lockCallback = (0, $9ea4175711f7ca12$export$f0123301da84dec0)(api, stepsDatabase, pmSchema, options);
        stepsDatabase.acquireSyncLock(lockCallback, false, 'restore');
    };
}



var $8Yfbq = parcelRequire("8Yfbq");





const $a5de712ae25052da$export$4abb9cd0bdff89ec = async ({ editorView: editorView, stepsDatabase: stepsDatabase, version: version, steps: steps, broadcast: broadcast })=>{
    const baseDocJSON = (0, $9NwnH.getDocBeforeUnconfirmedSteps)(editorView.state).toJSON();
    const hasChanged = await stepsDatabase.updateIfChanged(version, baseDocJSON, steps);
    if (hasChanged) broadcast();
    else editorView.dispatch(editorView.state.tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
        disabled: 'unableToSync'
    }));
};
const $a5de712ae25052da$export$fed59d57957883a7 = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))($a5de712ae25052da$export$4abb9cd0bdff89ec, 200);


















var $h3X17 = parcelRequire("h3X17");













const $de973e9ead6dfe2c$var$ENABLE_EDITOR_TIMEOUT = 3000;
const $de973e9ead6dfe2c$export$33afc5c2570a827c = (status, granted)=>{
    switch(status){
        case 'init':
            return granted ? 'granted_initial' : 'waiting_initial';
        case 'waiting_initial':
        case 'waiting_recovery':
            return granted ? 'granted_recovery' : 'waiting_recovery';
        case 'granted_initial':
        case 'granted_recovery':
        default:
            return status;
    }
};
const $de973e9ead6dfe2c$export$b79afd6d47f11781 = (api)=>{
    const historyState = api?.history?.sharedState?.currentState?.();
    return (historyState?.done?.eventCount ?? 0) > 0 || (historyState?.undone?.eventCount ?? 0) > 0;
};
async function $de973e9ead6dfe2c$export$5ac754b16bef384(api, stepsDatabase, editorView, isActiveTab, options) {
    if ((0, $91bcx.isOfflineMode)(api?.connectivity?.sharedState.currentState()?.mode)) return;
    let status = 'init';
    let previousStatus = 'init';
    const lockCallback = async (granted)=>{
        previousStatus = status;
        status = $de973e9ead6dfe2c$export$33afc5c2570a827c(status, granted);
        // If we're transitioning to the same state, we might be in a loop.
        // This can happen if repeated timeouts occur (e.g., waiting_recovery -> waiting_recovery).
        if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
            if (status === previousStatus) {
                // Fallback: enable the editor and give up on syncing
                api?.core?.actions?.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
                return;
            }
        }
        const { steps: steps, docJSON: docJSON, version: version } = await stepsDatabase.getData(editorView?.state?.schema);
        const sendResyncAnalytics = ()=>{
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: (0, $d925B.ACTION).OFFLINE_STORAGE_RESYNC_ONLINE,
                resyncStatus: status,
                isActiveTab: isActiveTab
            });
        };
        const unconfirmedSteps = (0, $9NwnH.getCollabState)(editorView.state)?.unconfirmed ?? [];
        switch(status){
            case 'granted_initial':
                if (steps.length > 0) {
                    sendResyncAnalytics();
                    // Clear offline lock on unconfirmed steps
                    unconfirmedSteps.forEach((s)=>{
                        if (s.origin instanceof (0, $ks2lK.Transaction)) {
                            s.origin.setMeta('isOffline', false);
                            s.origin.setMeta('wasOffline', true);
                        }
                    });
                    // Create the offline version based on a snapshot of the doc at the time of returning online
                    options.createOfflineVersion?.({
                        doc: editorView.state.doc,
                        steps: unconfirmedSteps.map((s)=>s.step)
                    });
                    setTimeout(()=>{
                        api?.core?.actions?.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
                    }, $de973e9ead6dfe2c$var$ENABLE_EDITOR_TIMEOUT);
                } else if (docJSON && version !== null && unconfirmedSteps.length !== 0) {
                    // So we're here because another tab has already synced but the steps in the DB have been deleted
                    // In this case we revert to the document before going offline and allow collab to resync us
                    sendResyncAnalytics();
                    if ($de973e9ead6dfe2c$export$b79afd6d47f11781(api)) (0, $8755c63771d651df$export$43d640f3b62db5ab)(editorView);
                    const tr = (0, $9NwnH.syncFromAnotherSource)(editorView.state, version, docJSON, []);
                    (0, $85a440c10c4579b2$export$e62d02f588ae224b)(true)({
                        tr: tr
                    });
                    (0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes') && (0, $h3X17.tintDirtyTransaction)(tr);
                    editorView.dispatch(tr);
                    stepsDatabase.acquireSyncLock(lockCallback, true, 'resync');
                } else // At this point we've synced and can enable the editor
                setTimeout(()=>{
                    api?.core?.actions?.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
                }, $de973e9ead6dfe2c$var$ENABLE_EDITOR_TIMEOUT);
                break;
            case 'waiting_initial':
                // Reset to base document so we don't duplicate the unconfirmed steps, when we come back online we'll sync with the latest changes
                if (docJSON && version !== null && unconfirmedSteps?.length !== 0) {
                    sendResyncAnalytics();
                    if ($de973e9ead6dfe2c$export$b79afd6d47f11781(api)) (0, $8755c63771d651df$export$43d640f3b62db5ab)(editorView);
                    const tr = (0, $9NwnH.syncFromAnotherSource)(editorView.state, version, docJSON, []);
                    (0, $85a440c10c4579b2$export$e62d02f588ae224b)(true)({
                        tr: tr
                    });
                    editorView.dispatch(tr);
                    stepsDatabase.acquireSyncLock(lockCallback, true, 'resync');
                }
                break;
            case 'granted_recovery':
                if (steps.length > 0 && docJSON && version !== null) {
                    sendResyncAnalytics();
                    if ($de973e9ead6dfe2c$export$b79afd6d47f11781(api)) (0, $8755c63771d651df$export$43d640f3b62db5ab)(editorView);
                    editorView.dispatch((0, $9NwnH.syncFromAnotherSource)(editorView.state, version, docJSON, steps));
                }
                setTimeout(()=>{
                    api?.core?.actions?.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
                }, $de973e9ead6dfe2c$var$ENABLE_EDITOR_TIMEOUT);
                break;
            case 'waiting_recovery':
                if (steps.length > 0 && docJSON && version !== null) sendResyncAnalytics();
                api?.core?.actions?.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
                stepsDatabase.acquireSyncLock(lockCallback, true, 'resync');
                break;
            default:
                break;
        }
    };
    stepsDatabase.acquireSyncLock(lockCallback, false, 'resync');
}




/**
 * @generated SignedSource<<1e58d607e8989b3be87557d0b2d40fdf>>
 * @relayHash 147cfb56caf40781fcb1a06a43b2650f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2044cc1d4d9be7cb653dcf45f27af1fd0edc7eddcd49f51b760e768099e55e0
const $80824365c2b7ecec$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "adfContent"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionComment"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "adfContent",
                            "variableName": "adfContent"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "versionComment",
                            "variableName": "versionComment"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "ConfluenceInsertOfflineVersionPayload",
            "kind": "LinkedField",
            "name": "confluence_insertOfflineVersion",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "versionNumber"
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCreateOfflineVersionInsertVersionMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCreateOfflineVersionInsertVersionMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "147cfb56caf40781fcb1a06a43b2650f",
            "id": "e2044cc1d4d9be7cb653dcf45f27af1fd0edc7eddcd49f51b760e768099e55e0",
            "metadata": {},
            "name": "useCreateOfflineVersionInsertVersionMutation",
            "operationKind": "mutation",
            "text": "mutation useCreateOfflineVersionInsertVersionMutation($cloudId:ID!,$contentId:ID!,$adfContent:String!,$versionComment:String!){confluence_insertOfflineVersion(cloudId:$cloudId,input:{contentId:$contentId,adfContent:$adfContent,versionComment:$versionComment}){versionNumber,success,errors{message}}}"
        }
    };
}();
$80824365c2b7ecec$var$node.hash = "116628d327fa315abf5c5c89f4dd52a8";
var $80824365c2b7ecec$export$2e2bcd8739ae039 = $80824365c2b7ecec$var$node;












var $aXG5V = parcelRequire("aXG5V");








var $bQm3c = parcelRequire("bQm3c");


var $308Wd = parcelRequire("308Wd");









var $3sFtD = parcelRequire("3sFtD");


var $744ND = parcelRequire("744ND");

const $bf60d5cebe6d196a$var$i18n = (0, $aXWIB.defineMessages)({
    errorTitle: {
        id: "editor-offline-storage.version-insertion-error-flag.title",
        defaultMessage: "Error saving version history"
    },
    errorTitleRetry: {
        id: "editor-offline-storage.version-insertion-error-flag.title-retry",
        defaultMessage: "Failed to save"
    },
    errorDescription: {
        id: "editor-offline-storage.version-insertion-error-flag.description",
        defaultMessage: "We couldn't save a version history of your offline edits. Your changes are safe, but if you want a backup please try again."
    },
    errorDescriptionRetry: {
        id: "editor-offline-storage.version-insertion-error-flag.description-retry",
        defaultMessage: "We're still having trouble saving a version history of your offline edits. Please try again."
    },
    retryButton: {
        id: "editor-offline-storage.version-insertion-error-flag.retry-button",
        defaultMessage: "Try again"
    },
    successTitle: {
        id: "editor-offline-storage.version-insertion-success-flag.title",
        defaultMessage: "Version history saved"
    },
    successDescription: {
        id: "editor-offline-storage.version-insertion-success-flag.description",
        defaultMessage: "Your offline edits have been saved to version history."
    }
});
const $bf60d5cebe6d196a$var$ERROR_FLAG_ID = 'version-insertion-error-flag';
const $bf60d5cebe6d196a$var$SUCCESS_FLAG_ID = 'version-insertion-success-flag';
const $bf60d5cebe6d196a$export$ac18e6e44f1970de = (flags, intl, onRetry, onClose, manualRetryCount)=>{
    if (!flags) return;
    flags.showCustomFlag({
        id: $bf60d5cebe6d196a$var$ERROR_FLAG_ID,
        title: intl.formatMessage(manualRetryCount > 0 ? $bf60d5cebe6d196a$var$i18n.errorTitleRetry : $bf60d5cebe6d196a$var$i18n.errorTitle),
        description: intl.formatMessage(manualRetryCount > 0 ? $bf60d5cebe6d196a$var$i18n.errorDescriptionRetry : $bf60d5cebe6d196a$var$i18n.errorDescription),
        customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($744ND))), {
            color: "var(--ds-icon, #292A2E)",
            label: ""
        }),
        actions: [
            {
                content: intl.formatMessage($bf60d5cebe6d196a$var$i18n.retryButton),
                onClick: onRetry
            }
        ],
        onClose: onClose
    });
};
const $bf60d5cebe6d196a$export$fda504c08c17a634 = (flags, intl)=>{
    if (!flags) return;
    flags.showCustomFlag({
        id: $bf60d5cebe6d196a$var$SUCCESS_FLAG_ID,
        title: intl.formatMessage($bf60d5cebe6d196a$var$i18n.successTitle),
        description: intl.formatMessage($bf60d5cebe6d196a$var$i18n.successDescription),
        customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
            color: "var(--ds-icon-success, #6A9A23)",
            label: ""
        })
    });
};
const $bf60d5cebe6d196a$export$2e84f8b8ade6c591 = (flags)=>{
    if (!flags) return;
    flags.hideFlag($bf60d5cebe6d196a$var$ERROR_FLAG_ID);
};


const $185ed3c8b342a5b9$var$i18n = (0, $aXWIB.defineMessages)({
    VersionComment: {
        id: "editor-offline-storage.offline-version-comment",
        defaultMessage: "Offline edits"
    },
    VersionCommentManualRetry: {
        id: "editor-offline-storage.offline-version-comment-manual-retry",
        defaultMessage: "Offline edits (manual retry)"
    }
});
// Tech-spec:
// https://hello.atlassian.net/wiki/spaces/~712020fa3d29df95e344e18f663fa84c3d65c8/pages/5567284738/Tech+Spec+Version+History+Creation+API+with+Offline+Copy
const $185ed3c8b342a5b9$var$EditorOfflineStorageInsertOfflineVersionMutation = (0, $80824365c2b7ecec$export$2e2bcd8739ae039);
// Limit how often we can try to create new versions
// P50 disconnection time is ~7 seconds so this tries to minimise new versions
// if someone's connection is flaky.
const $185ed3c8b342a5b9$var$MAX_INTERVAL = 20000;
const $185ed3c8b342a5b9$export$a47b53017b47e379 = ({ contentId: contentId, api: api, stepsDatabase: stepsDatabase, flags: flags })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const intl = (0, $aXWIB.useIntl)();
    const manualRetryCountRef = (0, $42omo.useRef)(0);
    const [createOfflineVersion] = (0, $308Wd.useMutationInterop)($185ed3c8b342a5b9$var$EditorOfflineStorageInsertOfflineVersionMutation, {
        __callerPackage__: "@confluence/editor-offline-storage"
    });
    const createVersionUnthrottled = (0, $42omo.useCallback)(({ cloudId: paramCloudId, contentId: paramContentId, adfContent: adfContent, versionComment: versionComment })=>{
        // Create onRetry callback that will be reused for both error paths
        const onRetry = ()=>{
            if (!flags) return;
            // Increment manual retry count when user clicks retry
            manualRetryCountRef.current += 1;
            (0, $bf60d5cebe6d196a$export$2e84f8b8ade6c591)(flags);
            createVersionUnthrottled({
                cloudId: paramCloudId,
                contentId: paramContentId,
                adfContent: adfContent,
                versionComment: intl.formatMessage($185ed3c8b342a5b9$var$i18n.VersionCommentManualRetry)
            });
        };
        const onClose = ()=>{
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: 'OFFLINE_EDITING_VERSION_INSERTION_ERROR_FLAG_DISMISSED',
                manualRetryCount: manualRetryCountRef.current
            });
        };
        createOfflineVersion({
            variables: {
                cloudId: paramCloudId,
                contentId: paramContentId,
                adfContent: adfContent,
                versionComment: versionComment
            }
        }).then(async (res)=>{
            const errors = res.data?.confluence_insertOfflineVersion?.errors;
            if (errors && errors.length > 0) {
                (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                    api: api,
                    action: 'OFFLINE_EDITING_FAILED_STORE_RECOVERY_VERSION',
                    errorMessage: errors.map((err)=>err.message).join(','),
                    manualRetryCount: manualRetryCountRef.current
                });
                // Store the backup and show flag for later retry
                if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
                    await stepsDatabase.storeVersionInsertionBackup(adfContent);
                    if (flags && paramContentId) (0, $bf60d5cebe6d196a$export$ac18e6e44f1970de)(flags, intl, onRetry, onClose, manualRetryCountRef.current);
                }
                return;
            }
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: 'OFFLINE_EDITING_SUCCESS_STORE_RECOVERY_VERSION',
                success: res.data?.confluence_insertOfflineVersion?.success,
                manualRetryCount: manualRetryCountRef.current
            });
            // Show success flag only after manual retries
            if (manualRetryCountRef.current > 0 && flags) (0, $bf60d5cebe6d196a$export$fda504c08c17a634)(flags, intl);
            // Reset manual retry count on success
            manualRetryCountRef.current = 0;
            // Clear the stored backup on any successful version insertion
            if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) await stepsDatabase.clearVersionInsertionBackup();
        }).catch(async (e)=>{
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: 'OFFLINE_EDITING_FAILED_STORE_RECOVERY_VERSION',
                errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(e),
                manualRetryCount: manualRetryCountRef.current
            });
            // Store the backup and show flag for later retry
            if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
                await stepsDatabase.storeVersionInsertionBackup(adfContent);
                if (flags && paramContentId) (0, $bf60d5cebe6d196a$export$ac18e6e44f1970de)(flags, intl, onRetry, onClose, manualRetryCountRef.current);
            }
        });
    }, [
        createOfflineVersion,
        api,
        stepsDatabase,
        flags,
        intl
    ]);
    /**
   * Manually retry version insertion with stored backup content
   * Hides the flag and calls the core createVersionUnthrottled function
   */ const manualRetryCreateVersion = (0, $42omo.useCallback)((storedAdfContent)=>{
        if (!contentId || !flags) return;
        (0, $bf60d5cebe6d196a$export$2e84f8b8ade6c591)(flags);
        createVersionUnthrottled({
            cloudId: cloudId,
            contentId: contentId,
            adfContent: storedAdfContent,
            versionComment: intl.formatMessage($185ed3c8b342a5b9$var$i18n.VersionCommentManualRetry)
        });
    }, [
        contentId,
        cloudId,
        flags,
        intl,
        createVersionUnthrottled
    ]);
    const throttledCreateVersion = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))(createVersionUnthrottled, $185ed3c8b342a5b9$var$MAX_INTERVAL, {
            leading: true,
            trailing: false
        }), [
        createVersionUnthrottled
    ]);
    return {
        createVersion: (0, $42omo.useCallback)(({ doc: doc, steps: steps })=>{
            // Only create a new version if there are document changes
            // To avoid noisy versions we filter out any non-ReplaceSteps
            // Ignore ReplaceAroundSteps and other steps that aren't as likely to be intended by the user
            // Note: This is a best-effort approach and may not cover all cases
            if (steps.filter((s)=>s instanceof (0, $aXG5V.ReplaceStep)).length === 0) return;
            if (!contentId) {
                (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                    api: api,
                    action: 'OFFLINE_EDITING_FAILED_STORE_RECOVERY_VERSION',
                    errorMessage: 'No content id',
                    manualRetryCount: 0
                });
                return;
            }
            const adfContent = new (0, $h9yJL.JSONTransformer)().encode(doc);
            throttledCreateVersion({
                cloudId: cloudId,
                contentId: contentId,
                adfContent: JSON.stringify(adfContent),
                versionComment: intl.formatMessage($185ed3c8b342a5b9$var$i18n.VersionComment)
            });
        }, [
            api,
            contentId,
            throttledCreateVersion,
            cloudId,
            intl
        ]),
        manualRetryCreateVersion: manualRetryCreateVersion
    };
};


/**
 * `usePluginStateEffect` has a debounce - we avoid that here to ensure we
 * catch all states on a critical piece of code
 *
 * @param api
 * @param cb
 */ const $93f027f3fd7090c3$var$useConnectivityEffect = (api, cb)=>{
    // Get the latest effect similar to `usePluginStateEffect` (no debounce)
    const latestEffect = (0, $42omo.useRef)(cb);
    (0, $42omo.useLayoutEffect)(()=>{
        latestEffect.current = cb;
        return ()=>{
            latestEffect.current = undefined;
        };
    }, [
        cb
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        return api?.connectivity?.sharedState.onChange(({ prevSharedState: prevSharedState, nextSharedState: nextSharedState })=>{
            latestEffect.current?.({
                prevMode: prevSharedState?.mode,
                nextMode: nextSharedState?.mode
            });
        });
    }, [
        api
    ]);
};
const $93f027f3fd7090c3$export$68f4c8eca02a72d7 = ({ api: api, editorView: editorView, stepsDatabase: stepsDatabase, broadcastUpdate: broadcastUpdate, contentId: contentId, flags: flags })=>{
    const { createVersion: createOfflineVersion } = (0, $185ed3c8b342a5b9$export$a47b53017b47e379)({
        contentId: contentId,
        api: api,
        stepsDatabase: stepsDatabase,
        flags: flags
    });
    const isActivelySyncing = (0, $42omo.useRef)(false);
    $93f027f3fd7090c3$var$useConnectivityEffect(api, ({ prevMode: prevMode, nextMode: nextMode })=>{
        const { status: status, disabled: disabled } = (0, $bcc122a52e0f74cf$export$3b87fd119d006909).getState(editorView.state) ?? {};
        if (status !== 'ready' || disabled) return;
        // Only allow one sync at a time. This is to avoid flickering of the connection status causing online and offline resyncs to run at the same time.
        if (isActivelySyncing.current) return;
        isActivelySyncing.current = true;
        if ((0, $91bcx.isOfflineMode)(prevMode) && nextMode === 'online') {
            // Try to prioritise the "active" tab by delaying the inactive tabs, this is to minimise
            // our chance of disrupting the user by the reset
            if (document && !document?.hasFocus?.()) // Give the active document ~1s to connect
            setTimeout(()=>(0, $de973e9ead6dfe2c$export$5ac754b16bef384)(api, stepsDatabase, editorView, false, {
                    createOfflineVersion: createOfflineVersion
                }).finally(()=>{
                    isActivelySyncing.current = false;
                }), document?.visibilityState === 'visible' ? 500 : 1000);
            else (0, $de973e9ead6dfe2c$export$5ac754b16bef384)(api, stepsDatabase, editorView, true, {
                createOfflineVersion: createOfflineVersion
            }).finally(()=>{
                isActivelySyncing.current = false;
            });
        } else if ((0, $91bcx.isOfflineMode)(nextMode)) stepsDatabase.validateIndexedDBAccess().then((isIndexedDBAvailable)=>{
            if (isIndexedDBAvailable) stepsDatabase.clear(true).then(async (cleared)=>{
                if (cleared) await stepsDatabase.releaseSyncLock?.();
            }).finally(()=>{
                // Resync the db with the current state of the unconfirmed steps
                const { version: version, steps: steps } = (0, $9NwnH.sendableSteps)(editorView.state) ?? {};
                if (version !== undefined && steps !== undefined) (0, $a5de712ae25052da$export$4abb9cd0bdff89ec)({
                    editorView: editorView,
                    stepsDatabase: stepsDatabase,
                    version: version,
                    steps: steps,
                    broadcast: broadcastUpdate
                }).finally(()=>{
                    isActivelySyncing.current = false;
                });
                else isActivelySyncing.current = false;
            });
            else isActivelySyncing.current = false;
        });
    });
};









const $1b00d7c59071460d$export$e3acca0d39d792dc = ({ api: api, stepsDatabase: stepsDatabase, disabledRef: disabledRef })=>{
    const queryingSyncLock = (0, $42omo.useRef)(false);
    (0, $6qdjm.usePluginStateEffect)(api, [
        'editorOfflineStorage',
        'connectivity',
        'collabEdit'
    ], ()=>{
        // Check if we're safe to re-enable the lock
        if (disabledRef.current === 'unableToSync' && !queryingSyncLock.current) {
            queryingSyncLock.current = true;
            stepsDatabase.isLocked().then((locked)=>{
                // If we're not locked (and still unable to sync) we can re-enable
                if (!locked && disabledRef.current === 'unableToSync') api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
                        disabled: false
                    }));
            }).catch(()=>{}).finally(()=>{
                queryingSyncLock.current = false;
            });
        }
    });
};





const $1d19c6d3b6d5b560$export$ea606e96c5866df5 = ({ api: api, config: config })=>{
    const stepsDatabase = new (0, $f0050ff6ee6f7eb3$export$c7a2e99e9e26da1c)();
    return {
        name: 'editorOfflineStorage',
        pmPlugins () {
            return [
                {
                    name: 'editorOfflineStoragePlugin',
                    plugin: (0, $bcc122a52e0f74cf$export$ae829ec7b2625219)(stepsDatabase)
                }
            ];
        },
        getSharedState (state) {
            if (!state) return undefined;
            const { status: status, disabled: disabled, inactiveSyncing: inactiveSyncing } = (0, $bcc122a52e0f74cf$export$3b87fd119d006909).getState(state) ?? {};
            const { version: version, steps: steps } = (0, $9NwnH.sendableSteps)(state) ?? {};
            return {
                version: version ?? 0,
                steps: steps ?? [],
                status: status ?? 'pending',
                disabled: disabled ?? false,
                inactiveSyncing: inactiveSyncing ?? false
            };
        },
        usePluginHook: ({ editorView: editorView })=>{
            const [contentId] = (0, $ep3mz.usePageContentId)();
            const disabledRef = (0, $42omo.useRef)(false);
            const hasCheckedForVersionInsertionBackupRef = (0, $42omo.useRef)(false);
            const intl = (0, $aXWIB.useIntl)();
            (0, $6qdjm.usePluginStateEffect)(api, [
                'editorOfflineStorage'
            ], ({ editorOfflineStorageState: editorOfflineStorageState })=>{
                disabledRef.current = editorOfflineStorageState?.disabled ?? false;
            });
            const { createVersion: createOfflineVersion, manualRetryCreateVersion: manualRetryCreateVersion } = (0, $185ed3c8b342a5b9$export$a47b53017b47e379)({
                contentId: contentId,
                api: api,
                stepsDatabase: stepsDatabase,
                flags: config?.flags ?? null
            });
            (0, $42omo.useEffect)(()=>{
                if (contentId && !stepsDatabase.dbName && !disabledRef.current) stepsDatabase.init(contentId, api).then(async (initialized)=>{
                    if (!initialized) return;
                    if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
                        // Check and clear expired data before checking for backup
                        await stepsDatabase.checkAndClearExpiredData();
                        // Check for existing version insertion backup
                        if (!hasCheckedForVersionInsertionBackupRef.current) {
                            hasCheckedForVersionInsertionBackupRef.current = true;
                            const versionInsertionBackup = await stepsDatabase.getVersionInsertionBackup();
                            if (versionInsertionBackup) (0, $bf60d5cebe6d196a$export$ac18e6e44f1970de)(config?.flags, intl, // onRetry: Call manual retry with stored content
                            ()=>{
                                manualRetryCreateVersion(versionInsertionBackup.adfContent);
                            }, // onClose: Track when user dismisses the version insertion error flag
                            ()=>{
                                (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                                    api: api,
                                    action: 'OFFLINE_EDITING_VERSION_INSERTION_ERROR_FLAG_DISMISSED',
                                    manualRetryCount: 0
                                });
                            }, 0);
                        }
                    }
                });
            // We need stepsDatabase in deps to detect when DB is no longer initialised on re-render, e.g. when page goes full-width.
            }, [
                contentId,
                stepsDatabase,
                api,
                intl,
                manualRetryCreateVersion
            ]); // eslint-disable-line react-hooks/exhaustive-deps
            const broadcastUpdate = (0, $c71be5c341006c26$export$e38c76da774a8077)({
                api: api,
                editorView: editorView,
                stepsDatabase: stepsDatabase
            });
            /**
       * This is to resync the document online once we move from offline -> online
       */ (0, $93f027f3fd7090c3$export$68f4c8eca02a72d7)({
                api: api,
                editorView: editorView,
                broadcastUpdate: broadcastUpdate,
                stepsDatabase: stepsDatabase,
                contentId: contentId,
                flags: config?.flags ?? null
            });
            /**
       * See if it's safe to re-enable the plugin if it's been disabled due to the lock being held
       */ (0, $1b00d7c59071460d$export$e3acca0d39d792dc)({
                api: api,
                stepsDatabase: stepsDatabase,
                disabledRef: disabledRef
            });
            // Clean up the sync timeout on unmount
            // Otherwise its possible that it will fire with stale data after unmount
            (0, $42omo.useEffect)(()=>{
                return ()=>{
                    (0, $a5de712ae25052da$export$fed59d57957883a7).cancel();
                };
            }, [
                contentId,
                editorView
            ]);
            /**
       * This is to handle the initial load of the editor and syncing it from the indexeddb
       */ (0, $6qdjm.usePluginStateEffect)(api, [
                'editorOfflineStorage',
                'connectivity',
                'collabEdit'
            ], ({ editorOfflineStorageState: editorOfflineStorageState, connectivityState: connectivityState, collabEditState: collabEditState })=>{
                const { status: status, steps: steps, version: version, disabled: disabled } = editorOfflineStorageState ?? {};
                if (disabledRef.current) return;
                if (window?.indexedDB === undefined) {
                    // If indexeddb is not available disable offline editing here
                    if (!disabled) api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
                            disabled: 'stepsDatabaseError'
                        }));
                    return;
                }
                // Both the restore (init) sync lock and the resync online (online <-> offline) sync lock are released here.
                // We confirm the steps have synced with NCS before clearing the database and releasing the lock.
                if (steps?.length === 0 && stepsDatabase.hasLock) stepsDatabase.clear(false).then(async (cleared)=>{
                    if (cleared) {
                        if (stepsDatabase.lockPurpose === 'restore') // After we've the steps confirmed with NCS, we update the doc and version in the database.
                        await stepsDatabase.updateDocAndVersion(editorView).then((isUpdated)=>{
                            if (isUpdated) // Notify other tabs to sync from the updated doc/version in IndexedDB.
                            broadcastUpdate('restore');
                        });
                        await stepsDatabase.releaseSyncLock?.();
                    }
                });
                switch(status){
                    case 'pending':
                        // Restore steps once collab edit plugin is initialised
                        if (collabEditState?.initialised.collabInitialisedAt) {
                            const tr = editorView.state.tr;
                            tr.setMeta('addToHistory', false);
                            tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
                                status: 'restoring'
                            });
                            editorView.dispatch(tr);
                            (0, $576038989d33c4bf$export$312d5d76abf7691a)(api, stepsDatabase, editorView, 0, {
                                createOfflineVersion: createOfflineVersion
                            })(editorView.state.schema);
                        }
                        break;
                    case 'restoring':
                        break;
                    case 'ready':
                        const isFocusedAndVisible = document.visibilityState === 'visible' && document.hasFocus();
                        // If we are offline and we have steps to store, update the steps in the database
                        if (isFocusedAndVisible && steps && version !== undefined && (0, $91bcx.isOfflineMode)(connectivityState?.mode)) (0, $a5de712ae25052da$export$fed59d57957883a7)({
                            editorView: editorView,
                            stepsDatabase: stepsDatabase,
                            version: version,
                            steps: steps,
                            broadcast: broadcastUpdate
                        });
                        break;
                    case 'tooManyRetries':
                        // Unable to restore steps - ensure we disable the offline editing session to be safe
                        // in case there's something wrong with the DB.
                        if (!disabled) api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
                                disabled: 'tooManyRetries'
                            }));
                        break;
                    default:
                        break;
                }
            });
        }
    };
};



var $4vxk6 = parcelRequire("4vxk6");


var $d4d2J = parcelRequire("d4d2J");


var $3gyyc = parcelRequire("3gyyc");


var $6ZWlg = parcelRequire("6ZWlg");


var $6xiPL = parcelRequire("6xiPL");








var $a4TK8 = parcelRequire("a4TK8");













const $402b4b60c57df829$var$i18n = (0, $aXWIB.defineMessages)({
    title: {
        id: "editor-presets.conflicts-resolved-flag.title",
        defaultMessage: "All conflicts have been resolved"
    },
    description: {
        id: "editor-presets.conflicts-resolved-flag.description",
        defaultMessage: "Your offline edits have been successfully synced."
    },
    viewHistoryButton: {
        id: "editor-presets.conflicts-resolved-flag.view-history-button",
        defaultMessage: "View version history"
    }
});
const $402b4b60c57df829$var$FLAG_ID = 'conflicts-resolved-flag';
const $402b4b60c57df829$export$f4728fbe8fc5d546 = (flags, intl, contentId, spaceKey)=>{
    if (!flags) return;
    const versionHistoryUrl = (0, $1NBp8.CONTENT_HISTORY).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    flags.showSuccessFlag({
        id: $402b4b60c57df829$var$FLAG_ID,
        title: intl.formatMessage($402b4b60c57df829$var$i18n.title),
        description: intl.formatMessage($402b4b60c57df829$var$i18n.description),
        actions: [
            {
                content: intl.formatMessage($402b4b60c57df829$var$i18n.viewHistoryButton),
                href: versionHistoryUrl,
                onClick: ()=>{
                    $402b4b60c57df829$export$d04b5033a065369f(flags);
                }
            }
        ]
    });
};
const $402b4b60c57df829$export$d04b5033a065369f = (flags)=>{
    if (!flags) return;
    flags.hideFlag($402b4b60c57df829$var$FLAG_ID);
};















var $djYcq = parcelRequire("djYcq");


var $cyZvy = parcelRequire("cyZvy");










// Apply strike mark to deleted text
function $33fd45b068629a29$var$applyMarkToFragment(fragment, markType) {
    if (!markType) return fragment;
    // Create a mark of the given type
    const mark = markType.create({});
    const nodes = [];
    fragment.forEach((node)=>{
        if (node.isText) nodes.push(node.mark([
            ...node.marks,
            mark
        ]));
        else nodes.push(node.copy($33fd45b068629a29$var$applyMarkToFragment(node.content, markType)));
    });
    // Map over each node in the fragment and apply the mark
    return (0, $5SAOw.Fragment).fromArray(nodes);
}
const $33fd45b068629a29$export$f34037fb3390566b = (conflict, tr, selected = false)=>{
    return (0, $ftzrq.Decoration).widget(conflict.from, ()=>{
        const strikenText = document.createElement('span');
        const style = (0, $24P9d.convertToInlineCss)({
            background: selected ? "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)" : "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
            textDecoration: 'underline',
            textDecorationStyle: 'dotted',
            textDecorationThickness: "var(--ds-space-025, 2px)",
            textDecorationColor: "var(--ds-border-accent-orange, #E06C00)"
        });
        strikenText.setAttribute('style', style);
        // Render striken text fragment
        strikenText.appendChild((0, $5SAOw.DOMSerializer).fromSchema(tr.doc.type.schema).serializeFragment($33fd45b068629a29$var$applyMarkToFragment(conflict?.local.content, tr.doc.type.schema.marks.strike)));
        return strikenText;
    }, {
        side: -1,
        ignoreSelection: false
    });
};





/**
 * We have a couple of nodes that require us to compute style
 * on different elements, ideally all nodes should be able to
 * compute the appropriate styles based on their wrapper.
 */ const $3f8f658555914fb4$var$nestedCases = {
    'tableView-content-wrap': 'table',
    'mediaSingleView-content-wrap': '.rich-media-item',
    'bodiedExtensionView-content-wrap': '.extension-container',
    'multiBodiedExtensionView-content-wrap': '.multiBodiedExtension--container',
    'embedCardView-content-wrap': '.rich-media-item',
    'datasourceView-content-wrap': '.datasourceView-content-inner-wrap'
};
const $3f8f658555914fb4$var$computeNestedStyle = (dom)=>{
    const foundKey = Object.keys($3f8f658555914fb4$var$nestedCases).find((className)=>dom.classList.contains(className));
    const nestedSelector = foundKey && $3f8f658555914fb4$var$nestedCases[foundKey];
    if (nestedSelector) {
        const nestedElement = dom.querySelector(nestedSelector);
        if (nestedElement) return window.getComputedStyle(nestedElement);
    }
};
const $3f8f658555914fb4$var$measureHeight = (style)=>{
    return $3f8f658555914fb4$var$measureValue(style, [
        'height',
        'padding-top',
        'padding-bottom',
        'border-top-width',
        'border-bottom-width'
    ]);
};
const $3f8f658555914fb4$var$measureValue = (style, measureValues)=>{
    const [base, ...contentBoxValues] = measureValues;
    const measures = [
        style.getPropertyValue(base)
    ];
    const boxSizing = style.getPropertyValue('box-sizing');
    if (boxSizing === 'content-box') contentBoxValues.forEach((value)=>{
        measures.push(style.getPropertyValue(value));
    });
    let result = 0;
    for(let i = 0; i < measures.length; i++)result += parseFloat(measures[i]);
    return result;
};
function $3f8f658555914fb4$var$getLayoutModeFromTargetNode(node) {
    let layout;
    if (node.attrs.layout) layout = node.attrs.layout;
    if (node.marks && node.marks.length) layout = (node.marks.find((mark)=>mark.type.name === 'breakout') || {
        attrs: {
            mode: ''
        }
    }).attrs.mode;
    if (node.type.name === 'table' && node.attrs.width) layout = 'fixed-width';
    if ([
        'wide',
        'full-width',
        'fixed-width'
    ].indexOf(layout) === -1) return '';
    return layout;
}
/**
 * Converts a camelCased CSS property name to a hyphenated CSS property name.
 *
 * @param property - CamelCased CSS property name.
 * @returns Hyphenated CSS property name.
 */ function $3f8f658555914fb4$var$hyphenate(property) {
    // Ignored via go/ees005
    return property.replace(/[A-Z]/gu, (match)=>`-${match.toLowerCase()}`).replace(/^ms/u, '-ms');
}
const $3f8f658555914fb4$export$dfadf4096b7e8b0c = (node, pos)=>{
    return (0, $ftzrq.Decoration).widget(pos, (view, getPos)=>{
        const nodeStart = getPos();
        const element = document.createElement('span');
        element.className = 'conflictmarker';
        element.appendChild(document.createElement('span'));
        const dom = nodeStart !== undefined ? view.nodeDOM(nodeStart) : null;
        if (dom instanceof HTMLElement && element.firstChild) {
            const style = $3f8f658555914fb4$var$computeNestedStyle(dom) || window.getComputedStyle(dom);
            const conflictmarker = element.firstChild;
            conflictmarker.style.height = `${$3f8f658555914fb4$var$measureHeight(style)}px`;
            const layoutMode = node && $3f8f658555914fb4$var$getLayoutModeFromTargetNode(node);
            if (nodeStart !== 0 || layoutMode || node?.type.name === 'table') conflictmarker.style.marginTop = style.getPropertyValue('margin-top');
            const conflictMarkerCursorStyles = {
                content: "''",
                position: 'absolute',
                background: "var(--ds-background-accent-red-bolder, #C9372C)",
                width: "var(--ds-space-075, 6px)",
                marginLeft: "var(--ds-space-negative-075, -6px)",
                borderRadius: `${"var(--ds-radius-small, 4px)"} 0 0 ${"var(--ds-radius-small, 4px)"}`
            };
            for (const [rule, value] of Object.entries(conflictMarkerCursorStyles))conflictmarker.style.setProperty($3f8f658555914fb4$var$hyphenate(rule), value);
            conflictmarker.className = 'conflictmarker';
            conflictmarker.setAttribute('data-testid', 'conflictmarker');
        }
        return element;
    }, {
        side: -1
    });
};


const $d80773f42a527d1c$var$getBlockNodeAtPos = (pos, tr)=>{
    const $pos = tr.doc.resolve(pos);
    const node = $pos?.node();
    return node && node.isBlock && !node.isTextblock ? node : null;
};
const $d80773f42a527d1c$var$createInsertedDecoration = (conflict, tr, resolutionMode)=>{
    const node = $d80773f42a527d1c$var$getBlockNodeAtPos(conflict.from + 1, tr);
    if (node) return (0, $3f8f658555914fb4$export$dfadf4096b7e8b0c)(node, conflict.from);
    const styles = {
        textDecoration: 'underline',
        textDecorationStyle: 'dotted',
        textDecorationThickness: "var(--ds-space-025, 2px)",
        textDecorationColor: "var(--ds-border-accent-orange, #E06C00)"
    };
    // Background highlight behavior:
    // - Gate OFF (old behavior): Always show orange background
    // - Gate ON (new behavior): Only show orange background when actively resolving
    if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
        if (resolutionMode === 'resolving') styles.background = "var(--ds-background-accent-orange-subtlest, #FFF5DB)";
    } else // Old behavior: always show background
    styles.background = "var(--ds-background-accent-orange-subtlest, #FFF5DB)";
    return (0, $ftzrq.Decoration).inline(conflict.from, conflict.to, {
        style: (0, $24P9d.convertToInlineCss)(styles)
    });
};
const $d80773f42a527d1c$var$createSelectedDecoration = (conflict, tr)=>{
    if (conflict.type === 'deleted') return (0, $33fd45b068629a29$export$f34037fb3390566b)(conflict, tr, true);
    const node = $d80773f42a527d1c$var$getBlockNodeAtPos(conflict.from + 1, tr);
    if (node) return (0, $3f8f658555914fb4$export$dfadf4096b7e8b0c)(node, conflict.from);
    return (0, $ftzrq.Decoration).inline(conflict.from, conflict.to, {
        style: (0, $24P9d.convertToInlineCss)({
            background: "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
            textDecoration: 'underline',
            textDecorationStyle: 'dotted',
            textDecorationThickness: "var(--ds-space-025, 2px)",
            textDecorationColor: "var(--ds-border-accent-orange, #E06C00)"
        })
    });
};
function $d80773f42a527d1c$var$filterUndefined(c) {
    return c !== undefined;
}
const $d80773f42a527d1c$var$createDecorationsFromConflicts = (conflicts, selectedConflict, tr, resolutionMode)=>{
    if (!conflicts) return [];
    if (selectedConflict) {
        const selectedDecoration = $d80773f42a527d1c$var$createSelectedDecoration(selectedConflict, tr);
        const conflictDecorations = [
            ...conflicts.inserted.filter((c)=>c.id !== selectedConflict.id).map((c)=>$d80773f42a527d1c$var$createInsertedDecoration(c, tr, resolutionMode)),
            ...conflicts.deleted.filter((c)=>c.id !== selectedConflict.id).map((c)=>(0, $33fd45b068629a29$export$f34037fb3390566b)(c, tr)).filter($d80773f42a527d1c$var$filterUndefined)
        ];
        if (selectedDecoration) return conflictDecorations.concat(selectedDecoration);
        return conflictDecorations;
    } else return [
        ...conflicts.inserted.map((c)=>$d80773f42a527d1c$var$createInsertedDecoration(c, tr, resolutionMode)),
        ...conflicts.deleted.map((c)=>(0, $33fd45b068629a29$export$f34037fb3390566b)(c, tr)).filter($d80773f42a527d1c$var$filterUndefined)
    ];
};
const $d80773f42a527d1c$var$mapConflict = (change, mapping, type)=>{
    const from = mapping.map(change.from);
    const to = mapping.map(change.to);
    // We've collapsed the change and there's no visible marker to the user this conflict is no longer useful to us
    // These are "orphaned" conflicts similar to orphaned comments and for now we handle by resolving these since there
    // are no appropriate user actions.
    if (type === 'inserted' && from === to) return undefined;
    return {
        ...change,
        from: from,
        to: to
    };
};
const $d80773f42a527d1c$var$findSelectedConflict = (conflict, selection)=>selection.from >= conflict.from && selection.from <= conflict.to || selection.to >= conflict.from && selection.to <= conflict.to;
const $d80773f42a527d1c$var$getSelectedConflict = (conflicts, selection)=>{
    if (!conflicts) return undefined;
    const insertedSelectedConflict = conflicts?.inserted.find((conflict)=>$d80773f42a527d1c$var$findSelectedConflict(conflict, selection));
    const deletedSelectedConflict = conflicts?.deleted.find((conflict)=>$d80773f42a527d1c$var$findSelectedConflict(conflict, selection));
    if (insertedSelectedConflict) return {
        ...insertedSelectedConflict,
        type: 'inserted'
    };
    if (deletedSelectedConflict) return {
        ...deletedSelectedConflict,
        type: 'deleted'
    };
    return undefined;
};
const $d80773f42a527d1c$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $cyZvy.conflictResolutionPluginKey),
        state: {
            init: ()=>{
                return {
                    decorations: (0, $ftzrq.DecorationSet).empty,
                    conflicts: undefined,
                    selected: undefined,
                    isNextEnabled: false,
                    isPreviousEnabled: false,
                    resolutionMode: 'viewing'
                };
            },
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta((0, $cyZvy.conflictResolutionPluginKey));
                const navigatedConflict = tr.getMeta('nextConflict');
                // Early escape hatch to avoid running all the code below if not necessary
                if (pluginState.conflicts === undefined && meta === undefined) return pluginState;
                const conflicts = (0, $djYcq.getNewConflicts)(meta, pluginState.conflicts);
                const mappedConflicts = pluginState.conflicts ? {
                    inserted: pluginState.conflicts.inserted.map((c)=>$d80773f42a527d1c$var$mapConflict(c, tr.mapping, 'inserted')).filter($d80773f42a527d1c$var$filterUndefined),
                    deleted: pluginState.conflicts.deleted.map((c)=>$d80773f42a527d1c$var$mapConflict(c, tr.mapping, 'deleted')).filter($d80773f42a527d1c$var$filterUndefined)
                } : undefined;
                const conflictsRemaining = conflicts ?? mappedConflicts;
                // Update resolution mode based on metadata
                let resolutionMode = pluginState.resolutionMode;
                if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
                    if (meta?.type === 'startResolving') resolutionMode = 'resolving';
                    else if (meta?.type === 'stopResolving') resolutionMode = 'viewing';
                    else if (conflicts && !pluginState.conflicts) // Reset to viewing mode when new conflicts arrive
                    resolutionMode = 'viewing';
                }
                // Only select conflicts if explicitly navigated to OR if actively resolving with cursor selection
                let selectedConflict;
                if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
                    if (navigatedConflict) selectedConflict = navigatedConflict;
                    else if (resolutionMode === 'resolving') selectedConflict = $d80773f42a527d1c$var$getSelectedConflict(conflictsRemaining, tr.selection);
                } else selectedConflict = navigatedConflict ?? $d80773f42a527d1c$var$getSelectedConflict(conflictsRemaining, tr.selection);
                const decorations = conflicts || selectedConflict || pluginState.selected ? (0, $ftzrq.DecorationSet).create(tr.doc, $d80773f42a527d1c$var$createDecorationsFromConflicts(conflictsRemaining, selectedConflict, tr, resolutionMode)) : pluginState.decorations.map(tr.mapping, tr.doc);
                return {
                    decorations: decorations,
                    conflicts: conflictsRemaining,
                    selected: selectedConflict,
                    isPreviousEnabled: conflictsRemaining && selectedConflict ? (0, $djYcq.getNavigationInfo)(conflictsRemaining, selectedConflict, 'previous').isAbleToNavigate : false,
                    isNextEnabled: conflictsRemaining && selectedConflict ? (0, $djYcq.getNavigationInfo)(conflictsRemaining, selectedConflict, 'next').isAbleToNavigate : false,
                    resolutionMode: resolutionMode
                };
            }
        },
        props: {
            decorations: (state)=>(0, $cyZvy.conflictResolutionPluginKey).getState(state)?.decorations
        }
    });
};









const $751b8c45ea51c6cb$var$LazyContentComponent = /*#__PURE__*/ (0, $42omo.lazy)(async ()=>({
        default: (await (parcelRequire("fEcUb"))).ContentComponent
    }));
const $751b8c45ea51c6cb$var$ContentComponentWrapper = ({ api: api, config: config, editorView: editorView })=>{
    const intl = (0, $aXWIB.useIntl)();
    const lastConflictCount = (0, $42omo.useRef)(0);
    // Watch for conflicts being resolved. This is so we can show the success flag.
    (0, $6qdjm.usePluginStateEffect)(api, [
        'conflictResolutionUI'
    ], ({ conflictResolutionUIState: conflictResolutionUIState })=>{
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) return;
        if (!config?.flags) return;
        if (!config?.contentId || !config?.spaceKey) return;
        const currentConflictCount = (conflictResolutionUIState?.conflicts?.inserted?.length ?? 0) + (conflictResolutionUIState?.conflicts?.deleted?.length ?? 0);
        // If we had conflicts and now we don't, show success flag
        if (lastConflictCount.current > 0 && currentConflictCount === 0) (0, $402b4b60c57df829$export$f4728fbe8fc5d546)(config.flags, intl, config.contentId, config.spaceKey);
        lastConflictCount.current = currentConflictCount;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($751b8c45ea51c6cb$var$LazyContentComponent, {
        api: api,
        editorView: editorView
    }));
};
const $751b8c45ea51c6cb$export$bb9d066eb8005e17 = ({ api: api, config: config })=>{
    return {
        name: 'conflictResolutionUI',
        contentComponent: ({ editorView: editorView })=>{
            if (!editorView) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($751b8c45ea51c6cb$var$ContentComponentWrapper, {
                api: api,
                config: config,
                editorView: editorView
            });
        },
        getSharedState: (state)=>{
            if (!state) return undefined;
            return {
                selected: (0, $cyZvy.conflictResolutionPluginKey).getState(state)?.selected,
                isNextEnabled: (0, $cyZvy.conflictResolutionPluginKey).getState(state)?.isNextEnabled ?? true,
                isPreviousEnabled: (0, $cyZvy.conflictResolutionPluginKey).getState(state)?.isPreviousEnabled ?? true,
                conflicts: (0, $cyZvy.conflictResolutionPluginKey).getState(state)?.conflicts,
                resolutionMode: (0, $cyZvy.conflictResolutionPluginKey).getState(state)?.resolutionMode ?? 'viewing'
            };
        },
        commands: {
            navigateToFirstConflict: ({ tr: tr })=>{
                const conflicts = api?.conflictResolutionUI?.sharedState.currentState()?.conflicts;
                if (conflicts && (conflicts.inserted.length > 0 || conflicts?.deleted.length > 0)) return (0, $djYcq.navigateToAvailable)(undefined, tr, conflicts);
                return null;
            },
            startResolvingConflicts: ({ tr: tr })=>{
                const conflicts = api?.conflictResolutionUI?.sharedState.currentState()?.conflicts;
                // Early exit when we've no conflicts to resolve.
                if (!conflicts || conflicts.inserted.length === 0 && conflicts.deleted.length === 0) return null;
                // First, start resolving mode
                const trWithMode = tr.setMeta((0, $cyZvy.conflictResolutionPluginKey), {
                    type: 'startResolving'
                });
                // Then navigate to first conflict
                const trWithNavigation = (0, $djYcq.navigateToAvailable)(undefined, trWithMode, conflicts);
                return trWithNavigation || trWithMode;
            }
        },
        pmPlugins: ()=>{
            return [
                {
                    name: 'conflictResolutionPlugin',
                    plugin: (0, $d80773f42a527d1c$export$ae829ec7b2625219)
                }
            ];
        },
        usePluginHook: ({ editorView: editorView })=>{
            const lastReconnectionConflictMetadataRef = (0, $42omo.useRef)();
            (0, $6qdjm.usePluginStateEffect)(api, [
                'collabEdit'
            ], ({ collabEditState: collabEditState })=>{
                const { lastReconnectionConflictMetadata: lastReconnectionConflictMetadata } = collabEditState ?? {};
                if (lastReconnectionConflictMetadata && !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(lastReconnectionConflictMetadataRef.current, lastReconnectionConflictMetadata)) {
                    (0, $djYcq.setMetadata)(editorView, {
                        type: 'update',
                        data: lastReconnectionConflictMetadata
                    }, {
                        api: api
                    });
                    lastReconnectionConflictMetadataRef.current = lastReconnectionConflictMetadata;
                }
            });
        }
    };
};



var $5wfVt = parcelRequire("5wfVt");


var $eF5Eg = parcelRequire("eF5Eg");


var $iVURp = parcelRequire("iVURp");

const $83c8a91574f9bbb4$export$714213af40919bf6 = (quickInsert, isMarkdownMode)=>{
    if (!isMarkdownMode) return quickInsert;
    // Normalise to an object so we can spread + add the filter.
    const baseOptions = typeof quickInsert === 'object' && quickInsert !== null ? quickInsert : {};
    const callerFilter = baseOptions.itemFilter;
    const itemFilter = callerFilter ? (item)=>(0, $6WVPv.isMarkdownCompatibleQuickInsertItem)(item) && callerFilter(item) : (0, $6WVPv.isMarkdownCompatibleQuickInsertItem);
    return {
        ...baseOptions,
        itemFilter: itemFilter
    };
};
const $83c8a91574f9bbb4$var$allowOptionalAIPluginOptions = (pluginOptions)=>pluginOptions;
const $83c8a91574f9bbb4$var$allowFormatCodeProvider = (providers)=>providers;
function $83c8a91574f9bbb4$export$7cb04b251abcb35b(options) {
    const { intl: intl, appearance: appearance, prevAppearance: prevAppearance } = options;
    const isNativeEmbeddedLiveDoc = !!options.__livePage && !!options.isEmbeddedConfluence && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true);
    const isMarkdownMode = options.isMarkdownMode ?? false;
    const isEditorAIPluginEnabled = Boolean(options.editorPluginAIOptions);
    const quickInsertOptions = $83c8a91574f9bbb4$export$714213af40919bf6(options.quickInsert, isMarkdownMode);
    const agentManagedExtensionPluginOption = {
        agentManagedExtension: {
            cloudId: options.cloudId,
            contentType: options.contentType
        }
    };
    // `prettier-ignore` keeps the long fluent chain below on its current
    // `return fullPagePreset(...)` form. Without it Prettier re-indents ~570
    // chained-method lines and explodes the diff for any unrelated change.
    // The chain is purely declarative configuration.
    // prettier-ignore
    return (0, $2b80134f192952c5$export$9f1bd789d5e1fd40)({
        intl: intl,
        isRovoLLMEnabled: options.isRovoLLMEnabled,
        pluginOptions: $83c8a91574f9bbb4$var$allowOptionalAIPluginOptions({
            contentFormat: {
                initialContentMode: options.contentMode ?? 'standard'
            },
            base: {
                __livePage: options.__livePage
            },
            helpDialog: {
                imageUploadProviderExists: false,
                aiEnabled: options.isAIEnabledForContent ?? false
            },
            hyperlink: {
                editorAppearance: appearance,
                linkPicker: options.linking?.linkPicker,
                onClickCallback: options.linking?.smartLinks?.onClickCallback
            },
            quickInsert: {
                emptyStateHandler: options.elementBrowser?.emptyStateHandler,
                quickInsert: quickInsertOptions
            },
            placeholder: {
                viewMode: options.viewMode,
                isAIEnabled: options.isAIEnabledForContent ?? false,
                // hide placeholder when (1) variant1 is enabled (2) not embedded editor & (3) user would see BPQA.
                // match BPQA conditions as defined by shouldRenderBPQA in FullPageEditorComponent
                // in this case, only isCompanyHub is not handled yet by the placeholder plugin
                isPlaceholderHidden: !options.isEmbeddedConfluence && !options.isCompanyHub && options.isRovoLLMEnabled && (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant1'),
                enableLoadingSpinner: options.enablePlaceholderLoadingSpinner,
                isRovoLLMEnabled: options.isRovoLLMEnabled
            },
            selection: {
                __livePage: options.__livePage
            },
            ...agentManagedExtensionPluginOption,
            editorDisabled: {
                disabled: options.disabled
            },
            breakout: {
                editorAppearance: appearance
            },
            expand: {
                editorAppearance: appearance,
                __livePage: options.__livePage
            },
            annotation: {
                annotationManager: options.annotationProviders?.annotationManager,
                createCommentExperience: (0, $3YBks.createInlineCommentCompoundExperience),
                selectCommentExperience: (0, $4EKKB.selectInlineCommentCompoundExperience),
                viewInlineCommentTraceUFOPress: ()=>{
                    // Similar to logic in next/packages/annotation-provider-inline-comments/src/renderer/ViewComponent.tsx
                    // but for editor:
                    // Only start this trace if this is not viewing a just-created comment, in
                    // which case an `editor-create-inline-comment` action trace would still be
                    // running. We let it run to cover the entire create UI flow end-to-end.
                    const createExperienceState = (0, $fGzMp.getExperienceTracker)().getExperienceState((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE));
                    const skipTrace = createExperienceState?.hasStopped === false && (0, $6mKj3.expValEquals)('confluence_fe_create_comment_optimistic', 'isEnabled', true);
                    if (!skipTrace) (0, $4TXTZ.default)('view-inline-comment-action');
                }
            },
            media: {
                createCommentExperience: (0, $9wGTI.fg)('confluence_fe_create_inline_comment_exp_coverage_2') ? (0, $3YBks.createInlineCommentCompoundExperience) : undefined,
                editorAppearance: appearance,
                mediaViewerExtensions: options.media?.mediaViewerExtensions,
                fallbackMediaNameFetcher: options.media?.fallbackMediaNameFetcher
            },
            mentions: {
                handleMentionsChanged: options.handleMentionsChanged,
                currentUserId: options.currentUserId,
                ...(0, $6mKj3.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && {
                    getIsRovoPanelOpen: options.getIsRovoPanelOpen
                }
            },
            table: {
                __livePage: options.__livePage,
                editorAppearance: appearance,
                prevEditorAppearance: prevAppearance
            },
            tasksAndDecisions: {
                hasEditPermission: options.hasEditPermission,
                requestToEditContent: options.requestToEditContent,
                hasRequestedEditPermission: options.hasRequestedEditPermission
            },
            collabEdit: {
                collabEdit: options.collabEdit,
                __livePage: options.__livePage
            },
            // Remove the options.contextPanelOptions undefined checking after cleaning `platform_editor_ai_object_sidebar_injection` FG
            // and options.contextPanelOptions will be always defined.
            contextPanel: options.contextPanelOptions ? {
                objectSideBar: options.contextPanelOptions.objectSideBar
            } : undefined,
            extension: {
                extensionHandlers: options.extensionHandlers,
                editorAppearance: appearance,
                __rendererExtensionOptions: options.__rendererExtensionOptions,
                getExtensionHeight: options.getExtensionHeight,
                getUnsupportedContent: $7cb36df2e500ad5f$export$d4ded51d0f0bd2df
            },
            layout: {
                editorAppearance: appearance
            },
            card: {
                smartCardContext: (0, $3gyyc.isSSRStreaming)() ? options.smartCardContext : undefined,
                editorAppearance: appearance,
                linkPicker: options.linking?.linkPicker,
                onClickCallback: options.linking?.smartLinks?.onClickCallback,
                __livePage: options.__livePage,
                CompetitorPrompt: $dXIrr.PromptPopupContainer,
                enablePasteDisplayAsMenu: true
            },
            insertBlock: {
                editorAppearance: appearance,
                // In Markdown Mode, hide toolbar insert items whose underlying node
                // has no clean GFM round-trip (panels, layouts, dates, status,
                // mentions, emoji, decisions, expand, placeholder text, rich `media`).
                itemFilter: isMarkdownMode ? (0, $5e0cfaca612140f5$export$d51800a5a6fed7d2) : undefined,
                toolbarButtons: {
                    emoji: {
                        enabled: true,
                        showAt: 'lg'
                    },
                    insert: {
                        enabled: true,
                        showAt: 'lg'
                    },
                    layout: {
                        enabled: true,
                        showAt: 'lg'
                    },
                    media: {
                        enabled: true,
                        showAt: 'lg'
                    },
                    mention: {
                        enabled: true,
                        showAt: 'lg'
                    },
                    table: {
                        enabled: true,
                        showAt: 'md'
                    },
                    taskList: {
                        enabled: true,
                        showAt: 'lg'
                    }
                }
            },
            avatarGroup: {
                // Avatars are moved to Confluence codebase for Edit in Context
                // When Edit in Context is enabled primaryToolbarComponents is undefined
                // For more details please check
                // https://hello.atlassian.net/wiki/spaces/PCG/pages/2851572180/Editor+toolbar+for+live+pages+and+edit+in+context+projects
                collabEdit: options.collabEdit
            },
            codeBidiWarning: {
                editorAppearance: appearance
            },
            referentiality: {
                referentialityContext: options.referentialityContext
            },
            ...options.editorPluginAIOptions ? {
                ai: options.editorPluginAIOptions
            } : {},
            pasteOptionsToolbar: options.pasteOptionsToolbarPluginOptions,
            loom: {
                renderButton: options.loomPluginOptions.renderButton
            },
            editorViewMode: {
                viewMode: options.viewMode
            },
            aiDefinitions: options.editorPluginAIDefinitionsConfig,
            selectionMarker: {
                __livePage: options.__livePage ?? false
            },
            engagementPlatform: {
                coordinationClient: options.editorEngagementPlatformPluginConfig.coordinationClient
            },
            selectionExtension: options.selectionExtensionPluginOptions,
            metrics: // eslint-disable-next-line confluence-feature-gating/no-preconditioning
            (0, $6mKj3.expValEquals)('platform_editor_controls', 'cohort', 'variant1') ? {
                userPreferencesProvider: options.userPreferencesProvider
            } : undefined,
            primaryToolbar: {
                contextualFormattingEnabled: options.contextualFormattingEnabled
            },
            selectionToolbar: {
                contextualFormattingEnabled: options.contextualFormattingEnabled,
                // In embedded live doc, the toolbar is always unpinned and the pin option is hidden
                disablePin: isNativeEmbeddedLiveDoc
            },
            userPreferencesPlugin: {
                // In embedded live doc, force the toolbar to start unpinned regardless of any saved user preference
                initialToolbarDockingPosition: isNativeEmbeddedLiveDoc ? 'none' : undefined
            },
            blockMenu: {
                getLinkPath: options.getHeadingLinkPath,
                blockLinkHashPrefix: options.blockLinkHashPrefix
            },
            showDiff: options.showDiffPluginParams,
            syncedBlock: options.syncedBlockProvider && (0, $6mKj3.expValEquals)('platform_synced_block', 'isEnabled', true) ? {
                __livePage: options.__livePage,
                enableSourceCreation: true,
                syncedBlockRenderer: (0, $hmVoT.getSyncedBlockRenderer)({
                    syncBlockRendererOptions: {
                        eventHandlers: options.syncedBlockEventHandlers,
                        stickyHeaders: {
                            show: true,
                            offsetTop: 0
                        }
                    }
                }),
                syncBlockDataProvider: options.syncedBlockProvider
            } : undefined,
            limitedMode: options.limitedModePluginOptions || {},
            toolbar: {
                contextualFormattingEnabled: options.contextualFormattingMode ?? 'controlled',
                // In Markdown Mode, filter the toolbar two ways:
                //
                //   1. In wysiwyg view: hide buttons / menus whose underlying
                //      mark or node has no clean GFM round-trip (text colour,
                //      highlight, alignment, underline, sub/super, mention,
                //      emoji, layout, media, synced block).
                //   2. In source / preview view: hide everything except the
                //      view-mode toggle itself, since the buttons would have
                //      no effect on the source / preview surfaces.
                //
                componentFilter: isMarkdownMode ? (0, $8114702bedaf0f51$export$567bd3c3a1a1ead7) : undefined
            },
            trackChanges: {
                ButtonWrapper: options.trackChangesPluginOptions?.ButtonWrapper
            },
            aiSuggestions: options.aiSuggestionsPluginOptions,
            aiImageGeneration: {
                isRemixHidden: options.__isRemixHidden || isMarkdownMode,
                isRovoLLMEnabled: options.isRovoLLMEnabled
            }
        }),
        providers: $83c8a91574f9bbb4$var$allowFormatCodeProvider({
            // In embedded live doc, we always want the toolbar to be unpinned regardless of saved preferences.
            // Passing undefined for both providers prevents any shared user preference state from affecting
            // the embedded live doc toolbar docking position.
            userPreferencesProvider: isNativeEmbeddedLiveDoc ? undefined : options.userPreferencesProvider,
            userPreferencesProviderNext: isNativeEmbeddedLiveDoc ? undefined : options.userPreferencesProviderNext,
            cardProvider: options.linking?.smartLinks?.provider,
            contextIdentifierProvider: options.contextIdentifierProvider,
            inlineCommentAnnotationProvider: options.annotationProviders?.inlineComment,
            mediaProvider: options.media?.provider,
            syncMediaProvider: options.media?.syncProvider,
            mentionProvider: options.mentionProvider,
            profilecardProvider: options.mention?.profilecardProvider,
            emojiProvider: options.emojiProvider,
            emojiNodeDataProvider: options.emojiNodeDataProvider,
            formatCodeProvider: (0, $6xiPL.getCodeBlockFormatProvider)(),
            collabEditProvider: options.collabEdit?.provider,
            autoformattingProvider: options.autoformattingProvider,
            taskDecisionProvider: options.taskDecisionProvider
        }),
        enabledOptionalPlugins: {
            agentManagedExtension: options.isRovoLLMEnabled && (0, $6mKj3.expValEquals)('agent-managed_blocks_mvp', 'isEnabled', true),
            limitedMode: false,
            findReplace: Boolean(options.allowFindReplace),
            referentiality: Boolean(options.referentialityContext.plugin),
            loom: options.isLoomPluginEnabled,
            aiDefinitions: isEditorAIPluginEnabled && options.editorPluginAIDefinitionsEnabled,
            aiImageGeneration: isEditorAIPluginEnabled && (0, $6mKj3.expValEquals)('cc_page_experiences_editor_image_generation', 'isEnabled', true) && (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai'),
            connectivity: options.isDesktop || (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false),
            metrics: (0, $9wGTI.fg)('platform_editor_ease_of_use_metrics'),
            codeBlockAdvanced: true,
            selectionExtension: (0, $6mKj3.expValEquals)('platform_editor_controls', 'cohort', 'variant1'),
            aiExperience: Boolean(isEditorAIPluginEnabled && options.editorPluginAIOptions?.aiGlobalOptIn.status !== 'disabled'),
            interaction: Boolean(options?.__livePage) || (0, $6mKj3.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true),
            userPreferences: (0, $9wGTI.fg)('platform_editor_use_preferences_plugin'),
            trackChanges: (0, $9wGTI.fg)('aifc_create_enabled'),
            showDiff: Boolean(options?.showDiffPluginParams) || (0, $9wGTI.fg)('aifc_create_enabled'),
            toolbar: !options?.disableToolbar && ((0, $9wGTI.fg)('aifc_create_enabled') || isEditorAIPluginEnabled && options.editorPluginAIOptions?.aiGlobalOptIn.status !== 'enabled' && (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true)),
            blockMenu: (0, $6mKj3.expValEquals)('platform_editor_block_menu', 'isEnabled', true),
            localId: (0, $9wGTI.fg)('platform_editor_adf_with_localid'),
            aiStreamingOrchestrator: (0, $9wGTI.fg)('aifc_create_enabled'),
            syncedBlock: (0, $6mKj3.expValEquals)('platform_synced_block', 'isEnabled', true),
            floatingToolbar: !options?.disableFloatingToolbar,
            codeBidiWarning: !(0, $6mKj3.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true),
            contentFormat: true,
            uiControlRegistry: (0, $6mKj3.expValEquals)('platform_editor_paste_actions_menu', 'isEnabled', true),
            aiSuggestions: isEditorAIPluginEnabled && options.isRovoLLMEnabled && (0, $6mKj3.expVal)('platform_editor_ai_content_suggested_edits', 'isEnabled', false),
            aiSpeechToText: isEditorAIPluginEnabled && (0, $6mKj3.expValEquals)('ai_speech_to_text_in_editor', 'isEnabled', true),
            collabEdit: true
        }
    }).add((0, $eF5Eg.ssrPlugin))// When hiding content titles in URLs, skip the heading anchor links plugin to prevent generating anchor URLs that expose UGC.
    .maybeAdd([
        (0, $4vxk6.EditorHeadingLinksPlugin),
        {
            getHeadingLinkPath: options.getHeadingLinkPath
        }
    ], !options.shouldHideHeadingAnchorLinks).add((0, $iVURp.pageTitleUtilsPlugin)).add((0, $b6333eeaeea6365c$export$53933ef6873e4a9f)).add((0, $dMGoR.forgeEditorPlugin)).maybeAdd([
        (0, $1d19c6d3b6d5b560$export$ea606e96c5866df5),
        {
            flags: options.flags
        }
    ], options.isDesktop || (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)).maybeAdd([
        (0, $751b8c45ea51c6cb$export$bb9d066eb8005e17),
        {
            flags: options.flags,
            contentId: options.contentId,
            spaceKey: options.spaceKey
        }
    ], options.isDesktop || (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)).add((0, $5wfVt.emptyStatePlugin)).add((0, $iHrpD.legacyContentMacroPlugin)).maybeAdd((0, $0c12e133eae86678$export$c5dd41c01dfdca7c), (0, $9wGTI.fg)('confluence_frontend_native_tabs_extension'))// `previewComponent` is intentionally omitted: the preview view is
    // disabled in the toggle UI today and not yet implemented in Confluence.
    // When it lands, supply a Confluence renderer here (it needs product
    // providers — SmartCard, Emoji, media feature flags — so it can't live
    // in the platform plugin).
    .maybeAdd([
        (0, $ipg0f.markdownModePlugin),
        {
            isMarkdownMode: isMarkdownMode,
            contentId: options.contentId ?? '',
            viewModePersistence: {
                getInitialView: (0, $2x28u.readStoredMarkdownViewMode),
                onViewChange: (0, $2x28u.writeStoredMarkdownViewMode)
            },
            // EDITOR-6636 — pass through the Confluence-supplied
            // `serializeFileMedia`. Builds tenant attachment-proxy URLs
            // (`/wiki/download/attachments/...`) for `media(type:file)`
            // so the markdown text remains credential-free and the
            // renderer auths the bytes via the viewer's session cookie.
            serializeFileMedia: options.serializeFileMediaForMarkdown
        }
    ], isMarkdownMode).maybeAdd((0, $616343a1d45d9a96$export$c84116e7ea204952), (0, $6mKj3.expVal)('platform_editor_add_image_editing', 'isEnabled', false)).maybeAdd((0, $8c3629cd1d541fcd$export$d82c0e619eaaa2c2), options.isCompanyHub).maybeAdd([
        (0, $kqbzb.malleableUiPlugin),
        {
            __isRemixHidden: options.__isRemixHidden || isMarkdownMode,
            __isRovoLLMEnabled: options.isRovoLLMEnabled,
            __remixDisabledReason: options.__remixDisabledReason,
            __livePage: options.__livePage,
            shouldHideToolbarWhileRemixing: true,
            createRemixContentComponent: $d4d2J.createRemixContentComponent,
            diagramPaste: options.cloudId && options.spaceKey ? (0, $6ZWlg.createConfluenceMauiDiagramPasteConfig)({
                contentId: options.contentId,
                contentType: options.contentType,
                duplicateMauiApp: options.duplicateMauiApp,
                siteId: options.cloudId,
                spaceKey: options.spaceKey,
                userId: options.currentUserId
            }) : undefined
        }
    ], (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && !options.isEmbeddedConfluence).maybeAdd([
        (0, $lGoD9.nativeEmbedsPlugin)
    ], (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) || (0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience')).maybeAdd((0, $9bdb7ad03a409b2b$export$52b2e012ce18dd1), (0, $6mKj3.expVal)('platform_editor_ai_headingautocomplete', 'isEnabled', false));
}
module.exports["createFullPageEditorPreset"] = $83c8a91574f9bbb4$export$7cb04b251abcb35b;

});

parcelRegister("hcAEn", function(module, exports) {

let $c85ffca229ce5cc3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c85ffca229ce5cc3$var$load("4ZmzZ").then(()=>parcelRequire('6mNEk'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("2x28u", function(module, exports) {

var $1UApO = parcelRequire("1UApO");


var $17wUi = parcelRequire("17wUi");

const $46c9e3ceb36a3a8c$export$25ad9f1e249c47eb = 'syntax';
const $46c9e3ceb36a3a8c$var$isMarkdownViewMode = (value)=>value === 'syntax' || value === 'preview';
const $46c9e3ceb36a3a8c$export$6e4435a107f4f22b = ()=>{
    const stored = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).MARKDOWN_VIEW_MODE);
    if ($46c9e3ceb36a3a8c$var$isMarkdownViewMode(stored)) return stored;
    // No valid preference stored — persist the default so the toggle can read it.
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).MARKDOWN_VIEW_MODE, $46c9e3ceb36a3a8c$export$25ad9f1e249c47eb);
    return $46c9e3ceb36a3a8c$export$25ad9f1e249c47eb;
};
const $46c9e3ceb36a3a8c$export$2380bf8e3c6aedc9 = (mode)=>{
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).MARKDOWN_VIEW_MODE, mode);
};
module.exports["readStoredMarkdownViewMode"] = $46c9e3ceb36a3a8c$export$6e4435a107f4f22b;
module.exports["writeStoredMarkdownViewMode"] = $46c9e3ceb36a3a8c$export$2380bf8e3c6aedc9;

});

parcelRegister("4vxk6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $ftzrq = parcelRequire("ftzrq");


var $jSnXV = parcelRequire("jSnXV");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");

const $d4ec92cbc00adf4b$export$3e69d3882a51f072 = 'heading-links';
const $d4ec92cbc00adf4b$export$2dd355223baa0569 = new (0, $ks2lK.PluginKey)($d4ec92cbc00adf4b$export$3e69d3882a51f072);
var $d4ec92cbc00adf4b$export$ad105db915eb8d4a = /*#__PURE__*/ function(EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS) {
    EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS["NOT_ENROLLED"] = "not-enrolled";
    EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS["CONTROL"] = "control";
    EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS["VARIANT"] = "variant";
    return EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS;
}({});






var $aXWIB = parcelRequire("aXWIB");


var $3gadb = parcelRequire("3gadb");


var $d925B = parcelRequire("d925B");


var $cOrQJ = parcelRequire("cOrQJ");


var $202oG = parcelRequire("202oG");

const $4b64eb8446c0685a$export$9030f1f7cf11a203 = async (node, getHeadingLinkPath)=>{
    try {
        const headingId = (0, $202oG.getHeadingIdForNode)(node);
        if (!headingId) return false;
        const path = getHeadingLinkPath();
        if (!path) return false;
        const url = new URL(location.origin + path);
        url.hash = encodeURIComponent(headingId);
        const href = url.toString();
        if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            await navigator.clipboard.writeText(href);
            return true;
        }
        return false;
    } catch  {
        return false;
    }
};


const $a9415ea089d2d14f$var$i18n = (0, $aXWIB.defineMessages)({
    tooltipCopyMessage: {
        id: "editor-heading-links.link-component.tooltip.copy",
        defaultMessage: "Copy link to heading"
    },
    tooltipCopiedMessage: {
        id: "editor-heading-links.link-component.tooltip.copied",
        defaultMessage: "Copied!"
    },
    iconLabel: {
        id: "editor-heading-links.link-component.icon.label",
        defaultMessage: "Link icon"
    }
});
const $a9415ea089d2d14f$export$f356b7f7371242f8 = ({ node: node, intl: intl, analytics: analytics, isRightAligned: isRightAligned, getHeadingLinkPath: getHeadingLinkPath })=>{
    const [didCopy, setDidCopy] = (0, $42omo.useState)(false);
    const updateTooltip = (0, $42omo.useRef)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    (0, $42omo.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        didCopy
    ]);
    const handleClick = (0, $42omo.useCallback)(async ()=>{
        const didCopySucceed = await (0, $4b64eb8446c0685a$export$9030f1f7cf11a203)(node, getHeadingLinkPath);
        if (didCopySucceed) setDidCopy(true);
        // Should match the event fired for heading links on the view page
        // platform/packages/editor/renderer/src/react/nodes/heading.tsx
        analytics?.fireAnalyticsEvent?.({
            action: (0, $d925B.ACTION).CLICKED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
            eventType: (0, $d925B.EVENT_TYPE).UI
        });
    }, [
        node,
        analytics,
        getHeadingLinkPath
    ]);
    const tooltipContentFn = (0, $42omo.useCallback)(({ update: update })=>{
        updateTooltip.current = update;
        return didCopy ? intl.formatMessage($a9415ea089d2d14f$var$i18n.tooltipCopiedMessage) : intl.formatMessage($a9415ea089d2d14f$var$i18n.tooltipCopyMessage);
    }, [
        didCopy,
        intl
    ]);
    const handleMouseOut = (0, $42omo.useCallback)(()=>{
        setDidCopy(false);
    }, []);
    const headingLevel = node.attrs['level'];
    const alignmentClass = isRightAligned ? 'link-widget-right' : 'link-widget-left';
    const sizeClass = headingLevel > 3 ? 'link-widget-small' : 'link-widget-medium';
    let colorClass;
    if (didCopy) colorClass = colorMode === 'dark' ? 'link-widget-clicked-dark' : 'link-widget-clicked-light';
    else colorClass = colorMode === 'dark' ? 'link-widget-hovered-dark' : 'link-widget-hovered-light';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        delay: 0,
        position: "top",
        content: tooltipContentFn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "heading-link-copy-button",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `link-widget ${alignmentClass} ${sizeClass} ${colorClass}`,
        onClick: handleClick,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: handleMouseOut
    }));
};


const $61a2a9c96b4df241$export$181fa0f15c7f1584 = (position, node, isRightAligned, intl, analytics, getHeadingLinkPath)=>{
    return (0, $ftzrq.Decoration).widget(position, ()=>{
        const elem = document.createElement('span');
        // Trying to avoid both React and ProseMirror changing the same elements,
        // hence the nested container
        const container = document.createElement('span');
        // eslint-disable-next-line react/no-deprecated
        (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a9415ea089d2d14f$export$f356b7f7371242f8), {
            node: node,
            intl: intl,
            analytics: analytics,
            isRightAligned: isRightAligned,
            getHeadingLinkPath: getHeadingLinkPath
        }), container);
        elem.appendChild(container);
        return elem;
    }, {
        side: isRightAligned ? -1 : 1,
        key: `heading-link-${position}`,
        ignoreSelection: false
    });
};
const $61a2a9c96b4df241$export$ae829ec7b2625219 = (intl, analytics, getHeadingLinkPath)=>{
    const handleMouseOver = (view, event)=>{
        // Get the position of the cursor
        const result = view.posAtCoords({
            left: event.clientX,
            top: event.clientY
        });
        const pos = result?.pos;
        if (pos !== undefined) {
            // Resolve the position to a node
            let range = view.state.doc.resolve(pos);
            if (range.parent.type.name !== 'heading') {
                // There was an issue where, if you hovered over a heading from top to bottom,
                // the position would resolve to the document node rather than the heading.
                // Offsetting by 1 seems to fix the issue. However, we need to check both
                // pos and pos+1. If we only check the latter, there's a similar problem when
                // hovering headings from right to left.
                const adjPos = Math.min(pos + 1, view.state.doc.content.size);
                range = view.state.doc.resolve(adjPos);
            }
            // If the node is a heading, dispatch metadata to add a link decoration
            if (range.parent.type.name === 'heading') view.dispatch(view.state.tr.setMeta((0, $d4ec92cbc00adf4b$export$2dd355223baa0569), {
                applyHoverDecoration: true,
                from: range.start(),
                node: range.parent
            }));
        }
        return false;
    };
    const debouncedHandleMouseOver = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(handleMouseOver, 150);
    const plugin = new (0, $1S4f7.SafePlugin)({
        key: (0, $d4ec92cbc00adf4b$export$2dd355223baa0569),
        state: {
            init () {
                return {
                    hoveredHeading: undefined,
                    start: undefined
                };
            },
            apply: (tr, old, _, newState)=>{
                // Get the metadata that was dispatched from the mouseover event
                const hoverDecoration = tr.getMeta((0, $d4ec92cbc00adf4b$export$2dd355223baa0569));
                // If the metadata `applyHoverDecoration` property is present,
                // add a link decoration to the heading node. Note: Only one
                // decoration will ever exist on the page. When a new heading
                // is hovered, the old decoration will be replaced.
                if (hoverDecoration?.applyHoverDecoration) {
                    const node = hoverDecoration.node;
                    return {
                        hoveredHeading: node,
                        start: hoverDecoration.from
                    };
                }
                if (old.start !== undefined) {
                    const newStart = tr.mapping.map(old.start);
                    const newHeadingNode = newState.doc.resolve(newStart);
                    if (newHeadingNode.parent.content.size === 0 || newHeadingNode.parent.type.name !== 'heading') return {
                        hoveredHeading: undefined,
                        start: undefined
                    };
                    // If the heading is prepended, the start position will be off by 1,
                    // so we need to use the .start() method to get the correct position.
                    return {
                        hoveredHeading: newHeadingNode.parent,
                        start: newHeadingNode.start()
                    };
                }
                return old;
            }
        },
        props: {
            decorations (state) {
                const pluginState = plugin.getState(state);
                const heading = pluginState?.hoveredHeading;
                const start = pluginState?.start;
                if (heading && start !== undefined) {
                    const endMark = heading.marks.find((mark)=>mark.attrs?.align === 'end');
                    const position = endMark ? start : start + heading.content.size;
                    const link = $61a2a9c96b4df241$export$181fa0f15c7f1584(position, heading, endMark !== undefined, intl, analytics, getHeadingLinkPath);
                    return (0, $ftzrq.DecorationSet).create(state.doc, [
                        link
                    ]);
                }
                return (0, $ftzrq.DecorationSet).empty;
            },
            handleDOMEvents: {
                mouseover: debouncedHandleMouseOver
            }
        }
    });
    return plugin;
};
const $61a2a9c96b4df241$export$96df4e1ee1c54b95 = ({ api: api, config: { getHeadingLinkPath: getHeadingLinkPath } })=>({
        name: (0, $d4ec92cbc00adf4b$export$3e69d3882a51f072),
        pmPlugins () {
            return [
                {
                    name: (0, $d4ec92cbc00adf4b$export$3e69d3882a51f072),
                    plugin: ({ getIntl: getIntl })=>{
                        return $61a2a9c96b4df241$export$ae829ec7b2625219(getIntl(), api?.analytics?.actions, getHeadingLinkPath);
                    }
                }
            ];
        }
    });
module.exports["EditorHeadingLinksPlugin"] = $61a2a9c96b4df241$export$96df4e1ee1c54b95;

});

parcelRegister("djYcq", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $ks2lK = parcelRequire("ks2lK");


var $d925B = parcelRequire("d925B");


var $cyZvy = parcelRequire("cyZvy");

const $ea625f5574c5221d$export$bd9824d426074790 = (api)=>(payload)=>{
        return api?.attachAnalyticsEvent(payload);
    };


const $5899ae1a7b0c1755$export$cb5777189008ecf = (metadata, existingConflicts)=>{
    if (!metadata) return undefined;
    switch(metadata.type){
        // Navigate between conflicts using arrows - doesn't modify conflicts
        case 'navigate':
        // Enter/exit conflict resolution mode - doesn't modify conflicts
        case 'startResolving':
        case 'stopResolving':
            return existingConflicts;
        // Receive new conflicts from server after reconnection
        case 'update':
            return {
                inserted: metadata.data.inserted.map((c)=>({
                        ...c,
                        id: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
                    })),
                deleted: metadata.data.deleted.map((c)=>({
                        ...c,
                        id: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
                    }))
            };
        // User accepts/dismisses a single conflict (removes it from the list)
        case 'resolve':
        // User chooses to keep deleted text (restores it, then removes conflict from the list)
        case 'restore':
            if (!existingConflicts) return existingConflicts;
            return {
                inserted: existingConflicts.inserted.filter((conflict)=>conflict.id !== metadata.data.id),
                deleted: existingConflicts.deleted.filter((conflict)=>conflict.id !== metadata.data.id)
            };
        // User accepts all conflicts at once (clears the entire list)
        case 'resolveAll':
            return {
                inserted: [],
                deleted: []
            };
        default:
            return undefined;
    }
};
const $5899ae1a7b0c1755$export$6804620b9d3be6a7 = (conflicts, selected, direction)=>{
    const allConflicts = [
        ...conflicts?.inserted ?? [],
        ...conflicts?.deleted ?? []
    ].sort((a, b)=>a.from - b.from);
    if (!selected) return {
        isAbleToNavigate: true,
        newConflict: allConflicts.length > 0 ? allConflicts[0] : undefined
    };
    const idx = allConflicts.findIndex((c)=>c.id === selected.id);
    if (direction === 'next') {
        const isAbleToNavigate = idx < allConflicts.length - 1;
        return {
            isAbleToNavigate: isAbleToNavigate,
            newConflict: isAbleToNavigate ? allConflicts[idx + 1] : undefined
        };
    } else {
        const isAbleToNavigate = idx > 0;
        return {
            isAbleToNavigate: isAbleToNavigate,
            newConflict: isAbleToNavigate ? allConflicts[idx - 1] : undefined
        };
    }
};
const $5899ae1a7b0c1755$var$addTypeToConflict = (conflict, conflicts)=>{
    const type = conflicts.deleted.find((c)=>c.id === conflict.id) ? 'deleted' : 'inserted';
    return {
        ...conflict,
        type: type
    };
};
const $5899ae1a7b0c1755$var$navigateToSelection = (meta, tr, conflicts)=>{
    const { isAbleToNavigate: isAbleToNavigate, newConflict: newConflict } = $5899ae1a7b0c1755$export$6804620b9d3be6a7(conflicts, meta.data, meta.direction);
    if (isAbleToNavigate && newConflict) return tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, newConflict.from, newConflict.to)).setMeta('nextConflict', $5899ae1a7b0c1755$var$addTypeToConflict(newConflict, conflicts)).scrollIntoView();
    else return null;
};
const $5899ae1a7b0c1755$export$995f88ef5b52af82 = (currentConflict, tr, conflicts)=>{
    return $5899ae1a7b0c1755$var$navigateToSelection({
        type: 'navigate',
        direction: 'next',
        data: currentConflict
    }, tr, conflicts) ?? $5899ae1a7b0c1755$var$navigateToSelection({
        type: 'navigate',
        direction: 'previous',
        data: currentConflict
    }, tr, conflicts);
};
const $5899ae1a7b0c1755$export$f8685c902e685023 = (editorView, meta, options)=>{
    const { dispatch: dispatch, state: { tr: tr } } = editorView;
    if (meta.type === 'navigate') {
        const pluginState = (0, $cyZvy.conflictResolutionPluginKey).getState(editorView.state);
        if (pluginState?.conflicts) $5899ae1a7b0c1755$var$navigateToSelection(meta, tr, pluginState?.conflicts);
    } else if (meta.type === 'restore') tr.replace(meta.data.from, meta.data.to, meta.data.local);
    else if (meta.type === 'update') (0, $ea625f5574c5221d$export$bd9824d426074790)(options?.api?.analytics?.actions)({
        actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
        attributes: {
            inserted: meta.data.inserted.length,
            deleted: meta.data.deleted.length
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        action: 'offlineReconnectionConflict'
    })?.(tr);
    else if (meta.type === 'resolve') {
        const pluginState = (0, $cyZvy.conflictResolutionPluginKey).getState(editorView.state);
        if (pluginState?.conflicts) $5899ae1a7b0c1755$export$995f88ef5b52af82(meta.data, tr, pluginState?.conflicts);
    }
    dispatch(tr.setMeta((0, $cyZvy.conflictResolutionPluginKey), meta));
};
module.exports["getNewConflicts"] = $5899ae1a7b0c1755$export$cb5777189008ecf;
module.exports["getNavigationInfo"] = $5899ae1a7b0c1755$export$6804620b9d3be6a7;
module.exports["navigateToAvailable"] = $5899ae1a7b0c1755$export$995f88ef5b52af82;
module.exports["setMetadata"] = $5899ae1a7b0c1755$export$f8685c902e685023;

});

parcelRegister("fEcUb", function(module, exports) {

let $b6449a1e86f5b759$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b6449a1e86f5b759$var$load("4LYSa").then(()=>parcelRequire('50nRh'));

});

parcelRegister("eF5Eg", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");

const $fe598058b05d810f$var$pluginName = 'ssr-plugin';
const $fe598058b05d810f$var$pmPluginName = 'ssr-disable-transactions';
const $fe598058b05d810f$export$bfca3f3ccfec3116 = ()=>{
    return {
        name: $fe598058b05d810f$var$pluginName,
        pmPlugins () {
            return [
                {
                    name: $fe598058b05d810f$var$pmPluginName,
                    plugin () {
                        return new (0, $1S4f7.SafePlugin)({
                            filterTransaction () {
                                // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                                return true;
                            }
                        });
                    }
                }
            ];
        }
    };
};
module.exports["ssrPlugin"] = $fe598058b05d810f$export$bfca3f3ccfec3116;

});

parcelRegister("iVURp", function(module, exports) {

var $1gpr6 = parcelRequire("1gpr6");


var $adhil = parcelRequire("adhil");


var $ks2lK = parcelRequire("ks2lK");

const $3c910faa900bb0f6$var$selectDocStart = ()=>({ tr: tr })=>{
        const docStartSelection = (0, $1gpr6.isValidTargetNode)(tr.doc.firstChild) ? new (0, $adhil.GapCursorSelection)(tr.doc.resolve(0)) : (0, $ks2lK.Selection).atStart(tr.doc);
        tr.setSelection(docStartSelection);
        return tr;
    };
const $3c910faa900bb0f6$var$insertNewLineAtDocStart = ()=>({ tr: tr })=>{
        const { paragraph: paragraph, heading: heading } = tr.doc.type.schema.nodes;
        const firstChild = tr.doc.firstChild;
        if (firstChild && [
            paragraph,
            heading
        ].includes(firstChild.type) && !firstChild.childCount) return $3c910faa900bb0f6$var$selectDocStart()({
            tr: tr
        });
        const emptyParagraph = tr.doc.type.schema.nodes.paragraph.create();
        tr.insert(0, emptyParagraph);
        tr.setSelection((0, $ks2lK.TextSelection).near(tr.doc.resolve(0)));
        return tr;
    };
const $3c910faa900bb0f6$export$c7c689ff4e6df96c = ()=>{
    return {
        name: 'pageTitleUtils',
        dependencies: [],
        commands: {
            selectDocStart: $3c910faa900bb0f6$var$selectDocStart,
            insertNewLineAtDocStart: $3c910faa900bb0f6$var$insertNewLineAtDocStart
        }
    };
};
module.exports["pageTitleUtilsPlugin"] = $3c910faa900bb0f6$export$c7c689ff4e6df96c;

});

parcelRegister("cyZvy", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $6a5fd4c39fa17a5b$export$f4d7eeb0b3cec670 = new (0, $ks2lK.PluginKey)('conflictResolutionPluginKey');
module.exports["conflictResolutionPluginKey"] = $6a5fd4c39fa17a5b$export$f4d7eeb0b3cec670;

});


//# sourceMappingURL=FullPageEditorComponent.9b28fee4.js.map
